/* eslint-disable */
import { action } from 'easy-peasy';
import React from 'react';

export default {
  // State
  clients: [
    {
      id: 'culmia',
      name: 'Culmia',
      url: '/client/culmia',
      image: '/home/culmia-logo.jpg',
      provinces: [
        'Alicante',
        'Asturias',
        'Barcelona',
        'Córdoba',
        'Girona',
        'Granada',
        'Huelva',
        'Málaga',
        'Madrid',
        'Palma de Mallorca',
        'Pontevedra',
        'Valencia',
        'Vizcaya',
      ],
      promotions: [
        {
          id: 'odelania',
          name: 'Odelania',
          city: 'Huelva',
          province: 'Huelva',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/odelania',
          reviewStatus: {
            current: 2,
            total: 3,
            status: 'approved',
          },
          url: '/client/culmia/odelania',
          image: 'https://media.bizionar.digital/culmia/odelania/live/render_exterior_01.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '22 de noviembre de 2021',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '26 de noviembre de 2021',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '15 de diciembre de 2021',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'PISO PILOTO',
              closedReviews: 1,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '28 de septiembre de 2021',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '10 de noviembre de 2021',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/odelania/review01/render/interior/render_recibidor_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/odelania/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/odelania/review01/render/exterior/render_exterior_03.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/odelania/review01/render/exterior/orbit_thumb_v1.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/exterior/render_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/exterior/render_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/exterior/render_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/exterior/render_exterior_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/exterior/render_exterior_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/exterior/render_exterior_06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/exterior/render_exterior_07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/exterior/render_exterior_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/exterior/render_exterior_10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/exterior/render_exterior_11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/exterior/render_exterior_13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/exterior/render_exterior_15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 16',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/exterior/render_exterior_16.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/interior/render_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/interior/render_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/interior/render_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/interior/render_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/interior/render_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/interior/render_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/interior/render_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 08',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/interior/render_salon_08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/interior/render_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/interior/render_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/interior/render_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/interior/render_cocina_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 05',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/interior/render_cocina_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/interior/render_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Niño 01',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/interior/render_nino_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Niño 02',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/interior/render_nino_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Niño 03',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/interior/render_nino_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Niña 01',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/interior/render_nina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Niña 02',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/interior/render_nina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/interior/render_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/interior/render_bano_comun_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/interior/render_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/interior/render_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/interior/render_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 04',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/interior/render_suite_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/interior/render_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/interior/render_bano_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Estudio 01',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/interior/render_estudio_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Estudio 02',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/interior/render_estudio_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/interior/render_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/odelania/review01/render/interior/render_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/odelania/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/odelania/review02/render/interior/render_recibidor_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/odelania/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/odelania/review02/render/exterior/render_exterior_03.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/odelania/review02/render/exterior/orbit_thumb_v2.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/exterior/render_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/exterior/render_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/exterior/render_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/exterior/render_exterior_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/exterior/render_exterior_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/exterior/render_exterior_06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/exterior/render_exterior_07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/exterior/render_exterior_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/exterior/render_exterior_10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/exterior/render_exterior_11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/exterior/render_exterior_13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/exterior/render_exterior_15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 16',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/exterior/render_exterior_16.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/interior/render_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/interior/render_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/interior/render_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/interior/render_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/interior/render_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/interior/render_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 08',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/interior/render_salon_08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/interior/render_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/interior/render_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/interior/render_cocina_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 05',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/interior/render_cocina_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/interior/render_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Niño 01',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/interior/render_nino_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Niño 02',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/interior/render_nino_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Niño 03',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/interior/render_nino_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Niña 01',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/interior/render_nina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Niña 02',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/interior/render_nina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/interior/render_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/interior/render_bano_comun_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/interior/render_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/interior/render_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 04',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/interior/render_suite_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/interior/render_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/interior/render_bano_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Estudio 01',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/interior/render_estudio_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Estudio 02',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/interior/render_estudio_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/interior/render_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/interior/render_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/render/interior/render_terraza_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Video Interior',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/video/video_interior.mp4',
                  thumb: 'https://media.bizionar.digital/culmia/odelania/review02/video/video_interior_thumb.jpg',
                  type: 'video',
                  category: 'interiores',
                },
                {
                  name: 'Video Exterior Completo',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/video/video_exterior.mp4',
                  thumb: 'https://media.bizionar.digital/culmia/odelania/review02/video/video_exterior_thumb.jpg',
                  type: 'video',
                  category: 'exteriores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/odelania/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/odelania/review03/render/exterior/render_exterior_03.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/odelania/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/odelania/review02/render/exterior/orbit_thumb_v2.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/odelania/review03/render/exterior/render_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/odelania/review03/render/exterior/render_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/odelania/review03/render/exterior/render_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/odelania/review03/render/exterior/render_exterior_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/odelania/review03/render/exterior/render_exterior_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/odelania/review03/render/exterior/render_exterior_06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/odelania/review03/render/exterior/render_exterior_07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/odelania/review03/render/exterior/render_exterior_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/odelania/review03/render/exterior/render_exterior_10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/odelania/review03/render/exterior/render_exterior_11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/odelania/review03/render/exterior/render_exterior_13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/culmia/odelania/review03/render/exterior/render_exterior_15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 16',
                  src: 'https://media.bizionar.digital/culmia/odelania/review03/render/exterior/render_exterior_16.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior Completo',
                  src: 'https://media.bizionar.digital/culmia/odelania/review03/video/video_exterior.mp4',
                  thumb: 'https://media.bizionar.digital/culmia/odelania/review03/video/video_exterior_thumb.jpg',
                  type: 'video',
                  category: 'exteriores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'PISO PILOTO',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '10 de noviembre de 2021',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/odelania/download/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/odelania/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/odelania/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/odelania/live/render_exterior_03.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Vistas Reales',
                src: 'https://media.bizionar.digital/culmia/odelania/live/tour-vistas/index.html',
                thumb: 'https://media.bizionar.digital/culmia/odelania/live/render_exterior_03.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/odelania/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/odelania/live/render_exterior_03.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/culmia/odelania/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/culmia/odelania/live/render_exterior_11.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/odelania/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/odelania/live/video_exterior_thumb.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/odelania/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/odelania/live/video_exterior_thumb.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_exterior_01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_exterior_02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_exterior_03.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 04',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_exterior_04.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 05',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_exterior_05.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 06',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_exterior_06.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 07',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_exterior_07.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 08',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_exterior_08.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 10',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_exterior_10.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 11',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_exterior_11.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 13',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_exterior_13.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 15',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_exterior_15.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 16',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_exterior_16.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 07',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_salon_07.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_salon_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_salon_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_salon_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_salon_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_salon_06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 08',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_salon_08.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_cocina_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_cocina_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 04',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_cocina_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 05',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_cocina_05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Recibidor 01',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_recibidor_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Niño 01',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_nino_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Niño 02',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_nino_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Niño 03',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_nino_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Niña 01',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_nina_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Niña 02',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_nina_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_bano_comun_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 02',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_bano_comun_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_suite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 04',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_suite_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_bano_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 02',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_bano_suite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Estudio 01',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_estudio_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Estudio 02',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_estudio_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_terraza_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 02',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_terraza_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 03',
                src: 'https://media.bizionar.digital/culmia/odelania/live/render_terraza_03.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'aires-da-ponte',
          name: 'Aires da Ponte',
          city: 'Pontevedra',
          province: 'Pontevedra',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/aires-da-ponte',
          reviewStatus: {
            current: 1,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/aires-da-ponte',
          image: 'https://media.bizionar.digital/culmia/aires-da-ponte/live-aplacado/cam-01_aplacado.jpg',
          deliveries: [
            {
              categoryId: 'interiores',
              categoryName: 'PISO PILOTO',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '20 de octubre de 2021',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '10 de noviembre de 2021',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '25 de noviembre de 2021',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/aires-da-ponte/review01/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review01/render/interior/render_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review01/render/interior/render_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review01/render/interior/render_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review01/render/interior/render_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review01/render/interior/render_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review01/render/interior/render_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review01/render/interior/render_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review01/render/interior/render_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review01/render/interior/render_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review01/render/interior/render_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review01/render/interior/render_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review01/render/interior/render_hab2_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review01/render/interior/render_hab3_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review01/render/interior/render_hab4_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review01/render/interior/render_bano2_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review01/render/interior/render_bano2_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review01/render/interior/render_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review01/render/interior/render_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review01/render/interior/render_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review01/render/interior/render_bano1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review01/render/interior/render_bano1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review01/render/interior/render_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/aires-da-ponte/review01/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review02/render/interior/render_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review02/render/interior/render_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review02/render/interior/render_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review02/render/interior/render_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review02/render/interior/render_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review02/render/interior/render_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review02/render/interior/render_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review02/render/interior/render_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review02/render/interior/render_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review02/render/interior/render_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review02/render/interior/render_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review02/render/interior/render_hab2_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review02/render/interior/render_hab3_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review02/render/interior/render_hab4_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review02/render/interior/render_bano2_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review02/render/interior/render_bano2_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review02/render/interior/render_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review02/render/interior/render_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review02/render/interior/render_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review02/render/interior/render_bano1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review02/render/interior/render_bano1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review02/render/interior/render_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Video Interior',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review02/video/video_interior.mp4',
                  thumb: 'https://media.bizionar.digital/culmia/aires-da-ponte/review02/video/video_interior_thumb.jpg',
                  type: 'video',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/aires-da-ponte/review01/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review03/render/interior/render_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review03/render/interior/render_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review03/render/interior/render_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review03/render/interior/render_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review03/render/interior/render_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review03/render/interior/render_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review03/render/interior/render_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review03/render/interior/render_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review03/render/interior/render_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review03/render/interior/render_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review03/render/interior/render_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review03/render/interior/render_hab2_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review03/render/interior/render_hab3_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review03/render/interior/render_hab4_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review03/render/interior/render_bano2_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review03/render/interior/render_bano2_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review03/render/interior/render_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review03/render/interior/render_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review03/render/interior/render_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review03/render/interior/render_bano1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review03/render/interior/render_bano1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review03/render/interior/render_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Video Interior',
                  src: 'https://media.bizionar.digital/culmia/aires-da-ponte/review03/video/video_interior.mp4',
                  thumb: 'https://media.bizionar.digital/culmia/aires-da-ponte/review03/video/video_interior_thumb.jpg',
                  type: 'video',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES - APLACADO',
              filter: 'exteriores-aplacado',
              active: true,
            },
            {
              title: 'EXTERIORES - COMPOSITE',
              filter: 'exteriores-composite',
              active: false,
            },
            {
              title: 'PISO PILOTO',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '31 de octubre de 2023',
            categoryBundles: [
              {
                category: 'exteriores-aplacado',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/aires-da-ponte/download/render_exterior_aplacado_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'exteriores-composite',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/aires-da-ponte/download/render_exterior_composite_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/aires-da-ponte/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Simulador Solar',
                src: 'https://solar-simulator.bizionar.digital/culmia/aires-da-ponte/live-aplacado',
                thumb: 'https://media.bizionar.digital/culmia/aires-da-ponte/live-aplacado/cam-01_aplacado.jpg',
                type: 'solar-simulator',
                category: 'exteriores-aplacado',
              },
              {
                name: 'Simulador Solar',
                src: 'https://solar-simulator.bizionar.digital/culmia/aires-da-ponte/live-composite',
                thumb: 'https://media.bizionar.digital/culmia/aires-da-ponte/live-composite/cam-01_composite.jpg',
                type: 'solar-simulator',
                category: 'exteriores-composite',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live-aplacado/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/aires-da-ponte/live-aplacado/cam-01_aplacado.jpg',
                type: 'panoramic',
                category: 'exteriores-aplacado',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live-composite/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/aires-da-ponte/live-composite/cam-01_composite.jpg',
                type: 'panoramic',
                category: 'exteriores-composite',
              },
              {
                name: 'Tour Vistas Reales',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live/tour-vistas/index.html',
                thumb: 'https://media.bizionar.digital/culmia/aires-da-ponte/live-aplacado/cam-01_aplacado.jpg',
                type: 'panoramic',
                category: 'exteriores-aplacado',
              },
              {
                name: 'Tour Vistas Reales',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live/tour-vistas/index.html',
                thumb: 'https://media.bizionar.digital/culmia/aires-da-ponte/live-composite/cam-01_composite.jpg',
                type: 'panoramic',
                category: 'exteriores-composite',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/aires-da-ponte/live/render_exterior_01.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live-aplacado/video_completo_aplacado.mp4',
                thumb: 'https://media.bizionar.digital/culmia/aires-da-ponte/live-aplacado/cam-01_aplacado.jpg',
                type: 'video',
                category: 'exteriores-aplacado',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live-composite/video_completo_composite.mp4',
                thumb: 'https://media.bizionar.digital/culmia/aires-da-ponte/live-composite/cam-01_composite.jpg',
                type: 'video',
                category: 'exteriores-composite',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/aires-da-ponte/live/render_exterior_01.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 01 - Aplacado',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live-aplacado/cam-01_aplacado.jpg',
                type: 'render',
                category: 'exteriores-aplacado',
              },
              {
                name: 'Render Exterior 02 - Aplacado',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live-aplacado/cam-02_aplacado.jpg',
                type: 'render',
                category: 'exteriores-aplacado',
              },
              {
                name: 'Render Exterior 01 - Composite',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live-composite/cam-01_composite.jpg',
                type: 'render',
                category: 'exteriores-composite',
              },
              {
                name: 'Render Exterior 02 - Composite',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live-composite/cam-02_composite.jpg',
                type: 'render',
                category: 'exteriores-composite',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live/render_salon_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live/render_salon_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live/render_salon_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live/render_salon_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live/render_salon_05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live/render_salon_06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live/render_cocina_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live/render_cocina_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live/render_cocina_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Recibidor 01',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live/render_recibidor_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live/render_hab1_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 02',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live/render_hab2_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live/render_hab3_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 02',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live/render_hab4_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live/render_bano2_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 02',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live/render_bano2_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live/render_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live/render_suite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 03',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live/render_suite_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live/render_bano1_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 02',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live/render_bano1_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/aires-da-ponte/live/render_terraza_01.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: '2-colors-mollet',
          name: '2 Colors Mollet',
          city: 'Mollet del Vallès',
          province: 'Barcelona',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/2-colors-mollet',
          reviewStatus: {
            current: 1,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/2-colors-mollet',
          image: 'https://media.bizionar.digital/culmia/2-colors-mollet/live/render_exterior_02.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 1,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '28 de octubre de 2021',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '17 de noviembre de 2021',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'PISO PILOTO',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '28 de enero de 2022',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '14 de febrero de 2022',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '3 de marzo de 2022',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/2-colors-mollet/review01/render/exterior/render_exterior_02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/2-colors-mollet/review01/render/exterior/render_exterior_02.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review01/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review01/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review01/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review01/render/interior/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review01/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review01/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review01/render/interior/render_07_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review01/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review01/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review01/render/interior/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review01/render/interior/render_11_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review01/render/interior/render_12_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review01/render/interior/render_13_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review01/render/interior/render_14_hab2_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review01/render/interior/render_15_hab2_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review01/render/interior/render_16_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review01/render/interior/render_17_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review01/render/interior/render_18_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review01/render/interior/render_19_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review01/render/interior/render_20_banosuite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/2-colors-mollet/review01/render/exterior/render_exterior_02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/2-colors-mollet/review01/render/exterior/render_exterior_02.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review02/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review02/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review02/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review02/render/interior/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review02/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review02/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review02/render/interior/render_07_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review02/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review02/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review02/render/interior/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review02/render/interior/render_11_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review02/render/interior/render_12_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review02/render/interior/render_13_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review02/render/interior/render_14_hab2_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review02/render/interior/render_15_hab2_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review02/render/interior/render_16_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review02/render/interior/render_17_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review02/render/interior/render_18_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review02/render/interior/render_19_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review02/render/interior/render_20_banosuite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/2-colors-mollet/review01/render/exterior/render_exterior_02.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review03/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review03/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review03/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review03/render/interior/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review03/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review03/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review03/render/interior/render_07_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review03/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review03/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review03/render/interior/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review03/render/interior/render_11_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review03/render/interior/render_12_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review03/render/interior/render_13_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review03/render/interior/render_14_hab2_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review03/render/interior/render_15_hab2_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review03/render/interior/render_16_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review03/render/interior/render_17_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review03/render/interior/render_18_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review03/render/interior/render_19_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/2-colors-mollet/review03/render/interior/render_20_banosuite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '3 de marzo de 2022',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: '',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/2-colors-mollet/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/2-colors-mollet/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/2-colors-mollet/live/render_exterior_02.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/2-colors-mollet/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/2-colors-mollet/live/render_exterior_02.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/2-colors-mollet/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/2-colors-mollet/live/render_exterior_02.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/2-colors-mollet/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/2-colors-mollet/live/render_exterior_02.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/2-colors-mollet/live/render_01_salon_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/2-colors-mollet/live/render_02_salon_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/2-colors-mollet/live/render_03_salon_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/2-colors-mollet/live/render_04_salon_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/culmia/2-colors-mollet/live/render_05_salon_05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/culmia/2-colors-mollet/live/render_06_salon_06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 07',
                src: 'https://media.bizionar.digital/culmia/2-colors-mollet/live/render_07_salon_07.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/2-colors-mollet/live/render_08_cocina_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/2-colors-mollet/live/render_09_cocina_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/culmia/2-colors-mollet/live/render_10_cocina_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/2-colors-mollet/live/render_11_banocomun_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/culmia/2-colors-mollet/live/render_12_hab1_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 02',
                src: 'https://media.bizionar.digital/culmia/2-colors-mollet/live/render_13_hab1_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/culmia/2-colors-mollet/live/render_14_hab2_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 02',
                src: 'https://media.bizionar.digital/culmia/2-colors-mollet/live/render_15_hab2_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/culmia/2-colors-mollet/live/render_16_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/culmia/2-colors-mollet/live/render_17_suite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 03',
                src: 'https://media.bizionar.digital/culmia/2-colors-mollet/live/render_18_suite_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/2-colors-mollet/live/render_19_banosuite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 02',
                src: 'https://media.bizionar.digital/culmia/2-colors-mollet/live/render_20_banosuite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'essencia-sarria',
          name: 'Essència Sarrià',
          city: 'Barcelona',
          province: 'Barcelona',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/essencia-sarria',
          reviewStatus: {
            current: 2,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/essencia-sarria',
          image: 'https://media.bizionar.digital/culmia/essencia-sarria/live/render_exterior_01.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 1,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '28 de octubre de 2021',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '14 de diciembre de 2021',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 2,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '3 de marzo de 2022',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '7 de junio de 2022',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '15 de noviembre de 2022',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '26 de enero de 2023',
                  status: 'pending',
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/interior/render_08_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 08',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/interior/render_09_salon_08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 09',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/interior/render_10_salon_09.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 10',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/interior/render_11_salon_10.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 11',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/interior/render_12_salon_11.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/interior/render_13_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/interior/render_15_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/interior/render_16_cocina_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 05',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/interior/render_17_cocina_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 06',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/interior/render_18_cocina_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/interior/render_20_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/interior/render_21_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/interior/render_22_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/interior/render_23_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/interior/render_24_hab02_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/interior/render_25_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/interior/render_26_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/interior/render_27_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 04',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/interior/render_28_suite_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Vestidor 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/interior/render_29_vestidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/interior/render_30_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/interior/render_31_bano_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Cortesía 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/interior/render_32_bano_cortesia_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/interior/render_33_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/render/interior/render_08_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 08',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/render/interior/render_09_salon_08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 09',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/render/interior/render_10_salon_09.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 10',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/render/interior/render_11_salon_10.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 11',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/render/interior/render_12_salon_11.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/render/interior/render_13_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/render/interior/render_15_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/render/interior/render_16_cocina_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 05',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/render/interior/render_17_cocina_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 06',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/render/interior/render_18_cocina_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/render/interior/render_20_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/render/interior/render_21_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/render/interior/render_22_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/render/interior/render_23_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/render/interior/render_24_hab02_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/render/interior/render_25_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/render/interior/render_26_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/render/interior/render_27_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 04',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/render/interior/render_28_suite_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Vestidor 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/render/interior/render_29_vestidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/render/interior/render_30_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/render/interior/render_31_bano_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Cortesía 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/render/interior/render_32_bano_cortesia_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review02/render/interior/render_33_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review03/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review03/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review03/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review03/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review03/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review03/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review03/render/interior/render_08_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 08',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review03/render/interior/render_09_salon_08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 09',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review03/render/interior/render_10_salon_09.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 10',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review03/render/interior/render_11_salon_10.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 11',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review03/render/interior/render_12_salon_11.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review03/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review03/render/interior/render_13_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review03/render/interior/render_15_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review03/render/interior/render_16_cocina_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 05',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review03/render/interior/render_17_cocina_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 06',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review03/render/interior/render_18_cocina_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review03/render/interior/render_20_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review03/render/interior/render_21_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review03/render/interior/render_22_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review03/render/interior/render_23_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review03/render/interior/render_24_hab02_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review03/render/interior/render_25_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review03/render/interior/render_26_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review03/render/interior/render_27_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 04',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review03/render/interior/render_28_suite_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review03/render/interior/render_30_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review03/render/interior/render_31_bano_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Cortesía 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review03/render/interior/render_32_bano_cortesia_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review03/render/interior/render_33_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/essencia-sarria/review01/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review04/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review04/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review04/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review04/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review04/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review04/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review04/render/interior/render_08_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 08',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review04/render/interior/render_09_salon_08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 09',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review04/render/interior/render_10_salon_09.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 10',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review04/render/interior/render_11_salon_10.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 11',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review04/render/interior/render_12_salon_11.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review04/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review04/render/interior/render_13_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review04/render/interior/render_15_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review04/render/interior/render_16_cocina_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 05',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review04/render/interior/render_17_cocina_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 06',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review04/render/interior/render_18_cocina_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review04/render/interior/render_20_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review04/render/interior/render_21_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review04/render/interior/render_22_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review04/render/interior/render_23_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review04/render/interior/render_24_hab02_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review04/render/interior/render_25_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review04/render/interior/render_26_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review04/render/interior/render_27_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 04',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review04/render/interior/render_28_suite_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review04/render/interior/render_30_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review04/render/interior/render_31_bano_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Cortesía 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review04/render/interior/render_32_bano_cortesia_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/essencia-sarria/review04/render/interior/render_33_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '14 de diciembre de 2021',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: '',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: '',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/essencia-sarria/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/essencia-sarria/live/render_exterior_01.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Vistas Reales',
                src: 'https://media.bizionar.digital/culmia/essencia-sarria/live/tour-vistas/index.html',
                thumb: 'https://media.bizionar.digital/culmia/essencia-sarria/live/render_exterior_01.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
            ],
          },
        },
        {
          id: 'nou-vilablareix',
          name: 'Nou Vilablareix',
          city: 'Vilablareix',
          province: 'Girona',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/nou-vilablareix',
          reviewStatus: {
            current: 1,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/nou-vilablareix',
          image: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_exterior_01.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '28 de octubre de 2021',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '14 de diciembre de 2021',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '28 de marzo de 2022',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'PISO PILOTO',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '12 de noviembre de 2021',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '27 de enero de 2022',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '28 de marzo de 2022',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/exterior/orbit_thumb.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/exterior/render_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/exterior/render_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/exterior/render_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03 Night',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/exterior/render_exterior_03_night.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/exterior/render_exterior_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/exterior/render_exterior_05B.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/exterior/render_exterior_06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/exterior/render_exterior_07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/exterior/render_exterior_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/exterior/render_exterior_09B.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/exterior/render_exterior_10B.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/exterior/render_exterior_11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11 Night',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/exterior/render_exterior_11_night.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/exterior/render_exterior_12B.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/exterior/render_exterior_13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/interior/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/interior/render_11_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/interior/render_12_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/interior/render_13_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/interior/render_14_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/interior/render_15_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/interior/render_16_hab2_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/interior/render_17_hab2_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/interior/render_18_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/interior/render_19_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/interior/render_20_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/interior/render_21_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review01/render/interior/render_22_bano_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/exterior/orbit_thumb_v2.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior Completo',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/video/video_exterior.mp4',
                  thumb: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/video/video_exterior_thumb.jpg',
                  type: 'video',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/exterior/render_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/exterior/render_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/exterior/render_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03 Night',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/exterior/render_exterior_03_night.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/exterior/render_exterior_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/exterior/render_exterior_05B.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/exterior/render_exterior_06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/exterior/render_exterior_07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/exterior/render_exterior_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/exterior/render_exterior_09B.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/exterior/render_exterior_10B.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/exterior/render_exterior_11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11 Night',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/exterior/render_exterior_11_night.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/exterior/render_exterior_12B.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/exterior/render_exterior_13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/interior/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/interior/render_11_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/interior/render_12_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/interior/render_13_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/interior/render_14_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/interior/render_15_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/interior/render_16_hab2_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/interior/render_17_hab2_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/interior/render_18_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/interior/render_19_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/interior/render_20_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/interior/render_21_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review02/render/interior/render_22_bano_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/exterior/orbit_thumb_v3.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/exterior/render_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/exterior/render_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/exterior/render_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03 Night',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/exterior/render_exterior_03_night.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/exterior/render_exterior_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/exterior/render_exterior_05B.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/exterior/render_exterior_06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/exterior/render_exterior_07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/exterior/render_exterior_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/exterior/render_exterior_09B.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/exterior/render_exterior_10B.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/exterior/render_exterior_11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11 Night',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/exterior/render_exterior_11_night.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/exterior/render_exterior_12B.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/exterior/render_exterior_13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/interior/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/interior/render_11_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/interior/render_12_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/interior/render_13_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/interior/render_14_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/interior/render_15_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/interior/render_16_hab2_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/interior/render_17_hab2_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/interior/render_18_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/interior/render_19_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/interior/render_20_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/interior/render_21_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/nou-vilablareix/review03/render/interior/render_22_bano_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '28 de marzo de 2022',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/nou-vilablareix/download/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/nou-vilablareix/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_exterior_01.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_exterior_01.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/orbit_thumb_v3.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_exterior_01.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_exterior_01.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_exterior_01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_exterior_02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_exterior_03.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03 Night',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_exterior_03_night.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 04',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_exterior_04.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 05',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_exterior_05B.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 06',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_exterior_06.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 07',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_exterior_07.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 08',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_exterior_08.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 09',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_exterior_09B.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 10',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_exterior_10B.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 11',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_exterior_11.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 11 Night',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_exterior_11_night.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 12',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_exterior_12B.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 13',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_exterior_13.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_02_salon_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_03_salon_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_04_salon_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_05_salon_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_06_salon_05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_07_salon_06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_08_cocina_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_09_cocina_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_10_cocina_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_11_terraza_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 02',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_12_terraza_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Recibidor 01',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_01_recibidor_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_13_bano_comun_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_14_hab1_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 02',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_15_hab1_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_16_hab2_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 02',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_17_hab2_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 01',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_18_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 02',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_19_suite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 03',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_20_suite_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_21_bano_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 02',
                src: 'https://media.bizionar.digital/culmia/nou-vilablareix/live/render_22_bano_suite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'can-batllori',
          name: 'Can Batllori',
          city: 'L´Hospitalet de Llobregat',
          province: 'Barcelona',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/can-batllori',
          reviewStatus: {
            current: 1,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/can-batllori',
          image: 'https://media.bizionar.digital/culmia/can-batllori/live/render_exterior_04.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '24 de diciembre de 2021',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '24 de enero de 2022',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '11 de febrero de 2022',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '3 de febrero de 2022',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '25 de febrero de 2022',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '8 de marzo de 2022',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/exterior/orbit_thumb_v1.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/exterior/render_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/exterior/render_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/exterior/render_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/exterior/render_exterior_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/exterior/render_exterior_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/exterior/render_exterior_06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/exterior/render_exterior_07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/exterior/render_exterior_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/exterior/render_exterior_09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/exterior/render_exterior_10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/exterior/render_exterior_11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/exterior/render_exterior_12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/exterior/render_exterior_13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/exterior/render_exterior_14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/exterior/render_exterior_15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 16',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/exterior/render_exterior_16.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/interior/render_08_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/interior/render_09_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/interior/render_10_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/interior/render_12_cocina_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/interior/render_13_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/interior/render_16_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/interior/render_18_hab_01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/interior/render_19_hab_02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/interior/render_21_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/interior/render_22_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/interior/render_23_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/interior/render_24_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review01/render/interior/render_25_bano_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/exterior/orbit_thumb_v2.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/video/video_exterior.mp4',
                  thumb: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/exterior/render_exterior_03.jpg',
                  type: 'video',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/exterior/render_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/exterior/render_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/exterior/render_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/exterior/render_exterior_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/exterior/render_exterior_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/exterior/render_exterior_06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/exterior/render_exterior_07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/exterior/render_exterior_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/exterior/render_exterior_09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/exterior/render_exterior_10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/exterior/render_exterior_11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/exterior/render_exterior_12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/exterior/render_exterior_13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/exterior/render_exterior_14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/exterior/render_exterior_15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 16',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/exterior/render_exterior_16.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/interior/render_08_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/interior/render_09_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/interior/render_10_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/interior/render_12_cocina_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/interior/render_13_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/interior/render_16_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/interior/render_18_hab_01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/interior/render_19_hab_02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/interior/render_21_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/interior/render_22_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/interior/render_23_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/interior/render_24_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review02/render/interior/render_25_bano_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/exterior/orbit_thumb_v3.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/video/video_exterior.mp4',
                  thumb: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/exterior/render_exterior_03.jpg',
                  type: 'video',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/exterior/render_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/exterior/render_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/exterior/render_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/exterior/render_exterior_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/exterior/render_exterior_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/exterior/render_exterior_06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/exterior/render_exterior_07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/exterior/render_exterior_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/exterior/render_exterior_09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/exterior/render_exterior_10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/exterior/render_exterior_11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/exterior/render_exterior_12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/exterior/render_exterior_13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/exterior/render_exterior_14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/exterior/render_exterior_15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 16',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/exterior/render_exterior_16.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/interior/render_08_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/interior/render_09_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/interior/render_10_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/interior/render_12_cocina_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/interior/render_13_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/interior/render_16_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/interior/render_18_hab_01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/interior/render_19_hab_02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/interior/render_21_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/interior/render_22_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/interior/render_23_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/interior/render_24_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/can-batllori/review03/render/interior/render_25_bano_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '8 de marzo de 2022',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/can-batllori/download/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/can-batllori/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/can-batllori/live/render_exterior_01.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Vistas Reales',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/tour-vistas/index.html',
                thumb: 'https://media.bizionar.digital/culmia/can-batllori/live/render_exterior_01.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/can-batllori/live/render_exterior_01.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/culmia/can-batllori/live/orbit_thumb_v3.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/can-batllori/live/render_exterior_03.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/can-batllori/live/render_exterior_03.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_exterior_01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_exterior_02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_exterior_03.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 04',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_exterior_04.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 05',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_exterior_05.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 06',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_exterior_06.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 07',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_exterior_07.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 08',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_exterior_08.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 09',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_exterior_09.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 10',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_exterior_10.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 11',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_exterior_11.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 12',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_exterior_12.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 13',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_exterior_13.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 14',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_exterior_14.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 15',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_exterior_15.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 16',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_exterior_16.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_02_salon_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_03_salon_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_04_salon_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_05_salon_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_06_salon_05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_07_salon_06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 07',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_08_salon_07.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_09_cocina_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_10_cocina_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 04',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_12_cocina_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_13_terraza_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_16_bano_comun_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_18_hab_01_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_19_hab_02_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_21_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_22_suite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 03',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_23_suite_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_24_bano_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 02',
                src: 'https://media.bizionar.digital/culmia/can-batllori/live/render_25_bano_suite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'azahara-poniente',
          name: 'Azahara Poniente',
          city: 'Córdoba',
          province: 'Córdoba',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/azahara-poniente',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/azahara-poniente',
          image: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/exterior/render_exterior_11.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '24 de diciembre de 2021',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '28 de enero de 2022',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '9 de noviembre de 2022',
                  status: 'pending',
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'PISO PILOTO',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '16 de diciembre de 2021',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '18 de enero de 2022',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '10 de febrero de 2022',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/exterior/orbit_thumb_v1.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/exterior/render_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/exterior/render_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/exterior/render_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/exterior/render_exterior_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/exterior/render_exterior_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/exterior/render_exterior_06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/exterior/render_exterior_07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/exterior/render_exterior_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/exterior/render_exterior_09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/exterior/render_exterior_10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/exterior/render_exterior_11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/exterior/render_exterior_12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/exterior/render_exterior_13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/exterior/render_exterior_14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/exterior/render_exterior_15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/interior/render_07_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/interior/render_08_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/interior/render_09_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/interior/render_10_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/interior/render_11_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/interior/render_12_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/interior/render_13_hab2_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/interior/render_14_hab2_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/interior/render_15_habsuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/interior/render_16_habsuite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/interior/render_17_habsuite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/interior/render_18_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/interior/render_19_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review01/render/interior/render_20_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/exterior/orbit_thumb_v2.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/exterior/render_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/exterior/render_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/exterior/render_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/exterior/render_exterior_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/exterior/render_exterior_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/exterior/render_exterior_06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/exterior/render_exterior_07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/exterior/render_exterior_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/exterior/render_exterior_09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/exterior/render_exterior_10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/exterior/render_exterior_11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/exterior/render_exterior_12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/exterior/render_exterior_13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/exterior/render_exterior_14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Video Interior',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/video/video_interior.mp4',
                  thumb: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/video/video_interior_thumb.jpg',
                  type: 'video',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/interior/render_21_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/interior/render_07_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/interior/render_08_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/interior/render_09_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/interior/render_10_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/interior/render_11_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/interior/render_12_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/interior/render_13_hab2_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/interior/render_14_hab2_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/interior/render_15_habsuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/interior/render_16_habsuite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/interior/render_17_habsuite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/interior/render_18_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/interior/render_19_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/interior/render_20_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/exterior/orbit_thumb_v2.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/azahara-poniente/review02/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Video Completo',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/video/video_completo.mp4',
                  thumb: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/exterior/render_exterior_05.jpg',
                  type: 'video',
                  category: 'exteriores',
                },
                {
                  name: 'Video Completo',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/video/video_completo.mp4',
                  thumb: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/exterior/render_exterior_05.jpg',
                  type: 'video',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/exterior/render_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/exterior/render_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/exterior/render_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/exterior/render_exterior_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/exterior/render_exterior_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/exterior/render_exterior_06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/exterior/render_exterior_07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/exterior/render_exterior_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/exterior/render_exterior_09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/exterior/render_exterior_10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/exterior/render_exterior_11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/exterior/render_exterior_12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/exterior/render_exterior_13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/exterior/render_exterior_14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/interior/render_21_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/interior/render_07_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/interior/render_08_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/interior/render_09_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/interior/render_10_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/interior/render_11_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/interior/render_12_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/interior/render_13_hab2_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/interior/render_14_hab2_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/interior/render_15_habsuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/interior/render_16_habsuite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/interior/render_17_habsuite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/interior/render_18_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/interior/render_19_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/azahara-poniente/review03/render/interior/render_20_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '28 de enero de 2022',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/azahara-poniente/download/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/azahara-poniente/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_exterior_01.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_exterior_01.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_exterior_01.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_exterior_01.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_exterior_01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_exterior_02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_exterior_03.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 04',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_exterior_04.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 05',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_exterior_05.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 06',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_exterior_06.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 07',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_exterior_07.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 08',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_exterior_08.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 09',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_exterior_09.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 10',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_exterior_10.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 11',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_exterior_11.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 12',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_exterior_12.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 13',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_exterior_13.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 14',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_exterior_14.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_02_salon_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_03_salon_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_04_salon_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_05_salon_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_06_salon_05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_21_salon_06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Recibidor 01',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_01_recibidor_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_07_cocina_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_08_cocina_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_09_cocina_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_10_bano_comun_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_11_hab1_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 02',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_12_hab1_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_13_hab2_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 02',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_14_hab2_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_15_habsuite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_16_habsuite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 03',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_17_habsuite_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_18_bano_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_19_terraza_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 02',
                src: 'https://media.bizionar.digital/culmia/azahara-poniente/live/render_20_terraza_02.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'talassa-badalona',
          name: 'Talassa Badalona',
          city: 'Badalona',
          province: 'Barcelona',
          liveEnabled: true,
          showEnabled: false,
          reviewStatus: {
            current: 1,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/talassa-badalona',
          image: 'https://media.bizionar.digital/culmia/talassa-badalona/live/render_exterior_02.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '19 de noviembre de 2021',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '15 de diciembre de 2021',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '9 de febrero de 2022',
                  isFinal: true,
                  isLive: true,
                  status: 'closed',
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'PISO PILOTO',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '19 de noviembre de 2021',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '15 de diciembre de 2021',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '9 de febrero de 2022',
                  isFinal: true,
                  isLive: true,
                  status: 'closed',
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/talassa-badalona/review01/render/exterior/render_exterior_05.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/talassa-badalona/review01/render/exterior/render_exterior_05.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review01/render/exterior/render_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review01/render/exterior/render_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review01/render/exterior/render_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review01/render/exterior/render_exterior_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review01/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review01/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review01/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review01/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review01/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review01/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review01/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review01/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review01/render/interior/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review01/render/interior/render_11_bañocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review01/render/interior/render_12_hab2_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review01/render/interior/render_13_hab2_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review01/render/interior/render_14_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review01/render/interior/render_15_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review01/render/interior/render_16_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review01/render/interior/render_17_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review01/render/interior/render_18_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review01/render/interior/render_19_bañosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 04',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review01/render/interior/render_20_terraza_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review01/render/interior/render_21_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review01/render/interior/render_22_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review01/render/interior/render_23_terraza_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/talassa-badalona/review02/render/exterior/render_exterior_05.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/talassa-badalona/review02/render/exterior/render_exterior_05.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Video Interior',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review02/video/video_interior.mp4',
                  thumb: 'https://media.bizionar.digital/culmia/talassa-badalona/review02/video/video_interior_thumb.jpg',
                  type: 'video',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review02/render/exterior/render_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review02/render/exterior/render_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review02/render/exterior/render_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review02/render/exterior/render_exterior_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review02/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review02/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review02/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review02/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review02/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review02/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review02/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review02/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review02/render/interior/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review02/render/interior/render_11_bañocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review02/render/interior/render_12_hab2_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review02/render/interior/render_13_hab2_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review02/render/interior/render_14_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review02/render/interior/render_15_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review02/render/interior/render_16_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review02/render/interior/render_17_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review02/render/interior/render_18_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review02/render/interior/render_19_bañosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 04',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review02/render/interior/render_20_terraza_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review02/render/interior/render_21_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review02/render/interior/render_22_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review02/render/interior/render_23_terraza_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/talassa-badalona/review03/render/exterior/render_exterior_05.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/talassa-badalona/review03/render/exterior/render_exterior_05.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Video Interior',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review03/video/video_interior.mp4',
                  thumb: 'https://media.bizionar.digital/culmia/talassa-badalona/review03/render/interior/render_05_salon_04.jpg',
                  type: 'video',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review03/render/exterior/render_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review03/render/exterior/render_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review03/render/exterior/render_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review03/render/exterior/render_exterior_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review03/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review03/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review03/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review03/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review03/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review03/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review03/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review03/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review03/render/interior/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review03/render/interior/render_11_bañocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review03/render/interior/render_12_hab2_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review03/render/interior/render_13_hab2_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review03/render/interior/render_14_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review03/render/interior/render_15_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review03/render/interior/render_16_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review03/render/interior/render_17_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review03/render/interior/render_18_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review03/render/interior/render_19_bañosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 04',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review03/render/interior/render_20_terraza_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review03/render/interior/render_21_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review03/render/interior/render_22_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/culmia/talassa-badalona/review03/render/interior/render_23_terraza_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '9 de febrero de 2022',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/talassa-badalona/download/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/talassa-badalona/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/talassa-badalona/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/talassa-badalona/live/render_exterior_02.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/talassa-badalona/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/talassa-badalona/live/render_exterior_02.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/talassa-badalona/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/talassa-badalona/live/render_exterior_01.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/talassa-badalona/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/talassa-badalona/live/render_exterior_01.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/culmia/talassa-badalona/live/render_exterior_02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/culmia/talassa-badalona/live/render_exterior_01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/culmia/talassa-badalona/live/render_exterior_03.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 05',
                src: 'https://media.bizionar.digital/culmia/talassa-badalona/live/render_exterior_05.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Recibidor 01',
                src: 'https://media.bizionar.digital/culmia/talassa-badalona/live/render_01_recibidor_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/talassa-badalona/live/render_02_salon_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/talassa-badalona/live/render_03_salon_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/talassa-badalona/live/render_04_salon_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/talassa-badalona/live/render_05_salon_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/culmia/talassa-badalona/live/render_07_salon_06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/talassa-badalona/live/render_08_cocina_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/talassa-badalona/live/render_09_cocina_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/culmia/talassa-badalona/live/render_10_cocina_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/talassa-badalona/live/render_11_bañocomun_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/culmia/talassa-badalona/live/render_12_hab2_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 02',
                src: 'https://media.bizionar.digital/culmia/talassa-badalona/live/render_13_hab2_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/culmia/talassa-badalona/live/render_14_hab1_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 02',
                src: 'https://media.bizionar.digital/culmia/talassa-badalona/live/render_15_hab1_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/culmia/talassa-badalona/live/render_16_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/culmia/talassa-badalona/live/render_17_suite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 03',
                src: 'https://media.bizionar.digital/culmia/talassa-badalona/live/render_18_suite_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/talassa-badalona/live/render_19_bañosuite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 04',
                src: 'https://media.bizionar.digital/culmia/talassa-badalona/live/render_20_terraza_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/talassa-badalona/live/render_21_terraza_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 02',
                src: 'https://media.bizionar.digital/culmia/talassa-badalona/live/render_22_terraza_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 03',
                src: 'https://media.bizionar.digital/culmia/talassa-badalona/live/render_23_terraza_03.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'el-forti-de-denia',
          name: 'El Fortí de Denia',
          city: 'Denia',
          province: 'Alicante',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/el-forti-de-denia',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/el-forti-de-denia',
          image: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/render_exterior_01.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 1,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '31 de diciembre de 2021',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'PISO PILOTO 1',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '4 de febrero de 2022',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '24 de marzo de 2022',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '29 de abril de 2022',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores-piso2',
              categoryName: 'PISO PILOTO 2',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '6 de noviembre de 2023',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '18 de desembre de 2023',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '23 de enero de 2024',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior/render_11_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior/render_12_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior/render_13_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior/render_14_hab2_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior/render_15_hab2_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior/render_16_habsuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior/render_17_habsuite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior/render_18_habsuite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior/render_19_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior/render_20_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior/render_21_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior-piso2/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior-piso2/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior-piso2/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior-piso2/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior-piso2/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior-piso2/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior-piso2/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior-piso2/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior-piso2/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior-piso2/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior-piso2/render_11_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior-piso2/render_12_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior-piso2/render_13_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior-piso2/render_14_suite_01.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior-piso2/render_15_suite_02.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior-piso2/render_16_suite_03.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior-piso2/render_17_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior-piso2/render_18_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior-piso2/render_19_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/interior-piso2/render_20_terraza_03.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review05/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior/render_11_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior/render_12_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior/render_13_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior/render_14_hab2_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior/render_15_hab2_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior/render_16_habsuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior/render_17_habsuite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior/render_18_habsuite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior/render_19_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior/render_20_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior/render_21_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior-piso2/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior-piso2/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior-piso2/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior-piso2/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior-piso2/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior-piso2/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior-piso2/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior-piso2/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior-piso2/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior-piso2/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior-piso2/render_11_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior-piso2/render_12_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior-piso2/render_13_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior-piso2/render_14_suite_01.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior-piso2/render_15_suite_02.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior-piso2/render_16_suite_03.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior-piso2/render_17_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior-piso2/render_18_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior-piso2/render_19_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior-piso2/render_20_terraza_03.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Terraza 04',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior-piso2/render_21_terraza_04.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Terraza 05',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review02/render/interior-piso2/render_22_terraza_05.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review01/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review06/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior/render_11_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior/render_12_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior/render_13_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior/render_14_hab2_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior/render_15_hab2_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior/render_16_habsuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior/render_17_habsuite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior/render_18_habsuite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior/render_19_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior/render_20_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior/render_21_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior-piso2/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior-piso2/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior-piso2/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior-piso2/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior-piso2/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior-piso2/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior-piso2/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior-piso2/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior-piso2/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior-piso2/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior-piso2/render_11_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior-piso2/render_12_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior-piso2/render_13_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior-piso2/render_14_suite_01.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior-piso2/render_15_suite_02.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior-piso2/render_16_suite_03.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior-piso2/render_17_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior-piso2/render_18_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior-piso2/render_19_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior-piso2/render_20_terraza_03.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Terraza 04',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior-piso2/render_21_terraza_04.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Terraza 05',
                  src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/review03/render/interior-piso2/render_22_terraza_05.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
            {
              title: 'INTERIORES - PISO 2',
              filter: 'interiores-piso2',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '15 de febrero de 2024',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/el-forti-de-denia/download/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/el-forti-de-denia/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores-piso2',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/el-forti-de-denia/download/piso2/render_interior_piso2_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/render_exterior_01.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/render_exterior_01.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Tour Vistas Reales',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/tour-vistas/index.html',
                thumb: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/render_exterior_01.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/render_exterior_01.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/render_exterior_01.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/render_exterior_01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/render_exterior_02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/render_02_salon_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/render_03_salon_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/render_04_salon_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/render_05_salon_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/render_06_salon_05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/render_07_salon_06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Recibidor 01',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/render_01_recibidor_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/render_08_cocina_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/render_09_cocina_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/render_10_cocina_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/render_11_bano_comun_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/render_12_hab1_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 02',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/render_13_hab1_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/render_14_hab2_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 02',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/render_15_hab2_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 01',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/render_16_habsuite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 02',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/render_17_habsuite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 03',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/render_18_habsuite_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/render_19_bano_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/render_20_terraza_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 02',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/render_21_terraza_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/piso2/render_02_salon_01.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/piso2/render_03_salon_02.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/piso2/render_04_salon_03.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/piso2/render_05_salon_04.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/piso2/render_06_salon_05.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/piso2/render_07_salon_06.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Recibidor 01',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/piso2/render_01_recibidor_01.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/piso2/render_08_cocina_01.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/piso2/render_09_cocina_02.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/piso2/render_10_cocina_03.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Servicio Común 01',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/piso2/render_11_bano_comun_01.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/piso2/render_12_hab1_01.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Habitación 1 - 02',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/piso2/render_13_hab1_02.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Suite 01',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/piso2/render_14_suite_01.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Suite 02',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/piso2/render_15_suite_02.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Suite 03',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/piso2/render_16_suite_03.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Servicio Suite 01',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/piso2/render_17_bano_suite_01.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/piso2/render_18_terraza_01.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Terraza 02',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/piso2/render_19_terraza_02.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Terraza 03',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/piso2/render_20_terraza_03.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Terraza 04',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/piso2/render_21_terraza_04.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Terraza 05',
                src: 'https://media.bizionar.digital/culmia/el-forti-de-denia/live/piso2/render_22_terraza_05.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
            ],
          },
        },
        {
          id: 'augusta-volpelleres',
          name: 'Augusta Volpelleres',
          city: 'Sant Cugat del Vallès',
          province: 'Barcelona',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/augusta-volpelleres',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/augusta-volpelleres',
          image: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_exterior_01_b.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '14 de enero de 2022',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '16 de marzo de 2022',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '29 de marzo de 2022',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '10 de febrero de 2022',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '16 de marzo de 2022',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '29 de marzo de 2023',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/exterior/orbit_thumb_v1.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/exterior/render_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01 Night',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/exterior/render_exterior_01_b.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/exterior/render_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/exterior/render_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/exterior/render_exterior_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/exterior/render_exterior_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/exterior/render_exterior_06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/exterior/render_exterior_07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/exterior/render_exterior_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/exterior/render_exterior_09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/exterior/render_exterior_10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/exterior/render_exterior_11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/exterior/render_exterior_12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/exterior/render_exterior_13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/exterior/render_exterior_14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/exterior/render_exterior_15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/interior/render_08_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/interior/render_11_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/interior/render_12_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/interior/render_13_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/interior/render_14_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/interior/render_15_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/interior/render_16_hab_01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/interior/render_17_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/interior/render_18_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/interior/render_19_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/interior/render_20_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review01/render/interior/render_21_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review02/render/exterior/orbit_thumb_v3.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01 Night',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_01_b.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review02/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review02/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review02/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review02/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review02/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review02/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review02/render/interior/render_08_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review02/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review02/render/interior/render_11_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review02/render/interior/render_12_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review02/render/interior/render_13_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review02/render/interior/render_14_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review02/render/interior/render_15_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review02/render/interior/render_16_hab_01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review02/render/interior/render_17_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review02/render/interior/render_18_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review02/render/interior/render_19_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review02/render/interior/render_20_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review02/render/interior/render_21_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/orbit_thumb_v3.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01 Night',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_01_b.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/exterior/render_exterior_15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/interior/render_08_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/interior/render_11_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/interior/render_12_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/interior/render_13_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/interior/render_14_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/interior/render_15_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/interior/render_16_hab_01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/interior/render_17_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/interior/render_18_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/interior/render_19_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/interior/render_20_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/review03/render/interior/render_21_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'PISO PILOTO',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '18 de mayo de 2023',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/augusta-volpelleres/download/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/augusta-volpelleres/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/orbit_thumb_v3.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_exterior_01.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_exterior_01.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_exterior_01.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_exterior_01.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_exterior_01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 01 Night',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_exterior_01_b.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_exterior_02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_exterior_03.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 04',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_exterior_04.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 05',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_exterior_05.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 06',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_exterior_06.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 07',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_exterior_07.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 08',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_exterior_08.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 09',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_exterior_09.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 10',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_exterior_10.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 11',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_exterior_11.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 12',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_exterior_12.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 13',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_exterior_13.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 14',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_exterior_14.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 15',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_exterior_15.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_02_salon_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_03_salon_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_04_salon_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_05_salon_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_06_salon_05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_07_salon_06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 07',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_08_salon_07.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Recibidor 01',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_01_recibidor_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_11_cocina_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_12_cocina_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_13_cocina_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_14_terraza_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_15_bano_comun_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_16_hab_01_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_17_hab02_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 01',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_18_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 02',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_19_suite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 03',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_20_suite_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/augusta-volpelleres/live/render_21_bano_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'parc-textil',
          name: 'Parc Tèxtil',
          city: 'Sabadell',
          province: 'Barcelona',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/parc-textil',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/parc-textil',
          image: 'https://media.bizionar.digital/culmia/parc-textil/live/cam_exterior_02.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 1,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '1 de abril de 2022',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '22 de abril de 2022',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 10,
              totalReviews: 10,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '11 de febrero de 2022',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '8 de marzo de 2022',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '28 de marzo de 2022',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '31 de mayo de 2023',
                  status: 'closed',
                },
                {
                  id: 'review05',
                  name: 'ENTREGA 5',
                  date: '16 de junio de 2023',
                  status: 'closed',
                },
                {
                  id: 'review06',
                  name: 'ENTREGA 6',
                  date: '4 de julio de 2023',
                  status: 'closed',
                },
                {
                  id: 'review07',
                  name: 'ENTREGA 7',
                  date: '25 de julio de 2023',
                  status: 'closed',
                },
                {
                  id: 'review08',
                  name: 'ENTREGA 8',
                  date: '18 de septiembre de 2023',
                  status: 'closed',
                },
                {
                  id: 'review09',
                  name: 'ENTREGA 9',
                  date: '4 de octubre de 2023',
                  status: 'closed',
                },
                {
                  id: 'review10',
                  name: 'ENTREGA 10',
                  date: '20 de octubre de 2023',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                }
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/exterior/orbit_thumb_v1.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/exterior/cam_exterior_02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/exterior/cam_exterior_02.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/exterior/cam_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02 Night',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/exterior/cam_exterior_02_night.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/exterior/cam_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03 Night',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/exterior/cam_exterior_03_night.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/exterior/cam_exterior_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04 Night',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/exterior/cam_exterior_04_night.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/exterior/cam_exterior_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/exterior/cam_exterior_06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/exterior/cam_exterior_07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/exterior/cam_exterior_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/exterior/cam_exterior_10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/exterior/cam_exterior_11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/exterior/cam_exterior_14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/exterior/cam_exterior_15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/exterior/cam_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/interior/render_01_recibidor_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/interior/render_07_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/interior/render_08_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/interior/render_09_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/interior/render_10_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/interior/render_11_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/interior/render_12_hab01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/interior/render_13_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/interior/render_14_hab02_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/interior/render_15_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/interior/render_16_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/interior/render_17_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/interior/render_18_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/interior/render_19_bano_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/interior/render_20_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/interior/render_21_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review01/render/interior/render_22_terraza_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/exterior/orbit_thumb_v2.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/exterior/cam_exterior_02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/interior/render_02_salon_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/exterior/cam_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02 Night',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/exterior/cam_exterior_02_night.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/exterior/cam_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03 Night',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/exterior/cam_exterior_03_night.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/exterior/cam_exterior_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04 Night',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/exterior/cam_exterior_04_night.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/exterior/cam_exterior_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/exterior/cam_exterior_06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/exterior/cam_exterior_07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/exterior/cam_exterior_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/exterior/cam_exterior_10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/exterior/cam_exterior_11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/exterior/cam_exterior_14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/exterior/cam_exterior_15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/exterior/cam_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/interior/render_01_recibidor_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/interior/render_07_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/interior/render_08_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/interior/render_09_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/interior/render_10_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/interior/render_11_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/interior/render_12_hab01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/interior/render_13_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/interior/render_14_hab02_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/interior/render_15_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/interior/render_16_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/interior/render_17_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/interior/render_18_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/interior/render_19_bano_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/interior/render_20_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/interior/render_21_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review02/render/interior/render_22_terraza_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/parc-textil/review03/render/interior/render_02_salon_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review03/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review03/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review03/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review03/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review03/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review03/render/interior/render_01_recibidor_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review03/render/interior/render_07_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review03/render/interior/render_08_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review03/render/interior/render_09_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review03/render/interior/render_10_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review03/render/interior/render_11_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review03/render/interior/render_12_hab01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review03/render/interior/render_13_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review03/render/interior/render_14_hab02_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review03/render/interior/render_15_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review03/render/interior/render_16_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review03/render/interior/render_17_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review03/render/interior/render_18_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review03/render/interior/render_19_bano_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review03/render/interior/render_20_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review03/render/interior/render_21_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review03/render/interior/render_22_terraza_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/parc-textil/review04/render/interior/render_02_salon_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Video Completo',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review04/video/video_completo.mp4',
                  thumb: 'https://media.bizionar.digital/culmia/parc-textil/live/cam_exterior_02.jpg',
                  type: 'video',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review04/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review04/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review04/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review04/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review04/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review04/render/interior/render_01_recibidor_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review04/render/interior/render_07_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review04/render/interior/render_08_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review04/render/interior/render_09_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review04/render/interior/render_10_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review04/render/interior/render_11_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review04/render/interior/render_12_hab01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review04/render/interior/render_13_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review04/render/interior/render_14_hab02_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review04/render/interior/render_15_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review04/render/interior/render_16_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review04/render/interior/render_17_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review04/render/interior/render_18_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review04/render/interior/render_19_bano_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review04/render/interior/render_20_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review04/render/interior/render_21_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review04/render/interior/render_22_terraza_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review05',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review05/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/parc-textil/review05/render/interior/render_02_salon_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review05/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review05/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review05/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review05/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review05/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review05/render/interior/render_01_recibidor_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review05/render/interior/render_07_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review05/render/interior/render_08_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review05/render/interior/render_09_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review05/render/interior/render_10_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review05/render/interior/render_11_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review05/render/interior/render_12_hab01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review05/render/interior/render_13_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review05/render/interior/render_14_hab02_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review05/render/interior/render_15_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review05/render/interior/render_16_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review05/render/interior/render_17_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review05/render/interior/render_18_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review05/render/interior/render_19_bano_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review05/render/interior/render_20_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review05/render/interior/render_21_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review05/render/interior/render_22_terraza_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review06',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review06/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/parc-textil/review06/render/interior/render_02_salon_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review06/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review06/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review06/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review06/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review06/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review06/render/interior/render_01_recibidor_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review06/render/interior/render_07_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review06/render/interior/render_08_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review06/render/interior/render_09_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review06/render/interior/render_10_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review06/render/interior/render_11_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review06/render/interior/render_12_hab01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review06/render/interior/render_13_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review06/render/interior/render_14_hab02_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review06/render/interior/render_15_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review06/render/interior/render_16_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review06/render/interior/render_17_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review06/render/interior/render_18_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review06/render/interior/render_19_bano_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review06/render/interior/render_20_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review06/render/interior/render_21_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review06/render/interior/render_22_terraza_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review07',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review07/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/parc-textil/review07/render/interior/render_02_salon_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review07/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review07/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review07/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review07/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review07/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review07/render/interior/render_01_recibidor_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review07/render/interior/render_07_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review07/render/interior/render_08_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review07/render/interior/render_09_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review07/render/interior/render_10_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review07/render/interior/render_11_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review07/render/interior/render_12_hab01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review07/render/interior/render_13_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review07/render/interior/render_14_hab02_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review07/render/interior/render_15_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review07/render/interior/render_16_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review07/render/interior/render_17_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review07/render/interior/render_18_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review07/render/interior/render_19_bano_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review07/render/interior/render_20_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review07/render/interior/render_21_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review07/render/interior/render_22_terraza_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review08',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review08/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/parc-textil/review08/render/interior/render_02_salon_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review08/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review08/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review08/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review08/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review08/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review08/render/interior/render_01_recibidor_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review08/render/interior/render_07_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review08/render/interior/render_08_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review08/render/interior/render_09_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review08/render/interior/render_10_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review08/render/interior/render_11_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review08/render/interior/render_12_hab01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review08/render/interior/render_13_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review08/render/interior/render_14_hab02_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review08/render/interior/render_15_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review08/render/interior/render_16_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review08/render/interior/render_17_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review08/render/interior/render_18_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review08/render/interior/render_19_bano_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review08/render/interior/render_20_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review08/render/interior/render_21_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review08/render/interior/render_22_terraza_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review09',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review09/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/parc-textil/review09/render/interior/render_02_salon_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review09/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review09/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review09/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review09/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review09/render/interior/render_01_recibidor_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review09/render/interior/render_07_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review09/render/interior/render_08_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review09/render/interior/render_09_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review09/render/interior/render_10_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review09/render/interior/render_11_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review09/render/interior/render_12_hab01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review09/render/interior/render_13_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review09/render/interior/render_14_hab02_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review09/render/interior/render_15_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review09/render/interior/render_16_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review09/render/interior/render_17_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review09/render/interior/render_18_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review09/render/interior/render_19_bano_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review09/render/interior/render_20_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review09/render/interior/render_21_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review09/render/interior/render_22_terraza_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review10',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review10/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/parc-textil/review10/render/interior/render_02_salon_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review10/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review10/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review10/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review10/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review10/render/interior/render_01_recibidor_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review10/render/interior/render_07_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review10/render/interior/render_08_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review10/render/interior/render_09_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review10/render/interior/render_10_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review10/render/interior/render_11_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review10/render/interior/render_12_hab01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review10/render/interior/render_13_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review10/render/interior/render_14_hab02_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review10/render/interior/render_15_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review10/render/interior/render_16_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review10/render/interior/render_17_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review10/render/interior/render_18_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review10/render/interior/render_19_bano_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review10/render/interior/render_20_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review10/render/interior/render_21_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/culmia/parc-textil/review10/render/interior/render_22_terraza_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'PISO PILOTO',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '22 de abril de 2022',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/parc-textil/download/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/parc-textil/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/culmia/parc-textil/live/orbit_thumb_v2.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/parc-textil/live/cam_exterior_02.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Vistas Reales',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/tour-vistas/index.html',
                thumb: 'https://media.bizionar.digital/culmia/parc-textil/live/cam_exterior_02.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/parc-textil/live/cam_exterior_02.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/parc-textil/live/cam_exterior_02.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/parc-textil/live/cam_exterior_02.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/cam_exterior_02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02 Night',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/cam_exterior_02_night.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/cam_exterior_03.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03 Night',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/cam_exterior_03_night.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 04',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/cam_exterior_04.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 04 Night',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/cam_exterior_04_night.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 05',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/cam_exterior_05.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 06',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/cam_exterior_06.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 07',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/cam_exterior_07.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 08',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/cam_exterior_08.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 10',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/cam_exterior_10.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 11',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/cam_exterior_11.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 14',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/cam_exterior_14.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 15',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/cam_exterior_15.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/cam_exterior_01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/render_03_salon_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/render_02_salon_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/render_05_salon_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/render_06_salon_05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Recibidor 01',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/render_01_recibidor_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/render_07_cocina_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/render_08_cocina_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/render_09_cocina_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/render_10_banocomun_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/render_11_hab01_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 02',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/render_12_hab01_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/render_13_hab02_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 02',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/render_14_hab02_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 01',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/render_15_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 02',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/render_16_suite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 03',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/render_17_suite_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/render_18_banosuite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 02',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/render_19_bano_suite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/render_20_terraza_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 02',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/render_21_terraza_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 03',
                src: 'https://media.bizionar.digital/culmia/parc-textil/live/render_22_terraza_03.jpg',
                type: 'render',
                category: 'interiores',
              },

            ],
          },
        },
        {
          id: 'maestral-rocafort',
          name: 'Maestral Rocafort',
          city: 'Rocafort',
          province: 'Valencia',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/maestral-rocafort',
          reviewStatus: {
            current: 1,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/maestral-rocafort',
          image: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_exterior_08.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '14 de febrero de 2022',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '21 de marzo de 2022',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '5 de mayo de 2022',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '21 de marzo de 2022',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '5 de mayo de 2022',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '13 de mayo de 2022',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/render/exterior/render_exterior_02.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review01/render/exterior/render_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review01/render/exterior/render_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review01/render/exterior/render_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review01/render/exterior/render_exterior_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review01/render/exterior/render_exterior_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review01/render/exterior/render_exterior_06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review01/render/exterior/render_exterior_07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review01/render/exterior/render_exterior_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review01/render/interior/render_04_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review01/render/interior/render_05_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review01/render/interior/render_06_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review01/render/interior/render_07_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review01/render/interior/render_08_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review01/render/interior/render_09_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review01/render/interior/render_10_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review01/render/interior/render_11_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review01/render/interior/render_12_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review01/render/interior/render_12_cocina_03B.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review01/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Aseo 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review01/render/interior/render_02_Aseo_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Estudio 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review01/render/interior/render_03_estudio_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 01 - 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review01/render/interior/render_13_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 02 - 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review01/render/interior/render_14_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review01/render/interior/render_15_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review01/render/interior/render_17_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review01/render/interior/render_18_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review01/render/interior/render_19_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 04',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review01/render/interior/render_20_suite_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review01/render/interior/render_16_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review01/render/interior/render_21_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review01/render/interior/render_22_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/exterior/render_exterior_02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/exterior/render_exterior_02.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/render/exterior/render_exterior_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/render/exterior/render_exterior_07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/render/exterior/render_exterior_06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/render/exterior/render_exterior_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/render/exterior/render_exterior_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/render/exterior/render_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/render/exterior/render_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/render/exterior/render_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/render/interior/render_04_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/render/interior/render_05_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/render/interior/render_06_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/render/interior/render_07_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/render/interior/render_08_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/render/interior/render_09_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/render/interior/render_10_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/render/interior/render_11_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/render/interior/render_12_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/render/interior/render_12_cocina_03B.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Aseo 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/render/interior/render_02_Aseo_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Estudio 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/render/interior/render_03_estudio_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 01 - 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/render/interior/render_13_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 02 - 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/render/interior/render_14_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/render/interior/render_15_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/render/interior/render_17_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/render/interior/render_18_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/render/interior/render_19_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 04',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/render/interior/render_20_suite_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/render/interior/render_16_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/render/interior/render_21_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review02/render/interior/render_22_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/exterior/render_exterior_02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/exterior/render_exterior_02.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/exterior/render_exterior_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/exterior/render_exterior_07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/exterior/render_exterior_06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/exterior/render_exterior_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/exterior/render_exterior_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/exterior/render_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/exterior/render_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/exterior/render_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/interior/render_04_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/interior/render_05_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/interior/render_06_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/interior/render_07_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/interior/render_08_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/interior/render_09_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/interior/render_10_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/interior/render_11_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/interior/render_12_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/interior/render_12_cocina_03B.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Aseo 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/interior/render_02_Aseo_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Estudio 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/interior/render_03_estudio_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 01 - 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/interior/render_13_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 02 - 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/interior/render_14_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/interior/render_15_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/interior/render_17_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/interior/render_18_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/interior/render_19_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 04',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/interior/render_20_suite_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/interior/render_16_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/interior/render_21_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/maestral-rocafort/review03/render/interior/render_22_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ]
            }
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'PISO PILOTO',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '13 de mayo de 2022',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/maestral-rocafort/download/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/maestral-rocafort/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_exterior_02.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_exterior_02.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_exterior_08.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_exterior_08.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 08',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_exterior_08.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 07',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_exterior_07.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 06',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_exterior_06.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 05',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_exterior_05.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 04',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_exterior_04.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_exterior_03.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_exterior_02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_exterior_01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_04_salon_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_05_salon_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_06_salon_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_07_salon_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_08_salon_05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_09_salon_06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_10_cocina_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_11_cocina_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_12_cocina_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 04',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_12_cocina_03B.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Recibidor 01',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_01_recibidor_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Aseo 01',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_02_Aseo_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Estudio 01',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_03_estudio_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 01 - 01',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_13_hab01_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 02 - 01',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_14_hab02_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_15_banocomun_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_17_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_18_suite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 03',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_19_suite_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 04',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_20_suite_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_16_banosuite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_21_terraza_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 02',
                src: 'https://media.bizionar.digital/culmia/maestral-rocafort/live/render_22_terraza_02.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'insider',
          name: 'Insider',
          city: 'Sant Cugat del Vallès',
          province: 'Barcelona',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/insider',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/insider',
          image: 'https://media.bizionar.digital/culmia/insider/live/render_exterior_07.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '24 de marzo de 2022',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '7 de abril de 2022',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '21 de julio de 2022',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '13 de abril de 2022',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '13 de mayo de 2022',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '30 de mayo de 2022',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/insider/review01/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/insider/review02/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/insider/review01/render/exterior/orbit_thumb_v2.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/exterior/render_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/exterior/render_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/exterior/render_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/exterior/render_exterior_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/exterior/render_exterior_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/exterior/render_exterior_06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06 Night',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/exterior/render_exterior_06B.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/exterior/render_exterior_07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/exterior/render_exterior_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/exterior/render_exterior_09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/exterior/render_exterior_10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/exterior/render_exterior_11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/exterior/render_exterior_12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/exterior/render_exterior_13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/exterior/render_exterior_14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/exterior/render_exterior_15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/interior/render_08_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/interior/render_09_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/interior/render_11_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/interior/render_12_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/interior/render_13_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/interior/render_14_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/interior/render_15_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/interior/render_16_hab_01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/interior/render_17_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/interior/render_18_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/interior/render_19_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/interior/render_20_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/insider/review01/render/interior/render_21_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/insider/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/insider/review02/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/insider/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/insider/review02/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/insider/review02/render/exterior/orbit_thumb_v3.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/exterior/render_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/exterior/render_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/exterior/render_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/exterior/render_exterior_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/exterior/render_exterior_06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06 Night',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/exterior/render_exterior_06B.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/exterior/render_exterior_07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/exterior/render_exterior_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/exterior/render_exterior_09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/exterior/render_exterior_10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/exterior/render_exterior_11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/exterior/render_exterior_12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/exterior/render_exterior_13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/exterior/render_exterior_14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/exterior/render_exterior_15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/interior/render_08_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/interior/render_09_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/interior/render_11_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/interior/render_12_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/interior/render_13_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/interior/render_14_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/interior/render_15_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/interior/render_16_hab_01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/interior/render_17_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/interior/render_18_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/interior/render_19_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/interior/render_20_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/insider/review02/render/interior/render_21_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/insider/review03/render/exterior/orbit_thumb_v4.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/insider/review03/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/exterior/render_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/exterior/render_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/exterior/render_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/exterior/render_exterior_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/exterior/render_exterior_06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06 Night',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/exterior/render_exterior_06B.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/exterior/render_exterior_07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/exterior/render_exterior_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/exterior/render_exterior_09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/exterior/render_exterior_10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/exterior/render_exterior_11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/exterior/render_exterior_12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/exterior/render_exterior_13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/exterior/render_exterior_14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/exterior/render_exterior_15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/insider/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/insider/review02/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/interior/render_08_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/interior/render_09_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/interior/render_11_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/interior/render_12_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/interior/render_13_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/interior/render_14_terraza_01_C.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/interior/render_15_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/interior/render_16_hab_01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/interior/render_17_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/interior/render_18_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/interior/render_19_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/interior/render_20_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/insider/review03/render/interior/render_21_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '21 de julio de 2022',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/insider/download/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/insider/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/insider/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/insider/live/render_exterior_01.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/insider/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/insider/live/render_exterior_01.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/culmia/insider/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/culmia/insider/live/orbit_thumb_v4.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/insider/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/insider/live/render_exterior_01.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/insider/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/insider/live/render_exterior_01.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_exterior_01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_exterior_02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_exterior_03.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 05',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_exterior_05.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 06',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_exterior_06.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 06 Night',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_exterior_06B.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 07',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_exterior_07.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 08',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_exterior_08.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 09',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_exterior_09.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 10',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_exterior_10.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 11',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_exterior_11.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 12',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_exterior_12.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 13',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_exterior_13.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 14',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_exterior_14.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 15',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_exterior_15.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_02_salon_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_03_salon_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_04_salon_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_05_salon_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_06_salon_05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_07_salon_06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 07',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_08_salon_07.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Recibidor 01',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_09_recibidor_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_11_cocina_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_12_cocina_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_13_cocina_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_14_terraza_01_C.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_15_bano_comun_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_16_hab_01_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_17_hab02_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 01',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_18_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 02',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_19_suite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 03',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_20_suite_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/insider/live/render_21_bano_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'themis-riera',
          name: 'Themis Riera',
          city: 'Barcelona',
          province: 'Barcelona',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/themis-riera',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/themis-riera',
          image: 'https://media.bizionar.digital/culmia/themis-riera/live/cam02.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '12 de abril de 2022',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '4 de mayo de 2022',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '19 de mayo de 2022',
                  status: 'closed',
                  isLive: true,
                  isFinal: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '11 de febrero de 2022',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '21 de abril de 2022',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '4 de mayo de 2022',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/themis-riera/review01/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/themis-riera/review01/render/interior/render_02_salon_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review01/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review01/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review01/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review01/render/exterior/cam13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review01/render/exterior/cam15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review01/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review01/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review01/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review01/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review01/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review01/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review01/render/interior/render_08_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review01/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review01/render/interior/render_09_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review01/render/interior/render_10_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review01/render/interior/render_11_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review01/render/interior/render_12_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review01/render/interior/render_13_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review01/render/interior/render_14_hab01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review01/render/interior/render_15_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review01/render/interior/render_16_hab02_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review01/render/interior/render_17_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review01/render/interior/render_18_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review01/render/interior/render_19_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review01/render/interior/render_20_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review01/render/interior/render_21_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/themis-riera/review02/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/themis-riera/review02/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review02/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review02/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review02/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review02/render/exterior/cam13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review02/render/exterior/cam15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review02/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review02/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review02/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review02/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review02/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review02/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review02/render/interior/render_08_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review02/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review02/render/interior/render_09_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review02/render/interior/render_10_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review02/render/interior/render_11_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review02/render/interior/render_12_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review02/render/interior/render_13_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review02/render/interior/render_14_hab01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review02/render/interior/render_15_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review02/render/interior/render_16_hab02_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review02/render/interior/render_17_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review02/render/interior/render_18_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review02/render/interior/render_19_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review02/render/interior/render_20_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review02/render/interior/render_21_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/themis-riera/review03/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/themis-riera/review03/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review03/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review03/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review03/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review03/render/exterior/cam13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review03/render/exterior/cam15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review03/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review03/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review03/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review03/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review03/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review03/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review03/render/interior/render_08_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review03/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review03/render/interior/render_09_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review03/render/interior/render_10_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review03/render/interior/render_11_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review03/render/interior/render_12_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review03/render/interior/render_13_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review03/render/interior/render_14_hab01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review03/render/interior/render_15_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review03/render/interior/render_16_hab02_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review03/render/interior/render_17_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review03/render/interior/render_18_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review03/render/interior/render_19_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review03/render/interior/render_20_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/themis-riera/review03/render/interior/render_21_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'PISO PILOTO',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '19 de mayo de 2022',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/themis-riera/download/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/themis-riera/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/themis-riera/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/themis-riera/live/cam02.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Vistas Reales',
                src: 'https://media.bizionar.digital/culmia/themis-riera/live/tour-vistas/index.html',
                thumb: 'https://media.bizionar.digital/culmia/themis-riera/live/cam02.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/themis-riera/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/themis-riera/live/cam02.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/themis-riera/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/themis-riera/live/cam01.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/themis-riera/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/themis-riera/live/cam01.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/culmia/themis-riera/live/cam01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/culmia/themis-riera/live/cam02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 04',
                src: 'https://media.bizionar.digital/culmia/themis-riera/live/cam04.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 13',
                src: 'https://media.bizionar.digital/culmia/themis-riera/live/cam13.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 15',
                src: 'https://media.bizionar.digital/culmia/themis-riera/live/cam15.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/themis-riera/live/render_02_salon_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/themis-riera/live/render_03_salon_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/themis-riera/live/render_04_salon_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/themis-riera/live/render_05_salon_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/culmia/themis-riera/live/render_06_salon_05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/culmia/themis-riera/live/render_07_salon_06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 07',
                src: 'https://media.bizionar.digital/culmia/themis-riera/live/render_08_salon_07.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Recibidor 01',
                src: 'https://media.bizionar.digital/culmia/themis-riera/live/render_01_recibidor_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/themis-riera/live/render_09_cocina_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/themis-riera/live/render_10_cocina_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/culmia/themis-riera/live/render_11_cocina_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/themis-riera/live/render_12_banocomun_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/culmia/themis-riera/live/render_13_hab01_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 02',
                src: 'https://media.bizionar.digital/culmia/themis-riera/live/render_14_hab01_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/culmia/themis-riera/live/render_15_hab02_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 02',
                src: 'https://media.bizionar.digital/culmia/themis-riera/live/render_16_hab02_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 01',
                src: 'https://media.bizionar.digital/culmia/themis-riera/live/render_17_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 02',
                src: 'https://media.bizionar.digital/culmia/themis-riera/live/render_18_suite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 03',
                src: 'https://media.bizionar.digital/culmia/themis-riera/live/render_19_suite_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/themis-riera/live/render_20_banosuite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 02',
                src: 'https://media.bizionar.digital/culmia/themis-riera/live/render_21_terraza_01.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'la-font-de-volpelleres',
          name: 'La Font de Volpelleres',
          city: 'Sant Cugat del Vallès',
          province: 'Barcelona',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/la-font-de-volpelleres',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/la-font-de-volpelleres',
          image: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/cam_exterior_01.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '21 de abril de 2022',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '19 de mayo de 2022',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '2 de junio de 2022',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '13 de abril de 2022',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '19 de mayo de 2022',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '30 de mayo de 2022',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '11 de julio de 2022',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/exterior/orbit_thumb_v1.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/exterior/cam_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/exterior/cam_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/exterior/cam_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/exterior/cam_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/exterior/cam_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/exterior/cam_exterior_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/exterior/cam_exterior_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/exterior/cam_exterior_06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/exterior/cam_exterior_07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/exterior/cam_exterior_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/exterior/cam_exterior_09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/exterior/cam_exterior_10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/exterior/cam_exterior_11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/exterior/cam_exterior_12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/exterior/cam_exterior_13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/exterior/cam_exterior_14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/interior/render_08_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/interior/render_11_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/interior/render_12_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/interior/render_13_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/interior/render_14_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/interior/render_15_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/interior/render_16_hab_01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/interior/render_17_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/interior/render_18_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/interior/render_19_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/interior/render_20_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review01/render/interior/render_21_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },

              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/exterior/orbit_thumb_v2.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/exterior/cam_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/exterior/cam_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/exterior/cam_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/exterior/cam_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/exterior/cam_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/exterior/cam_exterior_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/exterior/cam_exterior_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/exterior/cam_exterior_06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/exterior/cam_exterior_07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/exterior/cam_exterior_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/exterior/cam_exterior_09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/exterior/cam_exterior_10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/exterior/cam_exterior_11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/exterior/cam_exterior_12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/exterior/cam_exterior_13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/exterior/cam_exterior_14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/interior/render_08_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/interior/render_11_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/interior/render_12_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/interior/render_13_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/interior/render_14_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/interior/render_15_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/interior/render_16_hab_01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/interior/render_17_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/interior/render_18_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/interior/render_19_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/interior/render_20_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review02/render/interior/render_21_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/exterior/orbit_thumb_v3.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/exterior/cam_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/exterior/cam_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/exterior/cam_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/exterior/cam_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/exterior/cam_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/exterior/cam_exterior_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/exterior/cam_exterior_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/exterior/cam_exterior_06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/exterior/cam_exterior_07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/exterior/cam_exterior_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/exterior/cam_exterior_09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/exterior/cam_exterior_10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/exterior/cam_exterior_11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/exterior/cam_exterior_12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/exterior/cam_exterior_13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/exterior/cam_exterior_14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/interior/render_08_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/interior/render_11_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/interior/render_12_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/interior/render_13_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/interior/render_14_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/interior/render_15_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/interior/render_16_hab_01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/interior/render_17_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/interior/render_18_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/interior/render_19_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/interior/render_20_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/interior/render_21_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/exterior/cam_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Video Completo',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review04/video/video_completo.mp4',
                  thumb: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review03/render/exterior/cam_exterior_01.jpg',
                  type: 'video',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review04/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review04/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review04/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review04/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review04/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review04/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review04/render/interior/render_08_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review04/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review04/render/interior/render_11_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review04/render/interior/render_12_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review04/render/interior/render_13_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review04/render/interior/render_14_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review04/render/interior/render_15_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review04/render/interior/render_16_hab_01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review04/render/interior/render_17_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review04/render/interior/render_18_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review04/render/interior/render_19_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review04/render/interior/render_20_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/review04/render/interior/render_21_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '17 de agosto de 2022',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/download/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/orbit_thumb_v3.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/cam_exterior_01.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/cam_exterior_01.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/cam_exterior_01.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/cam_exterior_01.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/cam_exterior_01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/cam_exterior_02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/cam_exterior_03.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 04',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/cam_exterior_04.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 05',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/cam_exterior_05.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 06',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/cam_exterior_06.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 07',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/cam_exterior_07.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 08',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/cam_exterior_08.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 09',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/cam_exterior_09.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 10',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/cam_exterior_10.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 11',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/cam_exterior_11.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 12',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/cam_exterior_12.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 13',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/cam_exterior_13.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 14',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/cam_exterior_14.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/render_02_salon_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/render_03_salon_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/render_04_salon_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/render_05_salon_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/render_06_salon_05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/render_07_salon_06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 07',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/render_08_salon_07.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Recibidor 01',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/render_01_recibidor_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/render_11_cocina_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/render_12_cocina_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/render_13_cocina_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/render_14_terraza_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/render_15_banocomun_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/render_16_hab_01_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/render_17_hab02_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 01',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/render_18_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 02',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/render_19_suite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 03',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/render_20_suite_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/la-font-de-volpelleres/live/render_21_bano_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'arbeyal-gijon',
          name: 'Arbeyal Gijón',
          city: 'Gijón',
          province: 'Asturias',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/arbeyal-gijon',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/arbeyal-gijon',
          image: 'https://media.bizionar.digital/culmia/arbeyal-gijon/live/cam02.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '29 de abril de 2022',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '19 de mayo de 2022',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '1 de junio de 2022',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'PISO PILOTO',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '29 de abril de 2022',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '20 de mayo de 2022',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '1 de junio de 2022',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review01/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review01/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review01/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review01/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review01/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review01/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 00 - Op1',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review01/render/exterior/cam00_op1.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 00 - Op2',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review01/render/exterior/cam00_op2.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review01/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review01/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review01/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review01/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review01/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review01/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review01/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review01/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review01/render/interior/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review01/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review01/render/interior/render_11_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review01/render/interior/render_12_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review01/render/interior/render_13_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review01/render/interior/render_14_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review01/render/interior/render_15_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review01/render/interior/render_16_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review01/render/interior/render_17_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 04',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review01/render/interior/render_18_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review02/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review02/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review02/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review02/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review02/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review02/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 00 - Op1',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review02/render/exterior/cam00_op1.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review02/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review02/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review02/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review02/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review02/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review02/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review02/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review02/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review02/render/interior/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review02/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review02/render/interior/render_11_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review02/render/interior/render_12_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review02/render/interior/render_13_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review02/render/interior/render_14_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review02/render/interior/render_15_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review02/render/interior/render_16_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review02/render/interior/render_17_banosuite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 04',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review02/render/interior/render_18_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review03/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review03/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review03/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review03/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 00 - Op1',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review03/render/exterior/cam00_op1.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review03/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review03/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review03/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review03/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review03/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review03/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review03/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review03/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review03/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review03/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review03/render/interior/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review03/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review03/render/interior/render_11_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review03/render/interior/render_12_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review03/render/interior/render_13_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review03/render/interior/render_14_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review03/render/interior/render_15_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review03/render/interior/render_16_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review03/render/interior/render_17_banosuite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 04',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/review03/render/interior/render_18_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '19 de mayo de 2022',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/arbeyal-gijon/download/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/arbeyal-gijon/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/arbeyal-gijon/live/cam01.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/arbeyal-gijon/live/cam01.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/arbeyal-gijon/live/cam01.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/arbeyal-gijon/live/cam01.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/live/cam01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/live/cam02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 04',
                src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/live/cam04.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 06',
                src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/live/cam06.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 00 - Op1',
                src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/live/cam00_op1.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/live/render_02_salon_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/live/render_03_salon_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/live/render_04_salon_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/live/render_05_salon_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/live/render_06_salon_05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/live/render_07_salon_06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/live/render_08_cocina_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/live/render_09_cocina_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/live/render_10_cocina_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Recibidor 01',
                src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/live/render_01_recibidor_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/live/render_11_hab1_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 02',
                src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/live/render_12_hab1_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/live/render_13_banocomun_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/live/render_14_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/live/render_15_suite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 03',
                src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/live/render_16_suite_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/live/render_17_banosuite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 04',
                src: 'https://media.bizionar.digital/culmia/arbeyal-gijon/live/render_18_terraza_01.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'placa-de-la-vila',
          name: 'Plaça de la Vila',
          city: 'Santa Coloma De Gramenet',
          province: 'Barcelona',
          liveEnabled: false,
          showEnabled: false,
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/placa-de-la-vila',
          image: 'https://media.bizionar.digital/culmia/placa-de-la-vila/review01/render/exterior/still06.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 0,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '9 de septiembre de 2022',
                  status: 'pending',
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 0,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '23 de septiembre de 2022',
                  status: 'pending',
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/placa-de-la-vila/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/placa-de-la-vila/review01/render/exterior/still01_dia.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/placa-de-la-vila/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/placa-de-la-vila/review01/render/exterior/still01_dia.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/placa-de-la-vila/review01/render/exterior/still01_dia.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01 - Noche',
                  src: 'https://media.bizionar.digital/culmia/placa-de-la-vila/review01/render/exterior/still01_night.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/placa-de-la-vila/review01/render/exterior/still03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/placa-de-la-vila/review01/render/exterior/still04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/placa-de-la-vila/review01/render/exterior/still06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/placa-de-la-vila/review01/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/placa-de-la-vila/review01/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/placa-de-la-vila/review01/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/placa-de-la-vila/review01/render/interior/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/placa-de-la-vila/review01/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/placa-de-la-vila/review01/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/placa-de-la-vila/review01/render/interior/render_07_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/placa-de-la-vila/review01/render/interior/render_09_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/placa-de-la-vila/review01/render/interior/render_10_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/placa-de-la-vila/review01/render/interior/render_08_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/placa-de-la-vila/review01/render/interior/render_14_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/placa-de-la-vila/review01/render/interior/render_15_hab2_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/placa-de-la-vila/review01/render/interior/render_13_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/placa-de-la-vila/review01/render/interior/render_16_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/placa-de-la-vila/review01/render/interior/render_17_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/placa-de-la-vila/review01/render/interior/render_18_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/placa-de-la-vila/review01/render/interior/render_19_banosuite.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/placa-de-la-vila/review01/render/interior/render_12_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
        },
        {
          id: 'estepona',
          name: 'Sunset Bay Estepona',
          city: 'Estepona',
          province: 'Málaga',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/estepona',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/estepona',
          image: 'https://media.bizionar.digital/culmia/estepona/live/cam_04.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 7,
              totalReviews: 7,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '28 de octubre de 2022',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '12 de diciembre de 2022',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '30 de enero de 2023',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '8 de febrero de 2023',
                  status: 'closed',
                },
                {
                  id: 'review05',
                  name: 'ENTREGA 5',
                  date: '15 de febrero de 2023',
                  status: 'closed',
                },
                {
                  id: 'review06',
                  name: 'ENTREGA 6',
                  date: '7 de noviembre de 2023',
                  status: 'closed',
                },
                {
                  id: 'review07',
                  name: 'ENTREGA 7',
                  date: '7 de mayo de 2025',
                  status: 'closed',
                },
                {
                  id: 'review08',
                  name: 'ENTREGA 8',
                  date: '11 de julio de 2025',
                  status: 'closed',
                  isLive: true,
                  isFinal: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '14 de octubre de 2022',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '12 de diciembre de 2022',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '30 de enero de 2023',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '8 de febrero de 2023',
                  status: 'closed',
                  isLive: true,
                  isFinal: true,
                },
              ],
            },
            {
              categoryId: 'salas-comunes',
              categoryName: 'SALAS COMUNES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '30 de agosto de 2024',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '30 de octubre de 2024',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '5 de noviembre de 2024',
                  status: 'closed',
                  isLive: true,
                  isFinal: true,
                }
              ],
            },
            {
              categoryId: 'zonas-comunes',
              categoryName: 'ZONAS COMUNES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '17 de julio de 2023',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '26 de septiembre de 2023',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '11 de octubre de 2024',
                  status: 'closed',
                  isLive: true,
                  isFinal: true,
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '11 de julio de 2025',
                  status: 'closed',
                  isLive: true,
                  isFinal: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/estepona/review01/render/exterior/cam_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/estepona/review01/render/exterior/cam_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Gourmet 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/salas-comunes/render_gourmet_001.jpg',
                  type: 'render',
                  category: 'salas-comunes',
                },
                {
                  name: 'Render Sala Gourmet 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/salas-comunes/render_gourmet_002.jpg',
                  type: 'render',
                  category: 'salas-comunes',
                },
                {
                  name: 'Render Sala Gourmet 03',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/salas-comunes/render_gourmet_003.jpg',
                  type: 'render',
                  category: 'salas-comunes',
                },
                {
                  name: 'Render Sala Gourmet 04',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/salas-comunes/render_gourmet_004.jpg',
                  type: 'render',
                  category: 'salas-comunes',
                },
                {
                  name: 'Render Sala Gourmet 05',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/salas-comunes/render_gourmet_005.jpg',
                  type: 'render',
                  category: 'salas-comunes',
                },
                {
                  name: 'Render Gym 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/salas-comunes/render_gym_001.jpg',
                  type: 'render',
                  category: 'salas-comunes',
                },
                {
                  name: 'Render Gym 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/salas-comunes/render_gym_002.jpg',
                  type: 'render',
                  category: 'salas-comunes',
                },
                {
                  name: 'Render Gym 03',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/salas-comunes/render_gym_003.jpg',
                  type: 'render',
                  category: 'salas-comunes',
                },
                {
                  name: 'Render Gym 04',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/salas-comunes/render_gym_004.jpg',
                  type: 'render',
                  category: 'salas-comunes',
                },
                {
                  name: 'Render Gym 05',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/salas-comunes/render_gym_005.jpg',
                  type: 'render',
                  category: 'salas-comunes',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/salas-comunes/render_terraza_001.jpg',
                  type: 'render',
                  category: 'salas-comunes',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/salas-comunes/render_terraza_002.jpg',
                  type: 'render',
                  category: 'salas-comunes',
                },
                {
                  name: 'Render Golf',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/exterior/golf.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Gym',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/exterior/gym.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Zona Lectura',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/exterior/lectura.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Zona Relax',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/exterior/relax.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/exterior/cam_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/exterior/cam_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/exterior/cam_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/exterior/cam_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/exterior/cam_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/interior/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/interior/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/interior/render_07_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/interior/render_12_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/interior/render_13_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/interior/render_14_hab2_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/interior/render_15_hab2_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/interior/render_16_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/interior/render_17_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/interior/render_18_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/interior/render_19_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/interior/render_20_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/interior/render_21_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review01/render/interior/render_22_terraza_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/estepona/review02/render/exterior/cam_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Sala Gourmet 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/salas-comunes/gourmet_1.jpg',
                  type: 'render',
                  category: 'salas-comunes',
                },
                {
                  name: 'Render Sala Gourmet 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/salas-comunes/gourmet_2.jpg',
                  type: 'render',
                  category: 'salas-comunes',
                },
                {
                  name: 'Render Sala Gourmet 03',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/salas-comunes/gourmet_3.jpg',
                  type: 'render',
                  category: 'salas-comunes',
                },
                {
                  name: 'Render Sala Gourmet 04',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/salas-comunes/gourmet_4.jpg',
                  type: 'render',
                  category: 'salas-comunes',
                },
                {
                  name: 'Render Gym 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/salas-comunes/gym_1.jpg',
                  type: 'render',
                  category: 'salas-comunes',
                },
                {
                  name: 'Render Gym 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/salas-comunes/gym_2.jpg',
                  type: 'render',
                  category: 'salas-comunes',
                },
                {
                  name: 'Render Gym 03',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/salas-comunes/gym_3.jpg',
                  type: 'render',
                  category: 'salas-comunes',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/salas-comunes/terraza_1.jpg',
                  type: 'render',
                  category: 'salas-comunes',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/salas-comunes/terraza_2.jpg',
                  type: 'render',
                  category: 'salas-comunes',
                },
                {
                  name: 'Render Golf',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/exterior/golf.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Gym',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/exterior/gym.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Zona Lectura',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/exterior/lectura.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Zona Relax',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/exterior/relax.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/estepona/review02/render/exterior/cam_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/exterior/cam_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/exterior/cam_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/exterior/cam_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/exterior/posterior.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/exterior/cam_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/exterior/cam_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/interior/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/interior/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/interior/render_07_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/interior/render_12_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/interior/render_13_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/interior/render_14_hab2_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/interior/render_15_hab2_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/interior/render_16_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/interior/render_17_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/interior/render_18_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/interior/render_19_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/interior/render_20_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/interior/render_21_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review02/render/interior/render_22_terraza_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/estepona/review03/render/exterior/cam_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/estepona/review03/render/exterior/cam_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Gourmet 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/salas-comunes/gourmet_1.jpg',
                  type: 'render',
                  category: 'salas-comunes',
                },
                {
                  name: 'Render Sala Gourmet 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/salas-comunes/gourmet_2.jpg',
                  type: 'render',
                  category: 'salas-comunes',
                },
                {
                  name: 'Render Sala Gourmet 03',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/salas-comunes/gourmet_3.jpg',
                  type: 'render',
                  category: 'salas-comunes',
                },
                {
                  name: 'Render Sala Gourmet 04',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/salas-comunes/gourmet_4.jpg',
                  type: 'render',
                  category: 'salas-comunes',
                },
                {
                  name: 'Render Gym 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/salas-comunes/gym_1.jpg',
                  type: 'render',
                  category: 'salas-comunes',
                },
                {
                  name: 'Render Gym 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/salas-comunes/gym_2.jpg',
                  type: 'render',
                  category: 'salas-comunes',
                },
                {
                  name: 'Render Gym 03',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/salas-comunes/gym_3.jpg',
                  type: 'render',
                  category: 'salas-comunes',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/salas-comunes/terraza_1.jpg',
                  type: 'render',
                  category: 'salas-comunes',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/salas-comunes/terraza_2.jpg',
                  type: 'render',
                  category: 'salas-comunes',
                },
                {
                  name: 'Render Golf',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/exterior/golf.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Gym',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/exterior/gym.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Zona Lectura',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/exterior/lectura.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Zona Relax',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/exterior/relax.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/exterior/cam_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/exterior/cam_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/exterior/cam_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/exterior/cam_09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/exterior/cam_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/exterior/cam_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/interior/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/interior/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/interior/render_07_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/interior/render_12_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/interior/render_13_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/interior/render_14_hab2_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/interior/render_15_hab2_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/interior/render_16_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/interior/render_17_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/interior/render_18_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/interior/render_19_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/interior/render_20_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/interior/render_21_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review03/render/interior/render_22_terraza_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/estepona/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/estepona/review04/render/exterior/cam_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/estepona/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/estepona/review04/render/exterior/cam_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/estepona/review04/render/exterior/cam_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/estepona/review04/render/exterior/cam_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/estepona/review04/render/exterior/cam_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/estepona/review04/render/exterior/cam_09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review04/render/exterior/cam_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review04/render/exterior/cam_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/estepona/review04/render/exterior/top_blanco.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/estepona/review04/render/exterior/top_entorno_50.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/estepona/review04/render/exterior/top_entorno_100.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/estepona/review04/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review04/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review04/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/estepona/review04/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/estepona/review04/render/interior/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/estepona/review04/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review04/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review04/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/estepona/review04/render/interior/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review04/render/interior/render_07_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review04/render/interior/render_12_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review04/render/interior/render_13_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review04/render/interior/render_14_hab2_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review04/render/interior/render_15_hab2_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review04/render/interior/render_16_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review04/render/interior/render_17_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review04/render/interior/render_18_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review04/render/interior/render_19_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review04/render/interior/render_20_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review04/render/interior/render_21_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review04/render/interior/render_22_terraza_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Zona Lectura',
                  src: 'https://media.bizionar.digital/culmia/estepona/review08/render/exterior/lectura.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review05',
              content: [
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/estepona/review05/render/exterior/cam_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/estepona/review05/render/exterior/cam_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/estepona/review05/render/exterior/cam_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/estepona/review05/render/exterior/cam_09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review05/render/exterior/cam_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review05/render/exterior/cam_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/estepona/review05/render/exterior/top_blanco.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/estepona/review05/render/exterior/top_entorno_50.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/estepona/review05/render/exterior/top_entorno_100.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
            {
              id: 'review06',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/estepona/review06/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/estepona/live/cam_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
              ],
            },
            {
              id: 'review07',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/estepona/review09/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/estepona/review07/render/exterior/cam_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Video Completo',
                  src: 'https://media.bizionar.digital/culmia/estepona/review07/video/video_completo.mp4',
                  thumb: 'https://media.bizionar.digital/culmia/estepona/live/cam_05.jpg',
                  type: 'video',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review07/render/exterior/cam_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review07/render/exterior/cam_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
            {
              id: 'review08',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/estepona/review10/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/estepona/review08/render/exterior/cam_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Simulador Solar',
                  src: 'https://solar-simulator.bizionar.digital/culmia/estepona/review07',
                  thumb: 'https://media.bizionar.digital/culmia/estepona/review08/render/exterior/cam_01.jpg',
                  type: 'solar-simulator',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/estepona/review08/render/exterior/cam_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/estepona/review08/render/exterior/cam_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/estepona/review08/render/exterior/top_blanco.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/estepona/review08/render/exterior/top_entorno_50.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/estepona/review08/render/exterior/top_entorno_100.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'PISO PILOTO',
              filter: 'interiores',
              active: false,
            },
            {
              title: 'ZONAS COMUNES',
              filter: 'zonas-comunes',
              active: false,
            },
            {
              title: 'SALAS COMUNES',
              filter: 'salas-comunes',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '23 de julio de 2025',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/estepona/download/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/estepona/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'salas-comunes',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/estepona/download/salas-comunes/render_salas-comunes_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'zonas-comunes',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/estepona/download/zonas-comunes/render_zonas-comunes_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Simulador Solar',
                src: 'https://solar-simulator.bizionar.digital/culmia/estepona/live',
                thumb: 'https://media.bizionar.digital/culmia/estepona/live/cam_05.jpg',
                type: 'solar-simulator',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/estepona/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/estepona/live/cam_01.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Vistas Reales',
                src: 'https://media.bizionar.digital/culmia/estepona/live/tour-vistas/index.html',
                thumb: 'https://media.bizionar.digital/culmia/estepona/live/cam_01.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/estepona/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/estepona/live/cam_01.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/estepona/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/estepona/live/cam_05.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/estepona/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/estepona/live/cam_05.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Render Sala Gourmet 01',
                src: 'https://media.bizionar.digital/culmia/estepona/live/salas-comunes/gourmet_1.jpg',
                type: 'render',
                category: 'salas-comunes',
              },
              {
                name: 'Render Sala Gourmet 02',
                src: 'https://media.bizionar.digital/culmia/estepona/live/salas-comunes/gourmet_2.jpg',
                type: 'render',
                category: 'salas-comunes',
              },
              {
                name: 'Render Sala Gourmet 03',
                src: 'https://media.bizionar.digital/culmia/estepona/live/salas-comunes/gourmet_3.jpg',
                type: 'render',
                category: 'salas-comunes',
              },
              {
                name: 'Render Sala Gourmet 04',
                src: 'https://media.bizionar.digital/culmia/estepona/live/salas-comunes/gourmet_4.jpg',
                type: 'render',
                category: 'salas-comunes',
              },
              {
                name: 'Render Gym 01',
                src: 'https://media.bizionar.digital/culmia/estepona/live/salas-comunes/gym_1.jpg',
                type: 'render',
                category: 'salas-comunes',
              },
              {
                name: 'Render Gym 02',
                src: 'https://media.bizionar.digital/culmia/estepona/live/salas-comunes/gym_2.jpg',
                type: 'render',
                category: 'salas-comunes',
              },
              {
                name: 'Render Gym 03',
                src: 'https://media.bizionar.digital/culmia/estepona/live/salas-comunes/gym_3.jpg',
                type: 'render',
                category: 'salas-comunes',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/estepona/live/salas-comunes/terraza_1.jpg',
                type: 'render',
                category: 'salas-comunes',
              },
              {
                name: 'Render Terraza 02',
                src: 'https://media.bizionar.digital/culmia/estepona/live/salas-comunes/terraza_2.jpg',
                type: 'render',
                category: 'salas-comunes',
              },
              {
                name: 'Render Golf',
                src: 'https://media.bizionar.digital/culmia/estepona/live/zonas-comunes/golf.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Gym',
                src: 'https://media.bizionar.digital/culmia/estepona/live/zonas-comunes/gym.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Zona Lectura',
                src: 'https://media.bizionar.digital/culmia/estepona/live/zonas-comunes/lectura.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Zona Relax',
                src: 'https://media.bizionar.digital/culmia/estepona/live/zonas-comunes/relax.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Exterior 04',
                src: 'https://media.bizionar.digital/culmia/estepona/live/cam_04.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 05',
                src: 'https://media.bizionar.digital/culmia/estepona/live/cam_05.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 08',
                src: 'https://media.bizionar.digital/culmia/estepona/live/cam_08.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 09',
                src: 'https://media.bizionar.digital/culmia/estepona/live/cam_09.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/culmia/estepona/live/cam_01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/culmia/estepona/live/cam_02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 10',
                src: 'https://media.bizionar.digital/culmia/estepona/live/top_blanco.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 11',
                src: 'https://media.bizionar.digital/culmia/estepona/live/top_entorno_50.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 12',
                src: 'https://media.bizionar.digital/culmia/estepona/live/top_entorno_100.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Suite Fase 02',
                src: 'https://media.bizionar.digital/culmia/estepona/live/render_suite_fase2.jpg',
                type: 'render',
                category: 'interiores',
              },
                {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/culmia/estepona/live/render_06_salon_06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/estepona/live/render_01_salon_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/estepona/live/render_02_salon_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/estepona/live/render_03_salon_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/estepona/live/render_04_salon_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/culmia/estepona/live/render_05_salon_05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/estepona/live/render_08_cocina_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/estepona/live/render_09_cocina_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/culmia/estepona/live/render_10_cocina_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Recibidor 01',
                src: 'https://media.bizionar.digital/culmia/estepona/live/render_07_recibidor_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/culmia/estepona/live/render_12_hab1_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 02',
                src: 'https://media.bizionar.digital/culmia/estepona/live/render_13_hab1_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/culmia/estepona/live/render_14_hab2_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 02',
                src: 'https://media.bizionar.digital/culmia/estepona/live/render_15_hab2_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/estepona/live/render_16_banocomun_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/culmia/estepona/live/render_17_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/culmia/estepona/live/render_18_suite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/estepona/live/render_19_banosuite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/estepona/live/render_20_terraza_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/estepona/live/render_21_terraza_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/estepona/live/render_22_terraza_03.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'urban-monestir',
          name: 'Urban Monestir',
          city: 'Sant Cugat del Vallés',
          province: 'Barcelona',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/urban-monestir',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/urban-monestir',
          image: 'https://media.bizionar.digital/culmia/urban-monestir/live/render_exterior_01.jpg',
          deliveries: [
            {
              categoryId: 'coworking',
              categoryName: 'COWORKING',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '31 de octubre de 2023',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '26 de enero de 2024',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '9 de febrero de 2024',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '5 de abril de 2024',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '16 de octubre de 2022',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '31 de marzo de 2023',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '14 de abril de 2023',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/urban-monestir/review01/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Coworking 01',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review01/render/coworking/cam01.jpg',
                  type: 'render',
                  category: 'coworking',
                },
                {
                  name: 'Render Coworking 02',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review01/render/coworking/cam02.jpg',
                  type: 'render',
                  category: 'coworking',
                },
                {
                  name: 'Render Coworking 03',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review01/render/coworking/cam03.jpg',
                  type: 'render',
                  category: 'coworking',
                },
                {
                  name: 'Render Coworking 04',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review01/render/coworking/cam04.jpg',
                  type: 'render',
                  category: 'coworking',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review01/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review01/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review01/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review01/render/interior/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review01/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review01/render/interior/render_07_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review01/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review01/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review01/render/interior/render_10_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review01/render/interior/render_11_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review01/render/interior/render_12_hab01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review01/render/interior/render_13_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review01/render/interior/render_14_banocomun_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review01/render/interior/render_15_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review01/render/interior/render_16_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review01/render/interior/render_17_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review01/render/interior/render_18_banosuite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review01/render/interior/render_19_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/urban-monestir/review01/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Coworking 01',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review02/render/coworking/cam01.jpg',
                  type: 'render',
                  category: 'coworking',
                },
                {
                  name: 'Render Coworking 02',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review02/render/coworking/cam02.jpg',
                  type: 'render',
                  category: 'coworking',
                },
                {
                  name: 'Render Coworking 03',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review02/render/coworking/cam03.jpg',
                  type: 'render',
                  category: 'coworking',
                },
                {
                  name: 'Render Coworking 04',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review02/render/coworking/cam04.jpg',
                  type: 'render',
                  category: 'coworking',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review02/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review02/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review02/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review02/render/interior/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review02/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review02/render/interior/render_07_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review02/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review02/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review02/render/interior/render_10_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review02/render/interior/render_11_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review02/render/interior/render_12_hab01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review02/render/interior/render_13_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review02/render/interior/render_14_banocomun_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review02/render/interior/render_15_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review02/render/interior/render_16_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review02/render/interior/render_17_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review02/render/interior/render_18_banosuite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review02/render/interior/render_19_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/urban-monestir/review01/render/exterior/render_exterior_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Coworking 01',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review03/render/coworking/cam01.jpg',
                  type: 'render',
                  category: 'coworking',
                },
                {
                  name: 'Render Coworking 02',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review03/render/coworking/cam02.jpg',
                  type: 'render',
                  category: 'coworking',
                },
                {
                  name: 'Render Coworking 03',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review03/render/coworking/cam03.jpg',
                  type: 'render',
                  category: 'coworking',
                },
                {
                  name: 'Render Coworking 04',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review03/render/coworking/cam04.jpg',
                  type: 'render',
                  category: 'coworking',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review03/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review03/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review03/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review03/render/interior/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review03/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review03/render/interior/render_07_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review03/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review03/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review03/render/interior/render_10_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review03/render/interior/render_11_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review03/render/interior/render_12_hab01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review03/render/interior/render_13_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review03/render/interior/render_14_banocomun_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review03/render/interior/render_15_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review03/render/interior/render_16_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review03/render/interior/render_17_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review03/render/interior/render_18_banosuite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review03/render/interior/render_19_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Render Coworking 01',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review04/render/coworking/cam01.jpg',
                  type: 'render',
                  category: 'coworking',
                },
                {
                  name: 'Render Coworking 02',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review04/render/coworking/cam02.jpg',
                  type: 'render',
                  category: 'coworking',
                },
                {
                  name: 'Render Coworking 03',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review04/render/coworking/cam03.jpg',
                  type: 'render',
                  category: 'coworking',
                },
                {
                  name: 'Render Coworking 04',
                  src: 'https://media.bizionar.digital/culmia/urban-monestir/review04/render/coworking/cam04.jpg',
                  type: 'render',
                  category: 'coworking',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: true,
            },
            {
              title: 'COWORKING',
              filter: 'coworking',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '24 de abril de 2023',
            categoryBundles: [
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/urban-monestir/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'coworking',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/urban-monestir/download/coworking/render_coworking_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/urban-monestir/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/urban-monestir/live/render_exterior_01.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/urban-monestir/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/urban-monestir/live/render_exterior_01.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/urban-monestir/live/render_02_salon_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/urban-monestir/live/render_01_salon_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/urban-monestir/live/render_03_salon_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/urban-monestir/live/render_04_salon_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/culmia/urban-monestir/live/render_06_salon_06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 07',
                src: 'https://media.bizionar.digital/culmia/urban-monestir/live/render_07_salon_07.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/urban-monestir/live/render_08_cocina_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/urban-monestir/live/render_09_cocina_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Recibidor 01',
                src: 'https://media.bizionar.digital/culmia/urban-monestir/live/render_10_recibidor_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/culmia/urban-monestir/live/render_11_hab01_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 02',
                src: 'https://media.bizionar.digital/culmia/urban-monestir/live/render_12_hab01_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/urban-monestir/live/render_13_banocomun_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 02',
                src: 'https://media.bizionar.digital/culmia/urban-monestir/live/render_14_banocomun_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/culmia/urban-monestir/live/render_15_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/culmia/urban-monestir/live/render_16_suite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/urban-monestir/live/render_17_banosuite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 02',
                src: 'https://media.bizionar.digital/culmia/urban-monestir/live/render_18_banosuite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/urban-monestir/live/render_19_terraza_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Coworking 01',
                src: 'https://media.bizionar.digital/culmia/urban-monestir/live/coworking/cam01.jpg',
                type: 'render',
                category: 'coworking',
              },
              {
                name: 'Render Coworking 02',
                src: 'https://media.bizionar.digital/culmia/urban-monestir/live/coworking/cam02.jpg',
                type: 'render',
                category: 'coworking',
              },
              {
                name: 'Render Coworking 03',
                src: 'https://media.bizionar.digital/culmia/urban-monestir/live/coworking/cam03.jpg',
                type: 'render',
                category: 'coworking',
              },
              {
                name: 'Render Coworking 04',
                src: 'https://media.bizionar.digital/culmia/urban-monestir/live/coworking/cam04.jpg',
                type: 'render',
                category: 'coworking',
              },
            ],
          },
        },
        {
          id: 'nou-llevant-viladecans',
          name: 'Nou Llevant Viladecans',
          city: 'Viladecans',
          province: 'Barcelona',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/nou-llevant-viladecans',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/nou-llevant-viladecans',
          image: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/cam05.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '24 de abril de 2023',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '19 de junio de 2023',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '27 de octubre de 2023',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '24 de abril de 2023',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '19 de junio de 2023',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '4 de julio de 2023',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/exterior/cam05.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/exterior/cam05.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/exterior/cam05.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/interior/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/interior/render_07_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/interior/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/interior/render_11_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/interior/render_12_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/interior/render_13_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/interior/render_14_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/interior/render_15_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/interior/render_16_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/interior/render_17_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/interior/render_18_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/interior/render_19_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02 - 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review01/render/interior/render_20_terraza02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/exterior/cam05.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/exterior/cam05.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/exterior/cam05.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/exterior/cam05.jpg',
                  type: 'render',



                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/interior/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/interior/render_07_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/interior/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/interior/render_11_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/interior/render_12_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/interior/render_13_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/interior/render_14_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/interior/render_15_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/interior/render_16_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/interior/render_17_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/interior/render_18_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/interior/render_19_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02 - 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review02/render/interior/render_20_terraza02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/exterior/cam05.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/exterior/cam05.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/exterior/cam05.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/interior/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/interior/render_07_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/interior/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/interior/render_11_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/interior/render_12_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/interior/render_13_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/interior/render_14_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/interior/render_15_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/interior/render_16_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/interior/render_17_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/interior/render_18_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/interior/render_19_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02 - 01',
                  src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/review03/render/interior/render_20_terraza02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'PISO PILOTO',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '4 de julio de 2023',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/download/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/cam05.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/cam05.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/cam05.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/cam05.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/cam05.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 05',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/cam05.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 04',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/cam04.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/cam03.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/cam01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/cam02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 06',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/cam06.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 07',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/cam07.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 08',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/cam08.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 09',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/cam09.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 10',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/cam10.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/render_01_salon_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/render_02_salon_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/render_03_salon_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/render_04_salon_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/render_05_salon_05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/render_06_salon_06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 07',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/render_07_salon_07.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/render_08_cocina_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/render_09_cocina_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/render_10_cocina_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Recibidor 01',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/render_11_recibidor_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/render_12_banocomun_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/render_13_hab01_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/render_14_hab02_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/render_15_banosuite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/render_16_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/render_17_suite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/render_18_terraza_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 02',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/render_19_terraza_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 02 - 01',
                src: 'https://media.bizionar.digital/culmia/nou-llevant-viladecans/live/render_20_terraza02_01.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'bermeo',
          name: 'Bermeo',
          city: 'Bermeo',
          province: 'Vizcaya',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/bermeo',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/bermeo',
          image: 'https://media.bizionar.digital/culmia/bermeo/live/render_02_salon_02.jpg',
          deliveries: [
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '24 de mayo de 2023',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '14 de junio de 2023',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '30 de junio de 2023',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/bermeo/review01/render/interior/render_02_salon_02.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review01/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review01/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review01/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review01/render/interior/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review01/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review01/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review01/render/interior/render_07_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review01/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review01/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review01/render/interior/render_11_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review01/render/interior/render_12_hab01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review01/render/interior/render_13_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review01/render/interior/render_14_hab02_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review01/render/interior/render_15_hab03_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review01/render/interior/render_17_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review01/render/interior/render_18_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review01/render/interior/render_19_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review01/render/interior/render_20_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review01/render/interior/render_21_banosuite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review01/render/interior/render_22_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review01/render/interior/render_23_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/bermeo/review02/render/interior/render_02_salon_02.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review02/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review02/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review02/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review02/render/interior/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review02/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review02/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review02/render/interior/render_07_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review02/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review02/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review02/render/interior/render_11_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review02/render/interior/render_12_hab01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review02/render/interior/render_13_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review02/render/interior/render_14_hab02_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review02/render/interior/render_15_hab03_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review02/render/interior/render_17_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review02/render/interior/render_18_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review02/render/interior/render_19_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review02/render/interior/render_20_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review02/render/interior/render_21_banosuite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review02/render/interior/render_22_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review02/render/interior/render_23_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/bermeo/review03/render/interior/render_02_salon_02.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review03/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review03/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review03/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review03/render/interior/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review03/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review03/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review03/render/interior/render_07_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review03/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review03/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review03/render/interior/render_11_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review03/render/interior/render_12_hab01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review03/render/interior/render_13_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review03/render/interior/render_14_hab02_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review03/render/interior/render_15_hab03_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review03/render/interior/render_17_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review03/render/interior/render_18_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review03/render/interior/render_19_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review03/render/interior/render_20_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review03/render/interior/render_21_banosuite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review03/render/interior/render_22_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/bermeo/review03/render/interior/render_23_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '4 de julio de 2023',
            categoryBundles: [
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/bermeo/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/bermeo/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/bermeo/live/render_02_salon_02.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/bermeo/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/bermeo/live/render_02_salon_02.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/bermeo/live/render_01_salon_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/bermeo/live/render_02_salon_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/bermeo/live/render_03_salon_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/bermeo/live/render_04_salon_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/culmia/bermeo/live/render_05_salon_05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/culmia/bermeo/live/render_06_salon_06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Recibidor 01',
                src: 'https://media.bizionar.digital/culmia/bermeo/live/render_07_recibidor_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/bermeo/live/render_08_cocina_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/bermeo/live/render_09_cocina_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/culmia/bermeo/live/render_11_hab01_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 02',
                src: 'https://media.bizionar.digital/culmia/bermeo/live/render_12_hab01_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/culmia/bermeo/live/render_13_hab02_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 02',
                src: 'https://media.bizionar.digital/culmia/bermeo/live/render_14_hab02_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 3 - 01',
                src: 'https://media.bizionar.digital/culmia/bermeo/live/render_15_hab03_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/bermeo/live/render_17_banocomun_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/culmia/bermeo/live/render_18_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/culmia/bermeo/live/render_19_suite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/bermeo/live/render_20_banosuite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 02',
                src: 'https://media.bizionar.digital/culmia/bermeo/live/render_21_banosuite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/bermeo/live/render_22_terraza_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 02',
                src: 'https://media.bizionar.digital/culmia/bermeo/live/render_23_terraza_02.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'mar-de-calonge',
          name: 'Mar de Calonge',
          city: 'Baix Empordà',
          province: 'Girona',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/mar-de-calonge',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/mar-de-calonge',
          image: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/cam03.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 4,
              totalReviews: 4,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '4 de julio de 2023',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '28 de julio de 2023',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '18 de agosto de 2023',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '13 de septiembre de 2023',
                  status: 'closed',
                },
                {
                  id: 'review05',
                  name: 'ENTREGA 5',
                  date: '31 de enero de 2025',
                  isLive: true,
                  isFinal: true,
                  status: 'closed',
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 7,
              totalReviews: 7,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '31 de mayo de 2023',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '17 de julio de 2023',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '28 de julio de 2023',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '18 de agosto de 2023',
                  status: 'closed',
                },
                {
                  id: 'review05',
                  name: 'ENTREGA 5',
                  date: '13 de septiembre de 2023',
                  status: 'closed',
                },
                {
                  id: 'review06',
                  name: 'ENTREGA 6',
                  date: '13 de noviembre de 2023',
                  status: 'closed',
                },
                {
                  id: 'review07',
                  name: 'ENTREGA 7',
                  date: '13 de diciembre de 2023',
                  status: 'closed',
                },
                {
                  id: 'review08',
                  name: 'ENTREGA 8',
                  date: '15 de enero de 2025',
                  status: 'closed',
                },
                {
                  id: 'review09',
                  name: 'ENTREGA 9',
                  date: '1 de febrero de 2025',
                  isLive: true,
                  isFinal: true,
                  status: 'closed',
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mar-de-calonge/review01/render/exterior/cam03.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mar-de-calonge/review01/render/exterior/cam03.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review01/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review01/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review01/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review01/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review01/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review01/render/interior/render_01_salon01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review01/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review01/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review01/render/interior/render_04_salon04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review01/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review01/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review01/render/interior/render_07_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 08',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review01/render/interior/render_08_salon_08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review01/render/interior/render_09_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review01/render/interior/render_10_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review01/render/interior/render_11_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review01/render/interior/render_12_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review01/render/interior/render_13_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review01/render/interior/render_14_bano_comun_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review01/render/interior/render_15_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review01/render/interior/render_16_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review01/render/interior/render_17_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review01/render/interior/render_18_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review01/render/interior/render_20_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review01/render/interior/render_21_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mar-de-calonge/review02/render/exterior/cam03.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mar-de-calonge/review02/render/exterior/cam03.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review02/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review02/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review02/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review02/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review02/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review02/render/interior/render_01_salon01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review02/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review02/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review02/render/interior/render_04_salon04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review02/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review02/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review02/render/interior/render_07_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 08',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review02/render/interior/render_08_salon_08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review02/render/interior/render_09_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review02/render/interior/render_10_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review02/render/interior/render_11_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review02/render/interior/render_12_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review02/render/interior/render_13_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review02/render/interior/render_14_bano_comun_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review02/render/interior/render_15_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review02/render/interior/render_16_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review02/render/interior/render_17_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review02/render/interior/render_18_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review02/render/interior/render_20_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review02/render/interior/render_21_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review05/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/render/exterior/cam03.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/render/exterior/cam03.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/render/interior/render_01_salon01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/render/interior/render_04_salon04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/render/interior/render_07_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 08',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/render/interior/render_08_salon_08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/render/interior/render_09_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/render/interior/render_10_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/render/interior/render_11_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/render/interior/render_12_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/render/interior/render_13_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/render/interior/render_14_bano_comun_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/render/interior/render_15_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/render/interior/render_16_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/render/interior/render_17_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/render/interior/render_18_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/render/interior/render_20_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/render/interior/render_21_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mar-de-calonge/review04/render/exterior/cam03.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mar-de-calonge/review04/render/exterior/cam03.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review04/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review04/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review04/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review04/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review04/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review04/render/interior/render_01_salon01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review04/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review04/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review04/render/interior/render_04_salon04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review04/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review04/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review04/render/interior/render_07_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 08',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review04/render/interior/render_08_salon_08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review04/render/interior/render_09_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review04/render/interior/render_10_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review04/render/interior/render_11_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review04/render/interior/render_12_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review04/render/interior/render_13_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review04/render/interior/render_14_bano_comun_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review04/render/interior/render_15_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review04/render/interior/render_16_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review04/render/interior/render_17_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review04/render/interior/render_18_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review04/render/interior/render_20_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review04/render/interior/render_21_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review05',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review09/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mar-de-calonge/review05/render/exterior/cam03.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review05/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/render/exterior/cam03.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Aérea Extra',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review05/render/exterior/aerea_extra.png',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Captura High',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review05/render/exterior/captura_high.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review05/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review05/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review05/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review05/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review05/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review05/render/interior/render_01_salon01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review05/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review05/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review05/render/interior/render_04_salon04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review05/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review05/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review05/render/interior/render_07_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 08',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review05/render/interior/render_08_salon_08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review05/render/interior/render_09_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review05/render/interior/render_10_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review05/render/interior/render_11_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review05/render/interior/render_12_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review05/render/interior/render_13_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review05/render/interior/render_14_bano_comun_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review05/render/interior/render_15_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review05/render/interior/render_16_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review05/render/interior/render_17_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review05/render/interior/render_18_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review05/render/interior/render_20_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review05/render/interior/render_21_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review06',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review06/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/render/exterior/cam03.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review06/render/interior/render_01_salon01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review06/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review06/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review06/render/interior/render_04_salon04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review06/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review06/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review06/render/interior/render_07_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 08',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review06/render/interior/render_08_salon_08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review06/render/interior/render_09_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review06/render/interior/render_10_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review06/render/interior/render_11_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review06/render/interior/render_12_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review06/render/interior/render_13_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review06/render/interior/render_14_bano_comun_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review06/render/interior/render_15_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review06/render/interior/render_16_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review06/render/interior/render_17_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review06/render/interior/render_18_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review06/render/interior/render_20_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review06/render/interior/render_21_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review07',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review07/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/render/exterior/cam03.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review07/render/interior/render_01_salon01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review07/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review07/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review07/render/interior/render_04_salon04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review07/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review07/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review07/render/interior/render_07_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 08',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review07/render/interior/render_08_salon_08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review07/render/interior/render_09_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review07/render/interior/render_10_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review07/render/interior/render_11_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review07/render/interior/render_12_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review07/render/interior/render_13_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review07/render/interior/render_14_bano_comun_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review07/render/interior/render_15_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review07/render/interior/render_16_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review07/render/interior/render_17_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review07/render/interior/render_18_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review07/render/interior/render_20_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review07/render/interior/render_21_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review08',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review09/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mar-de-calonge/review03/render/exterior/cam03.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review08/render/interior/render_01_salon01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review08/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review08/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review08/render/interior/render_04_salon04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review08/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review08/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review08/render/interior/render_07_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 08',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review08/render/interior/render_08_salon_08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review08/render/interior/render_09_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review08/render/interior/render_10_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review08/render/interior/render_11_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review08/render/interior/render_12_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review08/render/interior/render_13_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review08/render/interior/render_14_bano_comun_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review08/render/interior/render_15_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review08/render/interior/render_16_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review08/render/interior/render_17_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review08/render/interior/render_18_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review08/render/interior/render_20_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review08/render/interior/render_21_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review09',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review10/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mar-de-calonge/review05/render/exterior/cam03.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review09/render/interior/render_01_salon01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review09/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review09/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review09/render/interior/render_04_salon04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review09/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review09/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review09/render/interior/render_07_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 08',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review09/render/interior/render_08_salon_08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review09/render/interior/render_09_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review09/render/interior/render_10_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review09/render/interior/render_11_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review09/render/interior/render_12_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review09/render/interior/render_13_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review09/render/interior/render_14_bano_comun_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review09/render/interior/render_15_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review09/render/interior/render_16_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review09/render/interior/render_17_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review09/render/interior/render_18_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review09/render/interior/render_20_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/mar-de-calonge/review09/render/interior/render_21_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '18 de febrero de 2025',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/mar-de-calonge/download/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/mar-de-calonge/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/cam03.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/cam03.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/cam03.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/cam03.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Aérea Extra',
                src: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/aerea_extra.png',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Captura High',
                src: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/captura_high.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/cam01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/cam02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/cam03.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 04',
                src: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/cam04.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 05',
                src: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/cam05.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/render_01_salon01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/render_02_salon_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/render_03_salon_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/render_04_salon04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/render_05_salon_05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/render_06_salon_06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 07',
                src: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/render_07_salon_07.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 08',
                src: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/render_08_salon_08.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/render_09_cocina_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/render_10_cocina_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/render_11_hab01_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/render_12_hab02_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/render_13_bano_comun_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 02',
                src: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/render_14_bano_comun_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/render_15_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/render_16_suite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 03',
                src: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/render_17_suite_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/render_18_bano_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/render_20_terraza_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 02',
                src: 'https://media.bizionar.digital/culmia/mar-de-calonge/live/render_21_terraza_02.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'can-mare',
          name: 'Can Mare',
          city: 'Palma de Mallorca',
          province: 'Palma de Mallorca',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/can-mare',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/can-mare',
          image: 'https://media.bizionar.digital/culmia/can-mare/live/render_pool.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '5 de julio de 2023',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '11 de agosto de 2023',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '13 de noviembre de 2023',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 5,
              totalReviews: 5,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '25 de julio de 2023',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '25 de septiembre de 2023',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '13 de noviembre de 2023',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '15 de noviembre de 2024',
                  status: 'closed',
                },
                {
                  id: 'review05',
                  name: 'ENTREGA 5',
                  date: '8 de marzo de 2024',
                  status: 'closed',
                },
                {
                  id: 'review06',
                  name: 'ENTREGA 6',
                  date: '18 de marzo de 2024',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                }
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/can-mare/review01/render/exterior/render_pool.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/can-mare/review01/render/exterior/render_pool.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review01/render/exterior/render_pool.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review01/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review01/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review01/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review01/render/interior/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review01/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review01/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review01/render/interior/render_07_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review01/render/interior/render_08_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review01/render/interior/render_09_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review01/render/interior/render_10_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review01/render/interior/render_11_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review01/render/interior/render_12_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review01/render/interior/render_13_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review01/render/interior/render_14_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review01/render/interior/render_15_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review01/render/interior/render_16_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review01/render/interior/render_17_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review01/render/interior/render_18_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/can-mare/review02/render/exterior/render_pool.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/can-mare/review02/render/exterior/render_pool.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review02/render/exterior/render_pool.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review02/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review02/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review02/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review02/render/interior/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review02/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review02/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review02/render/interior/render_07_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review02/render/interior/render_08_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review02/render/interior/render_09_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review02/render/interior/render_10_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review02/render/interior/render_11_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review02/render/interior/render_12_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review02/render/interior/render_13_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review02/render/interior/render_14_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review02/render/interior/render_15_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review02/render/interior/render_16_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review02/render/interior/render_17_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review02/render/interior/render_18_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review06/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/can-mare/review03/render/exterior/render_pool.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/can-mare/review03/render/exterior/render_pool.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review03/render/exterior/render_pool.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review03/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review03/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review03/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review03/render/interior/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review03/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review03/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review03/render/interior/render_07_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review03/render/interior/render_08_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review03/render/interior/render_09_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review03/render/interior/render_10_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review03/render/interior/render_11_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review03/render/interior/render_12_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review03/render/interior/render_13_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review03/render/interior/render_14_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review03/render/interior/render_15_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review03/render/interior/render_16_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review03/render/interior/render_17_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review03/render/interior/render_18_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/can-mare/review03/render/exterior/render_pool.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review04/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review04/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review04/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review04/render/interior/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review04/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review04/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review04/render/interior/render_07_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review04/render/interior/render_08_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review04/render/interior/render_09_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review04/render/interior/render_10_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review04/render/interior/render_11_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review04/render/interior/render_12_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review04/render/interior/render_13_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review04/render/interior/render_14_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review04/render/interior/render_15_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review04/render/interior/render_16_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review04/render/interior/render_17_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review04/render/interior/render_18_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review05',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review05/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/can-mare/review03/render/exterior/render_pool.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review05/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review05/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review05/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review05/render/interior/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review05/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review05/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review05/render/interior/render_07_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review05/render/interior/render_08_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review05/render/interior/render_09_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review05/render/interior/render_10_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review05/render/interior/render_11_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review05/render/interior/render_12_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review05/render/interior/render_13_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review05/render/interior/render_14_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review05/render/interior/render_15_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review05/render/interior/render_16_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review05/render/interior/render_17_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review05/render/interior/render_18_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review06',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review06/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/can-mare/review03/render/exterior/render_pool.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review06/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review06/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review06/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review06/render/interior/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review06/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review06/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review06/render/interior/render_07_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review06/render/interior/render_08_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review06/render/interior/render_09_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review06/render/interior/render_10_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review06/render/interior/render_11_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review06/render/interior/render_12_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review06/render/interior/render_13_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review06/render/interior/render_14_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review06/render/interior/render_15_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review06/render/interior/render_16_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review06/render/interior/render_17_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare/review06/render/interior/render_18_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '8 de abril de 2024',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/can-mare/download/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/can-mare/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/can-mare/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/can-mare/live/render_pool.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/can-mare/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/can-mare/live/render_pool.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/culmia/can-mare/live/render_pool.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/can-mare/live/render_01_salon_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/can-mare/live/render_02_salon_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/can-mare/live/render_03_salon_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/can-mare/live/render_04_salon_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/culmia/can-mare/live/render_05_salon_05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/culmia/can-mare/live/render_06_salon_06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/can-mare/live/render_07_cocina_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/can-mare/live/render_08_cocina_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Recibidor 01',
                src: 'https://media.bizionar.digital/culmia/can-mare/live/render_09_recibidor_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/culmia/can-mare/live/render_10_hab01_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/culmia/can-mare/live/render_11_hab02_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/can-mare/live/render_12_banocomun_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/culmia/can-mare/live/render_13_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/culmia/can-mare/live/render_14_suite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 03',
                src: 'https://media.bizionar.digital/culmia/can-mare/live/render_15_suite_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/can-mare/live/render_16_banosuite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/can-mare/live/render_17_terraza_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 02',
                src: 'https://media.bizionar.digital/culmia/can-mare/live/render_18_terraza_02.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'arbeyal-ii-gijon',
          name: 'Arbeyal III Gijón',
          city: 'Gijón',
          province: 'Asturias',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/arbeyal-ii-gijon',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/arbeyal-ii-gijon',
          image: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/cam06b.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '18 de agosto de 2023',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '5 de septiembre de 2023',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '18 de agosto de 2023',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '5 de septiembre de 2023',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '15 de septiembre de 2023',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review01/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review01/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01 - Estudio',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review01/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02 - Estudio',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review01/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07 - Estudio',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review01/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review01/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review01/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review01/render/exterior/cam06b.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review01/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review01/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review01/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review01/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review01/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review01/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review01/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review01/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review01/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review01/render/interior/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review01/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review01/render/interior/render_11_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review01/render/interior/render_12_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review01/render/interior/render_13_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review01/render/interior/render_14_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review01/render/interior/render_15_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review01/render/interior/render_16_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review01/render/interior/render_17_banosuite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review01/render/interior/render_18_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review02/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review02/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01 - Estudio',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review02/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02 - Estudio',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review02/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07 - Estudio',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review02/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review02/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review02/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review02/render/exterior/cam06b.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review02/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review02/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review02/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review02/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review02/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review02/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review02/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review02/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review02/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review02/render/interior/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review02/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review02/render/interior/render_11_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review02/render/interior/render_12_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review02/render/interior/render_13_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review02/render/interior/render_14_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review02/render/interior/render_15_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review02/render/interior/render_16_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review02/render/interior/render_17_banosuite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review02/render/interior/render_18_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review02/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review03/render/interior/render_03_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review03/render/interior/render_02_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review03/render/interior/render_04_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review03/render/interior/render_05_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review03/render/interior/render_06_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review03/render/interior/render_07_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review03/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review03/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review03/render/interior/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review03/render/interior/render_01_recibidor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review03/render/interior/render_11_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review03/render/interior/render_12_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review03/render/interior/render_13_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review03/render/interior/render_14_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review03/render/interior/render_15_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review03/render/interior/render_16_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review03/render/interior/render_17_banosuite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/review03/render/interior/render_18_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '12 de septiembre de 2023',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/download/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/cam01.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/cam01.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/cam01.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/cam01.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 01 - Estudio',
                src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/cam01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02 - Estudio',
                src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/cam02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 07 - Estudio',
                src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/cam07.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/cam03.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 04',
                src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/cam04.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 06',
                src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/cam06b.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 09',
                src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/cam09.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/render_03_salon_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/render_02_salon_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/render_04_salon_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/render_05_salon_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/render_06_salon_05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/render_07_salon_06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/render_08_cocina_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/render_09_cocina_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/render_10_cocina_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Recibidor 01',
                src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/render_01_recibidor_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/render_11_hab1_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 02',
                src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/render_12_hab1_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/render_13_banocomun_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/render_14_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/render_15_suite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 03',
                src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/render_16_suite_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/render_17_banosuite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/arbeyal-ii-gijon/live/render_18_terraza_01.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'arbeyal-iv-gijon',
          name: 'Arbeyal IV Gijón',
          city: 'Gijón',
          province: 'Asturias',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/arbeyal-iv-gijon',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/arbeyal-iv-gijon',
          image: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/exterior/cam04.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '22 de mayo de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '30 de mayo de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '16 de junio de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '30 de mayo de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '16 de junio de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '3 de julio de 2025',
                  status: 'pending',
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review01/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review01/render/interior/render_SALON01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01 - Estudio',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review01/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07 - Estudio',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review01/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12 - Estudio',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review01/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review01/render/interior/render_SALON01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review01/render/interior/render_SALON02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review01/render/interior/render_SALON03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review01/render/interior/render_SALON04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review01/render/interior/render_SALON05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review01/render/interior/render_SALON06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review01/render/interior/render_SALON07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review01/render/interior/render_COCINA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review01/render/interior/render_COCINA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review01/render/interior/render_COCINA03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review01/render/interior/render_BANO_COMUN01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review01/render/interior/render_BANO_COMUN02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación1 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review01/render/interior/render_HAB01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación2 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review01/render/interior/render_HAB02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review01/render/interior/render_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review01/render/interior/render_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review01/render/interior/render_BANO_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review01/render/interior/render_BANO_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review01/render/interior/render_TERRAZA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review01/render/interior/render_TERRAZA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/render/exterior/cam02.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/render/exterior/cam04.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/render/interior/render_SALON01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/render/exterior/cam13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/render/exterior/cam14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01 - Estudio',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07 - Estudio',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12 - Estudio',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/render/interior/render_SALON01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/render/interior/render_SALON02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/render/interior/render_SALON03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/render/interior/render_SALON04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/render/interior/render_SALON05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/render/interior/render_SALON06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/render/interior/render_SALON07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/render/interior/render_COCINA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/render/interior/render_COCINA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/render/interior/render_COCINA03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/render/interior/render_BANO_COMUN01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/render/interior/render_BANO_COMUN02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación1 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/render/interior/render_HAB01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación2 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/render/interior/render_HAB02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/render/interior/render_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/render/interior/render_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/render/interior/render_BANO_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/render/interior/render_BANO_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/render/interior/render_TERRAZA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review02/render/interior/render_TERRAZA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/render/exterior/cam02.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/render/exterior/cam04.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/render/interior/render_SALON01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/render/exterior/cam13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/render/exterior/cam14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01 - Estudio',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07 - Estudio',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12 - Estudio',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/render/interior/render_SALON01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/render/interior/render_SALON02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/render/interior/render_SALON03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/render/interior/render_SALON04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/render/interior/render_SALON05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/render/interior/render_SALON06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/render/interior/render_SALON07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/render/interior/render_COCINA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/render/interior/render_COCINA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/render/interior/render_COCINA03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/render/interior/render_BANO_COMUN01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/render/interior/render_BANO_COMUN02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación1 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/render/interior/render_HAB01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación2 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/render/interior/render_HAB02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/render/interior/render_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/render/interior/render_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/render/interior/render_BANO_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/render/interior/render_BANO_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/render/interior/render_TERRAZA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/review03/render/interior/render_TERRAZA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '8 de julio de 2025',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/download/exterior/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/download/interior/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/exterior/cam04.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/exterior/cam04.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/exterior/cam02.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/video/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/exterior/cam04.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/video/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/exterior/cam04.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 04',
                src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/exterior/cam04.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/exterior/cam02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 13',
                src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/exterior/cam13.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 14',
                src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/exterior/cam14.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 01 - Estudio',
                src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/exterior/cam01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 07 - Estudio',
                src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/exterior/cam07.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 12 - Estudio',
                src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/exterior/cam12.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/interior/render_SALON01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/interior/render_SALON02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/interior/render_SALON03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/interior/render_SALON04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/interior/render_SALON05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/interior/render_SALON06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 07',
                src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/interior/render_SALON07.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/interior/render_COCINA01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/interior/render_COCINA02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/interior/render_COCINA03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/interior/render_BANO_COMUN01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 02',
                src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/interior/render_BANO_COMUN02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación1 01',
                src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/interior/render_HAB01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación2 01',
                src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/interior/render_HAB02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 01',
                src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/interior/render_SUITE01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 02',
                src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/interior/render_SUITE02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/interior/render_BANO_SUITE01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 02',
                src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/interior/render_BANO_SUITE02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/interior/render_TERRAZA01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 02',
                src: 'https://media.bizionar.digital/culmia/arbeyal-iv-gijon/live/interior/render_TERRAZA02.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'mijas',
          name: 'Cala Swing Mijas',
          city: 'Mijas',
          province: 'Málaga',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/mijas',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/mijas',
          image: 'https://media.bizionar.digital/culmia/mijas/live/cam03.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 6,
              totalReviews: 6,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '5 de marzo de 2024',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '17 de abril de 2024',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '24 de abril de 2024',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '14 de junio de 2024',
                  status: 'closed',
                },
                {
                  id: 'review05',
                  name: 'ENTREGA 5',
                  date: '15 de julio de 2024',
                  status: 'closed',
                },
                {
                  id: 'review06',
                  name: 'ENTREGA 6',
                  date: '12 de mayo de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
                {
                  id: 'review07',
                  name: 'ENTREGA 7',
                  date: '19 de octubre de 2026',
                  status: 'pending',
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 5,
              totalReviews: 5,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '5 de marzo de 2024',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '2 de abril de 2024',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '17 de abril de 2024',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '29 de abril de 2024',
                  status: 'closed',
                },
                {
                  id: 'review05',
                  name: 'ENTREGA 5',
                  date: '18 de junio de 2024',
                  status: 'closed',
                },
                {
                  id: 'review06',
                  name: 'ENTREGA 6',
                  date: '8 de julio de 2024',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/mijas/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mijas/review01/render/exterior/cam13.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/mijas/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mijas/review01/render/exterior/cam03.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/mijas/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mijas/review01/render/exterior/cam13.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/mijas/review01/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/mijas/review01/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/mijas/review01/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/mijas/review01/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/mijas/review01/render/exterior/cam13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/culmia/mijas/review01/render/exterior/cam15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render interior 01',
                  src: 'https://media.bizionar.digital/culmia/mijas/review01/render/interior/render_CAM01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 02',
                  src: 'https://media.bizionar.digital/culmia/mijas/review01/render/interior/render_CAM02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 03',
                  src: 'https://media.bizionar.digital/culmia/mijas/review01/render/interior/render_CAM03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 04',
                  src: 'https://media.bizionar.digital/culmia/mijas/review01/render/interior/render_CAM04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 05',
                  src: 'https://media.bizionar.digital/culmia/mijas/review01/render/interior/render_CAM05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 06',
                  src: 'https://media.bizionar.digital/culmia/mijas/review01/render/interior/render_CAM06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 07',
                  src: 'https://media.bizionar.digital/culmia/mijas/review01/render/interior/render_CAM07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 08',
                  src: 'https://media.bizionar.digital/culmia/mijas/review01/render/interior/render_CAM08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 09',
                  src: 'https://media.bizionar.digital/culmia/mijas/review01/render/interior/render_CAM09.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 10',
                  src: 'https://media.bizionar.digital/culmia/mijas/review01/render/interior/render_CAM10.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 11',
                  src: 'https://media.bizionar.digital/culmia/mijas/review01/render/interior/render_CAM11.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 12',
                  src: 'https://media.bizionar.digital/culmia/mijas/review01/render/interior/render_CAM12.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 13',
                  src: 'https://media.bizionar.digital/culmia/mijas/review01/render/interior/render_CAM13.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 14',
                  src: 'https://media.bizionar.digital/culmia/mijas/review01/render/interior/render_CAM14.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 15',
                  src: 'https://media.bizionar.digital/culmia/mijas/review01/render/interior/render_CAM15.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 16',
                  src: 'https://media.bizionar.digital/culmia/mijas/review01/render/interior/render_CAM16.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 17',
                  src: 'https://media.bizionar.digital/culmia/mijas/review01/render/interior/render_CAM17.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 18',
                  src: 'https://media.bizionar.digital/culmia/mijas/review01/render/interior/render_CAM18.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 19',
                  src: 'https://media.bizionar.digital/culmia/mijas/review01/render/interior/render_CAM19.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 20',
                  src: 'https://media.bizionar.digital/culmia/mijas/review01/render/interior/render_CAM20.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/mijas/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mijas/review02/render/exterior/cam13.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/mijas/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mijas/review02/render/exterior/cam03.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/mijas/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mijas/review02/render/exterior/cam13.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/mijas/review02/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/mijas/review02/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/mijas/review02/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/mijas/review02/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/mijas/review02/render/exterior/cam13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/culmia/mijas/review02/render/exterior/cam15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Aérea',
                  src: 'https://media.bizionar.digital/culmia/mijas/review02/render/exterior/aerea_still.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Top',
                  src: 'https://media.bizionar.digital/culmia/mijas/review02/render/exterior/top.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render interior 01',
                  src: 'https://media.bizionar.digital/culmia/mijas/review02/render/interior/render_CAM01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 02',
                  src: 'https://media.bizionar.digital/culmia/mijas/review02/render/interior/render_CAM02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 03',
                  src: 'https://media.bizionar.digital/culmia/mijas/review02/render/interior/render_CAM03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 04',
                  src: 'https://media.bizionar.digital/culmia/mijas/review02/render/interior/render_CAM04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 05',
                  src: 'https://media.bizionar.digital/culmia/mijas/review02/render/interior/render_CAM05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 06',
                  src: 'https://media.bizionar.digital/culmia/mijas/review02/render/interior/render_CAM06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 07',
                  src: 'https://media.bizionar.digital/culmia/mijas/review02/render/interior/render_CAM07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 08',
                  src: 'https://media.bizionar.digital/culmia/mijas/review02/render/interior/render_CAM08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 09',
                  src: 'https://media.bizionar.digital/culmia/mijas/review02/render/interior/render_CAM09.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 10',
                  src: 'https://media.bizionar.digital/culmia/mijas/review02/render/interior/render_CAM10.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 11',
                  src: 'https://media.bizionar.digital/culmia/mijas/review02/render/interior/render_CAM11.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 12',
                  src: 'https://media.bizionar.digital/culmia/mijas/review02/render/interior/render_CAM12.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 13',
                  src: 'https://media.bizionar.digital/culmia/mijas/review02/render/interior/render_CAM13.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 14',
                  src: 'https://media.bizionar.digital/culmia/mijas/review02/render/interior/render_CAM14.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 15',
                  src: 'https://media.bizionar.digital/culmia/mijas/review02/render/interior/render_CAM15.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 16',
                  src: 'https://media.bizionar.digital/culmia/mijas/review02/render/interior/render_CAM16.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 17',
                  src: 'https://media.bizionar.digital/culmia/mijas/review02/render/interior/render_CAM17.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 18',
                  src: 'https://media.bizionar.digital/culmia/mijas/review02/render/interior/render_CAM18.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 19',
                  src: 'https://media.bizionar.digital/culmia/mijas/review02/render/interior/render_CAM19.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 20',
                  src: 'https://media.bizionar.digital/culmia/mijas/review02/render/interior/render_CAM20.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/mijas/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mijas/review03/render/exterior/cam13.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/mijas/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mijas/review03/render/exterior/cam03.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/mijas/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mijas/review03/render/exterior/cam13.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/mijas/review03/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/mijas/review03/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/mijas/review03/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/mijas/review03/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/mijas/review03/render/exterior/cam13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/culmia/mijas/review03/render/exterior/cam15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Aérea',
                  src: 'https://media.bizionar.digital/culmia/mijas/review03/render/exterior/aerea_still.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Top',
                  src: 'https://media.bizionar.digital/culmia/mijas/review03/render/exterior/top.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render interior 01',
                  src: 'https://media.bizionar.digital/culmia/mijas/review03/render/interior/render_CAM01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 02',
                  src: 'https://media.bizionar.digital/culmia/mijas/review03/render/interior/render_CAM02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 03',
                  src: 'https://media.bizionar.digital/culmia/mijas/review03/render/interior/render_CAM03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 04',
                  src: 'https://media.bizionar.digital/culmia/mijas/review03/render/interior/render_CAM04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 05',
                  src: 'https://media.bizionar.digital/culmia/mijas/review03/render/interior/render_CAM05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 06',
                  src: 'https://media.bizionar.digital/culmia/mijas/review03/render/interior/render_CAM06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 07',
                  src: 'https://media.bizionar.digital/culmia/mijas/review03/render/interior/render_CAM07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 08',
                  src: 'https://media.bizionar.digital/culmia/mijas/review03/render/interior/render_CAM08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 09',
                  src: 'https://media.bizionar.digital/culmia/mijas/review03/render/interior/render_CAM09.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 10',
                  src: 'https://media.bizionar.digital/culmia/mijas/review03/render/interior/render_CAM10.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 11',
                  src: 'https://media.bizionar.digital/culmia/mijas/review03/render/interior/render_CAM11.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 12',
                  src: 'https://media.bizionar.digital/culmia/mijas/review03/render/interior/render_CAM12.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 13',
                  src: 'https://media.bizionar.digital/culmia/mijas/review03/render/interior/render_CAM13.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 14',
                  src: 'https://media.bizionar.digital/culmia/mijas/review03/render/interior/render_CAM14.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 15',
                  src: 'https://media.bizionar.digital/culmia/mijas/review03/render/interior/render_CAM15.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 16',
                  src: 'https://media.bizionar.digital/culmia/mijas/review03/render/interior/render_CAM16.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 17',
                  src: 'https://media.bizionar.digital/culmia/mijas/review03/render/interior/render_CAM17.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 18',
                  src: 'https://media.bizionar.digital/culmia/mijas/review03/render/interior/render_CAM18.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 19',
                  src: 'https://media.bizionar.digital/culmia/mijas/review03/render/interior/render_CAM19.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 20',
                  src: 'https://media.bizionar.digital/culmia/mijas/review03/render/interior/render_CAM20.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/mijas/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mijas/live/cam13.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/mijas/review04/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/mijas/review04/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/mijas/review04/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/mijas/review04/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/mijas/review04/render/exterior/cam13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/culmia/mijas/review04/render/exterior/cam15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Aérea',
                  src: 'https://media.bizionar.digital/culmia/mijas/review04/render/exterior/aerea_still.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Top',
                  src: 'https://media.bizionar.digital/culmia/mijas/review04/render/exterior/top.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render interior 01',
                  src: 'https://media.bizionar.digital/culmia/mijas/review04/render/interior/render_CAM01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 02',
                  src: 'https://media.bizionar.digital/culmia/mijas/review04/render/interior/render_CAM02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 03',
                  src: 'https://media.bizionar.digital/culmia/mijas/review04/render/interior/render_CAM03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 04',
                  src: 'https://media.bizionar.digital/culmia/mijas/review04/render/interior/render_CAM04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 05',
                  src: 'https://media.bizionar.digital/culmia/mijas/review04/render/interior/render_CAM05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 06',
                  src: 'https://media.bizionar.digital/culmia/mijas/review04/render/interior/render_CAM06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 07',
                  src: 'https://media.bizionar.digital/culmia/mijas/review04/render/interior/render_CAM07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 08',
                  src: 'https://media.bizionar.digital/culmia/mijas/review04/render/interior/render_CAM08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 09',
                  src: 'https://media.bizionar.digital/culmia/mijas/review04/render/interior/render_CAM09.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 10',
                  src: 'https://media.bizionar.digital/culmia/mijas/review04/render/interior/render_CAM10.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 11',
                  src: 'https://media.bizionar.digital/culmia/mijas/review04/render/interior/render_CAM11.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 12',
                  src: 'https://media.bizionar.digital/culmia/mijas/review04/render/interior/render_CAM12.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 13',
                  src: 'https://media.bizionar.digital/culmia/mijas/review04/render/interior/render_CAM13.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 14',
                  src: 'https://media.bizionar.digital/culmia/mijas/review04/render/interior/render_CAM14.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 15',
                  src: 'https://media.bizionar.digital/culmia/mijas/review04/render/interior/render_CAM15.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 16',
                  src: 'https://media.bizionar.digital/culmia/mijas/review04/render/interior/render_CAM16.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 17',
                  src: 'https://media.bizionar.digital/culmia/mijas/review04/render/interior/render_CAM17.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 18',
                  src: 'https://media.bizionar.digital/culmia/mijas/review04/render/interior/render_CAM18.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 19',
                  src: 'https://media.bizionar.digital/culmia/mijas/review04/render/interior/render_CAM19.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 20',
                  src: 'https://media.bizionar.digital/culmia/mijas/review04/render/interior/render_CAM20.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review05',
              content: [
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/mijas/review05/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/mijas/review05/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/mijas/review05/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/mijas/review05/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/mijas/review05/render/exterior/cam13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/culmia/mijas/review05/render/exterior/cam15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Aérea',
                  src: 'https://media.bizionar.digital/culmia/mijas/review05/render/exterior/aerea_still.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Top',
                  src: 'https://media.bizionar.digital/culmia/mijas/review05/render/exterior/top.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render interior 01',
                  src: 'https://media.bizionar.digital/culmia/mijas/review05/render/interior/render_CAM01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 02',
                  src: 'https://media.bizionar.digital/culmia/mijas/review05/render/interior/render_CAM02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 03',
                  src: 'https://media.bizionar.digital/culmia/mijas/review05/render/interior/render_CAM03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 04',
                  src: 'https://media.bizionar.digital/culmia/mijas/review05/render/interior/render_CAM04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 05',
                  src: 'https://media.bizionar.digital/culmia/mijas/review05/render/interior/render_CAM05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 06',
                  src: 'https://media.bizionar.digital/culmia/mijas/review05/render/interior/render_CAM06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 07',
                  src: 'https://media.bizionar.digital/culmia/mijas/review05/render/interior/render_CAM07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 08',
                  src: 'https://media.bizionar.digital/culmia/mijas/review05/render/interior/render_CAM08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 09',
                  src: 'https://media.bizionar.digital/culmia/mijas/review05/render/interior/render_CAM09.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 10',
                  src: 'https://media.bizionar.digital/culmia/mijas/review05/render/interior/render_CAM10.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 11',
                  src: 'https://media.bizionar.digital/culmia/mijas/review05/render/interior/render_CAM11.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 12',
                  src: 'https://media.bizionar.digital/culmia/mijas/review05/render/interior/render_CAM12.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 13',
                  src: 'https://media.bizionar.digital/culmia/mijas/review05/render/interior/render_CAM13.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 14',
                  src: 'https://media.bizionar.digital/culmia/mijas/review05/render/interior/render_CAM14.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 15',
                  src: 'https://media.bizionar.digital/culmia/mijas/review05/render/interior/render_CAM15.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 16',
                  src: 'https://media.bizionar.digital/culmia/mijas/review05/render/interior/render_CAM16.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 17',
                  src: 'https://media.bizionar.digital/culmia/mijas/review05/render/interior/render_CAM17.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 18',
                  src: 'https://media.bizionar.digital/culmia/mijas/review05/render/interior/render_CAM18.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 19',
                  src: 'https://media.bizionar.digital/culmia/mijas/review05/render/interior/render_CAM19.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 20',
                  src: 'https://media.bizionar.digital/culmia/mijas/review05/render/interior/render_CAM20.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review06',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/mijas/review06/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mijas/review06/render/exterior/cam03.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/mijas/review06/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mijas/review06/render/exterior/cam08.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Simulador Solar',
                  src: 'https://solar-simulator.bizionar.digital/culmia/mijas/review06',
                  thumb: 'https://media.bizionar.digital/culmia/mijas/review06/render/exterior/cam03.jpg',
                  type: 'solar-simulator',
                  category: 'exteriores',
                },
                {
                  name: 'Video Completo',
                  src: 'https://media.bizionar.digital/culmia/mijas/review06/video/video_completo.mp4',
                  thumb: 'https://media.bizionar.digital/culmia/mijas/review06/render/exterior/cam03.jpg',
                  type: 'video',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/mijas/review06/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/mijas/review06/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/mijas/review06/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Aérea',
                  src: 'https://media.bizionar.digital/culmia/mijas/review06/render/exterior/aerea_still.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Top',
                  src: 'https://media.bizionar.digital/culmia/mijas/review06/render/exterior/top.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render interior 01',
                  src: 'https://media.bizionar.digital/culmia/mijas/review06/render/interior/render_CAM01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 02',
                  src: 'https://media.bizionar.digital/culmia/mijas/review06/render/interior/render_CAM02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 03',
                  src: 'https://media.bizionar.digital/culmia/mijas/review06/render/interior/render_CAM03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 04',
                  src: 'https://media.bizionar.digital/culmia/mijas/review06/render/interior/render_CAM04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 05',
                  src: 'https://media.bizionar.digital/culmia/mijas/review06/render/interior/render_CAM05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 06',
                  src: 'https://media.bizionar.digital/culmia/mijas/review06/render/interior/render_CAM06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 07',
                  src: 'https://media.bizionar.digital/culmia/mijas/review06/render/interior/render_CAM07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 08',
                  src: 'https://media.bizionar.digital/culmia/mijas/review06/render/interior/render_CAM08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 09',
                  src: 'https://media.bizionar.digital/culmia/mijas/review06/render/interior/render_CAM09.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 10',
                  src: 'https://media.bizionar.digital/culmia/mijas/review06/render/interior/render_CAM10.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 11',
                  src: 'https://media.bizionar.digital/culmia/mijas/review06/render/interior/render_CAM11.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 12',
                  src: 'https://media.bizionar.digital/culmia/mijas/review06/render/interior/render_CAM12.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 13',
                  src: 'https://media.bizionar.digital/culmia/mijas/review06/render/interior/render_CAM13.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 14',
                  src: 'https://media.bizionar.digital/culmia/mijas/review06/render/interior/render_CAM14.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 15',
                  src: 'https://media.bizionar.digital/culmia/mijas/review06/render/interior/render_CAM15.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 16',
                  src: 'https://media.bizionar.digital/culmia/mijas/review06/render/interior/render_CAM16.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 17',
                  src: 'https://media.bizionar.digital/culmia/mijas/review06/render/interior/render_CAM17.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 18',
                  src: 'https://media.bizionar.digital/culmia/mijas/review06/render/interior/render_CAM18.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 19',
                  src: 'https://media.bizionar.digital/culmia/mijas/review06/render/interior/render_CAM19.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 20',
                  src: 'https://media.bizionar.digital/culmia/mijas/review06/render/interior/render_CAM20.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review07',
              content: [
                {
                  name: 'Render Integración 01',
                  src: 'https://media.bizionar.digital/culmia/mijas/review07/render/exterior/01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Integración 02',
                  src: 'https://media.bizionar.digital/culmia/mijas/review07/render/exterior/02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Integración 03',
                  src: 'https://media.bizionar.digital/culmia/mijas/review07/render/exterior/03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Integración 04',
                  src: 'https://media.bizionar.digital/culmia/mijas/review07/render/exterior/04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Integración 05',
                  src: 'https://media.bizionar.digital/culmia/mijas/review07/render/exterior/05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '27 de mayo de 2025',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/mijas/download/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/mijas/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/mijas/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/mijas/live/cam03.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/mijas/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/mijas/live/cam03.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/mijas/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/mijas/live/cam03.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Vistas Reales',
                src: 'https://media.bizionar.digital/culmia/mijas/live/tour-vistas-reales/index.html',
                thumb: 'https://media.bizionar.digital/culmia/mijas/live/cam03.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/mijas/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/mijas/live/cam03.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/culmia/mijas/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/culmia/mijas/live/cam03.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Simulador Solar',
                src: 'https://solar-simulator.bizionar.digital/culmia/mijas/live',
                thumb: 'https://media.bizionar.digital/culmia/mijas/live/cam03.jpg',
                type: 'solar-simulator',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/culmia/mijas/live/cam03.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 08',
                src: 'https://media.bizionar.digital/culmia/mijas/live/cam08.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 09',
                src: 'https://media.bizionar.digital/culmia/mijas/live/cam09.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 11',
                src: 'https://media.bizionar.digital/culmia/mijas/live/cam11.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 13',
                src: 'https://media.bizionar.digital/culmia/mijas/live/cam13.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 15',
                src: 'https://media.bizionar.digital/culmia/mijas/live/cam15.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Aérea',
                src: 'https://media.bizionar.digital/culmia/mijas/live/aerea_still.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Top',
                src: 'https://media.bizionar.digital/culmia/mijas/live/top.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render interior 01',
                src: 'https://media.bizionar.digital/culmia/mijas/live/render_CAM01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 02',
                src: 'https://media.bizionar.digital/culmia/mijas/live/render_CAM02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 03',
                src: 'https://media.bizionar.digital/culmia/mijas/live/render_CAM03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 04',
                src: 'https://media.bizionar.digital/culmia/mijas/live/render_CAM04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 05',
                src: 'https://media.bizionar.digital/culmia/mijas/live/render_CAM05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 06',
                src: 'https://media.bizionar.digital/culmia/mijas/live/render_CAM06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 07',
                src: 'https://media.bizionar.digital/culmia/mijas/live/render_CAM07.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 08',
                src: 'https://media.bizionar.digital/culmia/mijas/live/render_CAM08.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 09',
                src: 'https://media.bizionar.digital/culmia/mijas/live/render_CAM09.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 10',
                src: 'https://media.bizionar.digital/culmia/mijas/live/render_CAM10.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 11',
                src: 'https://media.bizionar.digital/culmia/mijas/live/render_CAM11.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 12',
                src: 'https://media.bizionar.digital/culmia/mijas/live/render_CAM12.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 13',
                src: 'https://media.bizionar.digital/culmia/mijas/live/render_CAM13.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 14',
                src: 'https://media.bizionar.digital/culmia/mijas/live/render_CAM14.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 15',
                src: 'https://media.bizionar.digital/culmia/mijas/live/render_CAM15.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 16',
                src: 'https://media.bizionar.digital/culmia/mijas/live/render_CAM16.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 17',
                src: 'https://media.bizionar.digital/culmia/mijas/live/render_CAM17.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 18',
                src: 'https://media.bizionar.digital/culmia/mijas/live/render_CAM18.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 19',
                src: 'https://media.bizionar.digital/culmia/mijas/live/render_CAM19.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 20',
                src: 'https://media.bizionar.digital/culmia/mijas/live/render_CAM20.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'marcelona',
          name: 'MarCelOna Montjuïc',
          city: 'Barcelona',
          province: 'Barcelona',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/marcelona',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/marcelona',
          image: 'https://media.bizionar.digital/culmia/marcelona/live/cam01.jpg',
          deliveries: [
            {
              categoryId: 'zonas-comunes',
              categoryName: 'ZONAS COMUNES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '27 de febrero de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '18 de marzo de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '30 de marzo de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '9 de mayo de 2024',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '13 de septiembre de 2024',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '23 de enero de 2025',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '21 de febrero de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 4,
              totalReviews: 4,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '23 de abril de 2024',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '4 de julio de 2024',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '1 de agosto de 2024',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '27 de agosto de 2024',
                  status: 'closed',
                },
                {
                  id: 'review05',
                  name: 'ENTREGA 5',
                  date: '31 de octubre de 2024',
                  status: 'closed',
                },
                {
                  id: 'review06',
                  name: 'ENTREGA 6',
                  date: '6 de noviembre de 2024',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/marcelona/review01/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/marcelona/review01/render/exterior/cam01.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render exterior 01',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render exterior 02',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render exterior 03',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render exterior 04',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render exterior 05',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render exterior 06',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render interior 01',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/interior/render_01_still_salon_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 02',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/interior/render_02_still_salon_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 03',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/interior/render_03_still_salon_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 04',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/interior/render_04_still_salon_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 05',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/interior/render_05_still_salon_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 06',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/interior/render_06_still_terraza_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 07',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/interior/render_07_still_cocina_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 08',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/interior/render_08_still_cocina_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 09',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/interior/render_09_still_suite_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 10',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/interior/render_10_still_suite_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 11',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/interior/render_11_still_suite_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 12',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/interior/render_12_still_serv_ppl_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 13',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/interior/render_13_still_serv_ppl_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 14',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/interior/render_14_still_hab01_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 15',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/interior/render_15_still_hab01_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 16',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/interior/render_16_still_serv_comun_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 17',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/interior/render_17_still_serv_comun_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Coworking 02',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/zonas-comunes/coworking_02.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking 01',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/zonas-comunes/coworking_01.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking 03',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/zonas-comunes/coworking_03.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking 04',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/zonas-comunes/coworking_04.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Club Social 01',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/zonas-comunes/club_social_01.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Club Social 02',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/zonas-comunes/club_social_02.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Club Social 03',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/zonas-comunes/club_social_03.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Club Social 04',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/zonas-comunes/club_social_04.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Gimnasio 01',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/zonas-comunes/gym_01.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Gimnasio 02',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/zonas-comunes/gym_02.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Gimnasio 03',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/zonas-comunes/gym_03.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Gimnasio 04',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/zonas-comunes/gym_04.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Vestíbulo 01',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/zonas-comunes/vestibulo.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Terraza Coworking 01',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/zonas-comunes/cowork_terraza.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Terraza Club Social 01',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/zonas-comunes/club_terraza.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Bicicletas 01',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/render/zonas-comunes/bicicletas.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Video Completo Zonas Comunes',
                  thumb: 'https://media.bizionar.digital/culmia/marcelona/review01/render/zonas-comunes/club_terraza.jpg',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review01/video/video_zzcc_completo.mp4',
                  type: 'video',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review05/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/marcelona/review02/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review05/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/marcelona/review02/render/exterior/cam01.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/marcelona/review02/render/interior/render_01_still_salon_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render exterior 01',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render exterior 02',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render exterior 03',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render exterior 04',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render exterior 05',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render exterior 06',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render interior 01',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/interior/render_01_still_salon_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 02',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/interior/render_02_still_salon_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 03',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/interior/render_03_still_salon_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 04',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/interior/render_04_still_salon_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 05',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/interior/render_05_still_salon_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 06',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/interior/render_06_still_terraza_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 07',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/interior/render_07_still_cocina_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 08',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/interior/render_08_still_cocina_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 09',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/interior/render_09_still_suite_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 10',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/interior/render_10_still_suite_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 11',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/interior/render_11_still_suite_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 12',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/interior/render_12_still_serv_ppl_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 13',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/interior/render_13_still_serv_ppl_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 14',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/interior/render_14_still_hab01_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 15',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/interior/render_15_still_hab01_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 16',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/interior/render_16_still_serv_comun_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 17',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/interior/render_17_still_serv_comun_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Coworking 02',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/zonas-comunes/coworking_02.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking 01',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/zonas-comunes/coworking_01.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking 03',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/zonas-comunes/coworking_03.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking 04',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/zonas-comunes/coworking_04.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Club Social 01',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/zonas-comunes/club_social_01.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Club Social 02',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/zonas-comunes/club_social_02.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Club Social 03',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/zonas-comunes/club_social_03.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Club Social 04',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/zonas-comunes/club_social_04.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Gimnasio 01',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/zonas-comunes/gym_01.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Gimnasio 02',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/zonas-comunes/gym_02.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Gimnasio 03',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/zonas-comunes/gym_03.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Gimnasio 04',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/zonas-comunes/gym_04.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Vestíbulo 01',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/zonas-comunes/vestibulo.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Terraza Coworking 01',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/zonas-comunes/cowork_terraza.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Terraza Club Social 01',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/zonas-comunes/club_terraza.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Bicicletas 01',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/render/zonas-comunes/bicicletas.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Video Completo Zonas Comunes',
                  thumb: 'https://media.bizionar.digital/culmia/marcelona/review02/render/zonas-comunes/club_terraza.jpg',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review02/video/video_zzcc_completo.mp4',
                  type: 'video',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/marcelona/review03/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/marcelona/review03/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/marcelona/review03/render/exterior/cam01.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render exterior 01',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review03/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render exterior 02',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review03/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render exterior 03',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review03/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render exterior 04',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review03/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render exterior 05',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review03/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render exterior 06',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review03/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Aérea',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review03/render/exterior/cam_top.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render interior 01',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review03/render/interior/render_01_still_salon_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 02',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review03/render/interior/render_02_still_salon_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 03',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review03/render/interior/render_03_still_salon_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 04',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review03/render/interior/render_04_still_salon_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 05',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review03/render/interior/render_05_still_salon_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 06',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review03/render/interior/render_06_still_terraza_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 07',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review03/render/interior/render_07_still_cocina_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 08',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review03/render/interior/render_08_still_cocina_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 09',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review03/render/interior/render_09_still_suite_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 10',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review03/render/interior/render_10_still_suite_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 11',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review03/render/interior/render_11_still_suite_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 12',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review03/render/interior/render_12_still_serv_ppl_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 13',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review03/render/interior/render_13_still_serv_ppl_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 14',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review03/render/interior/render_14_still_hab01_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 15',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review03/render/interior/render_15_still_hab01_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 16',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review03/render/interior/render_16_still_serv_comun_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 17',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review03/render/interior/render_17_still_serv_comun_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Espacio Bicicletas 01',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review03/render/zonas-comunes/bicicletas.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Video Completo Zonas Comunes',
                  thumb: 'https://media.bizionar.digital/culmia/marcelona/review02/render/zonas-comunes/club_terraza.jpg',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review03/video/video_zzcc_completo.mp4',
                  type: 'video',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review06/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/marcelona/review04/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review05/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/marcelona/review02/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review04/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/marcelona/review04/render/exterior/cam01.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Video Completo',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review04/video/video_completo_hd.mp4',
                  thumb: 'https://media.bizionar.digital/culmia/marcelona/review04/render/exterior/cam01.jpg',
                  type: 'video',
                  category: 'exteriores',
                },
                {
                  name: 'Render exterior 01',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review04/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render exterior 02',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review04/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render exterior 03',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review04/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render exterior 04',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review04/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render exterior 05',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review04/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render exterior 06',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review04/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Aérea',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review04/render/exterior/cam_top.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render interior 01',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review04/render/interior/render_01_still_salon_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 02',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review04/render/interior/render_02_still_salon_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 03',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review04/render/interior/render_03_still_salon_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 04',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review04/render/interior/render_04_still_salon_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 05',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review04/render/interior/render_05_still_salon_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 06',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review04/render/interior/render_06_still_terraza_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 07',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review04/render/interior/render_07_still_cocina_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 08',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review04/render/interior/render_08_still_cocina_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 09',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review04/render/interior/render_09_still_suite_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 10',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review04/render/interior/render_10_still_suite_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 11',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review04/render/interior/render_11_still_suite_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 12',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review04/render/interior/render_12_still_serv_ppl_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 13',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review04/render/interior/render_13_still_serv_ppl_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 14',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review04/render/interior/render_14_still_hab01_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 15',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review04/render/interior/render_15_still_hab01_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 16',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review04/render/interior/render_16_still_serv_comun_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 17',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review04/render/interior/render_17_still_serv_comun_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review05',
              content: [
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review05/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/marcelona/review05/render/interior/render_01_still_salon_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 01',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review05/render/interior/render_01_still_salon_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 02',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review05/render/interior/render_02_still_salon_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 03',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review05/render/interior/render_03_still_salon_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 04',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review05/render/interior/render_04_still_salon_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 05',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review05/render/interior/render_05_still_salon_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 06',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review05/render/interior/render_06_still_terraza_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 07',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review05/render/interior/render_07_still_cocina_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 08',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review05/render/interior/render_08_still_cocina_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 09',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review05/render/interior/render_09_still_suite_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 10',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review05/render/interior/render_10_still_suite_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 11',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review05/render/interior/render_11_still_suite_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 12',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review05/render/interior/render_12_still_serv_ppl_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 13',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review05/render/interior/render_13_still_serv_ppl_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 14',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review05/render/interior/render_14_still_hab01_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 15',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review05/render/interior/render_15_still_hab01_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 16',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review05/render/interior/render_16_still_serv_comun_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 17',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review05/render/interior/render_17_still_serv_comun_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review06',
              content: [
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review06/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/marcelona/review06/render/interior/render_01_still_salon_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 01',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review06/render/interior/render_01_still_salon_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 02',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review06/render/interior/render_02_still_salon_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 03',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review06/render/interior/render_03_still_salon_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 04',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review06/render/interior/render_04_still_salon_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 05',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review06/render/interior/render_05_still_salon_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 06',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review06/render/interior/render_06_still_terraza_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 07',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review06/render/interior/render_07_still_cocina_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 08',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review06/render/interior/render_08_still_cocina_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 09',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review06/render/interior/render_09_still_suite_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 10',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review06/render/interior/render_10_still_suite_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 11',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review06/render/interior/render_11_still_suite_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 12',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review06/render/interior/render_12_still_serv_ppl_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 13',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review06/render/interior/render_13_still_serv_ppl_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 14',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review06/render/interior/render_14_still_hab01_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 15',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review06/render/interior/render_15_still_hab01_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 16',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review06/render/interior/render_16_still_serv_comun_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render interior 17',
                  src: 'https://media.bizionar.digital/culmia/marcelona/review06/render/interior/render_17_still_serv_comun_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
            {
              title: 'ZONAS COMUNES',
              filter: 'zonas-comunes',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '14 de abril de 2025',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/marcelona/download/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/marcelona/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'zonas-comunes',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/marcelona/download/zonas-comunes/render_zonas-comunes_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Vistas Reales',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/tour-vistas/index.html',
                thumb: 'https://media.bizionar.digital/culmia/marcelona/live/cam02.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/marcelona/live/cam01.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/marcelona/live/cam01.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/culmia/marcelona/review04/orbit/index.html',
                thumb: 'https://media.bizionar.digital/culmia/marcelona/live/cam01.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/marcelona/live/cam01.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/marcelona/live/cam01.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Video Completo Zonas Comunes',
                thumb: 'https://media.bizionar.digital/culmia/marcelona/live/zonas-comunes/club_terraza.jpg',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/zonas-comunes/video/video_zzcc_completo.mp4',
                type: 'video',
                category: 'zonas-comunes',
              },
              {
                name: 'Render exterior 01',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/cam01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render exterior 02',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/cam02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render exterior 03',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/cam03.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render exterior 04',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/cam04.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render exterior 05',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/cam05.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render exterior 06',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/cam06.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Aérea',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/cam_top.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render interior 01',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/render_01_still_salon_001.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 02',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/render_02_still_salon_002.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 03',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/render_03_still_salon_003.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 04',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/render_04_still_salon_004.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 05',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/render_05_still_salon_005.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 06',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/render_06_still_terraza_001.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 07',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/render_07_still_cocina_001.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 08',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/render_08_still_cocina_002.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 09',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/render_09_still_suite_001.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 10',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/render_10_still_suite_002.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 11',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/render_11_still_suite_003.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 12',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/render_12_still_serv_ppl_001.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 13',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/render_13_still_serv_ppl_002.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 14',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/render_14_still_hab01_001.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 15',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/render_15_still_hab01_002.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 16',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/render_16_still_serv_comun_001.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render interior 17',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/render_17_still_serv_comun_002.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Sala Coworking 02',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/zonas-comunes/coworking_02.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Coworking 01',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/zonas-comunes/coworking_01.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Coworking 03',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/zonas-comunes/coworking_03.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Coworking 04',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/zonas-comunes/coworking_04.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Club Social 01',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/zonas-comunes/club_social_01.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Club Social 02',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/zonas-comunes/club_social_02.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Club Social 03',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/zonas-comunes/club_social_03.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Club Social 04',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/zonas-comunes/club_social_04.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Gimnasio 01',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/zonas-comunes/gym_01.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Gimnasio 02',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/zonas-comunes/gym_02.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Gimnasio 03',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/zonas-comunes/gym_03.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Gimnasio 04',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/zonas-comunes/gym_04.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Vestíbulo 01',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/zonas-comunes/vestibulo.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Terraza Coworking 01',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/zonas-comunes/cowork_terraza.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Terraza Club Social 01',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/zonas-comunes/club_terraza.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Bicicletas 01',
                src: 'https://media.bizionar.digital/culmia/marcelona/live/zonas-comunes/bicicletas.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
            ],
          },
        },
        {
          id: 'costa-galera-iii',
          name: 'Costa Galera III',
          city: 'Almuñecar',
          province: 'Granada',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/costa-galera-iii',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/costa-galera-iii',
          image: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/cam01.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 4,
              totalReviews: 4,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '30 de abril de 2024',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '17 de mayo de 2024',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '22 de mayo de 2024',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '23 de mayo de 2024',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
                {
                  id: 'review05',
                  name: 'ENTREGA 5',
                  date: '12 de agosto de 2024',
                  status: 'pending',
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '26 de abril de 2024',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '17 de mayo de 2024',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '22 de mayo de 2024',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review01/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review01/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review01/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review01/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review01/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review01/render/exterior/cam14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 17',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review01/render/exterior/cam17.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 18',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review01/render/exterior/cam18.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review01/render/interior/render_SALON01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review01/render/interior/render_SALON02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review01/render/interior/render_SALON03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review01/render/interior/render_SALON04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review01/render/interior/render_COCINA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review01/render/interior/render_COCINA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review01/render/interior/render_COCINA03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review01/render/interior/render_RECIBIDOR.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review01/render/interior/render_BANO_COMUN01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review01/render/interior/render_BANO_COMUN02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación1 01',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review01/render/interior/render_HAB01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación1 02',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review01/render/interior/render_HAB01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación2 01',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review01/render/interior/render_HAB02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación2 02',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review01/render/interior/render_HAB02_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review01/render/interior/render_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review01/render/interior/render_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review01/render/interior/render_BANO_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review01/render/interior/render_BANO_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review01/render/interior/render_TERRAZA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/costa-galera-iii/review02/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/costa-galera-iii/review02/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Tour Vistas Reales',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/tour-vistas-reales/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/costa-galera-iii/review02/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review02/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review02/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review02/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review02/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review02/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review02/render/exterior/cam14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 17',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review02/render/exterior/cam17.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 18',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review02/render/exterior/cam18.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review02/render/interior/render_SALON01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review02/render/interior/render_SALON02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review02/render/interior/render_SALON03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review02/render/interior/render_SALON04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review02/render/interior/render_COCINA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review02/render/interior/render_COCINA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review02/render/interior/render_COCINA03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review02/render/interior/render_RECIBIDOR.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review02/render/interior/render_BANO_COMUN01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review02/render/interior/render_BANO_COMUN02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación1 01',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review02/render/interior/render_HAB01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación1 02',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review02/render/interior/render_HAB01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación2 01',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review02/render/interior/render_HAB02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación2 02',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review02/render/interior/render_HAB02_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review02/render/interior/render_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review02/render/interior/render_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review02/render/interior/render_BANO_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review02/render/interior/render_BANO_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review02/render/interior/render_TERRAZA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },

              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/costa-galera-iii/review03/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/costa-galera-iii/review03/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Tour Vistas Reales',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/tour-vistas-reales/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/costa-galera-iii/review03/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review03/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review03/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review03/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review03/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review03/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review03/render/exterior/cam14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 17',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review03/render/exterior/cam17.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 18',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review03/render/exterior/cam18.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review03/render/interior/render_SALON01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review03/render/interior/render_SALON02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review03/render/interior/render_SALON03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review03/render/interior/render_SALON04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review03/render/interior/render_COCINA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review03/render/interior/render_COCINA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review03/render/interior/render_COCINA03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review03/render/interior/render_RECIBIDOR.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review03/render/interior/render_BANO_COMUN01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review03/render/interior/render_BANO_COMUN02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación1 01',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review03/render/interior/render_HAB01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación1 02',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review03/render/interior/render_HAB01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación2 01',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review03/render/interior/render_HAB02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación2 02',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review03/render/interior/render_HAB02_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review03/render/interior/render_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review03/render/interior/render_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review03/render/interior/render_BANO_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review03/render/interior/render_BANO_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review03/render/interior/render_TERRAZA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/costa-galera-iii/review04/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Vistas Reales',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/tour-vistas-reales/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/costa-galera-iii/review04/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review04/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review04/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review04/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review04/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review04/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review04/render/exterior/cam14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 17',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review04/render/exterior/cam17.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 18',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review04/render/exterior/cam18.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
            {
              id: 'review05',
              content: [
                {
                  name: 'Tour Multipunto Zonas Comunes',
                  src: 'https://media.bizionar.digital/culmia/costa-galera-iii/review05/tour-multipunto-zzcc/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '23 de mayo de 2024',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/costa-galera-iii/download/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/costa-galera-iii/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/cam01.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Simulador Solar',
                src: 'https://solar-simulator.bizionar.digital/culmia/costa-galera-iii/live',
                thumb: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/cam01.jpg',
                type: 'solar-simulator',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/cam01.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Tour Vistas Reales',
                src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/tour-vistas-reales/index.html',
                thumb: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/cam01.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/cam01.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/cam01.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/cam01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 05',
                src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/cam05.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 07',
                src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/cam07.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 08',
                src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/cam08.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 09',
                src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/cam09.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 14',
                src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/cam14.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 17',
                src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/cam17.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 18',
                src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/cam18.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/render_SALON01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/render_SALON02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/render_SALON03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/render_SALON04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/render_COCINA01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/render_COCINA02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/render_COCINA03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Recibidor 01',
                src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/render_RECIBIDOR.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/render_BANO_COMUN01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 02',
                src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/render_BANO_COMUN02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación1 01',
                src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/render_HAB01_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación1 02',
                src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/render_HAB01_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación2 01',
                src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/render_HAB02_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación2 02',
                src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/render_HAB02_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 01',
                src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/render_SUITE01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 02',
                src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/render_SUITE02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/render_BANO_SUITE01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 02',
                src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/render_BANO_SUITE02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/costa-galera-iii/live/render_TERRAZA01.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'port-montjuic',
          name: 'Port Montjuic',
          city: 'Barcelona',
          province: 'Barcelona',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/port-montjuic',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/port-montjuic',
          image: 'https://media.bizionar.digital/culmia/port-montjuic/live/cam01_02.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 1,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '12 de agosto de 2024',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '4 de septiembre de 2024',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 1,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '20 de junio de 2024',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '12 de agosto de 2024',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review01/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/port-montjuic/review01/render/interior/render_SALON01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/port-montjuic/review01/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review01/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review01/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review01/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01 - 02 combinado',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review01/render/exterior/cam01_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review01/render/interior/render_SALON01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review01/render/interior/render_SALON02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review01/render/interior/render_SALON03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review01/render/interior/render_SALON04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review01/render/interior/render_SALON05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Comedor 01',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review01/render/interior/render_COMEDOR01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Comedor 02',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review01/render/interior/render_COMEDOR02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Comedor 03',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review01/render/interior/render_COMEDOR03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review01/render/interior/render_COCINA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review01/render/interior/render_BANO_COMUN01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review01/render/interior/render_BANO_COMUN02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación1 01',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review01/render/interior/render_HAB01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación1 02',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review01/render/interior/render_HAB01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación2 01',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review01/render/interior/render_HAB02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación2 02',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review01/render/interior/render_HAB02_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review01/render/interior/render_SUITE01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review01/render/interior/render_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review01/render/interior/render_SUITE03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review01/render/interior/render_BANO_SUITE01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review01/render/interior/render_BANO_SUITE01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review01/render/interior/render_TERRAZA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },

              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review02/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/port-montjuic/review02/render/interior/render_SALON01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/port-montjuic/review02/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review02/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review02/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review02/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01 - 02 combinado',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review02/render/exterior/cam01_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review02/render/interior/render_SALON01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review02/render/interior/render_SALON02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review02/render/interior/render_SALON03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review02/render/interior/render_SALON04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review02/render/interior/render_SALON05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Comedor 01',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review02/render/interior/render_COMEDOR01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Comedor 02',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review02/render/interior/render_COMEDOR02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Comedor 03',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review02/render/interior/render_COMEDOR03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review02/render/interior/render_COCINA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review02/render/interior/render_BANO_COMUN01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review02/render/interior/render_BANO_COMUN02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación1 01',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review02/render/interior/render_HAB01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación1 02',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review02/render/interior/render_HAB01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación2 01',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review02/render/interior/render_HAB02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación2 02',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review02/render/interior/render_HAB02_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review02/render/interior/render_SUITE01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review02/render/interior/render_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review02/render/interior/render_SUITE03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review02/render/interior/render_BANO_SUITE01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review02/render/interior/render_BANO_SUITE01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/port-montjuic/review02/render/interior/render_TERRAZA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '26 de septiembre de 2024',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/port-montjuic/download/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/port-montjuic/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Vistas Reales',
                src: 'https://media.bizionar.digital/culmia/port-montjuic/live/tour-vistas-reales/index.html',
                thumb: 'https://media.bizionar.digital/culmia/port-montjuic/live/cam01.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Simulador Solar',
                src: 'https://solar-simulator.bizionar.digital/culmia/port-montjuic',
                thumb: 'https://media.bizionar.digital/culmia/port-montjuic/live/cam01.jpg',
                type: 'solar-simulator',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/port-montjuic/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/port-montjuic/live/cam01.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/port-montjuic/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/port-montjuic/live/cam01.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/port-montjuic/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/port-montjuic/live/cam01.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/port-montjuic/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/port-montjuic/live/cam01.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/culmia/port-montjuic/live/cam01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/culmia/port-montjuic/live/cam02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/culmia/port-montjuic/live/cam03.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 01 - 02 combinado',
                src: 'https://media.bizionar.digital/culmia/port-montjuic/live/cam01_02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/port-montjuic/live/render_SALON01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/port-montjuic/live/render_SALON02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/port-montjuic/live/render_SALON03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/port-montjuic/live/render_SALON04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/culmia/port-montjuic/live/render_SALON05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Comedor 01',
                src: 'https://media.bizionar.digital/culmia/port-montjuic/live/render_COMEDOR01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Comedor 02',
                src: 'https://media.bizionar.digital/culmia/port-montjuic/live/render_COMEDOR02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Comedor 03',
                src: 'https://media.bizionar.digital/culmia/port-montjuic/live/render_COMEDOR03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/port-montjuic/live/render_COCINA01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/port-montjuic/live/render_BANO_COMUN01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 02',
                src: 'https://media.bizionar.digital/culmia/port-montjuic/live/render_BANO_COMUN02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación1 01',
                src: 'https://media.bizionar.digital/culmia/port-montjuic/live/render_HAB01_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación1 02',
                src: 'https://media.bizionar.digital/culmia/port-montjuic/live/render_HAB01_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación2 01',
                src: 'https://media.bizionar.digital/culmia/port-montjuic/live/render_HAB02_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación2 02',
                src: 'https://media.bizionar.digital/culmia/port-montjuic/live/render_HAB02_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 01',
                src: 'https://media.bizionar.digital/culmia/port-montjuic/live/render_SUITE01_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 02',
                src: 'https://media.bizionar.digital/culmia/port-montjuic/live/render_SUITE02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 03',
                src: 'https://media.bizionar.digital/culmia/port-montjuic/live/render_SUITE03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/port-montjuic/live/render_BANO_SUITE01_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 02',
                src: 'https://media.bizionar.digital/culmia/port-montjuic/live/render_BANO_SUITE01_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/port-montjuic/live/render_TERRAZA01.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'can-mare-ii',
          name: 'Can Mare II',
          city: 'Palma de Mallorca',
          province: 'Palma de Mallorca',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/can-mare-ii',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/can-mare-ii',
          image: 'https://media.bizionar.digital/culmia/can-mare-ii/live/exterior/cam01.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '31 de julio de 2024',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '28 de octubre de 2024',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '15 de enero de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '29 de julio de 2024',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '2 de diciembre de 2024',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '15 de enero de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/can-mare-ii/review01/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/can-mare-ii/review01/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review01/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review01/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review01/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review01/render/interior/render_SALON02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review01/render/interior/render_SALON01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review01/render/interior/render_SALON03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review01/render/interior/render_SALON04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Comedor 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review01/render/interior/render_COMEDOR01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Comedor 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review01/render/interior/render_COMEDOR.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review01/render/interior/render_COCINA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review01/render/interior/render_COCINA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review01/render/interior/render_BANO_COMUN01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review01/render/interior/render_BANO_COMUN02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación1 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review01/render/interior/render_HAB01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación1 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review01/render/interior/render_HAB01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación2 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review01/render/interior/render_HAB02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación2 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review01/render/interior/render_HAB02_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review01/render/interior/render_SUITE_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review01/render/interior/render_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review01/render/interior/render_BANO_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review01/render/interior/render_BANO_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review01/render/interior/render_TERRAZA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/can-mare-ii/review02/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review02/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/can-mare-ii/review02/render/interior/render_SALON02.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review02/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review02/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review02/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review02/render/interior/render_SALON02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review02/render/interior/render_SALON01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review02/render/interior/render_SALON03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review02/render/interior/render_SALON04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Comedor 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review02/render/interior/render_COMEDOR01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Comedor 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review02/render/interior/render_COMEDOR.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review02/render/interior/render_COCINA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review02/render/interior/render_COCINA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review02/render/interior/render_BANO_COMUN01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review02/render/interior/render_BANO_COMUN02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación1 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review02/render/interior/render_HAB01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación1 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review02/render/interior/render_HAB01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación2 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review02/render/interior/render_HAB02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación2 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review02/render/interior/render_HAB02_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review02/render/interior/render_SUITE_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review02/render/interior/render_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review02/render/interior/render_BANO_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review02/render/interior/render_BANO_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review02/render/interior/render_TERRAZA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/can-mare-ii/review03/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review03/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/can-mare-ii/review03/render/interior/render_SALON02.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review03/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review03/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review03/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review03/render/interior/render_SALON02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review03/render/interior/render_SALON01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review03/render/interior/render_SALON03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review03/render/interior/render_SALON04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Comedor 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review03/render/interior/render_COMEDOR01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Comedor 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review03/render/interior/render_COMEDOR.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review03/render/interior/render_COCINA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review03/render/interior/render_COCINA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review03/render/interior/render_BANO_COMUN01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review03/render/interior/render_BANO_COMUN02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación1 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review03/render/interior/render_HAB01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación1 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review03/render/interior/render_HAB01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación2 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review03/render/interior/render_HAB02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación2 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review03/render/interior/render_HAB02_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review03/render/interior/render_SUITE_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review03/render/interior/render_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review03/render/interior/render_BANO_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review03/render/interior/render_BANO_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/can-mare-ii/review03/render/interior/render_TERRAZA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '16 de enero de 2025',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/can-mare-ii/download/exterior/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/can-mare-ii/download/interior/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/can-mare-ii/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/can-mare-ii/live/exterior/cam01.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Multipunto Interior',
                src: 'https://media.bizionar.digital/culmia/can-mare-ii/live/tour-multipunto/index.html',
                thumb: 'https://media.bizionar.digital/culmia/can-mare-ii/live/interior/render_SALON02.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/can-mare-ii/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/can-mare-ii/live/exterior/cam01.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/can-mare-ii/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/can-mare-ii/live/exterior/cam01.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/culmia/can-mare-ii/live/exterior/cam01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 08',
                src: 'https://media.bizionar.digital/culmia/can-mare-ii/live/exterior/cam08.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 09',
                src: 'https://media.bizionar.digital/culmia/can-mare-ii/live/exterior/cam09.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/can-mare-ii/live/interior/render_SALON02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/can-mare-ii/live/interior/render_SALON01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/can-mare-ii/live/interior/render_SALON03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/can-mare-ii/live/interior/render_SALON04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Comedor 01',
                src: 'https://media.bizionar.digital/culmia/can-mare-ii/live/interior/render_COMEDOR01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Comedor 02',
                src: 'https://media.bizionar.digital/culmia/can-mare-ii/live/interior/render_COMEDOR.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/can-mare-ii/live/interior/render_COCINA01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/can-mare-ii/live/interior/render_COCINA02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/can-mare-ii/live/interior/render_BANO_COMUN01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 02',
                src: 'https://media.bizionar.digital/culmia/can-mare-ii/live/interior/render_BANO_COMUN02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación1 01',
                src: 'https://media.bizionar.digital/culmia/can-mare-ii/live/interior/render_HAB01_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación1 02',
                src: 'https://media.bizionar.digital/culmia/can-mare-ii/live/interior/render_HAB01_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación2 01',
                src: 'https://media.bizionar.digital/culmia/can-mare-ii/live/interior/render_HAB02_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación2 02',
                src: 'https://media.bizionar.digital/culmia/can-mare-ii/live/interior/render_HAB02_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 01',
                src: 'https://media.bizionar.digital/culmia/can-mare-ii/live/interior/render_SUITE_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 02',
                src: 'https://media.bizionar.digital/culmia/can-mare-ii/live/interior/render_SUITE02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/can-mare-ii/live/interior/render_BANO_SUITE01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 02',
                src: 'https://media.bizionar.digital/culmia/can-mare-ii/live/interior/render_BANO_SUITE02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/can-mare-ii/live/interior/render_TERRAZA01.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'portonovo',
          name: 'Portonovo Sanxenxo',
          city: 'Portonovo',
          province: 'Pontevedra',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/portonovo',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/portonovo',
          image: 'https://media.bizionar.digital/culmia/portonovo/live/cam_01.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 5,
              totalReviews: 5,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '9 de diciembre de 2024',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '21 de enero de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '7 de febrero de 2025',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '19 de marzo de 2025',
                  status: 'closed',
                },
                {
                  id: 'review05',
                  name: 'ENTREGA 5',
                  date: '25 de marzo de 2025',
                  status: 'closed',
                },
                {
                  id: 'review06',
                  name: 'ENTREGA 6',
                  date: '25 de marzo de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 4,
              totalReviews: 4,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '9 de diciembre de 2024',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '24 de diciembre de 2024',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '7 de febrero de 2025',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '19 de marzo de 2025',
                  status: 'closed',
                },
                {
                  id: 'review05',
                  name: 'ENTREGA 5',
                  date: '22 de julio de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/portonovo/review01/render/exterior/cam_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/portonovo/review01/render/exterior/cam_04.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Vistas Reales',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review01/tour-vistas-reales/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/portonovo/review01/render/exterior/cam_00.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review01/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/portonovo/review01/render/interior/render_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review01/render/exterior/cam_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review01/render/exterior/cam_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review01/render/exterior/cam_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review01/render/exterior/cam_00.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review01/render/interior/render_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review01/render/interior/render_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review01/render/interior/render_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review01/render/interior/render_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review01/render/interior/render_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review01/render/interior/render_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 08',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review01/render/interior/render_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review01/render/interior/render_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review01/render/interior/render_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review01/render/interior/render_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review01/render/interior/render_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review01/render/interior/render_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review01/render/interior/render_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review01/render/interior/render_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review01/render/interior/render_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review01/render/interior/render_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review01/render/interior/render_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review01/render/interior/render_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review01/render/interior/render_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review01/render/interior/render_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/portonovo/review02/render/exterior/cam_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/portonovo/review02/render/exterior/cam_04.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Vistas Reales',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review01/tour-vistas-reales/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/portonovo/review02/render/exterior/cam_00.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review02/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/portonovo/review02/render/interior/render_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review02/render/exterior/cam_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review02/render/exterior/cam_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review02/render/exterior/cam_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review02/render/exterior/cam_00.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review02/render/interior/render_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review02/render/interior/render_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review02/render/interior/render_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review02/render/interior/render_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review02/render/interior/render_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review02/render/interior/render_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 08',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review02/render/interior/render_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review02/render/interior/render_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review02/render/interior/render_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review02/render/interior/render_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review02/render/interior/render_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review02/render/interior/render_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review02/render/interior/render_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review02/render/interior/render_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review02/render/interior/render_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review02/render/interior/render_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review02/render/interior/render_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review02/render/interior/render_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review02/render/interior/render_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review02/render/interior/render_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ]
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/portonovo/review03/render/exterior/cam_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/portonovo/review03/render/exterior/cam_04.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Vistas Reales',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review01/tour-vistas-reales/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/portonovo/review03/render/exterior/cam_00.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review03/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/portonovo/review03/render/interior/render_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Video Completo',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review03/video/video_completo.mp4',
                  thumb: 'https://media.bizionar.digital/culmia/portonovo/review03/render/exterior/cam_01.jpg',
                  type: 'video',
                  category: 'exteriores',
                },
                {
                  name: 'Video Completo',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review03/video/video_completo.mp4',
                  thumb: 'https://media.bizionar.digital/culmia/portonovo/review03/render/exterior/cam_01.jpg',
                  type: 'video',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review03/render/exterior/cam_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review03/render/exterior/cam_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review03/render/exterior/cam_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review03/render/exterior/cam_00.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review03/render/interior/render_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review03/render/interior/render_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review03/render/interior/render_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review03/render/interior/render_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review03/render/interior/render_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review03/render/interior/render_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 08',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review03/render/interior/render_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review03/render/interior/render_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review03/render/interior/render_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review03/render/interior/render_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review03/render/interior/render_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review03/render/interior/render_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review03/render/interior/render_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review03/render/interior/render_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review03/render/interior/render_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review03/render/interior/render_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review03/render/interior/render_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review03/render/interior/render_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review03/render/interior/render_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review03/render/interior/render_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ]
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/portonovo/review04/render/exterior/cam_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review04/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/portonovo/review04/render/exterior/cam_04.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Vistas Reales',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review01/tour-vistas-reales/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/portonovo/review04/render/exterior/cam_00.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review04/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/portonovo/review04/render/interior/render_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Video Completo',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review04/video/video_completo.mp4',
                  thumb: 'https://media.bizionar.digital/culmia/portonovo/review04/render/exterior/cam_01.jpg',
                  type: 'video',
                  category: 'exteriores',
                },
                {
                  name: 'Video Completo',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review04/video/video_completo.mp4',
                  thumb: 'https://media.bizionar.digital/culmia/portonovo/review04/render/exterior/cam_01.jpg',
                  type: 'video',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review04/render/exterior/cam_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review04/render/exterior/cam_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review04/render/exterior/cam_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review04/render/exterior/cam_00.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review04/render/interior/render_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review04/render/interior/render_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review04/render/interior/render_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review04/render/interior/render_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review04/render/interior/render_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review04/render/interior/render_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 08',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review04/render/interior/render_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review04/render/interior/render_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review04/render/interior/render_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review04/render/interior/render_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review04/render/interior/render_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review04/render/interior/render_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review04/render/interior/render_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review04/render/interior/render_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review04/render/interior/render_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review04/render/interior/render_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review04/render/interior/render_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review04/render/interior/render_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review04/render/interior/render_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review04/render/interior/render_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ]
            },
            {
              id: 'review05',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review05/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/portonovo/review05/render/exterior/cam_01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review05/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/portonovo/review05/render/exterior/cam_04.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Vistas Reales',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review01/tour-vistas-reales/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/portonovo/review05/render/exterior/cam_00.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review05/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/portonovo/review05/render/interior/render_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Video Completo',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review05/video/video_completo.mp4',
                  thumb: 'https://media.bizionar.digital/culmia/portonovo/review05/render/exterior/cam_01.jpg',
                  type: 'video',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review05/render/exterior/cam_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review05/render/exterior/cam_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review05/render/exterior/cam_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review05/render/exterior/cam_00.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review05/render/interior/render_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review05/render/interior/render_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review05/render/interior/render_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review05/render/interior/render_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review05/render/interior/render_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review05/render/interior/render_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 08',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review05/render/interior/render_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review05/render/interior/render_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review05/render/interior/render_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review05/render/interior/render_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review05/render/interior/render_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review05/render/interior/render_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review05/render/interior/render_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review05/render/interior/render_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review05/render/interior/render_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review05/render/interior/render_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 02',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review05/render/interior/render_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Suite 03',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review05/render/interior/render_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review05/render/interior/render_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review05/render/interior/render_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ]
            },
            {
              id: 'review06',
              content: [
                {
                  name: 'Render Exterior Dia 02',
                  src: 'https://media.bizionar.digital/culmia/portonovo/review06/render/exterior/cam_02_day.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ]
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '29 de julio de 2025',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/portonovo/download/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/portonovo/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/portonovo/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/portonovo/live/cam_01.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/portonovo/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/portonovo/live/cam_01.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Tour Vistas Reales',
                src: 'https://media.bizionar.digital/culmia/portonovo/live/tour-vistas-reales/index.html',
                thumb: 'https://media.bizionar.digital/culmia/portonovo/live/cam_00.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/culmia/portonovo/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/culmia/portonovo/live/cam_04.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/portonovo/live/video/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/portonovo/live/cam_01.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/portonovo/live/video/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/portonovo/live/cam_01.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Render Exterior Dia 02',
                src: 'https://media.bizionar.digital/culmia/portonovo/live/cam_02_day.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/culmia/portonovo/live/cam_01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 04',
                src: 'https://media.bizionar.digital/culmia/portonovo/live/cam_04.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/culmia/portonovo/live/cam_02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/culmia/portonovo/live/cam_00.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/portonovo/live/render_Camera_001.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/portonovo/live/render_Camera_002.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/portonovo/live/render_Camera_003.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/portonovo/live/render_Camera_004.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/culmia/portonovo/live/render_Camera_005.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 07',
                src: 'https://media.bizionar.digital/culmia/portonovo/live/render_Camera_007.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 08',
                src: 'https://media.bizionar.digital/culmia/portonovo/live/render_Camera_008.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/portonovo/live/render_Camera_006.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/portonovo/live/render_Camera_009.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 02',
                src: 'https://media.bizionar.digital/culmia/portonovo/live/render_Camera_010.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Recibidor 01',
                src: 'https://media.bizionar.digital/culmia/portonovo/live/render_Camera_011.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/culmia/portonovo/live/render_Camera_012.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 3 - 01',
                src: 'https://media.bizionar.digital/culmia/portonovo/live/render_Camera_013.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/portonovo/live/render_Camera_014.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 02',
                src: 'https://media.bizionar.digital/culmia/portonovo/live/render_Camera_015.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 01',
                src: 'https://media.bizionar.digital/culmia/portonovo/live/render_Camera_018.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 02',
                src: 'https://media.bizionar.digital/culmia/portonovo/live/render_Camera_019.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Suite 03',
                src: 'https://media.bizionar.digital/culmia/portonovo/live/render_Camera_020.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/portonovo/live/render_Camera_016.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 02',
                src: 'https://media.bizionar.digital/culmia/portonovo/live/render_Camera_017.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'xaloc',
          name: 'Xaloc',
          city: 'Cerdanyola del Vallès',
          province: 'Barcelona',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/xaloc',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/xaloc',
          image: 'https://media.bizionar.digital/culmia/xaloc/live/exterior/cam01.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 4,
              totalReviews: 4,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '3 de septiembre de 2024',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '25 de septiembre de 2024',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '8 de noviembre de 2024',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '22 de noviembre de 2024',
                  status: 'closed',
                },
                {
                  id: 'review05',
                  name: 'ENTREGA 5',
                  date: '4 de diciembre de 2024',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '13 de septiembre de 2024',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '8 de noviembre de 2024',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '22 de noviembre de 2024',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '4 de diciembre de 2024',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review01/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/xaloc/review01/render/interior/render_SALON01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review01/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review01/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review01/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review01/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review01/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review01/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review01/render/interior/render_SALON01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review01/render/interior/render_SALON02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review01/render/interior/render_SALON03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review01/render/interior/render_SALON04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Comedor 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review01/render/interior/render_COMEDOR01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Comedor 02',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review01/render/interior/render_COMEDOR02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review01/render/interior/render_COCINA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review01/render/interior/render_COCINA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review01/render/interior/render_RECIBIDOR.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review01/render/interior/render_HAB01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review01/render/interior/render_HAB01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review01/render/interior/render_HAB02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review01/render/interior/render_BANO_COMUN01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review01/render/interior/render_BANO_COMUN02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review01/render/interior/render_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review01/render/interior/render_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review01/render/interior/render_BANO_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review01/render/interior/render_BANO_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review01/render/interior/render_TERRAZA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review01/render/interior/render_TERRAZA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/xaloc/review02/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Simulador Solar',
                  src: 'https://solar-simulator.bizionar.digital/culmia/xaloc/review01',
                  thumb: 'https://media.bizionar.digital/culmia/xaloc/review02/render/exterior/cam03.jpg',
                  type: 'solar-simulator',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/xaloc/review02/render/exterior/cam05.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Vistas Reales',
                  src: 'https://media.bizionar.digital/culmia/xaloc/live/tour-vistas-reales/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/xaloc/review02/render/exterior/cam05.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review02/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/xaloc/review02/render/interior/render_SALON01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review02/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review02/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review02/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review02/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review02/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review02/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review02/render/interior/render_SALON01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review02/render/interior/render_SALON02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review02/render/interior/render_SALON03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review02/render/interior/render_SALON04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Comedor 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review02/render/interior/render_COMEDOR01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Comedor 02',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review02/render/interior/render_COMEDOR02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review02/render/interior/render_COCINA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review02/render/interior/render_COCINA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review02/render/interior/render_RECIBIDOR.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review02/render/interior/render_HAB01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review02/render/interior/render_HAB01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review02/render/interior/render_HAB02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review02/render/interior/render_BANO_COMUN01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review02/render/interior/render_BANO_COMUN02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review02/render/interior/render_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review02/render/interior/render_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review02/render/interior/render_BANO_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review02/render/interior/render_BANO_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review02/render/interior/render_TERRAZA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review02/render/interior/render_TERRAZA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/xaloc/review03/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Simulador Solar',
                  src: 'https://solar-simulator.bizionar.digital/culmia/xaloc/review03',
                  thumb: 'https://media.bizionar.digital/culmia/xaloc/review03/render/exterior/cam03.jpg',
                  type: 'solar-simulator',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/xaloc/review03/render/exterior/cam05.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Vistas Reales',
                  src: 'https://media.bizionar.digital/culmia/xaloc/live/tour-vistas-reales/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/xaloc/review03/render/exterior/cam05.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review03/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/xaloc/review03/render/interior/render_SALON01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review03/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review03/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03 - versión 2',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review03/render/exterior/cam03_v2.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review03/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review03/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review03/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review03/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review03/render/interior/render_SALON01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review03/render/interior/render_SALON02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review03/render/interior/render_SALON03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review03/render/interior/render_SALON04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Comedor 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review03/render/interior/render_COMEDOR01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Comedor 02',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review03/render/interior/render_COMEDOR02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review03/render/interior/render_COCINA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review03/render/interior/render_COCINA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review03/render/interior/render_COCINA03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review03/render/interior/render_RECIBIDOR.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review03/render/interior/render_HAB01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review03/render/interior/render_HAB02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review03/render/interior/render_BANO_COMUN01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review03/render/interior/render_BANO_COMUN02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review03/render/interior/render_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review03/render/interior/render_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review03/render/interior/render_BANO_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review03/render/interior/render_BANO_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review03/render/interior/render_TERRAZA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review03/render/interior/render_TERRAZA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/xaloc/review04/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Simulador Solar',
                  src: 'https://solar-simulator.bizionar.digital/culmia/xaloc/review04',
                  thumb: 'https://media.bizionar.digital/culmia/xaloc/review04/render/exterior/cam03.jpg',
                  type: 'solar-simulator',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review04/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/xaloc/review04/render/exterior/cam05.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Vistas Reales',
                  src: 'https://media.bizionar.digital/culmia/xaloc/live/tour-vistas-reales/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/xaloc/review04/render/exterior/cam05.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review04/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/xaloc/review04/render/interior/render_SALON01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review04/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review04/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03 - versión 2',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review04/render/exterior/cam03_v2.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review04/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review04/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review04/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review04/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review04/render/interior/render_SALON01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review04/render/interior/render_SALON02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review04/render/interior/render_SALON03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review04/render/interior/render_SALON04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Comedor 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review04/render/interior/render_COMEDOR01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Comedor 02',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review04/render/interior/render_COMEDOR02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review04/render/interior/render_COCINA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review04/render/interior/render_COCINA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review04/render/interior/render_COCINA03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review04/render/interior/render_RECIBIDOR.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review04/render/interior/render_HAB01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review04/render/interior/render_HAB02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review04/render/interior/render_BANO_COMUN01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review04/render/interior/render_BANO_COMUN02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review04/render/interior/render_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review04/render/interior/render_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review04/render/interior/render_BANO_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review04/render/interior/render_BANO_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review04/render/interior/render_TERRAZA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review04/render/interior/render_TERRAZA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review05',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review05/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/xaloc/review05/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Simulador Solar',
                  src: 'https://solar-simulator.bizionar.digital/culmia/xaloc/review05',
                  thumb: 'https://media.bizionar.digital/culmia/xaloc/review05/render/exterior/cam03.jpg',
                  type: 'solar-simulator',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review05/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/xaloc/review05/render/exterior/cam05.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Vistas Reales',
                  src: 'https://media.bizionar.digital/culmia/xaloc/live/tour-vistas-reales/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/xaloc/review05/render/exterior/cam05.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review05/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review05/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03 - versión 2',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review05/render/exterior/cam03_v2.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review05/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review05/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review05/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/xaloc/review05/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '10 de diciembre de 2024',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/xaloc/download/exterior/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/xaloc/download/interior/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/xaloc/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/xaloc/live/exterior/cam01.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Simulador Solar',
                src: 'https://solar-simulator.bizionar.digital/culmia/xaloc/live',
                thumb: 'https://media.bizionar.digital/culmia/xaloc/live/exterior/cam03.jpg',
                type: 'solar-simulator',
                category: 'exteriores',
              },
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/culmia/xaloc/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/culmia/xaloc/live/exterior/cam05.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Tour Vistas Reales',
                src: 'https://media.bizionar.digital/culmia/xaloc/live/tour-vistas-reales/index.html',
                thumb: 'https://media.bizionar.digital/culmia/xaloc/live/exterior/cam05.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/xaloc/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/xaloc/live/exterior/cam01.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/xaloc/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/xaloc/live/exterior/cam01.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/culmia/xaloc/live/exterior/cam01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/culmia/xaloc/live/exterior/cam03.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03 - versión 2',
                src: 'https://media.bizionar.digital/culmia/xaloc/live/exterior/cam03_v2.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 05',
                src: 'https://media.bizionar.digital/culmia/xaloc/live/exterior/cam05.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 08',
                src: 'https://media.bizionar.digital/culmia/xaloc/live/exterior/cam08.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 11',
                src: 'https://media.bizionar.digital/culmia/xaloc/live/exterior/cam11.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 12',
                src: 'https://media.bizionar.digital/culmia/xaloc/live/exterior/cam12.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/xaloc/live/interior/render_SALON01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/xaloc/live/interior/render_SALON02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/xaloc/live/interior/render_SALON03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/xaloc/live/interior/render_SALON04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Comedor 01',
                src: 'https://media.bizionar.digital/culmia/xaloc/live/interior/render_COMEDOR01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Comedor 02',
                src: 'https://media.bizionar.digital/culmia/xaloc/live/interior/render_COMEDOR02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/xaloc/live/interior/render_COCINA01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/xaloc/live/interior/render_COCINA02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/culmia/xaloc/live/interior/render_COCINA03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Recibidor 01',
                src: 'https://media.bizionar.digital/culmia/xaloc/live/interior/render_RECIBIDOR.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/culmia/xaloc/live/interior/render_HAB01_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/culmia/xaloc/live/interior/render_HAB02_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/xaloc/live/interior/render_BANO_COMUN01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 02',
                src: 'https://media.bizionar.digital/culmia/xaloc/live/interior/render_BANO_COMUN02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/culmia/xaloc/live/interior/render_SUITE01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/culmia/xaloc/live/interior/render_SUITE02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/xaloc/live/interior/render_BANO_SUITE01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 02',
                src: 'https://media.bizionar.digital/culmia/xaloc/live/interior/render_BANO_SUITE02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/xaloc/live/interior/render_TERRAZA01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 02',
                src: 'https://media.bizionar.digital/culmia/xaloc/live/interior/render_TERRAZA02.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'mistral',
          name: 'Mistral',
          city: 'Cerdanyola del Vallès',
          province: 'Barcelona',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/mistral',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/mistral',
          image: 'https://media.bizionar.digital/culmia/mistral/live/cam03.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '23 de diciembre de 2024',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '28 de febrero de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '16 de abril de 2025',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '8 de mayo de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '23 de diciembre de 2024',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '28 de febrero de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '16 de abril de 2025',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '8 de mayo de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/mistral/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mistral/review01/render/exterior/cam04.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Simulador Solar',
                  src: 'https://solar-simulator.bizionar.digital/culmia/mistral/review01',
                  thumb: 'https://media.bizionar.digital/culmia/mistral/review01/render/exterior/cam03.jpg',
                  type: 'solar-simulator',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/mistral/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mistral/review01/render/exterior/cam05.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/mistral/review01/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mistral/review01/render/interior/render_SALON_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/mistral/review01/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/mistral/review01/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/mistral/review01/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/mistral/review01/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/mistral/review01/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 16',
                  src: 'https://media.bizionar.digital/culmia/mistral/review01/render/exterior/cam16.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/mistral/review01/render/interior/render_SALON_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/mistral/review01/render/interior/render_SALON_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/mistral/review01/render/interior/render_SALON03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/mistral/review01/render/interior/render_SALON04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/mistral/review01/render/interior/render_SALON05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/mistral/review01/render/interior/render_SALON06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/mistral/review01/render/interior/render_SALON07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/mistral/review01/render/interior/render_COCINA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/mistral/review01/render/interior/render_COCINA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/mistral/review01/render/interior/render_TERRAZA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/mistral/review01/render/interior/render_TERRAZA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/mistral/review01/render/interior/render_HAB01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/mistral/review01/render/interior/render_HAB01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/mistral/review01/render/interior/render_HAB02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/mistral/review01/render/interior/render_BANO_COMUN01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/mistral/review01/render/interior/render_BANO_COMUN02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/mistral/review01/render/interior/render_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/mistral/review01/render/interior/render_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/mistral/review01/render/interior/render_BANO_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/mistral/review01/render/interior/render_BANY_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/mistral/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mistral/review02/render/exterior/cam04.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Simulador Solar',
                  src: 'https://solar-simulator.bizionar.digital/culmia/mistral/review02',
                  thumb: 'https://media.bizionar.digital/culmia/mistral/review02/render/exterior/cam03.jpg',
                  type: 'solar-simulator',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/mistral/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mistral/review02/render/exterior/cam05.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/mistral/review02/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mistral/review02/render/interior/render_SALON_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/mistral/review02/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/mistral/review02/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/mistral/review02/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/mistral/review02/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/mistral/review02/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 16',
                  src: 'https://media.bizionar.digital/culmia/mistral/review02/render/exterior/cam16.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/mistral/review02/render/interior/render_SALON_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/mistral/review02/render/interior/render_SALON_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/mistral/review02/render/interior/render_SALON03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/mistral/review02/render/interior/render_SALON04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/mistral/review02/render/interior/render_SALON05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/mistral/review02/render/interior/render_SALON06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/mistral/review02/render/interior/render_SALON07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/mistral/review02/render/interior/render_COCINA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/mistral/review02/render/interior/render_COCINA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/mistral/review02/render/interior/render_COCINA03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/mistral/review02/render/interior/render_TERRAZA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/mistral/review02/render/interior/render_TERRAZA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/mistral/review02/render/interior/render_HAB01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/mistral/review02/render/interior/render_HAB01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/mistral/review02/render/interior/render_HAB02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/mistral/review02/render/interior/render_BANO_COMUN01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/mistral/review02/render/interior/render_BANO_COMUN02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/mistral/review02/render/interior/render_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/mistral/review02/render/interior/render_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/mistral/review02/render/interior/render_BANO_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/mistral/review02/render/interior/render_BANY_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/mistral/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mistral/review03/render/exterior/cam04.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Simulador Solar',
                  src: 'https://solar-simulator.bizionar.digital/culmia/mistral/review02',
                  thumb: 'https://media.bizionar.digital/culmia/mistral/review03/render/exterior/cam03.jpg',
                  type: 'solar-simulator',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/mistral/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mistral/review03/render/exterior/cam05.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/mistral/review03/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mistral/review03/render/interior/render_SALON_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/mistral/review03/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/mistral/review03/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/mistral/review03/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/mistral/review03/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/mistral/review03/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 16',
                  src: 'https://media.bizionar.digital/culmia/mistral/review03/render/exterior/cam16.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/mistral/review03/render/interior/render_SALON_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/mistral/review03/render/interior/render_SALON_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/mistral/review03/render/interior/render_SALON03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/mistral/review03/render/interior/render_SALON04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/mistral/review03/render/interior/render_SALON05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/mistral/review03/render/interior/render_SALON06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/mistral/review03/render/interior/render_SALON07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/mistral/review03/render/interior/render_COCINA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/mistral/review03/render/interior/render_COCINA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/mistral/review03/render/interior/render_COCINA03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/mistral/review03/render/interior/render_TERRAZA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/mistral/review03/render/interior/render_TERRAZA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/mistral/review03/render/interior/render_HAB01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/mistral/review03/render/interior/render_HAB01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/mistral/review03/render/interior/render_HAB02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/mistral/review03/render/interior/render_BANO_COMUN01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/mistral/review03/render/interior/render_BANO_COMUN02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/mistral/review03/render/interior/render_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/mistral/review03/render/interior/render_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/mistral/review03/render/interior/render_BANO_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/mistral/review03/render/interior/render_BANY_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/mistral/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mistral/review04/render/exterior/cam04.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Simulador Solar',
                  src: 'https://solar-simulator.bizionar.digital/culmia/mistral/review03',
                  thumb: 'https://media.bizionar.digital/culmia/mistral/review04/render/exterior/cam03.jpg',
                  type: 'solar-simulator',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/mistral/review04/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mistral/review04/render/exterior/cam05.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/mistral/review04/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/mistral/review04/render/interior/render_SALON_01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/mistral/review04/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/mistral/review04/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/mistral/review04/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/mistral/review04/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/mistral/review04/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 16',
                  src: 'https://media.bizionar.digital/culmia/mistral/review04/render/exterior/cam16.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/mistral/review04/render/interior/render_SALON_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/mistral/review04/render/interior/render_SALON_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/mistral/review04/render/interior/render_SALON03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/mistral/review04/render/interior/render_SALON04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/mistral/review04/render/interior/render_SALON05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/mistral/review04/render/interior/render_SALON06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/mistral/review04/render/interior/render_SALON07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/mistral/review04/render/interior/render_COCINA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/mistral/review04/render/interior/render_COCINA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/mistral/review04/render/interior/render_COCINA03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/mistral/review04/render/interior/render_TERRAZA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/mistral/review04/render/interior/render_TERRAZA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/mistral/review04/render/interior/render_HAB01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/mistral/review04/render/interior/render_HAB01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/mistral/review04/render/interior/render_HAB02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/mistral/review04/render/interior/render_BANO_COMUN01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/mistral/review04/render/interior/render_BANO_COMUN02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/mistral/review04/render/interior/render_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/mistral/review04/render/interior/render_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/mistral/review04/render/interior/render_BANO_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/mistral/review04/render/interior/render_BANY_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '18 de junio de 2025',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/mistral/download/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/mistral/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/mistral/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/mistral/live/cam04.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Simulador Solar',
                src: 'https://solar-simulator.bizionar.digital/culmia/mistral/live',
                thumb: 'https://media.bizionar.digital/culmia/mistral/live/cam03.jpg',
                type: 'solar-simulator',
                category: 'exteriores',
              },
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/culmia/mistral/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/culmia/mistral/live/cam05.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/mistral/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/mistral/live/cam03.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/culmia/mistral/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/culmia/mistral/live/cam03.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/culmia/mistral/live/cam03.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 04',
                src: 'https://media.bizionar.digital/culmia/mistral/live/cam04.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 05',
                src: 'https://media.bizionar.digital/culmia/mistral/live/cam05.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 08',
                src: 'https://media.bizionar.digital/culmia/mistral/live/cam08.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 12',
                src: 'https://media.bizionar.digital/culmia/mistral/live/cam12.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 16',
                src: 'https://media.bizionar.digital/culmia/mistral/live/cam16.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/mistral/live/render_SALON_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/mistral/live/render_SALON_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/mistral/live/render_SALON03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/mistral/live/render_SALON04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/culmia/mistral/live/render_SALON05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/culmia/mistral/live/render_SALON06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 07',
                src: 'https://media.bizionar.digital/culmia/mistral/live/render_SALON07.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/mistral/live/render_COCINA01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/mistral/live/render_COCINA02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/culmia/mistral/live/render_COCINA03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/mistral/live/render_TERRAZA01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 02',
                src: 'https://media.bizionar.digital/culmia/mistral/live/render_TERRAZA02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/culmia/mistral/live/render_HAB01_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 02',
                src: 'https://media.bizionar.digital/culmia/mistral/live/render_HAB01_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/culmia/mistral/live/render_HAB02_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/mistral/live/render_BANO_COMUN01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 02',
                src: 'https://media.bizionar.digital/culmia/mistral/live/render_BANO_COMUN02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/culmia/mistral/live/render_SUITE01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/culmia/mistral/live/render_SUITE02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/mistral/live/render_BANO_SUITE01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 02',
                src: 'https://media.bizionar.digital/culmia/mistral/live/render_BANY_SUITE02.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'retamar-eros',
          name: 'Retamar Eros',
          city: 'Alcorcón',
          province: 'Madrid',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/retamar-eros',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/retamar-eros',
          image: 'https://media.bizionar.digital/culmia/retamar-eros/live/exterior/cam06.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '28 de julio de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '3 de noviembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '23 de enero de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '9 de abril de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '30 de septiembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '23 de enero de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-eros/review01/render/exterior/cam05d.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-eros/review01/render/exterior/cam06.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review01/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-eros/review01/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review01/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05 noche',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review01/render/exterior/cam05n.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review01/render/exterior/cam05d.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review01/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review01/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review01/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review01/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review01/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review01/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review01/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review01/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review01/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review01/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review01/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review01/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review01/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review01/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review01/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review01/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review01/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review01/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review01/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review01/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review01/render/interior/still_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review01/render/interior/still_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-eros/review02/render/exterior/cam05d.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-eros/review02/render/exterior/cam06.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review02/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-eros/review02/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review02/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05 noche',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review02/render/exterior/cam05n.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review02/render/exterior/cam05d.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review02/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review02/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review02/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review02/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review02/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review02/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review02/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review02/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review02/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review02/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review02/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review02/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review02/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review02/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review02/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review02/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review02/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review02/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review02/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review02/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review02/render/interior/still_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review02/render/interior/still_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-eros/review03/render/exterior/cam05d.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-eros/review03/render/exterior/cam06.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review03/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-eros/review03/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review03/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05 noche',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review03/render/exterior/cam05n.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review03/render/exterior/cam05d.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review03/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review03/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review03/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review03/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review03/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review03/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review03/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review03/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review03/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review03/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review03/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review03/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review03/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review03/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review03/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review03/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review03/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review03/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review03/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review03/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review03/render/interior/still_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-eros/review03/render/interior/still_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '10 de febrero de 2026',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/retamar-eros/download/exterior/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/retamar-eros/download/interior/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/culmia/retamar-eros/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/culmia/retamar-eros/live/exterior/cam05d.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/retamar-eros/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/retamar-eros/live/exterior/cam06.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 06',
                src: 'https://media.bizionar.digital/culmia/retamar-eros/live/exterior/cam06.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 05 noche',
                src: 'https://media.bizionar.digital/culmia/retamar-eros/live/exterior/cam05n.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 05',
                src: 'https://media.bizionar.digital/culmia/retamar-eros/live/exterior/cam05d.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 10',
                src: 'https://media.bizionar.digital/culmia/retamar-eros/live/exterior/cam10.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/culmia/retamar-eros/live/exterior/cam02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/retamar-eros/live/interior/still_Camera_001.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/retamar-eros/live/interior/still_Camera_002.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/retamar-eros/live/interior/still_Camera_003.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/retamar-eros/live/interior/still_Camera_004.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/retamar-eros/live/interior/still_Camera_005.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 02',
                src: 'https://media.bizionar.digital/culmia/retamar-eros/live/interior/still_Camera_006.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/retamar-eros/live/interior/still_Camera_007.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/retamar-eros/live/interior/still_Camera_008.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/culmia/retamar-eros/live/interior/still_Camera_009.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/culmia/retamar-eros/live/interior/still_Camera_010.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/culmia/retamar-eros/live/interior/still_Camera_011.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 03',
                src: 'https://media.bizionar.digital/culmia/retamar-eros/live/interior/still_Camera_012.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/retamar-eros/live/interior/still_Camera_013.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 02',
                src: 'https://media.bizionar.digital/culmia/retamar-eros/live/interior/still_Camera_014.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/culmia/retamar-eros/live/interior/still_Camera_015.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 02',
                src: 'https://media.bizionar.digital/culmia/retamar-eros/live/interior/still_Camera_016.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/culmia/retamar-eros/live/interior/still_Camera_017.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 02',
                src: 'https://media.bizionar.digital/culmia/retamar-eros/live/interior/still_Camera_018.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/retamar-eros/live/interior/still_Camera_019.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 02',
                src: 'https://media.bizionar.digital/culmia/retamar-eros/live/interior/still_Camera_020.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'retamar-isthar',
          name: 'Retamar Ishtar',
          city: 'Alcorcón',
          province: 'Madrid',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/retamar-isthar',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/retamar-isthar',
          image: 'https://media.bizionar.digital/culmia/retamar-isthar/live/exterior/cam02.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '24 de julio de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '8 de octubre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '14 de noviembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '15 de diciembre de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '5 de septiembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '2 de octubre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '14 de noviembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '15 de diciembre de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-isthar/review01/render/exterior/cam02.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-isthar/review01/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review01/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-isthar/review01/render/interior/still_Camera_007.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review01/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review01/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review01/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review01/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review01/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review01/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review01/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review01/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review01/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review01/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review01/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review01/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review01/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review01/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review01/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review01/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review01/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review01/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review01/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review01/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review01/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review01/render/interior/still_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review01/render/interior/still_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review01/render/interior/still_Camera_021.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review01/render/interior/still_Camera_022.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review01/render/interior/still_Camera_023.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-isthar/review02/render/exterior/cam02.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review02/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-isthar/review02/render/interior/still_Camera_007.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-isthar/review02/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review02/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review02/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review02/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review02/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review02/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review02/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review02/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review02/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review02/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review02/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review02/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review02/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review02/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review02/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review02/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review02/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review02/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review02/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review02/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review02/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review02/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review02/render/interior/still_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review02/render/interior/still_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review02/render/interior/still_Camera_021.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review02/render/interior/still_Camera_022.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review02/render/interior/still_Camera_023.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-isthar/review03/render/exterior/cam02.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-isthar/review03/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review03/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-isthar/review03/render/interior/still_Camera_007.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review03/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review03/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review03/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review03/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review03/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review03/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review03/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review03/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review03/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review03/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review03/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review03/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review03/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review03/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review03/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review03/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review03/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review03/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review03/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review03/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review03/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review03/render/interior/still_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review03/render/interior/still_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review03/render/interior/still_Camera_021.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review03/render/interior/still_Camera_022.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review03/render/interior/still_Camera_023.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review04/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-isthar/review04/render/exterior/cam02.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-isthar/review04/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review04/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-isthar/review04/render/interior/still_Camera_007.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review04/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review04/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review04/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review04/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review04/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review04/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review04/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review04/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review04/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review04/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review04/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review04/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review04/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review04/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review04/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review04/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review04/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review04/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review04/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review04/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review04/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review04/render/interior/still_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review04/render/interior/still_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review04/render/interior/still_Camera_021.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review04/render/interior/still_Camera_022.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-isthar/review04/render/interior/still_Camera_023.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '23 de diciembre de 2025',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/retamar-isthar/download/exterior/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/retamar-isthar/download/interior/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/culmia/retamar-isthar/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/culmia/retamar-isthar/live/exterior/cam02.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/retamar-isthar/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/retamar-isthar/live/exterior/cam02.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Multipunto Interior',
                src: 'https://media.bizionar.digital/culmia/retamar-isthar/live/tour-multipunto/index.html',
                thumb: 'https://media.bizionar.digital/culmia/retamar-isthar/live/interior/still_Camera_007.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/culmia/retamar-isthar/live/exterior/cam02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 07',
                src: 'https://media.bizionar.digital/culmia/retamar-isthar/live/exterior/cam07.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 06',
                src: 'https://media.bizionar.digital/culmia/retamar-isthar/live/exterior/cam06.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/retamar-isthar/live/interior/still_Camera_001.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/retamar-isthar/live/interior/still_Camera_002.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/retamar-isthar/live/interior/still_Camera_003.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/retamar-isthar/live/interior/still_Camera_004.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/culmia/retamar-isthar/live/interior/still_Camera_005.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/culmia/retamar-isthar/live/interior/still_Camera_006.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 07',
                src: 'https://media.bizionar.digital/culmia/retamar-isthar/live/interior/still_Camera_007.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/retamar-isthar/live/interior/still_Camera_008.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 02',
                src: 'https://media.bizionar.digital/culmia/retamar-isthar/live/interior/still_Camera_009.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/retamar-isthar/live/interior/still_Camera_010.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/retamar-isthar/live/interior/still_Camera_011.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/culmia/retamar-isthar/live/interior/still_Camera_012.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/culmia/retamar-isthar/live/interior/still_Camera_013.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/culmia/retamar-isthar/live/interior/still_Camera_014.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 03',
                src: 'https://media.bizionar.digital/culmia/retamar-isthar/live/interior/still_Camera_015.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/retamar-isthar/live/interior/still_Camera_016.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 02',
                src: 'https://media.bizionar.digital/culmia/retamar-isthar/live/interior/still_Camera_017.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/culmia/retamar-isthar/live/interior/still_Camera_018.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 02',
                src: 'https://media.bizionar.digital/culmia/retamar-isthar/live/interior/still_Camera_019.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/culmia/retamar-isthar/live/interior/still_Camera_020.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 02',
                src: 'https://media.bizionar.digital/culmia/retamar-isthar/live/interior/still_Camera_021.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/retamar-isthar/live/interior/still_Camera_022.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 02',
                src: 'https://media.bizionar.digital/culmia/retamar-isthar/live/interior/still_Camera_023.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'retamar-bes',
          name: 'Retamar Bes',
          city: 'Alcorcón',
          province: 'Madrid',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/retamar-bes',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/retamar-bes',
          image: 'https://media.bizionar.digital/culmia/retamar-bes/live/exterior/cam02.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 4,
              totalReviews: 4,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '14 de abril de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '8 de julio de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '1 de octubre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '3 de novembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review05',
                  name: 'ENTREGA 5',
                  date: '23 de enero de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review01/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review01/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review01/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review01/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review01/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-bes/review02/render/exterior/cam02.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-bes/review02/render/exterior/cam12.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review02/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review02/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review02/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review02/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review02/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-bes/review03/render/exterior/cam02.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-bes/review03/render/exterior/cam12.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review03/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review03/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review03/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review03/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review03/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-bes/review04/render/exterior/cam02.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-bes/review04/render/exterior/cam12.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review04/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review04/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review04/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review04/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review04/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
            {
              id: 'review05',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review05/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-bes/review05/render/exterior/cam02.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review05/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-bes/review05/render/exterior/cam12.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review05/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review05/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review05/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review05/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/retamar-bes/review05/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '10 de febrero de 2026',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/retamar-bes/download/exterior/render_exterior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/culmia/retamar-bes/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/culmia/retamar-bes/live/exterior/cam02.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/retamar-bes/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/retamar-bes/live/exterior/cam12.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/culmia/retamar-bes/live/exterior/cam03.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/culmia/retamar-bes/live/exterior/cam02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 05',
                src: 'https://media.bizionar.digital/culmia/retamar-bes/live/exterior/cam05.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 09',
                src: 'https://media.bizionar.digital/culmia/retamar-bes/live/exterior/cam09.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 12',
                src: 'https://media.bizionar.digital/culmia/retamar-bes/live/exterior/cam12.jpg',
                type: 'render',
                category: 'exteriores',
              },
            ],
          },
        },
        {
          id: 'retamar-lonos',
          name: 'Retamar Lono',
          city: 'Alcorcón',
          province: 'Madrid',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/retamar-lonos',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/retamar-lonos',
          image: 'https://media.bizionar.digital/culmia/retamar-lonos/live/exterior/Cam003.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '2 de julio de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '1 de octubre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '4 de noviembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '23 de enero de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-lonos/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-lonos/review01/render/exterior/Cam003.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-lonos/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-lonos/review01/render/exterior/Cam003.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-lonos/review01/render/exterior/Cam003.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/retamar-lonos/review01/render/exterior/Cam005.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/retamar-lonos/review01/render/exterior/Cam009.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/retamar-lonos/review01/render/exterior/Cam007.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-lonos/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-lonos/review02/render/exterior/Cam009.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-lonos/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-lonos/review02/render/exterior/Cam003.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-lonos/review02/render/exterior/Cam003.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/retamar-lonos/review02/render/exterior/Cam005.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/retamar-lonos/review02/render/exterior/Cam009.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/retamar-lonos/review02/render/exterior/Cam007.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-lonos/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-lonos/review03/render/exterior/Cam009.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-lonos/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-lonos/review03/render/exterior/Cam003.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-lonos/review03/render/exterior/Cam003.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/retamar-lonos/review03/render/exterior/Cam005.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/retamar-lonos/review03/render/exterior/Cam009.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/retamar-lonos/review03/render/exterior/Cam007.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-lonos/review04/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-lonos/review04/render/exterior/Cam009.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-lonos/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-lonos/review04/render/exterior/Cam003.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-lonos/review04/render/exterior/Cam003.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/retamar-lonos/review04/render/exterior/Cam005.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/retamar-lonos/review04/render/exterior/Cam009.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/retamar-lonos/review04/render/exterior/Cam007.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '10 de febrero de 2026',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/retamar-lonos/download/exterior/render_exterior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/culmia/retamar-lonos/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/culmia/retamar-lonos/live/exterior/Cam009.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/retamar-lonos/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/retamar-lonos/live/exterior/Cam003.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/culmia/retamar-lonos/live/exterior/Cam003.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 05',
                src: 'https://media.bizionar.digital/culmia/retamar-lonos/live/exterior/Cam005.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 09',
                src: 'https://media.bizionar.digital/culmia/retamar-lonos/live/exterior/Cam009.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 07',
                src: 'https://media.bizionar.digital/culmia/retamar-lonos/live/exterior/Cam007.jpg',
                type: 'render',
                category: 'exteriores',
              },
            ],
          },
        },
        {
          id: 'retamar-milda',
          name: 'Retamar Milda',
          city: 'Alcorcón',
          province: 'Madrid',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/retamar-milda',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/retamar-milda',
          image: 'https://media.bizionar.digital/culmia/retamar-milda/live/exterior/cam02.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '19 de septiembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '10 de octubre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '14 de novembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '15 de diciembre de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-milda/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-milda/review01/render/exterior/cam02.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-milda/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-milda/review01/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Simulador Solar',
                  src: 'https://solar-simulator.bizionar.digital/culmia/retamar-milda/review01',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-milda/review01/render/exterior/cam02.jpg',
                  type: 'solar-simulator',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-milda/review01/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/retamar-milda/review01/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/retamar-milda/review01/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-milda/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-milda/review02/render/exterior/cam02.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-milda/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-milda/review02/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Simulador Solar',
                  src: 'https://solar-simulator.bizionar.digital/culmia/retamar-milda/review02',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-milda/review02/render/exterior/cam02.jpg',
                  type: 'solar-simulator',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-milda/review02/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/retamar-milda/review02/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/retamar-milda/review02/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-milda/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-milda/review03/render/exterior/cam02.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-milda/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-milda/review03/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Simulador Solar',
                  src: 'https://solar-simulator.bizionar.digital/culmia/retamar-milda/review03',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-milda/review03/render/exterior/cam02.jpg',
                  type: 'solar-simulator',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-milda/review03/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/retamar-milda/review03/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/retamar-milda/review03/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior Cámara Frontal',
                  src: 'https://media.bizionar.digital/culmia/retamar-milda/review03/render/exterior/cam_frontal.jpg',
                  type: 'render',
                  category: 'exteriores',
                }
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-milda/review04/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-milda/review04/render/exterior/cam02.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-milda/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-milda/review04/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Simulador Solar',
                  src: 'https://solar-simulator.bizionar.digital/culmia/retamar-milda/review03',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-milda/review04/render/exterior/cam02.jpg',
                  type: 'solar-simulator',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-milda/review04/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/retamar-milda/review04/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/culmia/retamar-milda/review04/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior Cámara Frontal',
                  src: 'https://media.bizionar.digital/culmia/retamar-milda/review04/render/exterior/cam_frontal.jpg',
                  type: 'render',
                  category: 'exteriores',
                }
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '23 de diciembre de 2025',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/retamar-milda/download/exterior/render_exterior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/culmia/retamar-milda/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/culmia/retamar-milda/live/exterior/cam02.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/retamar-milda/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/retamar-milda/live/exterior/cam02.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Simulador Solar',
                src: 'https://solar-simulator.bizionar.digital/culmia/retamar-milda/live',
                thumb: 'https://media.bizionar.digital/culmia/retamar-milda/live/exterior/cam02.jpg',
                type: 'solar-simulator',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/culmia/retamar-milda/live/exterior/cam02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 06',
                src: 'https://media.bizionar.digital/culmia/retamar-milda/live/exterior/cam06.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 10',
                src: 'https://media.bizionar.digital/culmia/retamar-milda/live/exterior/cam10.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior Cámara Frontal',
                src: 'https://media.bizionar.digital/culmia/retamar-milda/live/exterior/cam_frontal.jpg',
                type: 'render',
                category: 'exteriores',
              }
            ],
          },
        },
        {
          id: 'retamar-bastet',
          name: 'Retamar Bastet',
          city: 'Alcorcón',
          province: 'Madrid',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/retamar-bastet',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/retamar-bastet',
          image: 'https://media.bizionar.digital/culmia/retamar-bastet/live/exterior/cam03.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '26 de septiembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '14 de novembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '15 de diciembre de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-bastet/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-bastet/review01/render/exterior/cam03.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-bastet/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-bastet/review01/render/exterior/cam03.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-bastet/review01/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/retamar-bastet/review01/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/retamar-bastet/review01/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-bastet/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-bastet/review02/render/exterior/cam03.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-bastet/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-bastet/review02/render/exterior/cam03.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-bastet/review02/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/retamar-bastet/review02/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/retamar-bastet/review02/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-bastet/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-bastet/review03/render/exterior/cam03.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-bastet/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-bastet/review03/render/exterior/cam03.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-bastet/review03/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/retamar-bastet/review03/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/retamar-bastet/review03/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '23 de diciembre de 2025',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/retamar-bastet/download/exterior/render_exterior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/culmia/retamar-bastet/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/culmia/retamar-bastet/live/exterior/cam03.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/retamar-bastet/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/retamar-bastet/live/exterior/cam03.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/culmia/retamar-bastet/live/exterior/cam03.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 08',
                src: 'https://media.bizionar.digital/culmia/retamar-bastet/live/exterior/cam08.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 09',
                src: 'https://media.bizionar.digital/culmia/retamar-bastet/live/exterior/cam09.jpg',
                type: 'render',
                category: 'exteriores',
              },
            ],
          },
        },
        {
          id: 'retamar-sedna',
          name: 'Retamar Sedna',
          city: 'Alcorcón',
          province: 'Madrid',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/retamar-sedna',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/retamar-sedna',
          image: 'https://media.bizionar.digital/culmia/retamar-sedna/live/exterior/cam02.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '2 de octubre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '14 de noviembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '18 de diciembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '23 de enero de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '2 de octubre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '14 de noviembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '18 de diciembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '12 de enero de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'parking',
              categoryName: 'PARKING',
              closedReviews: 0,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '18 de diciembre de 2025',
                  status: 'pending',
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/render/exterior/cam06.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/render/interior/still_Camera_002.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/render/exterior/cam14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/render/interior/still_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/render/interior/still_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/render/interior/still_Camera_021.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/render/interior/still_Camera_022.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/render/interior/still_Camera_023.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Parking',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review01/render/parking/still.jpg',
                  type: 'render',
                  category: 'parking',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-sedna/review02/render/exterior/cam06.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-sedna/review02/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review02/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-sedna/review02/render/interior/still_Camera_002.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review02/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review02/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review02/render/exterior/cam14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review02/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review02/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review02/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review02/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review02/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review02/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Entrada 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review02/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Entrada 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review02/render/interior/still_Camera_023.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review02/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review02/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review02/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review02/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review02/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review02/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review02/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review02/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review02/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review02/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review02/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review02/render/interior/still_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review02/render/interior/still_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review02/render/interior/still_Camera_021.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review02/render/interior/still_Camera_022.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-sedna/review03/render/exterior/cam06.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-sedna/review03/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review03/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-sedna/review03/render/interior/still_Camera_002.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review03/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review03/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review03/render/exterior/cam14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review03/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review03/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review03/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review03/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review03/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review03/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Entrada 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review03/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Entrada 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review03/render/interior/still_Camera_023.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review03/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review03/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review03/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review03/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review03/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review03/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review03/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review03/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review03/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review03/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review03/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review03/render/interior/still_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review03/render/interior/still_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review03/render/interior/still_Camera_021.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review03/render/interior/still_Camera_022.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review04/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-sedna/review04/render/exterior/cam06.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-sedna/review04/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review04/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-sedna/review04/render/interior/still_Camera_002.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review04/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review04/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review04/render/exterior/cam14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review04/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review04/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review04/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review04/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review04/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review04/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Entrada 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review04/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Entrada 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review04/render/interior/still_Camera_023.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review04/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review04/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review04/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review04/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review04/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review04/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review04/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review04/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review04/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review04/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review04/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review04/render/interior/still_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review04/render/interior/still_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review04/render/interior/still_Camera_021.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-sedna/review04/render/interior/still_Camera_022.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '26 de enero de 2026',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/retamar-sedna/download/exterior/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/retamar-sedna/download/interior/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/culmia/retamar-sedna/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/culmia/retamar-sedna/live/exterior/cam06.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/retamar-sedna/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/retamar-sedna/live/exterior/cam02.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Multipunto Interior',
                src: 'https://media.bizionar.digital/culmia/retamar-sedna/live/tour-multipunto/index.html',
                thumb: 'https://media.bizionar.digital/culmia/retamar-sedna/live/interior/still_Camera_002.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/culmia/retamar-sedna/live/exterior/cam02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 08',
                src: 'https://media.bizionar.digital/culmia/retamar-sedna/live/exterior/cam06.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 09',
                src: 'https://media.bizionar.digital/culmia/retamar-sedna/live/exterior/cam14.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/retamar-sedna/live/interior/still_Camera_001.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/retamar-sedna/live/interior/still_Camera_002.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/retamar-sedna/live/interior/still_Camera_003.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/retamar-sedna/live/interior/still_Camera_004.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/culmia/retamar-sedna/live/interior/still_Camera_005.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/culmia/retamar-sedna/live/interior/still_Camera_006.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Entrada 01',
                src: 'https://media.bizionar.digital/culmia/retamar-sedna/live/interior/still_Camera_007.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Entrada 02',
                src: 'https://media.bizionar.digital/culmia/retamar-sedna/live/interior/still_Camera_023.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/retamar-sedna/live/interior/still_Camera_008.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 02',
                src: 'https://media.bizionar.digital/culmia/retamar-sedna/live/interior/still_Camera_009.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/retamar-sedna/live/interior/still_Camera_010.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/retamar-sedna/live/interior/still_Camera_011.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/culmia/retamar-sedna/live/interior/still_Camera_012.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/culmia/retamar-sedna/live/interior/still_Camera_013.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/culmia/retamar-sedna/live/interior/still_Camera_014.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/retamar-sedna/live/interior/still_Camera_015.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 02',
                src: 'https://media.bizionar.digital/culmia/retamar-sedna/live/interior/still_Camera_016.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/culmia/retamar-sedna/live/interior/still_Camera_017.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 02',
                src: 'https://media.bizionar.digital/culmia/retamar-sedna/live/interior/still_Camera_018.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/culmia/retamar-sedna/live/interior/still_Camera_019.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 02',
                src: 'https://media.bizionar.digital/culmia/retamar-sedna/live/interior/still_Camera_020.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/retamar-sedna/live/interior/still_Camera_021.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 02',
                src: 'https://media.bizionar.digital/culmia/retamar-sedna/live/interior/still_Camera_022.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'retamar-autum',
          name: 'Retamar Autum',
          city: 'Alcorcón',
          province: 'Madrid',
          liveEnabled: false,
          showEnabled: false,
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/retamar-autum',
          image: 'https://media.bizionar.digital/culmia/retamar-autum/review03/render/exterior/cam02.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '4 de marzo de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '17 de junio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '30 de octubre de 2026',
                  status: 'pending',
                }
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-autum/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-autum/review01/render/exterior/cam06.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-autum/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-autum/review01/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/retamar-autum/review01/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-autum/review01/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/retamar-autum/review01/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06 - Blue Hour',
                  src: 'https://media.bizionar.digital/culmia/retamar-autum/review01/render/exterior-ia/cam06_ia_blue_hour.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06 - Mediterranean Day',
                  src: 'https://media.bizionar.digital/culmia/retamar-autum/review01/render/exterior-ia/cam06_ia_mediterranean_day.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02 - Blue Hour',
                  src: 'https://media.bizionar.digital/culmia/retamar-autum/review01/render/exterior-ia/cam02_ia_blue_hour.jpg',
                 type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07 - Daylight Suset',
                  src: 'https://media.bizionar.digital/culmia/retamar-autum/review01/render/exterior-ia/cam07_ia_day_light_sunet.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07 - Mediterranean Day',
                  src: 'https://media.bizionar.digital/culmia/retamar-autum/review01/render/exterior-ia/cam07_ia_mediterranean_day.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07 - Sunset',
                  src: 'https://media.bizionar.digital/culmia/retamar-autum/review01/render/exterior-ia/cam07_ia_sunset.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-autum/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-autum/review02/render/exterior/cam06.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-autum/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-autum/review02/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/retamar-autum/review02/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-autum/review02/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/retamar-autum/review02/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-autum/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-autum/review03/render/exterior/cam06.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-autum/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-autum/review03/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-autum/review03/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02 - IA',
                  src: 'https://media.bizionar.digital/culmia/retamar-autum/review03/render/exterior/cam02_ia_blue_hour.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/retamar-autum/review03/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06 - IA',
                  src: 'https://media.bizionar.digital/culmia/retamar-autum/review03/render/exterior/cam06_ia_mediterranean_day.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/retamar-autum/review03/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07 - IA',
                  src: 'https://media.bizionar.digital/culmia/retamar-autum/review03/render/exterior/cam07_ia_sunset.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
          ],
        },
        {
          id: 'la-roca-natura',
          name: 'La Roca Natura',
          city: 'La Roca del Vallès',
          province: 'Barcelona',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/la-roca-natura',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/la-roca-natura',
          image: 'https://media.bizionar.digital/culmia/la-roca-natura/live/exterior/01.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '3 de octubre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '20 de noviembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '30 de diciembre de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '31 de octubre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '15 de diciembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '23 de diciembre de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/la-roca-natura/review01/render/exterior/01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review01/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/la-roca-natura/review01/render/interior/render_SALON01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review01/render/exterior/01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review01/render/exterior/05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review01/render/exterior/07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review01/render/exterior/13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 17',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review01/render/exterior/17.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review01/render/interior/render_SALON01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review01/render/interior/render_SALON02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review01/render/interior/render_SALON03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review01/render/interior/render_SALON04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review01/render/interior/render_SALON05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review01/render/interior/render_SALON06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review01/render/interior/render_TERRAZA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review01/render/interior/render_COCINA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review01/render/interior/render_COCINA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review01/render/interior/render_COCINA03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review01/render/interior/render_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review01/render/interior/render_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review01/render/interior/render_BANO_PRINCIPAL01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review01/render/interior/render_BANO_PRINCIPAL02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review01/render/interior/render_HAB01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review01/render/interior/render_HAB01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review01/render/interior/render_HAB02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review01/render/interior/render_HAB02_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review01/render/interior/render_BANO_SECUNDARIO01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review01/render/interior/render_BANO_SECUNDARIO02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/la-roca-natura/review02/render/exterior/01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review02/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/la-roca-natura/review02/render/interior/render_SALON01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review02/render/exterior/01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review02/render/exterior/05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review02/render/exterior/07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review02/render/exterior/13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 17',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review02/render/exterior/17.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review02/render/interior/render_SALON01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review02/render/interior/render_SALON02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review02/render/interior/render_SALON03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review02/render/interior/render_SALON04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review02/render/interior/render_SALON05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review02/render/interior/render_SALON06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review02/render/interior/render_TERRAZA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review02/render/interior/render_COCINA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review02/render/interior/render_COCINA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review02/render/interior/render_COCINA03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review02/render/interior/render_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review02/render/interior/render_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review02/render/interior/render_BANO_PRINCIPAL01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review02/render/interior/render_BANO_PRINCIPAL02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review02/render/interior/render_HAB01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review02/render/interior/render_HAB01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review02/render/interior/render_HAB02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review02/render/interior/render_HAB02_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review02/render/interior/render_BANO_SECUNDARIO01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review02/render/interior/render_BANO_SECUNDARIO02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/la-roca-natura/review03/render/exterior/01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review03/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/la-roca-natura/review03/render/interior/render_SALON01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review03/render/exterior/01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review03/render/exterior/05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review03/render/exterior/07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review03/render/exterior/13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 17',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review03/render/exterior/17.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review03/render/interior/render_SALON01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review03/render/interior/render_SALON02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review03/render/interior/render_SALON03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review03/render/interior/render_SALON04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review03/render/interior/render_SALON05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review03/render/interior/render_SALON06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review03/render/interior/render_TERRAZA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review03/render/interior/render_COCINA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review03/render/interior/render_COCINA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review03/render/interior/render_COCINA03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review03/render/interior/render_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review03/render/interior/render_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review03/render/interior/render_BANO_PRINCIPAL01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review03/render/interior/render_BANO_PRINCIPAL02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review03/render/interior/render_HAB01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review03/render/interior/render_HAB01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review03/render/interior/render_HAB02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review03/render/interior/render_HAB02_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review03/render/interior/render_BANO_SECUNDARIO01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/la-roca-natura/review03/render/interior/render_BANO_SECUNDARIO02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'PISO PILOTO',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '31 de julio de 2026',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/la-roca-natura/download/exterior/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/la-roca-natura/download/interior/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/la-roca-natura/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/la-roca-natura/live/exterior/01.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/la-roca-natura/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/la-roca-natura/live/exterior/01.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/culmia/la-roca-natura/live/exterior/01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 05',
                src: 'https://media.bizionar.digital/culmia/la-roca-natura/live/exterior/05.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 07',
                src: 'https://media.bizionar.digital/culmia/la-roca-natura/live/exterior/07.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 13',
                src: 'https://media.bizionar.digital/culmia/la-roca-natura/live/exterior/13.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 17',
                src: 'https://media.bizionar.digital/culmia/la-roca-natura/live/exterior/17.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/la-roca-natura/live/interior/render_SALON01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/la-roca-natura/live/interior/render_SALON02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/la-roca-natura/live/interior/render_SALON03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/la-roca-natura/live/interior/render_SALON04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/culmia/la-roca-natura/live/interior/render_SALON05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/culmia/la-roca-natura/live/interior/render_SALON06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/culmia/la-roca-natura/live/interior/render_TERRAZA01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/la-roca-natura/live/interior/render_COCINA01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/la-roca-natura/live/interior/render_COCINA02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/culmia/la-roca-natura/live/interior/render_COCINA03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/culmia/la-roca-natura/live/interior/render_SUITE01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/culmia/la-roca-natura/live/interior/render_SUITE02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/la-roca-natura/live/interior/render_BANO_PRINCIPAL01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 02',
                src: 'https://media.bizionar.digital/culmia/la-roca-natura/live/interior/render_BANO_PRINCIPAL02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/culmia/la-roca-natura/live/interior/render_HAB01_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 02',
                src: 'https://media.bizionar.digital/culmia/la-roca-natura/live/interior/render_HAB01_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/culmia/la-roca-natura/live/interior/render_HAB02_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 02',
                src: 'https://media.bizionar.digital/culmia/la-roca-natura/live/interior/render_HAB02_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/la-roca-natura/live/interior/render_BANO_SECUNDARIO01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 02',
                src: 'https://media.bizionar.digital/culmia/la-roca-natura/live/interior/render_BANO_SECUNDARIO02.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'eterna-michelena',
          name: 'Eterna Michelena',
          city: 'Pontevedra',
          province: 'Pontevedra',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://culmia-show.bizionar.digital/eterna-michelena',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/eterna-michelena',
          image: 'https://media.bizionar.digital/culmia/eterna-michelena/live/exterior/cam01.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '13 de febrero de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '13 de agosto de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '18 de septiembre de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 5,
              totalReviews: 5,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '19 de enero de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '29 de enero de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '17 de marzo de 2026',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '1 de abril de 2026',
                  status: 'closed',
                },
                {
                  id: 'review05',
                  name: 'ENTREGA 5',
                  date: '20 de abril de 2026',
                  status: 'closed',
                },
                {
                  id: 'review06',
                  name: 'ENTREGA 6',
                  date: '23 de abril de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/eterna-michelena/review01/render/exterior/cam01.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/eterna-michelena/review01/render/exterior/cam12.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review01/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/eterna-michelena/review01/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review01/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review01/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review01/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review01/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review01/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review01/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review01/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review01/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review01/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review01/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review01/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review01/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review01/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review01/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review01/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review01/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review01/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review01/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review01/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review01/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review01/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review01/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review01/render/interior/still_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review01/render/interior/still_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/eterna-michelena/review02/render/exterior/cam01.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/eterna-michelena/review02/render/exterior/cam12.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review02/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review02/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review02/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review02/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review02/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review02/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review02/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review02/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review02/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review02/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review02/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review02/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review02/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review02/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review02/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review02/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review02/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review02/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review02/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review02/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review02/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review02/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review02/render/interior/still_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review02/render/interior/still_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/eterna-michelena/review03/render/exterior/cam01.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/eterna-michelena/review03/render/exterior/cam12.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review03/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/eterna-michelena/review03/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review03/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review03/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review03/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review03/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review03/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review03/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review03/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review03/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review03/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review03/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review03/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review03/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review03/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review03/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review03/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review03/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review03/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review03/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review03/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review03/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review03/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review03/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review03/render/interior/still_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review03/render/interior/still_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review04/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/eterna-michelena/review04/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review04/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review04/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review04/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03 (sin isla)',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review04/render/interior/still_Camera_003_b.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review04/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review04/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review04/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06 (sin isla)',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review04/render/interior/still_Camera_006_b.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review04/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review04/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review04/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review04/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review04/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review04/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review04/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review04/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review04/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review04/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review04/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review04/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review04/render/interior/still_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review04/render/interior/still_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review05',
              content: [
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review05/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/eterna-michelena/review05/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review05/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review05/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review05/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03 (sin isla)',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review05/render/interior/still_Camera_003_b.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review05/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review05/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review05/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06 (sin isla)',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review05/render/interior/still_Camera_006_b.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review05/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review05/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review05/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review05/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review05/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review05/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review05/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review05/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review05/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review05/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review05/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review05/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review05/render/interior/still_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review05/render/interior/still_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review06',
              content: [
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review06/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/eterna-michelena/review06/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review06/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review06/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review06/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03 (sin isla)',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review06/render/interior/still_Camera_003_b.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review06/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review06/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review06/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06 (sin isla)',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review06/render/interior/still_Camera_006_b.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review06/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review06/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review06/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review06/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review06/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review06/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review06/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review06/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review06/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review06/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review06/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review06/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review06/render/interior/still_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/eterna-michelena/review06/render/interior/still_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'PISO PILOTO',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '21 de septiembre de 2026',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/eterna-michelena/download/exterior/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/eterna-michelena/download/interior/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/culmia/eterna-michelena/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/culmia/eterna-michelena/live/exterior/cam01.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/eterna-michelena/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/eterna-michelena/live/exterior/cam12.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/eterna-michelena/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/eterna-michelena/live/exterior/cam12.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/culmia/eterna-michelena/live/exterior/cam01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/culmia/eterna-michelena/live/exterior/cam03.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 11',
                src: 'https://media.bizionar.digital/culmia/eterna-michelena/live/exterior/cam11.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 12',
                src: 'https://media.bizionar.digital/culmia/eterna-michelena/live/exterior/cam12.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/culmia/eterna-michelena/live/interior/still_Camera_001.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/culmia/eterna-michelena/live/interior/still_Camera_002.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/culmia/eterna-michelena/live/interior/still_Camera_003.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03 (sin isla)',
                src: 'https://media.bizionar.digital/culmia/eterna-michelena/live/interior/still_Camera_003_b.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/culmia/eterna-michelena/live/interior/still_Camera_004.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/culmia/eterna-michelena/live/interior/still_Camera_005.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/culmia/eterna-michelena/live/interior/still_Camera_006.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06 (sin isla)',
                src: 'https://media.bizionar.digital/culmia/eterna-michelena/live/interior/still_Camera_006_b.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/culmia/eterna-michelena/live/interior/still_Camera_007.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/culmia/eterna-michelena/live/interior/still_Camera_008.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/culmia/eterna-michelena/live/interior/still_Camera_009.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 04',
                src: 'https://media.bizionar.digital/culmia/eterna-michelena/live/interior/still_Camera_010.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/culmia/eterna-michelena/live/interior/still_Camera_011.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/culmia/eterna-michelena/live/interior/still_Camera_012.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/culmia/eterna-michelena/live/interior/still_Camera_013.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 02',
                src: 'https://media.bizionar.digital/culmia/eterna-michelena/live/interior/still_Camera_014.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/culmia/eterna-michelena/live/interior/still_Camera_015.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 02',
                src: 'https://media.bizionar.digital/culmia/eterna-michelena/live/interior/still_Camera_016.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/culmia/eterna-michelena/live/interior/still_Camera_017.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 02',
                src: 'https://media.bizionar.digital/culmia/eterna-michelena/live/interior/still_Camera_018.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/culmia/eterna-michelena/live/interior/still_Camera_019.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 02',
                src: 'https://media.bizionar.digital/culmia/eterna-michelena/live/interior/still_Camera_020.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'retamar-balder',
          name: 'Retamar Balder',
          city: 'Alcorcón',
          province: 'Madrid',
          liveEnabled: false,
          showEnabled: false,
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/retamar-balder',
          image: 'https://media.bizionar.digital/culmia/retamar-balder/review03/render/exterior/cam08.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '24 de marzo de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '3 de junio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '26 de octubre de 2026',
                  status: 'pending',
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 0,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '25 de marzo de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '3 de junio de 2026',
                  status: 'pending',
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-balder/review01/render/exterior/cam29.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-balder/review01/render/exterior/cam08.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review01/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-balder/review01/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review01/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review01/render/exterior/cam16.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review01/render/exterior/cam26.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 29',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review01/render/exterior/cam29.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review01/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review01/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review01/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review01/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review01/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review01/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 07',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review01/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review01/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review01/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review01/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review01/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review01/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review01/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review01/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review01/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review01/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review01/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review01/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-balder/review02/render/exterior/cam29.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-balder/review02/render/exterior/cam08.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review02/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-balder/review02/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review02/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review02/render/exterior/cam16.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review02/render/exterior/cam26.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 29',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review02/render/exterior/cam29.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review02/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review02/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review02/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review02/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review02/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review02/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 07',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review02/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review02/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review02/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review02/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review02/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review02/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review02/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review02/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review02/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review02/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review02/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review02/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-balder/review03/render/exterior/cam29.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-balder/review03/render/exterior/cam08.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review03/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08 - IA',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review03/render/exterior/cam08_ia.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 16',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review03/render/exterior/cam16.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 16 - IA',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review03/render/exterior/cam16_ia.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 26',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review03/render/exterior/cam26.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 26 - IA',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review03/render/exterior/cam26_ia.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 29',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review03/render/exterior/cam29.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 29 - IA',
                  src: 'https://media.bizionar.digital/culmia/retamar-balder/review03/render/exterior/cam29_ia.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
          ],
        },
        {
          id: 'retamar-mitra',
          name: 'Retamar Mitra',
          city: 'Alcorcón',
          province: 'Madrid',
          liveEnabled: true,
          showEnabled: false,
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/retamar-mitra',
          image: 'https://media.bizionar.digital/culmia/retamar-mitra/live/exterior/cam03.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '24 de abril de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '5 de junio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '6 de agosto de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-mitra/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-mitra/review01/render/exterior/cam03.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-mitra/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-mitra/review01/render/exterior/cam03.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-mitra/review01/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/retamar-mitra/review01/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/retamar-mitra/review01/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 16',
                  src: 'https://media.bizionar.digital/culmia/retamar-mitra/review01/render/exterior/cam16.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-mitra/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-mitra/review02/render/exterior/cam03.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-mitra/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-mitra/review02/render/exterior/cam03.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-mitra/review02/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/retamar-mitra/review02/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/retamar-mitra/review02/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 16',
                  src: 'https://media.bizionar.digital/culmia/retamar-mitra/review02/render/exterior/cam16.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/retamar-mitra/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-mitra/review03/render/exterior/cam03.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/retamar-mitra/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/retamar-mitra/review03/render/exterior/cam03.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/culmia/retamar-mitra/review03/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/retamar-mitra/review03/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/culmia/retamar-mitra/review03/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 16',
                  src: 'https://media.bizionar.digital/culmia/retamar-mitra/review03/render/exterior/cam16.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '24 de agosto de 2026',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/culmia/retamar-mitra/download/exterior/render_exterior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/culmia/retamar-mitra/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/culmia/retamar-mitra/live/exterior/cam03.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/culmia/retamar-mitra/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/culmia/retamar-mitra/live/exterior/cam03.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/culmia/retamar-mitra/live/exterior/cam03.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 08',
                src: 'https://media.bizionar.digital/culmia/retamar-mitra/live/exterior/cam08.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 11',
                src: 'https://media.bizionar.digital/culmia/retamar-mitra/live/exterior/cam11.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 16',
                src: 'https://media.bizionar.digital/culmia/retamar-mitra/live/exterior/cam16.jpg',
                type: 'render',
                category: 'exteriores',
              },
            ],
          },
        },
        {
          id: 'rubi-futur',
          name: 'Rubí Futur',
          city: 'Rubí',
          province: 'Barcelona',
          liveEnabled: false,
          showEnabled: false,
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/rubi-futur',
          image: 'https://media.bizionar.digital/culmia/rubi-futur/review04/render/exterior/cam01.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '10 de junio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '13 de julio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '3 de agosto de 2026',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '3 de noviembre de 2026',
                  status: 'pending',
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '28 de julio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '23 de septiembre de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '3 de noviembre de 2026',
                  status: 'pending',
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/rubi-futur/review01/render/exterior/cam01.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/rubi-futur/review01/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review01/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/rubi-futur/review01/render/interior/render_SALON01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review01/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review01/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review01/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review01/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review01/render/interior/render_SALON01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review01/render/interior/render_SALON02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review01/render/interior/render_SALON03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review01/render/interior/render_SALON04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review01/render/interior/render_SALON05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review01/render/interior/render_SALON06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review01/render/interior/render_SALON07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review01/render/interior/render_REBEDOR.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review01/render/interior/render_COCINA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review01/render/interior/render_COCINA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review01/render/interior/render_COCINA03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review01/render/interior/render_TERRAZA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review01/render/interior/render_BANO_COMUN01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review01/render/interior/render_BANO_COMUN02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review01/render/interior/render_HAB01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review01/render/interior/render_HAB02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review01/render/interior/render_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review01/render/interior/render_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review01/render/interior/render_BANO_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review01/render/interior/render_BANO_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/rubi-futur/review02/render/exterior/cam01.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/rubi-futur/review02/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review02/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/rubi-futur/review02/render/interior/render_SALON01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review02/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review02/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review02/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review02/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review02/render/interior/render_SALON01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review02/render/interior/render_SALON02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review02/render/interior/render_SALON03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review02/render/interior/render_SALON04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review02/render/interior/render_SALON05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review02/render/interior/render_SALON06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review02/render/interior/render_SALON07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review02/render/interior/render_REBEDOR.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review02/render/interior/render_COCINA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review02/render/interior/render_COCINA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review02/render/interior/render_COCINA03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review02/render/interior/render_TERRAZA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review02/render/interior/render_BANO_COMUN01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review02/render/interior/render_BANO_COMUN02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review02/render/interior/render_HAB01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review02/render/interior/render_HAB02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review02/render/interior/render_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review02/render/interior/render_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review02/render/interior/render_BANO_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review02/render/interior/render_BANO_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/rubi-futur/review03/render/exterior/cam08.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/rubi-futur/review03/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review03/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/rubi-futur/review03/render/interior/render_SALON01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review03/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01 - IA',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review03/render/exterior/cam01_ia.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review03/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04 - IA',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review03/render/exterior/cam04_ia.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review03/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05 - IA',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review03/render/exterior/cam05_ia.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review03/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08 - IA',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review03/render/exterior/cam08_ia.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review03/render/interior/render_SALON01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review03/render/interior/render_SALON02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review03/render/interior/render_SALON03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review03/render/interior/render_SALON04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review03/render/interior/render_SALON05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review03/render/interior/render_SALON06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review03/render/interior/render_SALON07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review03/render/interior/render_REBEDOR.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review03/render/interior/render_COCINA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review03/render/interior/render_COCINA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review03/render/interior/render_COCINA03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review03/render/interior/render_TERRAZA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review03/render/interior/render_BANO_COMUN01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review03/render/interior/render_BANO_COMUN02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review03/render/interior/render_HAB01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review03/render/interior/render_HAB02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review03/render/interior/render_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review03/render/interior/render_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review03/render/interior/render_BANO_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review03/render/interior/render_BANO_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review04/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/rubi-futur/review04/render/exterior/cam08.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/rubi-futur/review04/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review04/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01 - IA',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review04/render/exterior/cam01_ia.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review04/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04 - IA',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review04/render/exterior/cam04_ia.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review04/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05 - IA',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review04/render/exterior/cam05_ia.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review04/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08 - IA',
                  src: 'https://media.bizionar.digital/culmia/rubi-futur/review04/render/exterior/cam08_ia.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
          ],
        },
        {
          id: 'valdecarros',
          name: 'Valdecarros',
          city: 'Madrid',
          province: 'Madrid',
          liveEnabled: false,
          showEnabled: false,
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/culmia/valdecarros',
          image: 'https://media.bizionar.digital/culmia/valdecarros/review01/render/exterior/cam01.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 0,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '13 de octubre de 2026',
                  status: 'pending',
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/culmia/valdecarros/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/valdecarros/review01/render/exterior/cam05.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/culmia/valdecarros/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/culmia/valdecarros/review01/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/culmia/valdecarros/review01/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/culmia/valdecarros/review01/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/culmia/valdecarros/review01/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/culmia/valdecarros/review01/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 16',
                  src: 'https://media.bizionar.digital/culmia/valdecarros/review01/render/exterior/cam16.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 22',
                  src: 'https://media.bizionar.digital/culmia/valdecarros/review01/render/exterior/cam22.jpg',
                  type: 'render',
                  category: 'exteriores',
                },

              ],
            },
          ],
        },
      ],
    },
    {
      id: 'hi-real-estate',
      name: 'hi! Real Estate',
      url: '/client/hi-real-estate',
      image: '/home/hi-real-estate-logo.jpg',
      provinces: [
        'Madrid',
      ],
      promotions: [
        {
          id: 'torrejon-aldovea',
          name: 'Torrejón - Aldovea',
          city: 'Torrejón de Ardoz',
          province: 'Madrid',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://hirealestate-show.bizionar.digital/torrejon-aldovea',
          reviewStatus: {
            current: 2,
            total: 3,
            status: 'approved',
          },
          url: '/client/hi-real-estate/torrejon-aldovea',
          image: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/exterior/render_exterior_05.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '28 de mayo de 2021',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '8 de junio de 2021',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '23 de junio de 2021',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '30 de agosto de 2021',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'PISO PILOTO',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '11 de junio de 2021',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '9 de julio de 2021',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '30 de agosto de 2021',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/exterior/render_exterior_05_night.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/exterior/render_exterior_02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/exterior/render_exterior_02.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/exterior/render_exterior_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05 - Night',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/exterior/render_exterior_05_night.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/exterior/render_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/exterior/render_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/exterior/render_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/exterior/render_exterior_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/exterior/render_exterior_06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/exterior/render_exterior_07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/exterior/render_exterior_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/exterior/render_exterior_09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/exterior/render_exterior_11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/exterior/render_exterior_13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 17',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/exterior/render_exterior_17.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/exterior/render_exterior_14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 18',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/exterior/render_exterior_18.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 19',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/exterior/render_exterior_19.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/exterior/render_exterior_15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/interior/render_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/interior/render_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/interior/render_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/interior/render_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/interior/render_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/interior/render_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/interior/render_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 08',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/interior/render_salon_08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/interior/render_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/interior/render_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/interior/render_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/interior/render_cocina_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Infantil 01',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/interior/render_infantil_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Infantil 02',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/interior/render_infantil_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Juvenil 01',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/interior/render_juvenil_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Juvenil 02',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/interior/render_juvenil_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/interior/render_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/interior/render_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/interior/render_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/interior/render_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 04',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/interior/render_suite_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/interior/render_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/interior/render_bano_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/interior/render_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review01/render/interior/render_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/exterior/render_exterior_05_night.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/exterior/render_exterior_02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/exterior/render_exterior_02.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/exterior/render_exterior_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05 - Night',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/exterior/render_exterior_05_night.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/exterior/render_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/exterior/render_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/exterior/render_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/exterior/render_exterior_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/exterior/render_exterior_06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/exterior/render_exterior_07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/exterior/render_exterior_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/exterior/render_exterior_09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/exterior/render_exterior_11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/exterior/render_exterior_13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 17',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/exterior/render_exterior_17.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/exterior/render_exterior_14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 18',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/exterior/render_exterior_18.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 19',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/exterior/render_exterior_19.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/exterior/render_exterior_15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Video Day Night',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/video/exterior/video_static_day_night.mp4',
                  thumb: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/exterior/render_exterior_05_night.jpg',
                  type: 'video',
                  category: 'exteriores',
                },
                {
                  name: 'Video Static Sky',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/video/exterior/video_static_sky.mp4',
                  thumb: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/video/exterior/video_static_sky_thumb.jpg',
                  type: 'video',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior Teaser',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/video/exterior/video_teaser.mp4',
                  thumb: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/video/exterior/video_teaser_thumb.jpg',
                  type: 'video',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior Completo',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/video/exterior/video_exterior.mp4',
                  thumb: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/video/exterior/video_exterior_thumb.jpg',
                  type: 'video',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/interior/render_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/interior/render_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/interior/render_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/interior/render_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/interior/render_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/interior/render_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/interior/render_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 08',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/interior/render_salon_08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/interior/render_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/interior/render_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/interior/render_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/interior/render_cocina_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Infantil 01',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/interior/render_infantil_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Infantil 02',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/interior/render_infantil_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Juvenil 01',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/interior/render_juvenil_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Juvenil 02',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/interior/render_juvenil_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/interior/render_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/interior/render_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/interior/render_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/interior/render_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 04',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/interior/render_suite_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/interior/render_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/interior/render_bano_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/interior/render_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/render/interior/render_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Video Interior',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/video/interior/video_interior.mp4',
                  thumb: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review02/video/interior/video_interior_thumb.jpg',
                  type: 'video',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/exterior/render_exterior_05_night.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review04/render/exterior/render_exterior_02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/exterior/render_exterior_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05 - Night',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/exterior/render_exterior_05_night.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/exterior/render_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/exterior/render_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/exterior/render_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/exterior/render_exterior_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/exterior/render_exterior_06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/exterior/render_exterior_07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/exterior/render_exterior_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/exterior/render_exterior_09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/exterior/render_exterior_11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/exterior/render_exterior_13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 17',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/exterior/render_exterior_17.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/exterior/render_exterior_14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 18',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/exterior/render_exterior_18.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 19',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/exterior/render_exterior_19.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/exterior/render_exterior_15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Video Day Night',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/video/video_static_day_night.mp4',
                  thumb: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/exterior/render_exterior_05_night.jpg',
                  type: 'video',
                  category: 'exteriores',
                },
                {
                  name: 'Video Static Sky',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/video/video_static_sky.mp4',
                  thumb: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/video/video_static_sky_thumb.jpg',
                  type: 'video',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior Teaser',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/video/video_teaser.mp4',
                  thumb: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/video/video_teaser_thumb.jpg',
                  type: 'video',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior Completo',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/video/video_exterior.mp4',
                  thumb: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/video/video_exterior_thumb.jpg',
                  type: 'video',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/interior/render_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/interior/render_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/interior/render_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/interior/render_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/interior/render_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/interior/render_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/interior/render_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 08',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/interior/render_salon_08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/interior/render_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/interior/render_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/interior/render_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/interior/render_cocina_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Infantil 01',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/interior/render_infantil_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Infantil 02',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/interior/render_infantil_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Juvenil 01',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/interior/render_juvenil_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Juvenil 02',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/interior/render_juvenil_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/interior/render_bano_comun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/interior/render_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/interior/render_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/interior/render_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 04',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/interior/render_suite_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/interior/render_bano_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/interior/render_bano_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/interior/render_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/render/interior/render_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Video Interior',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/video/video_interior.mp4',
                  thumb: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review03/video/video_interior_thumb.jpg',
                  type: 'video',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review04/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review04/render/exterior/render_exterior_05_night.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review04/render/exterior/render_exterior_02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review04/render/exterior/render_exterior_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05 - Night',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review04/render/exterior/render_exterior_05_night.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review04/render/exterior/render_exterior_01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review04/render/exterior/render_exterior_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review04/render/exterior/render_exterior_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review04/render/exterior/render_exterior_04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review04/render/exterior/render_exterior_06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review04/render/exterior/render_exterior_07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review04/render/exterior/render_exterior_08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review04/render/exterior/render_exterior_09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review04/render/exterior/render_exterior_11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review04/render/exterior/render_exterior_13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 17',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review04/render/exterior/render_exterior_17.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review04/render/exterior/render_exterior_14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 18',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review04/render/exterior/render_exterior_18.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 19',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review04/render/exterior/render_exterior_19.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review04/render/exterior/render_exterior_15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Video Day Night',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review04/video/video_static_day_night.mp4',
                  thumb: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review04/render/exterior/render_exterior_05_night.jpg',
                  type: 'video',
                  category: 'exteriores',
                },
                {
                  name: 'Video Static Sky',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review04/video/video_static_sky.mp4',
                  thumb: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review04/video/video_static_sky_thumb.jpg',
                  type: 'video',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior Teaser',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review04/video/video_teaser.mp4',
                  thumb: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review04/video/video_teaser_thumb.jpg',
                  type: 'video',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior Completo',
                  src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review04/video/video_exterior.mp4',
                  thumb: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/review04/video/video_exterior_thumb.jpg',
                  type: 'video',
                  category: 'exteriores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'PISO PILOTO',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '30 de agosto de 2021',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/download/render_exterior_md.zip',
                videoBundleUrl: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/download/video_exterior_md.zip',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/download/render_interior_md.zip',
                videoBundleUrl: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/download/video_interior_md.zip',
              },
            ],
            content: [
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_exterior_05_night.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_exterior_02.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_exterior_02.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 05',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_exterior_05.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 05 - Night',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_exterior_05_night.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_exterior_01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_exterior_02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_exterior_03.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 04',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_exterior_04.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 06',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_exterior_06.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 07',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_exterior_07.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 08',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_exterior_08.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 09',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_exterior_09.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 11',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_exterior_11.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 13',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_exterior_13.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 17',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_exterior_17.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 14',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_exterior_14.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 18',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_exterior_18.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 19',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_exterior_19.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 15',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_exterior_15.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Video Day Night',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/video_static_day_night.mp4',
                thumb: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_exterior_05_night.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Static Sky',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/video_static_sky.mp4',
                thumb: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/video_static_sky_thumb.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Exterior Teaser',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/video_teaser.mp4',
                thumb: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/video_teaser_thumb.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Exterior Completo',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/video_exterior.mp4',
                thumb: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/video_exterior_thumb.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_salon_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_salon_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_salon_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_salon_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_salon_05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_salon_06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 07',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_salon_07.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 08',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_salon_08.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_cocina_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_cocina_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_cocina_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 04',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_cocina_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Infantil 01',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_infantil_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Infantil 02',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_infantil_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Juvenil 01',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_juvenil_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Juvenil 02',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_juvenil_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_bano_comun_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_suite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 03',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_suite_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 04',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_suite_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_bano_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 02',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_bano_suite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_terraza_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 02',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/render_terraza_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Video Interior',
                src: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/video_interior.mp4',
                thumb: 'https://media.bizionar.digital/hi-real-estate/torrejon-aldovea/live/video_interior_thumb.jpg',
                type: 'video',
                category: 'interiores',
              },
            ],
          },
        },
      ],
    },
    {
      id: 'metrovacesa',
      name: 'metrovacesa',
      url: '/client/metrovacesa',
      image: '/home/metrovacesa-logo.jpg',
      provinces: [
        'Barcelona',
        'Lleida',
      ],
      promotions: [
        {
          id: 'gasometro',
          name: 'Gasometro',
          city: 'Terrassa',
          province: 'Barcelona',
          liveEnabled: true,
          showEnabled: false,
          digitalShowUrl: 'https://metrovacesa-show.bizionar.digital/gasometro',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/metrovacesa/gasometro',
          image: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/render/exterior/cam09.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '27 de diciembre de 2022',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '16 de enero de 2023',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '23 de enero de 2023',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'PISO PILOTO 1',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '21 de diciembre de 2022',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '13 de enero de 2023',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '23 de enero de 2023',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores-piso2',
              categoryName: 'PISO PILOTO 2',
              closedReviews: 1,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '26 de enero de 2023',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/exterior/cam09.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/exterior/cam09.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review07/tour/index.html',
                  thumb: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/render/exterior/cam09.jpg',
                  type: 'panoramic',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/exterior/cam15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 16',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/exterior/cam16.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior/render_07_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior/render_11_terraza.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior/render_12_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior/render_13_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior/render_14_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior/render_15_hab03_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior/render_16_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior/render_17_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior/render_18_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior/render_19_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior-piso2/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior-piso2/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior-piso2/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior-piso2/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior-piso2/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior-piso2/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior-piso2/render_07_salon_07.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior-piso2/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior-piso2/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior-piso2/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior-piso2/render_11_terraza.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior-piso2/render_12_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Habitación 1',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior-piso2/render_13_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Habitación 2',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior-piso2/render_14_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior-piso2/render_16_suite_01.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior-piso2/render_17_suite_02.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior-piso2/render_18_suite_03.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review01/render/interior-piso2/render_19_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores-piso2',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/metrovacesa/gasometro/review02/render/exterior/cam09.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/metrovacesa/gasometro/review02/render/exterior/cam09.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review02/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review02/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review02/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review02/render/exterior/cam15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 16',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review02/render/exterior/cam16.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 16 - zoom',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review02/render/exterior/cam16_zoom.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review02/render/interior/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review02/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review02/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review02/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review02/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review02/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review02/render/interior/render_07_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review02/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review02/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review02/render/interior/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review02/render/interior/render_11_terraza.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review02/render/interior/render_12_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review02/render/interior/render_13_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review02/render/interior/render_14_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review02/render/interior/render_15_hab03_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review02/render/interior/render_16_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review02/render/interior/render_17_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review02/render/interior/render_18_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review02/render/interior/render_19_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review05/tour/index.html',
                  thumb: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/render/exterior/cam09.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review05/tour/index.html',
                  thumb: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/render/exterior/cam09.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Video Completo',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/video/video_completo.mp4',
                  thumb: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/render/exterior/cam09.jpg',
                  type: 'video',
                  category: 'exteriores',
                },
                {
                  name: 'Video Completo',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/video/video_completo.mp4',
                  thumb: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/render/exterior/cam09.jpg',
                  type: 'video',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/render/exterior/cam15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 16',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/render/exterior/cam16.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 16 - zoom',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/render/exterior/cam16_zoom.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/render/interior/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/render/interior/render_07_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/render/interior/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/render/interior/render_11_terraza.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/render/interior/render_12_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/render/interior/render_13_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/render/interior/render_14_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/render/interior/render_15_hab03_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/render/interior/render_16_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/render/interior/render_17_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/render/interior/render_18_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/metrovacesa/gasometro/review03/render/interior/render_19_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'PISO PILOTO',
              filter: 'interiores',
              active: false,
            },
            {
              title: 'PISO PILOTO 2',
              filter: 'interiores-piso2',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '25 de enero de 2022',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/metrovacesa/gasometro/download/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/metrovacesa/gasometro/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores-piso2',
                renderBundleUrl: 'https://media.bizionar.digital/metrovacesa/gasometro/download/piso2/render_interior_piso2_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/metrovacesa/gasometro/live/cam09.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/metrovacesa/gasometro/live/cam09.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/metrovacesa/gasometro/live/cam09.jpg',
                type: 'panoramic',
                category: 'interiores-piso2',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/metrovacesa/gasometro/live/cam12.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/metrovacesa/gasometro/live/cam12.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/metrovacesa/gasometro/live/cam12.jpg',
                type: 'video',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Exterior 09',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/cam09.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 06',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/cam06.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 12',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/cam12.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 15',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/cam15.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 16',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/cam16.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 16 - zoom',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/cam16_zoom.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior Terraza Noche',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/terraza_night.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/render_04_salon_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/render_01_salon_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/render_02_salon_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/render_03_salon_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/render_05_salon_05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/render_06_salon_06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 07',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/render_07_salon_07.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/render_08_cocina_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/render_09_cocina_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/render_10_cocina_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/render_11_terraza.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/render_12_banocomun_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/render_13_hab01_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/render_14_hab02_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 3',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/render_15_hab03_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/render_16_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/render_17_suite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 03',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/render_18_suite_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/render_19_banosuite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/piso2/render_01_salon_01.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/piso2/render_02_salon_02.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/piso2/render_03_salon_03.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/piso2/render_04_salon_04.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/piso2/render_05_salon_05.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/piso2/render_06_salon_06.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Salón 07',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/piso2/render_07_salon_07.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/piso2/render_08_cocina_01.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/piso2/render_09_cocina_02.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/piso2/render_10_cocina_03.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/piso2/render_11_terraza.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/piso2/render_12_banocomun_01.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Habitación 1',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/piso2/render_13_hab01_01.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Habitación 2',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/piso2/render_14_hab02_01.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/piso2/render_16_suite_01.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/piso2/render_17_suite_02.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Habitación Suite 03',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/piso2/render_18_suite_03.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/metrovacesa/gasometro/live/piso2/render_19_banosuite_01.jpg',
                type: 'render',
                category: 'interiores-piso2',
              },
            ],
          },
        },
        {
          id: 'la-llotja-de-lleida',
          name: 'La Llotja de Lleida',
          city: 'Lleida',
          province: 'Lleida',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/show/index.html',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/metrovacesa/la-llotja-de-lleida',
          image: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/exterior/cam02.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '5 de diciembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '30 de diciembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '26 de enero de 2026',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '2 de febrero de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'PISO PILOTO',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '5 de diciembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '30 de diciembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '26 de enero de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/render/exterior/cam02.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/render/interior/render_SALON01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 18',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/render/exterior/cam18.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 19',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/render/exterior/cam19.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/render/interior/render_SALON01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/render/interior/render_SALON02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/render/interior/render_SALON03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/render/interior/render_SALON04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/render/interior/render_SALON05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/render/interior/render_SALON06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/render/interior/render_COCINA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/render/interior/render_COCINA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/render/interior/render_COCINA03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/render/interior/render_COCINA04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/render/interior/render_TERRAZA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/render/interior/render_TERRAZA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/render/interior/render_BANO_COMUN01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/render/interior/render_BANO_COMUN02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/render/interior/render_HAB01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/render/interior/render_HAB01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/render/interior/render_HAB02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/render/interior/render_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/render/interior/render_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/render/interior/render_BANO_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review01/render/interior/render_BANO_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/render/exterior/cam02.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/render/interior/render_SALON01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 18',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/render/exterior/cam18.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 19',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/render/exterior/cam19.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/render/interior/render_SALON01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/render/interior/render_SALON02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/render/interior/render_SALON03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/render/interior/render_SALON04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/render/interior/render_SALON05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/render/interior/render_SALON06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/render/interior/render_COCINA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/render/interior/render_COCINA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/render/interior/render_COCINA03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/render/interior/render_COCINA04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/render/interior/render_TERRAZA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/render/interior/render_TERRAZA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/render/interior/render_BANO_COMUN01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/render/interior/render_BANO_COMUN02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/render/interior/render_HAB01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/render/interior/render_HAB01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/render/interior/render_HAB02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/render/interior/render_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/render/interior/render_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/render/interior/render_BANO_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review02/render/interior/render_BANO_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/render/exterior/cam02.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/render/interior/render_SALON01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 18',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/render/exterior/cam18.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 19',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/render/exterior/cam19.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/render/interior/render_SALON01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/render/interior/render_SALON02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/render/interior/render_SALON03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/render/interior/render_SALON04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/render/interior/render_SALON05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/render/interior/render_SALON06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/render/interior/render_COCINA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/render/interior/render_COCINA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/render/interior/render_COCINA03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/render/interior/render_COCINA04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/render/interior/render_TERRAZA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/render/interior/render_TERRAZA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/render/interior/render_BANO_COMUN01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/render/interior/render_BANO_COMUN02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/render/interior/render_HAB01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/render/interior/render_HAB01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/render/interior/render_HAB02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/render/interior/render_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/render/interior/render_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/render/interior/render_BANO_SUITE01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review03/render/interior/render_BANO_SUITE02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review04/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review04/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review04/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review04/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review04/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review04/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 18',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review04/render/exterior/cam18.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 19',
                  src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/review04/render/exterior/cam19.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'PISO PILOTO',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '24 de febrero de 2026',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/download/exterior/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/download/interior/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/exterior/cam02.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/exterior/cam02.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/video/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/exterior/cam02.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/exterior/cam02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 04',
                src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/exterior/cam04.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 08',
                src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/exterior/cam08.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 10',
                src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/exterior/cam10.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 11',
                src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/exterior/cam11.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 18',
                src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/exterior/cam18.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 19',
                src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/exterior/cam19.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/interior/render_SALON01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/interior/render_SALON02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/interior/render_SALON03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/interior/render_SALON04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/interior/render_SALON05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/interior/render_SALON06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/interior/render_COCINA01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/interior/render_COCINA02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/interior/render_COCINA03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 04',
                src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/interior/render_COCINA04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/interior/render_TERRAZA01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 02',
                src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/interior/render_TERRAZA02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/interior/render_BANO_COMUN01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 02',
                src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/interior/render_BANO_COMUN02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/interior/render_HAB01_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 02',
                src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/interior/render_HAB01_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/interior/render_HAB02_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/interior/render_SUITE01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/interior/render_SUITE02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/interior/render_BANO_SUITE01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 02',
                src: 'https://media.bizionar.digital/metrovacesa/la-llotja-de-lleida/live/interior/render_BANO_SUITE02.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
            id: 'alemanya-60',
            name: 'Alemanya 60',
            city: 'Sabadell',
            province: 'Barcelona',
            liveEnabled: false,
            showEnabled: false,
            reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
            },
            url: '/client/metrovacesa/alemanya-60',
            image: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/render/exterior/cam_04.jpg',
            deliveries: [
                {
                  categoryId: 'exteriores',
                  categoryName: 'EXTERIORES',
                  closedReviews: 1,
                  totalReviews: 2,
                  reviews: [
                    {
                      id: 'review01',
                      name: 'ENTREGA 1',
                      date: '5 de marzo de 2026',
                      status: 'closed',
                    },
                    {
                      id: 'review02',
                      name: 'ENTREGA 2',
                      date: '17 de marzo de 2026',
                      status: 'pending',
                    },
                  ],
                },
                {
                  categoryId: 'interiores',
                  categoryName: 'PISO PILOTO',
                  closedReviews: 1,
                  totalReviews: 2,
                  reviews: [
                    {
                      id: 'review01',
                      name: 'ENTREGA 1',
                      date: '19 de febrero de 2026',
                      status: 'closed',
                    },
                    {
                      id: 'review02',
                      name: 'ENTREGA 2',
                      date: '17 de marzo de 2026',
                      status: 'pending',
                    },
                  ],
                },
            ],
            reviews: [
              {
                id: 'review01',
                content: [
                  {
                    name: 'Tour Multipunto Interior',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review01/tour-multipunto/index.html',
                    thumb: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review01/render/interior/still_Camera_001.jpg',
                    type: 'panoramic',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Exterior 04',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review01/render/exterior/cam_04.jpg',
                    type: 'render',
                    category: 'exteriores',
                  },
                  {
                    name: 'Render Exterior 06',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review01/render/exterior/cam_06.jpg',
                    type: 'render',
                    category: 'exteriores',
                  },
                  {
                    name: 'Render Exterior 09',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review01/render/exterior/cam_09.jpg',
                    type: 'render',
                    category: 'exteriores',
                  },
                  {
                    name: 'Render Exterior 11',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review01/render/exterior/cam_11.jpg',
                    type: 'render',
                    category: 'exteriores',
                  },
                  {
                    name: 'Render Exterior 15',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review01/render/exterior/cam_15.jpg',
                    type: 'render',
                    category: 'exteriores',
                  },
                  {
                    name: 'Render Exterior 18',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review01/render/exterior/cam_18.jpg',
                    type: 'render',
                    category: 'exteriores',
                  },
                  {
                    name: 'Render Exterior 29',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review01/render/exterior/cam_29.jpg',
                    type: 'render',
                    category: 'exteriores',
                  },
                  {
                    name: 'Render Exterior 30',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review01/render/exterior/cam_30.jpg',
                    type: 'render',
                    category: 'exteriores',
                  },
                  {
                    name: 'Render Salón 01',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review01/render/interior/still_Camera_001.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Salón 02',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review01/render/interior/still_Camera_002.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Salón 03',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review01/render/interior/still_Camera_003.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Salón 04',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review01/render/interior/still_Camera_004.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Salón 05',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review01/render/interior/still_Camera_005.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Salón 06',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review01/render/interior/still_Camera_006.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Salón 06',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review01/render/interior/still_Camera_007.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Cocina 01',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review01/render/interior/still_Camera_008.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Cocina 02',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review01/render/interior/still_Camera_009.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Terraza 01',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review01/render/interior/still_Camera_010.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Terraza 02',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review01/render/interior/still_Camera_011.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Habitación Suite 01',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review01/render/interior/still_Camera_012.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Habitación Suite 02',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review01/render/interior/still_Camera_013.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Baño Suite 01',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review01/render/interior/still_Camera_014.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Habitación 1 - 01',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review01/render/interior/still_Camera_015.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Habitación 1 - 02',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review01/render/interior/still_Camera_016.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Habitación 2 - 01',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review01/render/interior/still_Camera_017.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Habitación 2 - 02',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review01/render/interior/still_Camera_018.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Baño Común 01',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review01/render/interior/still_Camera_019.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                ],
              },
              {
                id: 'review02',
                content: [
                  {
                    name: 'Tour Virtual 360°',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/tour/index.html',
                    thumb: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/render/exterior/cam_04.jpg',
                    type: 'panoramic',
                    category: 'exteriores',
                  },
                  {
                    name: 'Orbita 3D',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/orbit/index.html',
                    thumb: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/render/exterior/cam_09.jpg',
                    type: 'orbit',
                    category: 'exteriores',
                  },
                  {
                    name: 'Tour Multipunto Interior',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/tour-multipunto/index.html',
                    thumb: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/render/interior/still_Camera_001.jpg',
                    type: 'panoramic',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Exterior 04',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/render/exterior/cam_04.jpg',
                    type: 'render',
                    category: 'exteriores',
                  },
                  {
                    name: 'Render Exterior 06',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/render/exterior/cam_06.jpg',
                    type: 'render',
                    category: 'exteriores',
                  },
                  {
                    name: 'Render Exterior 09',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/render/exterior/cam_09.jpg',
                    type: 'render',
                    category: 'exteriores',
                  },
                  {
                    name: 'Render Exterior 11',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/render/exterior/cam_11.jpg',
                    type: 'render',
                    category: 'exteriores',
                  },
                  {
                    name: 'Render Exterior 15',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/render/exterior/cam_15.jpg',
                    type: 'render',
                    category: 'exteriores',
                  },
                  {
                    name: 'Render Exterior 18',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/render/exterior/cam_18.jpg',
                    type: 'render',
                    category: 'exteriores',
                  },
                  {
                    name: 'Render Exterior 29',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/render/exterior/cam_29.jpg',
                    type: 'render',
                    category: 'exteriores',
                  },
                  {
                    name: 'Render Exterior 30',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/render/exterior/cam_30.jpg',
                    type: 'render',
                    category: 'exteriores',
                  },
                  {
                    name: 'Render Salón 01',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/render/interior/still_Camera_001.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Salón 02',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/render/interior/still_Camera_002.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Salón 03',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/render/interior/still_Camera_003.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Salón 04',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/render/interior/still_Camera_004.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Salón 05',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/render/interior/still_Camera_005.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Salón 06',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/render/interior/still_Camera_006.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Salón 06',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/render/interior/still_Camera_007.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Cocina 01',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/render/interior/still_Camera_008.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Cocina 02',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/render/interior/still_Camera_009.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Terraza 01',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/render/interior/still_Camera_010.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Terraza 02',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/render/interior/still_Camera_011.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Habitación Suite 01',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/render/interior/still_Camera_012.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Habitación Suite 02',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/render/interior/still_Camera_013.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Baño Suite 01',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/render/interior/still_Camera_014.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Habitación 1 - 01',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/render/interior/still_Camera_015.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Habitación 1 - 02',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/render/interior/still_Camera_016.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Habitación 2 - 01',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/render/interior/still_Camera_017.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Habitación 2 - 02',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/render/interior/still_Camera_018.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                  {
                    name: 'Render Baño Común 01',
                    src: 'https://media.bizionar.digital/metrovacesa/alemanya-60/review02/render/interior/still_Camera_019.jpg',
                    type: 'render',
                    category: 'interiores',
                  },
                ],
              },
            ],
            },
      ],
    },
    {
      id: 'ebrosa',
      name: 'ebrosa',
      url: '/client/ebrosa',
      image: '/home/ebrosa-logo.jpg',
      provinces: [
        'Barcelona',
        'Madrid',
        'Mallorca',
        'Zaragoza',
      ],
      promotions: [
        {
          id: 'air-box-valdebebas',
          name: 'AIR-BOX Valdebebas',
          city: 'Madrid',
          province: 'Madrid',
          liveEnabled: true,
          showEnabled: false,
          digitalShowUrl: '',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/ebrosa/air-box-valdebebas',
          image: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review01/render/exterior/render_exterior.jpg',
          deliveries: [
            {
              categoryId: 'interiores',
              categoryName: 'PISO PILOTO',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '29 de diciembre de 2022',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '9 de enero de 2023',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '10 de enero de 2023',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review01/render/exterior/render_exterior.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review01/render/interior/render_01_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review01/render/interior/render_02_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review01/render/interior/render_03_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review01/render/interior/render_04_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review01/render/interior/render_05_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review01/render/interior/render_06_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review01/render/interior/render_07_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review01/render/interior/render_08_cocina.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review01/render/interior/render_09_cocina.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review01/render/interior/render_10_cocina.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review01/render/interior/render_11_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review01/render/interior/render_12_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review01/render/interior/render_13_hab2_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review01/render/interior/render_14_hab2_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review01/render/interior/render_15_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review01/render/interior/render_16_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review01/render/interior/render_17_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review01/render/interior/render_18_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review01/render/interior/render_21_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review01/render/interior/render_19_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review01/render/interior/render_20_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review01/render/exterior/render_exterior.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review02/render/interior/render_01_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review02/render/interior/render_02_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review02/render/interior/render_03_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review02/render/interior/render_04_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review02/render/interior/render_05_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review02/render/interior/render_06_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review02/render/interior/render_07_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review02/render/interior/render_08_cocina.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review02/render/interior/render_09_cocina.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review02/render/interior/render_10_cocina.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review02/render/interior/render_11_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review02/render/interior/render_12_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review02/render/interior/render_13_hab2_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review02/render/interior/render_14_hab2_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review02/render/interior/render_15_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review02/render/interior/render_16_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review02/render/interior/render_17_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review02/render/interior/render_18_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review02/render/interior/render_21_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review02/render/interior/render_19_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review02/render/interior/render_20_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review01/render/exterior/render_exterior.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review03/render/interior/render_01_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review03/render/interior/render_02_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review03/render/interior/render_03_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review03/render/interior/render_04_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review03/render/interior/render_05_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review03/render/interior/render_06_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review03/render/interior/render_07_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review03/render/interior/render_08_cocina.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review03/render/interior/render_09_cocina.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review03/render/interior/render_10_cocina.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review03/render/interior/render_11_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review03/render/interior/render_12_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review03/render/interior/render_13_hab2_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review03/render/interior/render_14_hab2_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review03/render/interior/render_15_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review03/render/interior/render_16_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review03/render/interior/render_17_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review03/render/interior/render_18_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review03/render/interior/render_21_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review03/render/interior/render_19_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/review03/render/interior/render_20_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'PISO PILOTO',
              filter: 'interiores',
              active: true,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '16 de enero de 2023',
            categoryBundles: [
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/live/render_exterior.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/live/render_01_salon.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/live/render_02_salon.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/live/render_03_salon.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/live/render_04_salon.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/live/render_05_salon.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/live/render_06_salon.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 07',
                src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/live/render_07_salon.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/live/render_08_cocina.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/live/render_09_cocina.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/live/render_10_cocina.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/live/render_11_hab1_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 02',
                src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/live/render_12_hab1_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/live/render_13_hab2_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 02',
                src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/live/render_14_hab2_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/live/render_15_banocomun_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/live/render_16_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/live/render_17_suite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 03',
                src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/live/render_18_suite_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/live/render_21_banosuite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/live/render_19_terraza_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 02',
                src: 'https://media.bizionar.digital/ebrosa/air-box-valdebebas/live/render_20_terraza_02.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'quaddro-ensanche-de-vallecas',
          name: 'QUADDRO - Ensanche de Vallecas',
          city: 'Madrid',
          province: 'Madrid',
          liveEnabled: true,
          showEnabled: false,
          digitalShowUrl: '',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/ebrosa/quaddro-ensanche-de-vallecas',
          image: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review01/render/exterior/render_exterior.jpg',
          deliveries: [
            {
              categoryId: 'interiores',
              categoryName: 'PISO PILOTO',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '20 de enero de 2023',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '3 de febrero de 2023',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '6 de febrero de 2023',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review01/render/exterior/render_exterior.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review01/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review01/render/interior/render_07_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review01/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 08',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review01/render/interior/render_08_salon_08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review01/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review01/render/interior/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review01/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review01/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review01/render/interior/render_09_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review01/render/interior/render_10_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review01/render/interior/render_11_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review01/render/interior/render_12_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review01/render/interior/render_13_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review01/render/interior/render_14_hab2_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review01/render/interior/render_15_hab2_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review01/render/interior/render_16_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review01/render/interior/render_17_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review01/render/interior/render_19_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review01/render/interior/render_18_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review01/render/interior/render_16_banoppl_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review01/render/interior/render_20_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review01/render/exterior/render_exterior.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review02/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review02/render/interior/render_07_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review02/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 08',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review02/render/interior/render_08_salon_08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review02/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review02/render/interior/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review02/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review02/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review02/render/interior/render_09_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review02/render/interior/render_10_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review02/render/interior/render_11_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review02/render/interior/render_12_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review02/render/interior/render_13_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review02/render/interior/render_14_hab2_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review02/render/interior/render_15_hab2_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review02/render/interior/render_16_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review02/render/interior/render_17_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review02/render/interior/render_19_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review02/render/interior/render_18_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review02/render/interior/render_16_banoppl_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review02/render/interior/render_20_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review01/render/exterior/render_exterior.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review03/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review03/render/interior/render_07_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review03/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 08',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review03/render/interior/render_08_salon_08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review03/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review03/render/interior/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review03/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review03/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review03/render/interior/render_09_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review03/render/interior/render_10_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review03/render/interior/render_11_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review03/render/interior/render_12_hab1_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review03/render/interior/render_13_hab1_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review03/render/interior/render_14_hab2_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review03/render/interior/render_15_hab2_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review03/render/interior/render_16_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review03/render/interior/render_17_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review03/render/interior/render_19_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review03/render/interior/render_18_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review03/render/interior/render_16_banoppl_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/review03/render/interior/render_20_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'PISO PILOTO',
              filter: 'interiores',
              active: true,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '16 de enero de 2023',
            categoryBundles: [
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/live/render_exterior.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/live/render_06_salon_06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 07',
                src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/live/render_07_salon_07.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/live/render_05_salon_05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 08',
                src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/live/render_08_salon_08.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/live/render_03_salon_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/live/render_04_salon_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/live/render_01_salon_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/live/render_02_salon_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/live/render_09_cocina_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/live/render_10_cocina_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/live/render_11_cocina_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/live/render_12_hab1_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 02',
                src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/live/render_13_hab1_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/live/render_14_hab2_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 02',
                src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/live/render_15_hab2_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/live/render_16_banocomun_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/live/render_17_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 03',
                src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/live/render_19_suite_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/live/render_18_suite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/live/render_16_banoppl_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/ebrosa/quaddro-ensanche-de-vallecas/live/render_20_terraza_01.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'bic-sabadell',
          name: 'BiC - Sabadell',
          city: 'Sabadell',
          province: 'Barcelona',
          liveEnabled: true,
          showEnabled: false,
          digitalShowUrl: '',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/ebrosa/bic-sabadell',
          image: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/exterior/cam05.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '17 de marzo de 2023',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '29 de marzo de 2023',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '5 de abril de 2023',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'PISO PILOTO',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '21 de marzo de 2023',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '29 de marzo de 2023',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '5 de abril de 2023',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/render/exterior/cam07.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/render/exterior/cam07.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/render/interior/render_07_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/render/interior/render_10_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/render/interior/render_11_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/render/interior/render_12_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/render/interior/render_13_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/render/interior/render_14_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/render/interior/render_15_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/render/interior/render_16_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/render/interior/render_17_banosuite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/render/interior/render_18_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/render/interior/render_19_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review01/render/interior/render_20_terraza_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/exterior/cam07.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/exterior/cam07.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/exterior/cam04_night.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07 - Night',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/exterior/cam07_night.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/interior/render_07_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/interior/render_10_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/interior/render_11_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/interior/render_12_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/interior/render_13_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/interior/render_14_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/interior/render_15_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/interior/render_16_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/interior/render_17_banosuite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/interior/render_18_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/interior/render_19_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review02/render/interior/render_20_terraza_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/exterior/cam07.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/exterior/cam07.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04 - Night',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/exterior/cam04_night.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07 - Night',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/exterior/cam07_night.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/interior/render_07_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/interior/render_10_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/interior/render_11_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/interior/render_12_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/interior/render_13_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/interior/render_14_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/interior/render_15_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/interior/render_16_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/interior/render_17_banosuite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/interior/render_18_terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/interior/render_19_terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/review03/render/interior/render_20_terraza_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'PISO PILOTO',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '14 de abril de 2023',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/ebrosa/bic-sabadell/download/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/ebrosa/bic-sabadell/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/cam07.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/cam07.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 05',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/cam05.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/cam02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/cam03.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 04',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/cam04.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 04 - Night',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/cam04_night.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/cam01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 06',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/cam06.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 07',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/cam07.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 07 - Night',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/cam07_night.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 08',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/cam08.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 09',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/cam09.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 10',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/cam10.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/render_01_salon_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/render_02_salon_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/render_03_salon_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/render_05_salon_05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/render_06_salon_06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 07',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/render_07_salon_07.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/render_08_cocina_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/render_09_cocina_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/render_10_hab01_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/render_11_hab02_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/render_12_banocomun_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/render_13_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/render_14_suite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 03',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/render_15_suite_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/render_16_banosuite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 02',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/render_17_banosuite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/render_18_terraza_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 02',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/render_19_terraza_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 03',
                src: 'https://media.bizionar.digital/ebrosa/bic-sabadell/live/render_20_terraza_03.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'vntto-parque-venecia',
          name: 'vNtto - Parque Venecia',
          city: 'Zaragoza',
          province: 'Zaragoza',
          liveEnabled: true,
          showEnabled: false,
          digitalShowUrl: '',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/ebrosa/vntto-parque-venecia',
          image: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/live/render_exterior.jpg',
          deliveries: [
            {
              categoryId: 'interiores',
              categoryName: 'PISO PILOTO',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '5 de mayo de 2023',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '9 de junio de 2023',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '19 de junio de 2023',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review01/render/exterior/render_exterior.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review01/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review01/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review01/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review01/render/interior/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review01/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review01/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review01/render/interior/render_07_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review01/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review01/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review01/render/interior/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review01/render/interior/render_11_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review01/render/interior/render_12_hab01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review01/render/interior/render_13_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review01/render/interior/render_14_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review01/render/interior/render_15_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review01/render/interior/render_16_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review01/render/interior/render_17_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review01/render/interior/render_18_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review01/render/interior/render_19_terraza01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review01/render/interior/render_20_terraza01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review01/render/interior/render_21_terraza02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review01/render/exterior/render_exterior.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review02/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review02/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review02/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review02/render/interior/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review02/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review02/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review02/render/interior/render_07_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review02/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review02/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review02/render/interior/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review02/render/interior/render_11_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review02/render/interior/render_12_hab01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review02/render/interior/render_13_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review02/render/interior/render_14_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review02/render/interior/render_15_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review02/render/interior/render_16_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review02/render/interior/render_17_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review02/render/interior/render_18_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review02/render/interior/render_19_terraza01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review02/render/interior/render_20_terraza01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review02/render/interior/render_21_terraza02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review01/render/exterior/render_exterior.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review03/render/interior/render_01_salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review03/render/interior/render_02_salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review03/render/interior/render_03_salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review03/render/interior/render_04_salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review03/render/interior/render_05_salon_05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review03/render/interior/render_06_salon_06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 07',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review03/render/interior/render_07_salon_07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review03/render/interior/render_08_cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review03/render/interior/render_09_cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review03/render/interior/render_10_cocina_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review03/render/interior/render_11_hab01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review03/render/interior/render_12_hab01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review03/render/interior/render_13_hab02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review03/render/interior/render_14_banocomun_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review03/render/interior/render_15_suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review03/render/interior/render_16_suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review03/render/interior/render_17_suite_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review03/render/interior/render_18_banosuite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review03/render/interior/render_19_terraza01_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review03/render/interior/render_20_terraza01_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/review03/render/interior/render_21_terraza02_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'PISO PILOTO',
              filter: 'interiores',
              active: true,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '23 de junio de 2023',
            categoryBundles: [
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/live/render_exterior.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/live/render_01_salon_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/live/render_02_salon_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/live/render_03_salon_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/live/render_04_salon_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/live/render_05_salon_05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/live/render_06_salon_06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 07',
                src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/live/render_07_salon_07.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/live/render_08_cocina_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/live/render_09_cocina_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/live/render_10_cocina_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/live/render_11_hab01_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 02',
                src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/live/render_12_hab01_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/live/render_13_hab02_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/live/render_14_banocomun_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/live/render_15_suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/live/render_16_suite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 03',
                src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/live/render_17_suite_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/live/render_18_banosuite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/live/render_19_terraza01_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 02',
                src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/live/render_20_terraza01_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 03',
                src: 'https://media.bizionar.digital/ebrosa/vntto-parque-venecia/live/render_21_terraza02_01.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'esplugues',
          name: 'Esplugues',
          city: 'Esplugues de Llobregat',
          province: 'Barcelona',
          liveEnabled: true,
          showEnabled: false,
          digitalShowUrl: '',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/ebrosa/esplugues',
          image: 'https://media.bizionar.digital/ebrosa/esplugues/review05/render/exterior/cam02.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 4,
              totalReviews: 4,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '16 de mayo de 2024',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '5 de septiembre de 2024',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '13 de septiembre de 2024',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '24 de abril de 2025',
                  status: 'closed',
                },
                {
                  id: 'review05',
                  name: 'ENTREGA 5',
                  date: '14 de mayo de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'PISO PILOTO',
              closedReviews: 4,
              totalReviews: 4,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '13 de mayo de 2024',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '5 de septiembre de 2024',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '13 de septiembre de 2024',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '24 de abril de 2025',
                  status: 'closed',
                },
                {
                  id: 'review05',
                  name: 'ENTREGA 5',
                  date: '20 de mayo de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/esplugues/review01/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/esplugues/review01/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review01/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review01/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review01/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review01/render/interior/cam01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review01/render/interior/cam02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review01/render/interior/cam03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review01/render/interior/cam04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review01/render/interior/cam05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review01/render/interior/cam06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review01/render/interior/cam07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review01/render/interior/cam08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review01/render/interior/cam09.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review01/render/interior/cam10.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review01/render/interior/cam11.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review01/render/interior/cam12.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review01/render/interior/cam13.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review01/render/interior/cam14.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review01/render/interior/cam15.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review01/render/interior/cam16.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review01/render/interior/cam17.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 03',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review01/render/interior/cam18.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review01/render/interior/cam19.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review01/render/interior/cam20.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/esplugues/review02/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/esplugues/review02/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review02/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review02/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review02/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review02/render/interior/cam01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review02/render/interior/cam02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review02/render/interior/cam03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review02/render/interior/cam04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review02/render/interior/cam05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review02/render/interior/cam06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review02/render/interior/cam07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review02/render/interior/cam08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review02/render/interior/cam09.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review02/render/interior/cam10.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review02/render/interior/cam11.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review02/render/interior/cam12.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review02/render/interior/cam13.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review02/render/interior/cam14.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review02/render/interior/cam15.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review02/render/interior/cam16.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review02/render/interior/cam17.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 03',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review02/render/interior/cam18.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review02/render/interior/cam19.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review02/render/interior/cam20.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/esplugues/review03/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/esplugues/review03/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review03/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review03/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review03/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review03/render/interior/cam01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review03/render/interior/cam02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review03/render/interior/cam03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review03/render/interior/cam04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review03/render/interior/cam05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review03/render/interior/cam06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review03/render/interior/cam07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review03/render/interior/cam08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review03/render/interior/cam09.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review03/render/interior/cam10.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review03/render/interior/cam11.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review03/render/interior/cam12.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review03/render/interior/cam13.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review03/render/interior/cam14.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review03/render/interior/cam15.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review03/render/interior/cam16.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review03/render/interior/cam17.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 03',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review03/render/interior/cam18.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review03/render/interior/cam19.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review03/render/interior/cam20.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/esplugues/review04/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/esplugues/review04/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review04/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review04/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review04/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review04/render/interior/cam01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review04/render/interior/cam02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review04/render/interior/cam03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review04/render/interior/cam04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review04/render/interior/cam05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review04/render/interior/cam06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review04/render/interior/cam07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review04/render/interior/cam08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review04/render/interior/cam09.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review04/render/interior/cam10.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review04/render/interior/cam11.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review04/render/interior/cam12.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review04/render/interior/cam13.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review04/render/interior/cam14.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review04/render/interior/cam15.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review04/render/interior/cam16.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review04/render/interior/cam17.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 03',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review04/render/interior/cam18.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review04/render/interior/cam19.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review04/render/interior/cam20.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review05',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review05/tour/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/esplugues/review05/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review05/tour/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/esplugues/review05/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review05/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review05/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review05/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review05/render/interior/cam01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review05/render/interior/cam02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review05/render/interior/cam03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review05/render/interior/cam04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review05/render/interior/cam05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review05/render/interior/cam06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review05/render/interior/cam07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review05/render/interior/cam08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review05/render/interior/cam09.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review05/render/interior/cam10.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review05/render/interior/cam11.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review05/render/interior/cam12.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review05/render/interior/cam13.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review05/render/interior/cam14.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review05/render/interior/cam15.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review05/render/interior/cam16.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review05/render/interior/cam17.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 03',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review05/render/interior/cam18.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review05/render/interior/cam19.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/ebrosa/esplugues/review05/render/interior/cam20.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '23 de septiembre de 2024',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/ebrosa/esplugues/download/exterior/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/ebrosa/esplugues/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/ebrosa/esplugues/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/ebrosa/esplugues/live/exterior/cam01.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/ebrosa/esplugues/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/ebrosa/esplugues/live/exterior/cam01.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/ebrosa/esplugues/live/exterior/cam01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/ebrosa/esplugues/live/exterior/cam02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 04',
                src: 'https://media.bizionar.digital/ebrosa/esplugues/live/exterior/cam04.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/ebrosa/esplugues/live/cam01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/ebrosa/esplugues/live/cam02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/ebrosa/esplugues/live/cam03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/ebrosa/esplugues/live/cam04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/ebrosa/esplugues/live/cam05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/ebrosa/esplugues/live/cam06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 02',
                src: 'https://media.bizionar.digital/ebrosa/esplugues/live/cam07.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/ebrosa/esplugues/live/cam08.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/ebrosa/esplugues/live/cam09.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/ebrosa/esplugues/live/cam10.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 04',
                src: 'https://media.bizionar.digital/ebrosa/esplugues/live/cam11.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/ebrosa/esplugues/live/cam12.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/ebrosa/esplugues/live/cam13.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 03',
                src: 'https://media.bizionar.digital/ebrosa/esplugues/live/cam14.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/ebrosa/esplugues/live/cam15.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 02',
                src: 'https://media.bizionar.digital/ebrosa/esplugues/live/cam16.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 02',
                src: 'https://media.bizionar.digital/ebrosa/esplugues/live/cam17.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 03',
                src: 'https://media.bizionar.digital/ebrosa/esplugues/live/cam18.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/ebrosa/esplugues/live/cam19.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 02',
                src: 'https://media.bizionar.digital/ebrosa/esplugues/live/cam20.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 't-vrex',
          name: 'T-VRÈX',
          city: 'Zaragoza',
          province: 'Zaragoza',
          liveEnabled: true,
          showEnabled: false,
          digitalShowUrl: '',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/ebrosa/t-vrex',
          image: 'https://media.bizionar.digital/ebrosa/t-vrex/live/render_still_001_salon.jpg',
          deliveries: [
            {
              categoryId: 'interiores',
              categoryName: 'PISO PILOTO',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '2 de julio de 2024',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '8 de julio de 2024',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '10 de julio de 2024',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '12 de julio de 2024',
                  status: 'closed',
                  isFinal: true,
                  isLive: true
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/t-vrex/review01/render/interior/render_still_001_salon.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review01/render/interior/render_still_001_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review01/render/interior/render_still_002_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review01/render/interior/render_still_003_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review01/render/interior/render_still_004_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review01/render/interior/render_still_006_cocina.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review01/render/interior/render_still_007_cocina.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review01/render/interior/render_still_008_cocina.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review01/render/interior/render_still_009_cocina.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review01/render/interior/render_still_015_hab02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review01/render/interior/render_still_016_hab02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review01/render/interior/render_still_017_hab03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review01/render/interior/render_still_018_hab03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review01/render/interior/render_still_019_serv_comun.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review01/render/interior/render_still_020_serv_comun.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review01/render/interior/render_still_010_suite.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review01/render/interior/render_still_011_suite.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review01/render/interior/render_still_012_suite.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review01/render/interior/render_still_013_serv_ppl.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review01/render/interior/render_still_014_serv_ppl.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review01/render/interior/render_still_005_terraza.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/t-vrex/review02/render/interior/render_still_001_salon.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review02/render/interior/render_still_001_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review02/render/interior/render_still_002_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review02/render/interior/render_still_003_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review02/render/interior/render_still_004_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review02/render/interior/render_still_006_cocina.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review02/render/interior/render_still_007_cocina.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review02/render/interior/render_still_008_cocina.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review02/render/interior/render_still_009_cocina.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review02/render/interior/render_still_015_hab02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review02/render/interior/render_still_016_hab02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review02/render/interior/render_still_017_hab03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review02/render/interior/render_still_018_hab03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review02/render/interior/render_still_019_serv_comun.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review02/render/interior/render_still_020_serv_comun.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review02/render/interior/render_still_010_suite.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review02/render/interior/render_still_011_suite.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review02/render/interior/render_still_012_suite.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review02/render/interior/render_still_013_serv_ppl.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review02/render/interior/render_still_014_serv_ppl.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review02/render/interior/render_still_005_terraza.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/t-vrex/review03/render/interior/render_still_001_salon.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review03/render/interior/render_still_001_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review03/render/interior/render_still_002_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review03/render/interior/render_still_003_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review03/render/interior/render_still_004_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review03/render/interior/render_still_006_cocina.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review03/render/interior/render_still_007_cocina.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review03/render/interior/render_still_008_cocina.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review03/render/interior/render_still_009_cocina.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review03/render/interior/render_still_015_hab02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review03/render/interior/render_still_016_hab02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review03/render/interior/render_still_017_hab03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review03/render/interior/render_still_018_hab03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review03/render/interior/render_still_019_serv_comun.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review03/render/interior/render_still_020_serv_comun.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review03/render/interior/render_still_010_suite.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review03/render/interior/render_still_011_suite.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review03/render/interior/render_still_012_suite.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review03/render/interior/render_still_013_serv_ppl.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review03/render/interior/render_still_014_serv_ppl.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review03/render/interior/render_still_005_terraza.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/t-vrex/review04/render/interior/render_still_001_salon.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review04/render/interior/render_still_001_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review04/render/interior/render_still_002_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review04/render/interior/render_still_003_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review04/render/interior/render_still_004_salon.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review04/render/interior/render_still_006_cocina.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review04/render/interior/render_still_007_cocina.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review04/render/interior/render_still_008_cocina.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review04/render/interior/render_still_009_cocina.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review04/render/interior/render_still_015_hab02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review04/render/interior/render_still_016_hab02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review04/render/interior/render_still_017_hab03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review04/render/interior/render_still_018_hab03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review04/render/interior/render_still_019_serv_comun.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review04/render/interior/render_still_020_serv_comun.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review04/render/interior/render_still_010_suite.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review04/render/interior/render_still_011_suite.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review04/render/interior/render_still_012_suite.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review04/render/interior/render_still_013_serv_ppl.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review04/render/interior/render_still_014_serv_ppl.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/ebrosa/t-vrex/review04/render/interior/render_still_005_terraza.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: true,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '8 de julio de 2024',
            categoryBundles: [
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/ebrosa/t-vrex/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/ebrosa/t-vrex/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/ebrosa/t-vrex/live/render_still_001_salon.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/ebrosa/t-vrex/live/render_still_001_salon.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/ebrosa/t-vrex/live/render_still_002_salon.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/ebrosa/t-vrex/live/render_still_003_salon.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/ebrosa/t-vrex/live/render_still_004_salon.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/ebrosa/t-vrex/live/render_still_006_cocina.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/ebrosa/t-vrex/live/render_still_007_cocina.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/ebrosa/t-vrex/live/render_still_008_cocina.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 04',
                src: 'https://media.bizionar.digital/ebrosa/t-vrex/live/render_still_009_cocina.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/ebrosa/t-vrex/live/render_still_015_hab02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 02',
                src: 'https://media.bizionar.digital/ebrosa/t-vrex/live/render_still_016_hab02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 3 - 01',
                src: 'https://media.bizionar.digital/ebrosa/t-vrex/live/render_still_017_hab03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 3 - 02',
                src: 'https://media.bizionar.digital/ebrosa/t-vrex/live/render_still_018_hab03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/ebrosa/t-vrex/live/render_still_019_serv_comun.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 02',
                src: 'https://media.bizionar.digital/ebrosa/t-vrex/live/render_still_020_serv_comun.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/ebrosa/t-vrex/live/render_still_010_suite.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/ebrosa/t-vrex/live/render_still_011_suite.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 03',
                src: 'https://media.bizionar.digital/ebrosa/t-vrex/live/render_still_012_suite.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/ebrosa/t-vrex/live/render_still_013_serv_ppl.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 02',
                src: 'https://media.bizionar.digital/ebrosa/t-vrex/live/render_still_014_serv_ppl.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/ebrosa/t-vrex/live/render_still_005_terraza.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'iconiq',
          name: 'ICONIQ',
          city: 'Zaragoza',
          province: 'Zaragoza',
          liveEnabled: true,
          showEnabled: false,
          digitalShowUrl: '',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/ebrosa/iconiq',
          image: 'https://media.bizionar.digital/ebrosa/iconiq/live/interior/still_Camera_001.jpg',
          deliveries: [
            {
              categoryId: 'interiores',
              categoryName: 'PISO PILOTO',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '26 de marzo de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '7 de abril de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '14 de abril de 2026',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '8 de mayo de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review01/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/iconiq/review01/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review01/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review01/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review01/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review01/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review01/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review01/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review01/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review01/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review01/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review01/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review01/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review01/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review01/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review01/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review01/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review01/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review01/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review01/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review01/render/interior/still_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review01/render/interior/still_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review02/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/iconiq/review02/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review02/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review02/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review02/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review02/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review02/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review02/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review02/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review02/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review02/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review02/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review02/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review02/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review02/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review02/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review02/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review02/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review02/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review02/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review02/render/interior/still_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review02/render/interior/still_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review03/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/iconiq/review03/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review03/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review03/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review03/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review03/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review03/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review03/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review03/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review03/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review03/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review03/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review03/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review03/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review03/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review03/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review03/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review03/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review03/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review03/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review03/render/interior/still_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review03/render/interior/still_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review04/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/iconiq/review04/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review04/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review04/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review04/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review04/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review04/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review04/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review04/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review04/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review04/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review04/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review04/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review04/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review04/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review04/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review04/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review04/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review04/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review04/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review04/render/interior/still_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/ebrosa/iconiq/review04/render/interior/still_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: true,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '11 de mayo de 2026',
            categoryBundles: [
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/ebrosa/iconiq/download/interior/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/ebrosa/iconiq/live/tour-multipunto/index.html',
                thumb: 'https://media.bizionar.digital/ebrosa/iconiq/live/interior/still_Camera_001.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/ebrosa/iconiq/live/interior/still_Camera_001.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/ebrosa/iconiq/live/interior/still_Camera_002.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/ebrosa/iconiq/live/interior/still_Camera_003.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/ebrosa/iconiq/live/interior/still_Camera_004.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/ebrosa/iconiq/live/interior/still_Camera_005.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 02',
                src: 'https://media.bizionar.digital/ebrosa/iconiq/live/interior/still_Camera_006.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/ebrosa/iconiq/live/interior/still_Camera_007.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/ebrosa/iconiq/live/interior/still_Camera_008.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/ebrosa/iconiq/live/interior/still_Camera_009.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/ebrosa/iconiq/live/interior/still_Camera_010.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/ebrosa/iconiq/live/interior/still_Camera_011.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 03',
                src: 'https://media.bizionar.digital/ebrosa/iconiq/live/interior/still_Camera_012.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/ebrosa/iconiq/live/interior/still_Camera_013.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 02',
                src: 'https://media.bizionar.digital/ebrosa/iconiq/live/interior/still_Camera_014.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/ebrosa/iconiq/live/interior/still_Camera_015.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 02',
                src: 'https://media.bizionar.digital/ebrosa/iconiq/live/interior/still_Camera_016.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 3 - 01',
                src: 'https://media.bizionar.digital/ebrosa/iconiq/live/interior/still_Camera_017.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 3 - 02',
                src: 'https://media.bizionar.digital/ebrosa/iconiq/live/interior/still_Camera_018.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/ebrosa/iconiq/live/interior/still_Camera_019.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 02',
                src: 'https://media.bizionar.digital/ebrosa/iconiq/live/interior/still_Camera_020.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'h133',
          name: 'H133',
          city: 'Zaragoza',
          province: 'Zaragoza',
          liveEnabled: false,
          showEnabled: false,
          digitalShowUrl: '',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/ebrosa/h133',
          image: 'https://media.bizionar.digital/ebrosa/h133/review01/render/interior/still_Camera_001.jpg',
          deliveries: [
            {
              categoryId: 'interiores',
              categoryName: 'PISO PILOTO',
              closedReviews: 0,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '26 de octubre de 2026',
                  status: 'pending',
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/ebrosa/h133/review01/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/ebrosa/h133/review01/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/ebrosa/h133/review01/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/ebrosa/h133/review01/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/ebrosa/h133/review01/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/ebrosa/h133/review01/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/ebrosa/h133/review01/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/ebrosa/h133/review01/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/ebrosa/h133/review01/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/ebrosa/h133/review01/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/ebrosa/h133/review01/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/ebrosa/h133/review01/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/ebrosa/h133/review01/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/ebrosa/h133/review01/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Dormitorio Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/h133/review01/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Dormitorio Suite 02',
                  src: 'https://media.bizionar.digital/ebrosa/h133/review01/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/ebrosa/h133/review01/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Dormitorio 2 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/h133/review01/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Dormitorio 2 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/h133/review01/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Dormitorio 3 - 01',
                  src: 'https://media.bizionar.digital/ebrosa/h133/review01/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Dormitorio 3 - 02',
                  src: 'https://media.bizionar.digital/ebrosa/h133/review01/render/interior/still_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/ebrosa/h133/review01/render/interior/still_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: 'azul-real-estate',
      name: 'Azul Real Estate',
      url: '/client/azul-real-estate',
      image: '/home/azul-real-estate-logo.jpg',
      provinces: [
        'Cádiz',
      ],
      promotions: [
        {
          id: 'alcaidesa-homes',
          name: 'Alcaidesa Homes',
          city: 'La Alcaidesa',
          province: 'Cádiz',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/tour/index.html',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/azul-real-estate/alcaidesa-homes',
          image: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/cam04.jpg',
          deliveries: [
            {
              categoryId: 'conjunto-general',
              categoryName: 'CONJUNTO GENERAL',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '10 de abril de 2024',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '25 de abril de 2024',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES FASE 1 - PARTE 1',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '9 de febrero de 2024',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '6 de marzo de 2024',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '13 de marzo de 2024',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'exteriores-fase1-parte2',
              categoryName: 'EXTERIORES FASE 1 - PARTE 2',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '25 de marzo de 2024',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '5 de abril de 2024',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '25 de abril de 2024',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'PISO PILOTO',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '9 de febrero de 2024',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '6 de marzo de 2024',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '12 de marzo de 2024',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review01/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review01/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review01/render/exterior-fase1-parte2/cam10.jpg',
                  type: 'render',
                  category: 'exteriores-fase1-parte2',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review01/render/exterior-fase1-parte2/cam13.jpg',
                  type: 'render',
                  category: 'exteriores-fase1-parte2',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review01/render/exterior-fase1-parte2/cam15.jpg',
                  type: 'render',
                  category: 'exteriores-fase1-parte2',
                },
                {
                  name: 'Render Exterior 19',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review01/render/exterior-fase1-parte2/cam19.jpg',
                  type: 'render',
                  category: 'exteriores-fase1-parte2',
                },
                {
                  name: 'Zonas Comunes 01',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review01/render/zonas-comunes/zzcc_cam01.jpg',
                  type: 'render',
                  category: 'conjunto-general',
                },
                {
                  name: 'Zonas Comunes 05',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review01/render/zonas-comunes/zzcc_cam05.jpg',
                  type: 'render',
                  category: 'conjunto-general',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review01/render/interior/salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review01/render/interior/salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review01/render/interior/salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review01/render/interior/salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Comedor 01',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review01/render/interior/comedor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Comedor 02',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review01/render/interior/comedor_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review01/render/interior/cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review01/render/interior/cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Doble 01',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review01/render/interior/habitacion_doble_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Doble 02',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review01/render/interior/habitacion_doble_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Individual 01',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review01/render/interior/habitacion_individual.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Secundario 01',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review01/render/interior/bano_sec_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Secundario 02',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review01/render/interior/bano_sec_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review01/render/interior/suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review01/render/interior/suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review01/render/interior/suite_bano_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review01/render/interior/suite_bano_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review01/render/interior/terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review01/render/interior/terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review01/render/interior/terraza_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Completo',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review02/render/exterior/cam04.jpg',
                  type: 'panoramic',
                  category: 'conjunto-general',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review02/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review02/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review02/render/exterior-fase1-parte2/cam10.jpg',
                  type: 'render',
                  category: 'exteriores-fase1-parte2',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review02/render/exterior-fase1-parte2/cam13.jpg',
                  type: 'render',
                  category: 'exteriores-fase1-parte2',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review02/render/exterior-fase1-parte2/cam15.jpg',
                  type: 'render',
                  category: 'exteriores-fase1-parte2',
                },
                {
                  name: 'Render Exterior 19',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review02/render/exterior-fase1-parte2/cam19.jpg',
                  type: 'render',
                  category: 'exteriores-fase1-parte2',
                },
                {
                  name: 'Zonas Comunes 01',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review02/render/conjunto-general/zzcc_cam01.jpg',
                  type: 'render',
                  category: 'conjunto-general',
                },
                {
                  name: 'Zonas Comunes 05',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review02/render/conjunto-general/zzcc_cam05.jpg',
                  type: 'render',
                  category: 'conjunto-general',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review02/render/interior/salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review02/render/interior/salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review02/render/interior/salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review02/render/interior/salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Comedor 01',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review02/render/interior/comedor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Comedor 02',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review02/render/interior/comedor_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review02/render/interior/cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review02/render/interior/cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Doble 01',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review02/render/interior/habitacion_doble_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Individual 01',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review02/render/interior/habitacion_individual.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Secundario 01',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review02/render/interior/bano_sec_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Secundario 02',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review02/render/interior/bano_sec_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review02/render/interior/suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review02/render/interior/suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review02/render/interior/suite_bano_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review02/render/interior/suite_bano_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review02/render/interior/terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review02/render/interior/terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review02/render/interior/terraza_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review03/multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/cam04.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review03/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review03/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review03/render/exterior-fase1-parte2/cam10.jpg',
                  type: 'render',
                  category: 'exteriores-fase1-parte2',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review03/render/exterior-fase1-parte2/cam13.jpg',
                  type: 'render',
                  category: 'exteriores-fase1-parte2',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review03/render/exterior-fase1-parte2/cam15.jpg',
                  type: 'render',
                  category: 'exteriores-fase1-parte2',
                },
                {
                  name: 'Render Exterior 19',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review03/render/exterior-fase1-parte2/cam19.jpg',
                  type: 'render',
                  category: 'exteriores-fase1-parte2',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review03/render/interior/salon_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review03/render/interior/salon_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review03/render/interior/salon_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review03/render/interior/salon_04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Comedor 01',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review03/render/interior/comedor_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Comedor 02',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review03/render/interior/comedor_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review03/render/interior/cocina_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review03/render/interior/cocina_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Doble 01',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review03/render/interior/habitacion_doble_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Individual 01',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review03/render/interior/habitacion_individual.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Secundario 01',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review03/render/interior/bano_sec_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Secundario 02',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review03/render/interior/bano_sec_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review03/render/interior/suite_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review03/render/interior/suite_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review03/render/interior/suite_bano_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review03/render/interior/suite_bano_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review03/render/interior/terraza_01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review03/render/interior/terraza_02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/review03/render/interior/terraza_03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '8 de mayo de 2024',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/download/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Digital Showroom',
                src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/cam04.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Digital Showroom',
                src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/cam04.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/alcaidesa_completo.mp4',
                thumb: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/cam04.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/alcaidesa_completo.mp4',
                thumb: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/cam04.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 04',
                src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/cam04.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 07',
                src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/cam07.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 13',
                src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/cam13.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 19',
                src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/cam19.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 15',
                src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/cam15.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 10',
                src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/cam10.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Zonas Comunes 05',
                src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/zzcc_cam05.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Zonas Comunes 01',
                src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/zzcc_cam01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/salon_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/salon_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/salon_03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/salon_04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Comedor 01',
                src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/comedor_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Comedor 02',
                src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/comedor_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/cocina_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/cocina_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Doble 01',
                src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/habitacion_doble_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Individual 01',
                src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/habitacion_individual.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Secundario 01',
                src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/bano_sec_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Secundario 02',
                src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/bano_sec_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/suite_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/suite_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/suite_bano_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 02',
                src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/suite_bano_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/terraza_01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 02',
                src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/terraza_02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 03',
                src: 'https://media.bizionar.digital/azul-real-estate/alcaidesa-homes/live/terraza_03.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
      ],
    },
    {
      id: 'la-llave-de-oro',
      name: 'La Llave de Oro',
      url: '/client/la-llave-de-oro',
      image: '/home/la-llave-de-oro-logo.jpg',
      provinces: [
        'Madrid',
      ],
      promotions: [
        {
          id: 'alcala-de-henares',
          name: 'Alcalá de Henares',
          city: 'Alcalá de Henares',
          province: 'Madrid',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/show/index.html',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/la-llave-de-oro/alcala-de-henares',
          image: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/cam18.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '4 de octubre de 2024',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '13 de enero de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '19 de febrero de 2025',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '24 de febrero de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'PISO PILOTO',
              closedReviews: 4,
              totalReviews: 4,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '18 de septiembre de 2024',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '18 de febrero de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '24 de febrero de 2025',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '3 de marzo de 2025',
                  status: 'closed',
                },
                {
                  id: 'review05',
                  name: 'ENTREGA 5',
                  date: '28 de mayo de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'axonometricas',
              categoryName: 'AXONOMÉTRICAS',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '19 de febrero de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '24 de febrero de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '3 de marzo de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/render/interior/render_Cam01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/render/exterior/cam18.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/render/exterior/cam05.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 18',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/render/exterior/cam18.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/render/exterior/cam13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/render/exterior/cam15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/render/interior/render_Cam01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/render/interior/render_Cam02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/render/interior/render_Cam03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/render/interior/render_Cam04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/render/interior/render_Cam05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/render/interior/render_Cam06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/render/interior/render_Cam07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/render/interior/render_Cam08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/render/interior/render_Cam09.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/render/interior/render_Cam10.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/render/interior/render_Cam11.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/render/interior/render_Cam12.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/render/interior/render_Cam13.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/render/interior/render_Cam14.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/render/interior/render_Cam15.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/render/interior/render_Cam16.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/render/interior/render_Cam17.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/render/interior/render_Cam18.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/render/interior/render_Cam19.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/render/interior/render_Cam20.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Axonométrica 4D',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/render/axonometricas/Axo_4D_01.jpg',
                  type: 'render',
                  category: 'axonometricas',
                },
                {
                  name: 'Axonométrica 3D',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/render/axonometricas/Axo_3D_03.jpg',
                  type: 'render',
                  category: 'axonometricas',
                },
                {
                  name: 'Axonométrica 2D',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review01/render/axonometricas/Axo_2D_02.jpg',
                  type: 'render',
                  category: 'axonometricas',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/render/exterior/cam18.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/render/interior/render_Cam01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/render/exterior/cam05.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 18',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/render/exterior/cam18.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/render/exterior/cam13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/render/exterior/cam15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/render/interior/render_Cam01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/render/interior/render_Cam02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/render/interior/render_Cam03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/render/interior/render_Cam04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/render/interior/render_Cam05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/render/interior/render_Cam06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/render/interior/render_Cam07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/render/interior/render_Cam08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/render/interior/render_Cam09.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/render/interior/render_Cam10.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/render/interior/render_Cam11.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/render/interior/render_Cam12.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/render/interior/render_Cam13.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/render/interior/render_Cam14.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/render/interior/render_Cam15.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/render/interior/render_Cam16.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/render/interior/render_Cam17.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/render/interior/render_Cam18.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/render/interior/render_Cam19.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/render/interior/render_Cam20.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Axonométrica 4D',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/render/axonometricas/Axo_4D_01.jpg',
                  type: 'render',
                  category: 'axonometricas',
                },
                {
                  name: 'Axonométrica 3D',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/render/axonometricas/Axo_3D_03.jpg',
                  type: 'render',
                  category: 'axonometricas',
                },
                {
                  name: 'Axonométrica 2D',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review02/render/axonometricas/Axo_2D_02.jpg',
                  type: 'render',
                  category: 'axonometricas',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/render/exterior/cam18.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/render/exterior/cam05.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review04/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/render/interior/render_Cam01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 18',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/render/exterior/cam18.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/render/exterior/cam13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/render/exterior/cam15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/render/interior/render_Cam01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/render/interior/render_Cam02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/render/interior/render_Cam03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/render/interior/render_Cam04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/render/interior/render_Cam05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/render/interior/render_Cam06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/render/interior/render_Cam07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/render/interior/render_Cam08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/render/interior/render_Cam09.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/render/interior/render_Cam10.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/render/interior/render_Cam11.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/render/interior/render_Cam12.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/render/interior/render_Cam13.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/render/interior/render_Cam14.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/render/interior/render_Cam15.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/render/interior/render_Cam16.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/render/interior/render_Cam17.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/render/interior/render_Cam18.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/render/interior/render_Cam19.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/render/interior/render_Cam20.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Axonométrica 4D',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/render/axonometricas/Axo_4D_01.jpg',
                  type: 'render',
                  category: 'axonometricas',
                },
                {
                  name: 'Axonométrica 3D',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/render/axonometricas/Axo_3D_03.jpg',
                  type: 'render',
                  category: 'axonometricas',
                },
                {
                  name: 'Axonométrica 2D',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review03/render/axonometricas/Axo_2D_02.jpg',
                  type: 'render',
                  category: 'axonometricas',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review04/render/exterior/cam18.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review04/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review04/render/exterior/cam05.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review05/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review04/render/interior/render_Cam01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 18',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review04/render/exterior/cam18.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review04/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review04/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review04/render/exterior/cam13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review04/render/exterior/cam15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review04/render/interior/render_Cam01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review04/render/interior/render_Cam02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review04/render/interior/render_Cam03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review04/render/interior/render_Cam04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review04/render/interior/render_Cam05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review04/render/interior/render_Cam06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review04/render/interior/render_Cam07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review04/render/interior/render_Cam08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review04/render/interior/render_Cam09.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review04/render/interior/render_Cam10.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review04/render/interior/render_Cam11.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review04/render/interior/render_Cam12.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review04/render/interior/render_Cam13.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review04/render/interior/render_Cam14.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review04/render/interior/render_Cam15.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review04/render/interior/render_Cam16.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review04/render/interior/render_Cam17.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review04/render/interior/render_Cam18.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review04/render/interior/render_Cam19.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review04/render/interior/render_Cam20.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review05',
              content: [
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review06/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review05/render/interior/render_Cam01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Video Completo',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review05/video/video_completo.mp4',
                  thumb: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/cam18.jpg',
                  type: 'video',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review05/render/interior/render_Cam01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review05/render/interior/render_Cam02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review05/render/interior/render_Cam03.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review05/render/interior/render_Cam04.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review05/render/interior/render_Cam05.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review05/render/interior/render_Cam06.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review05/render/interior/render_Cam07.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review05/render/interior/render_Cam08.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review05/render/interior/render_Cam09.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 04',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review05/render/interior/render_Cam10.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review05/render/interior/render_Cam11.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review05/render/interior/render_Cam12.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review05/render/interior/render_Cam13.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review05/render/interior/render_Cam14.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review05/render/interior/render_Cam15.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review05/render/interior/render_Cam16.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 02',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review05/render/interior/render_Cam17.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review05/render/interior/render_Cam18.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 02',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review05/render/interior/render_Cam19.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/review05/render/interior/render_Cam20.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
            {
              title: 'AXONOMÉTRICAS',
              filter: 'axonometricas',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '29 de mayo de 2025',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/download/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'axonometricas',
                renderBundleUrl: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/download/render_axonometricas_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/cam18.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/cam18.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/cam05.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/cam18.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/cam18.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 18',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/cam18.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 05',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/cam05.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 09',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/cam09.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 13',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/cam13.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 15',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/cam15.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/render_Cam01.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/render_Cam02.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/render_Cam03.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/render_Cam04.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/render_Cam05.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/render_Cam06.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/render_Cam07.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/render_Cam08.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/render_Cam09.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 04',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/render_Cam10.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/render_Cam11.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/render_Cam12.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 03',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/render_Cam13.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/render_Cam14.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 02',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/render_Cam15.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/render_Cam16.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 02',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/render_Cam17.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/render_Cam18.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 02',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/render_Cam19.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/render_Cam20.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Axonométrica 4D',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/Axo_4D_01.jpg',
                type: 'render',
                category: 'axonometricas',
              },
              {
                name: 'Axonométrica 3D',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/Axo_3D_03.jpg',
                type: 'render',
                category: 'axonometricas',
              },
              {
                name: 'Axonométrica 2D',
                src: 'https://media.bizionar.digital/la-llave-de-oro/alcala-de-henares/live/Axo_2D_02.jpg',
                type: 'render',
                category: 'axonometricas',
              },
            ],
          },
        },
      ],
    },
    {
      id: 'erro-y-eugui',
      name: 'ERRO y EUGUI',
      url: '/client/erro-y-eugui',
      image: '/home/erro-y-eugui-logo.jpg',
      provinces: [
        'Navarra',
      ],
      promotions: [
        {
          id: 'arrosadia',
          name: 'Arrosadía',
          city: 'Pamplona',
          province: 'Navarra',
          liveEnabled: true,
          showEnabled: false,
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/erro-y-eugui/arrosadia',
          image: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/live/cam01.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '31 de octubre de 2024',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '19 de noviembre de 2024',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '13 de enero de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '17 de enero de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '23 de enero de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '27 de enero de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review01/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review01/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review01/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review01/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review01/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review01/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review01/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review01/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review01/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review01/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review01/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review01/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review01/render/interior/still_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review01/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review01/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review01/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review01/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review01/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review01/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review01/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review01/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 02',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review01/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review01/render/interior/still_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review02/render/exterior/cam02.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review02/show/index.html',
                  thumb: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review02/render/exterior/cam03.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review02/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review02/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review02/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review02/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review02/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review02/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review02/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review02/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review02/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review02/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review02/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review02/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review02/render/interior/still_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review02/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review02/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review02/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review02/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review02/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review02/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review02/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review02/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 02',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review02/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review02/render/interior/still_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review03/render/exterior/cam02.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review03/show/index.html',
                  thumb: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review03/render/exterior/cam03.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review03/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review03/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review03/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review03/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review03/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review03/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review03/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review03/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 06',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review03/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review03/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review03/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review03/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Recibidor 01',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review03/render/interior/still_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review03/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review03/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review03/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review03/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review03/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review03/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review03/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review03/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 02',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review03/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/review03/render/interior/still_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '15 de enero de 2025',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/download/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual',
                src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/live/show/index.html',
                thumb: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/live/cam03.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/live/cam01.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/live/cam01.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/live/cam01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/live/cam02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/live/cam03.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/live/still_Camera_001.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/live/still_Camera_002.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/live/still_Camera_003.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/live/still_Camera_004.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/live/still_Camera_005.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 06',
                src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/live/still_Camera_006.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/live/still_Camera_007.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/live/still_Camera_008.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/live/still_Camera_009.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Recibidor 01',
                src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/live/still_Camera_020.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/live/still_Camera_010.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/live/still_Camera_011.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/live/still_Camera_012.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 03',
                src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/live/still_Camera_013.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/live/still_Camera_014.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/live/still_Camera_015.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 02',
                src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/live/still_Camera_016.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 3 - 01',
                src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/live/still_Camera_017.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 3 - 02',
                src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/live/still_Camera_018.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/erro-y-eugui/arrosadia/live/still_Camera_019.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
      ],
    },
    {
      id: 'inmocaixa',
      name: 'INMOCAIXA',
      url: '/client/inmocaixa',
      image: '/home/inmocaixa-logo.jpg',
      provinces: [
        'Sevilla',
      ],
      promotions: [
        {
          id: 'nervion-zenit',
          name: 'Nervión - Zenit',
          city: 'Sevilla',
          province: 'Sevilla',
          liveEnabled: true,
          showEnabled: false,
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/inmocaixa/nervion-zenit',
          image: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/live/exterior/render_CAM03_DAY.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 0,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '27 de diciembre de 2024',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '21 de enero de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '27 de diciembre de 2024',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '16 de enero de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '4 de marzo de 2026',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '9 de marzo de 2026',
                  status: 'closed',
                },
                {
                  id: 'review05',
                  name: 'ENTREGA 5',
                  date: '11 de marzo de 2026',
                  status: 'pending',
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review01/render/exterior/render_CAM03_DAY.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review01/render/exterior/render_CAM03_DAY.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review01/render/exterior/render_CAM06_NIGHT.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review01/render/exterior/render_CAM08_DAY.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review01/render/exterior/render_CAM11_DAY.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review01/render/exterior/render_CAM14_SUNSET.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 18',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review01/render/exterior/render_CAM18_DAY.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review01/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review01/render/interior/render_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review01/render/interior/render_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review01/render/interior/render_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review01/render/interior/render_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review01/render/interior/render_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review01/render/interior/render_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review01/render/interior/render_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review01/render/interior/render_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review01/render/interior/render_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review01/render/interior/render_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review01/render/interior/render_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review01/render/interior/render_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review01/render/interior/render_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review01/render/interior/render_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review01/render/interior/render_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review01/render/interior/render_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review01/render/interior/render_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review01/render/interior/render_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review01/render/interior/render_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 02',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review01/render/interior/render_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review01/render/interior/render_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review02/render/exterior/render_CAM03_DAY.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review02/render/exterior/render_CAM03_DAY.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review02/render/exterior/render_CAM06_NIGHT.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review02/render/exterior/render_CAM08_DAY.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review02/render/exterior/render_CAM11_DAY.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review02/render/exterior/render_CAM14_SUNSET.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 18',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review02/render/exterior/render_CAM18_DAY.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review02/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review02/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review02/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review02/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review02/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review02/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review02/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review02/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review02/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review02/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review02/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review02/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review02/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review02/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review02/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review02/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review02/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review02/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review02/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review02/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 02',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review02/render/interior/still_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review02/render/interior/still_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review04/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review04/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review04/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review04/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review04/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review04/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review04/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review04/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review04/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review04/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review04/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review04/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review04/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review04/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review04/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review04/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review04/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review04/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review04/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review04/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 02',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review04/render/interior/still_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review04/render/interior/still_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review05/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review05/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review05/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review05/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review05/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review05/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review05/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review05/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review05/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review05/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review05/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review05/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review05/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review05/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review05/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review05/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review05/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review05/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review05/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review05/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 02',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review05/render/interior/still_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review05/render/interior/still_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review05',
              content: [
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review06/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review06/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review06/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review06/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review06/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review06/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review06/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review06/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review06/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review06/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review06/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review06/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review06/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review06/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review06/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review06/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review06/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review06/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review06/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review06/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 02',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review06/render/interior/still_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/review06/render/interior/still_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'PISO PILOTO',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '23 de enero de 2025',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/download/exterior/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/download/interior/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/live/exterior/render_CAM03_DAY.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/live/exterior/render_CAM03_DAY.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 06',
                src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/live/exterior/render_CAM06_NIGHT.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 08',
                src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/live/exterior/render_CAM08_DAY.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 11',
                src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/live/exterior/render_CAM11_DAY.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 14',
                src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/live/exterior/render_CAM14_SUNSET.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 18',
                src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/live/exterior/render_CAM18_DAY.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/live/interior/still_Camera_001.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/live/interior/still_Camera_002.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 03',
                src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/live/interior/still_Camera_003.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 04',
                src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/live/interior/still_Camera_004.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 05',
                src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/live/interior/still_Camera_005.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/live/interior/still_Camera_006.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 02',
                src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/live/interior/still_Camera_007.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 03',
                src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/live/interior/still_Camera_008.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/live/interior/still_Camera_009.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 02',
                src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/live/interior/still_Camera_010.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 03',
                src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/live/interior/still_Camera_011.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/live/interior/still_Camera_012.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 02',
                src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/live/interior/still_Camera_013.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 03',
                src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/live/interior/still_Camera_014.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/live/interior/still_Camera_015.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/live/interior/still_Camera_016.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 02',
                src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/live/interior/still_Camera_017.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 3 - 01',
                src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/live/interior/still_Camera_018.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 3 - 02',
                src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/live/interior/still_Camera_019.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/inmocaixa/nervion-zenit/live/interior/still_Camera_020.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'sevilla-32',
          name: 'Sevilla 32',
          city: 'Sevilla',
          province: 'Sevilla',
          liveEnabled: false,
          showEnabled: false,
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/inmocaixa/sevilla-32',
          image: 'https://media.bizionar.digital/inmocaixa/sevilla-32/live/exterior/cam02.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '19 de enero de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '5 de febrero de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '10 de febrero de 2026',
                  status: 'pending',
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '12 de enero de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '4 de febrero de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '10 de febrero de 2026',
                  status: 'pending',
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review01/render/exterior/cam06.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review01/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review01/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review01/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review01/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review01/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review01/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review01/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review01/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review01/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review01/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review01/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review01/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review01/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review01/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review01/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review01/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review01/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review01/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review01/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review01/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review01/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review01/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review01/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review01/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review01/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review01/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 02',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review01/render/interior/still_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review01/render/interior/still_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review02/render/exterior/cam06.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review02/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review02/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review02/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review02/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review02/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review02/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review02/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review02/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review02/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review02/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review02/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review02/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review02/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review02/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review02/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review02/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review02/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review02/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review02/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review02/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review02/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review02/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review02/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review02/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review02/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review02/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 02',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review02/render/interior/still_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review02/render/interior/still_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review03/render/exterior/cam06.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review03/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review03/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review03/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review03/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review03/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review03/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review03/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review03/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review03/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review03/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 03',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review03/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 04',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review03/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 05',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review03/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review03/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 02',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review03/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 03',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review03/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review03/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review03/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 03',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review03/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review03/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 02',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review03/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 03',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review03/render/interior/still_Camera_014.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review03/render/interior/still_Camera_015.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review03/render/interior/still_Camera_016.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 02',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review03/render/interior/still_Camera_017.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review03/render/interior/still_Camera_018.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 02',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review03/render/interior/still_Camera_019.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/inmocaixa/sevilla-32/review03/render/interior/still_Camera_020.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: 'via-celere',
      name: 'VÍA CÉLERE',
      url: '/client/via-celere',
      image: '/home/via-celere-logo.jpg',
      provinces: [
        'Barcelona',
        'Madrid',
        'Málaga',
        'Sevilla',
        'Valencia',
        'Valladolid',
      ],
      promotions: [
        {
          id: 'blossom-hills',
          name: 'Blossom Hills',
          city: 'Benalmádena',
          province: 'Málaga',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://media.bizionar.digital/via-celere/blossom-hills/show/index.html',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/via-celere/blossom-hills',
          image: 'https://media.bizionar.digital/via-celere/blossom-hills/live/exterior/cam01.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '3 de marzo de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '3 de septiembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '18 de septiembre de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '3 de marzo de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '28 de marzo de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '22 de mayo de 2025',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '2 de junio de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'zonas-comunes',
              categoryName: 'ZONAS COMUNES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '22 de mayo de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '2 de junio de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '17 de junio de 2025',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '18 de septiembre de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/blossom-hills/review01/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/blossom-hills/review01/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/blossom-hills/review01/render/exterior/cam01.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review01/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review01/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review01/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review01/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review01/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review01/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review01/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review01/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review01/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review01/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review01/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review01/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review01/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Chillout 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review01/render/zonas-comunes/chill_01.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Chillout 02',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review01/render/zonas-comunes/chill_02.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Chillout 03',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review01/render/zonas-comunes/chill_03.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Gym 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review01/render/zonas-comunes/gym_1.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Gym 02',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review01/render/zonas-comunes/gym_2.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Gym 03',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review01/render/zonas-comunes/gym_3.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review05/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/blossom-hills/review02/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/blossom-hills/review01/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/blossom-hills/review02/render/exterior/cam01.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review02/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review02/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review02/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review02/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review02/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review02/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review02/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review02/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review02/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review02/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review02/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review02/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review02/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Chillout 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review02/render/zonas-comunes/chill_01.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Chillout 02',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review02/render/zonas-comunes/chill_02.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Chillout 03',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review02/render/zonas-comunes/chill_03.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Gym 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review02/render/zonas-comunes/gym_1.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Gym 02',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review02/render/zonas-comunes/gym_2.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Gym 03',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review02/render/zonas-comunes/gym_3.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review06/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/blossom-hills/review03/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/blossom-hills/review01/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/blossom-hills/review03/render/exterior/cam01.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review03/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review03/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review03/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review03/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review03/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review03/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review03/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review03/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review03/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review03/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review03/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review03/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review03/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Chillout 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review03/render/zonas-comunes/chill_01.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Chillout 02',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review03/render/zonas-comunes/chill_02.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Chillout 03',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review03/render/zonas-comunes/chill_03.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Gym 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review03/render/zonas-comunes/gym_1.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Gym 02',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review03/render/zonas-comunes/gym_2.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Gym 03',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review03/render/zonas-comunes/gym_3.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review06/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/blossom-hills/review01/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review04/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review04/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review04/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review04/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review04/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review04/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review04/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review04/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Chillout 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review04/render/zonas-comunes/chill_01.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Chillout 02',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review04/render/zonas-comunes/chill_02.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Chillout 03',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review04/render/zonas-comunes/chill_03.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Gym 01',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review04/render/zonas-comunes/gym_1.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Gym 02',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review04/render/zonas-comunes/gym_2.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Gym 03',
                  src: 'https://media.bizionar.digital/via-celere/blossom-hills/review04/render/zonas-comunes/gym_3.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'PISO PILOTO',
              filter: 'interiores',
              active: false,
            },
            {
              title: 'ZONAS COMUNES',
              filter: 'zonas-comunes',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '27 de agosto de 2026',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/blossom-hills/download/exterior/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/blossom-hills/download/interior/render_interior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'zonas-comunes',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/blossom-hills/download/zonas-comunes/render_zonas-comunes_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/via-celere/blossom-hills/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/blossom-hills/live/exterior/cam01.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/via-celere/blossom-hills/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/blossom-hills/live/exterior/cam01.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/via-celere/blossom-hills/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/blossom-hills/live/exterior/cam01.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/via-celere/blossom-hills/live/video/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/via-celere/blossom-hills/live/exterior/cam01.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/via-celere/blossom-hills/live/video/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/via-celere/blossom-hills/live/exterior/cam01.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/via-celere/blossom-hills/live/exterior/cam01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/via-celere/blossom-hills/live/exterior/cam02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 06',
                src: 'https://media.bizionar.digital/via-celere/blossom-hills/live/exterior/cam06.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 10',
                src: 'https://media.bizionar.digital/via-celere/blossom-hills/live/exterior/cam10.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 12',
                src: 'https://media.bizionar.digital/via-celere/blossom-hills/live/exterior/cam12.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/via-celere/blossom-hills/live/interior/still_Camera_001.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/via-celere/blossom-hills/live/interior/still_Camera_002.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/via-celere/blossom-hills/live/interior/still_Camera_003.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/via-celere/blossom-hills/live/interior/still_Camera_004.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/via-celere/blossom-hills/live/interior/still_Camera_005.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/via-celere/blossom-hills/live/interior/still_Camera_006.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/via-celere/blossom-hills/live/interior/still_Camera_007.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/via-celere/blossom-hills/live/interior/still_Camera_008.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Chillout 01',
                src: 'https://media.bizionar.digital/via-celere/blossom-hills/live/zonas-comunes/chill_01.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Chillout 02',
                src: 'https://media.bizionar.digital/via-celere/blossom-hills/live/zonas-comunes/chill_02.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Chillout 03',
                src: 'https://media.bizionar.digital/via-celere/blossom-hills/live/zonas-comunes/chill_03.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Gym 01',
                src: 'https://media.bizionar.digital/via-celere/blossom-hills/live/zonas-comunes/gym_1.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Gym 02',
                src: 'https://media.bizionar.digital/via-celere/blossom-hills/live/zonas-comunes/gym_2.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Gym 03',
                src: 'https://media.bizionar.digital/via-celere/blossom-hills/live/zonas-comunes/gym_3.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
            ],
          },
        },
        {
          id: 'allegra',
          name: 'Allegra',
          city: 'Madrid',
          province: 'Madrid',
          liveEnabled: true,
          showEnabled: false,
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/via-celere/allegra',
          image: 'https://media.bizionar.digital/via-celere/allegra/live/exterior/cam03.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '20 de juny de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '5 de septiembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '22 de septiembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '2 de octubre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review05',
                  name: 'ENTREGA 5',
                  date: '13 de julio de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 4,
              totalReviews: 4,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '11 de abril de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '7 de mayo de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '25 de junio de 2025',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '26 de agosto de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
                {
                  id: 'review05',
                  name: 'ENTREGA 5',
                  date: '18 de septiembre de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'zonas-comunes',
              categoryName: 'ZONAS COMUNES',
              closedReviews: 1,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '2 de febrero de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '11 de marzo de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '26 de marzo de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/allegra/review01/render/exterior/cam06.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/allegra/review01/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/allegra/review01/render/exterior/cam01.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review01/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review01/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review01/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review01/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review01/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review01/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review01/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review01/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review01/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review01/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review01/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review01/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review01/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review01/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review01/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review01/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review01/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 04',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review01/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review01/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review01/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review06/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/allegra/review02/render/exterior/cam06.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/allegra/review02/render/exterior/cam01.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review06/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/allegra/review02/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review02/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review02/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review02/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review02/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review02/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review02/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review02/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review02/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review02/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review02/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review02/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review02/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review02/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review02/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review02/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review02/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review02/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 04',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review02/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review02/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review02/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review08/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/allegra/review03/render/exterior/cam06.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/allegra/review03/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/allegra/review03/render/exterior/cam01.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review03/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review03/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review03/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review03/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review03/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review03/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review03/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review03/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review03/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review03/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review03/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review03/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review03/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review03/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review03/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review03/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review03/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review03/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review03/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 03',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review03/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review09/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/allegra/review04/render/exterior/cam06.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review09/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/allegra/review04/render/exterior/cam06.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/allegra/review04/render/exterior/cam01.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review04/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review04/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review04/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review04/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review04/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review04/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review04/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review04/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review04/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review04/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review04/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review04/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review04/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review04/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review05',
              content: [
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review05/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/allegra/review05/render/exterior/cam01.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review10/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/allegra/review05/render/exterior/cam06.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review09/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/allegra/review04/render/exterior/cam06.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review05/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review05/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review05/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review05/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review05/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review05/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review05/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review05/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review05/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review05/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review05/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review05/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review05/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/allegra/review05/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'PISO PILOTO',
              filter: 'interiores',
              active: false,
            },
            {
              title: 'ZONAS COMUNES',
              filter: 'zonas-comunes',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '22 de julio de 2026',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/allegra/download/exterior/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/allegra/download/interior/render_interior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'zonas-comunes',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/allegra/download/zonas-comunes/render_zonas-comunes_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/via-celere/allegra/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/allegra/live/exterior/cam06.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/via-celere/allegra/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/allegra/live/exterior/cam06.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/via-celere/allegra/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/allegra/live/exterior/cam01.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/via-celere/allegra/live/exterior/cam01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/via-celere/allegra/live/exterior/cam03.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 06',
                src: 'https://media.bizionar.digital/via-celere/allegra/live/exterior/cam06.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 08',
                src: 'https://media.bizionar.digital/via-celere/allegra/live/exterior/cam08.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 11',
                src: 'https://media.bizionar.digital/via-celere/allegra/live/exterior/cam11.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 12',
                src: 'https://media.bizionar.digital/via-celere/allegra/live/exterior/cam12.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/via-celere/allegra/live/interior/still_Camera_001.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/via-celere/allegra/live/interior/still_Camera_002.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/via-celere/allegra/live/interior/still_Camera_003.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/via-celere/allegra/live/interior/still_Camera_004.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/via-celere/allegra/live/interior/still_Camera_005.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/via-celere/allegra/live/interior/still_Camera_006.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/via-celere/allegra/live/interior/still_Camera_007.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/via-celere/allegra/live/interior/still_Camera_008.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Sala Social - 01',
                src: 'https://media.bizionar.digital/via-celere/allegra/live/zonas-comunes/still_Camera_001.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 02',
                src: 'https://media.bizionar.digital/via-celere/allegra/live/zonas-comunes/still_Camera_002.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 03',
                src: 'https://media.bizionar.digital/via-celere/allegra/live/zonas-comunes/still_Camera_003.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit - 01',
                src: 'https://media.bizionar.digital/via-celere/allegra/live/zonas-comunes/still_Camera_004.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit - 02',
                src: 'https://media.bizionar.digital/via-celere/allegra/live/zonas-comunes/still_Camera_005.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit - 03',
                src: 'https://media.bizionar.digital/via-celere/allegra/live/zonas-comunes/still_Camera_006.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
            ],
          },
        },
        {
          id: 'victoria',
          name: 'Victoria I',
          city: 'Rincón de la Victoria',
          province: 'Málaga',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://media.bizionar.digital/via-celere/victoria/show/index.html',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/via-celere/victoria',
          image: 'https://media.bizionar.digital/via-celere/victoria/live/exterior/cam001_AI.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '10 de abril de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '30 de junio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '6 de julio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '17 de julio de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 4,
              totalReviews: 4,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '15 de octubre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '3 de noviembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '10 de noviembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '12 de noviembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review05',
                  name: 'ENTREGA 5',
                  date: '16 de julio de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'zonas-comunes',
              categoryName: 'ZONAS COMUNES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '3 de febrero de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '18 de junio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '14 de julio de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review01/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/victoria/review01/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render General 03',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review01/render/exterior/general_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Victoria I - 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review01/render/exterior/victoria1_b1.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Victoria I - 03',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review01/render/exterior/victoria1_b3.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Victoria I - 05',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review01/render/exterior/victoria1_b5.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review01/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review01/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review01/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review01/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review01/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review01/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review01/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review01/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review01/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review01/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review01/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 04',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review01/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Estancia Exterior - 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review01/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Estancia Exterior - 02',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review01/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Estancia Exterior - 03',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review01/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/victoria/review02/render/exterior/cam003_AI.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/victoria/review02/render/exterior/cam001_AI.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review02/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/victoria/review02/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render General 03',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review02/render/exterior/general_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior - 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review02/render/exterior/cam001.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior - 01 IA',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review02/render/exterior/cam001_AI.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior - 03',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review02/render/exterior/cam003.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior - 03 IA',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review02/render/exterior/cam003_AI.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior - 05',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review02/render/exterior/cam005.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior - 05 IA',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review02/render/exterior/cam005_AI.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review02/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review02/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review02/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review02/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review02/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review02/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review02/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review02/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review02/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review02/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review02/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 04',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review02/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Estancia Exterior - 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review02/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Estancia Exterior - 02',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review02/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Estancia Exterior - 03',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review02/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/victoria/review03/render/exterior/cam003_AI.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/victoria/review03/render/exterior/cam001_AI.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review03/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/victoria/review03/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render General 03',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review03/render/exterior/general_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior - 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review03/render/exterior/cam001.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior - 01 IA',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review03/render/exterior/cam001_AI.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior - 03',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review03/render/exterior/cam003.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior - 03 IA',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review03/render/exterior/cam003_AI.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior - 05',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review03/render/exterior/cam005.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior - 05 IA',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review03/render/exterior/cam005_AI.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review03/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review03/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review03/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review03/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review03/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review03/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review03/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review03/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review03/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 01 IA',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review03/render/zonas-comunes/still_Camera_001_ai.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review03/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review03/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03 IA',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review03/render/zonas-comunes/still_Camera_003_ai.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 04',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review03/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Estancia Exterior - 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review03/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Estancia Exterior - 02',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review03/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Estancia Exterior - 02 IA',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review03/render/zonas-comunes/still_Camera_006_ai.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Estancia Exterior - 03',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review03/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/victoria/review04/render/exterior/cam003_AI.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/victoria/review04/render/exterior/cam001_AI.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review04/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/victoria/review04/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render General 03',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review04/render/exterior/general_03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior - 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review04/render/exterior/cam001.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior - 01 IA',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review04/render/exterior/cam001_AI.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior - 03',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review04/render/exterior/cam003.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior - 03 IA',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review04/render/exterior/cam003_AI.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior - 05',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review04/render/exterior/cam005.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior - 05 IA',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review04/render/exterior/cam005_AI.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review04/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review04/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review04/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review04/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review04/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review04/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review04/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review04/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review05',
              content: [
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review05/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/victoria/review05/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review05/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review05/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review05/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review05/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review05/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review05/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review05/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria/review05/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'PISO PILOTO',
              filter: 'interiores',
              active: false,
            },
            {
              title: 'ZONAS COMUNES',
              filter: 'zonas-comunes',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '17 de julio de 2026',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/victoria/download/exterior/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/victoria/download/interior/render_interior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'zonas-comunes',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/victoria/download/zonas-comunes/render_zonas-comunes_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/via-celere/victoria/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/victoria/live/exterior/cam003_AI.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/via-celere/victoria/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/victoria/live/exterior/cam003_AI.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/via-celere/victoria/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/victoria/live/exterior/cam001_AI.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Render General 03',
                src: 'https://media.bizionar.digital/via-celere/victoria/live/exterior/general_03.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior - 01',
                src: 'https://media.bizionar.digital/via-celere/victoria/live/exterior/cam001.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior - 01 IA',
                src: 'https://media.bizionar.digital/via-celere/victoria/live/exterior/cam001_AI.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior - 03',
                src: 'https://media.bizionar.digital/via-celere/victoria/live/exterior/cam003.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior - 03 IA',
                src: 'https://media.bizionar.digital/via-celere/victoria/live/exterior/cam003_AI.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior - 05',
                src: 'https://media.bizionar.digital/via-celere/victoria/live/exterior/cam005.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior - 05 IA',
                src: 'https://media.bizionar.digital/via-celere/victoria/live/exterior/cam005_AI.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/via-celere/victoria/live/interior/still_Camera_001.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/via-celere/victoria/live/interior/still_Camera_002.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/via-celere/victoria/live/interior/still_Camera_003.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/via-celere/victoria/live/interior/still_Camera_004.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/via-celere/victoria/live/interior/still_Camera_005.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/via-celere/victoria/live/interior/still_Camera_006.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/via-celere/victoria/live/interior/still_Camera_007.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/via-celere/victoria/live/interior/still_Camera_008.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Sala Social - 01',
                src: 'https://media.bizionar.digital/via-celere/victoria/live/zonas-comunes/still_Camera_001.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 01 IA',
                src: 'https://media.bizionar.digital/via-celere/victoria/live/zonas-comunes/still_Camera_001_ai.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 02',
                src: 'https://media.bizionar.digital/via-celere/victoria/live/zonas-comunes/still_Camera_002.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 03',
                src: 'https://media.bizionar.digital/via-celere/victoria/live/zonas-comunes/still_Camera_003.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 03 IA',
                src: 'https://media.bizionar.digital/via-celere/victoria/live/zonas-comunes/still_Camera_003_ai.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 04',
                src: 'https://media.bizionar.digital/via-celere/victoria/live/zonas-comunes/still_Camera_004.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Estancia Exterior - 01',
                src: 'https://media.bizionar.digital/via-celere/victoria/live/zonas-comunes/still_Camera_005.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Estancia Exterior - 02',
                src: 'https://media.bizionar.digital/via-celere/victoria/live/zonas-comunes/still_Camera_006.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Estancia Exterior - 02 IA',
                src: 'https://media.bizionar.digital/via-celere/victoria/live/zonas-comunes/still_Camera_006_ai.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Estancia Exterior - 03',
                src: 'https://media.bizionar.digital/via-celere/victoria/live/zonas-comunes/still_Camera_007.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
            ],
          },
        },
        {
          id: 'victoria-ii',
          name: 'Victoria II',
          city: 'Rincón de la Victoria',
          province: 'Málaga',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://media.bizionar.digital/via-celere/victoria-ii/show/index.html',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/via-celere/victoria-ii',
          image: 'https://media.bizionar.digital/via-celere/victoria-ii/live/exterior/cam001.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '10 de abril de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '30 de junio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '6 de agosto de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '1 de diciembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '23 de enero de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '15 de julio de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'zonas-comunes',
              categoryName: 'ZONAS COMUNES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '9 de julio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '9 de julio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '15 de julio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '17 de julio de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review01/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/victoria-ii/review01/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render General 02',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review01/render/exterior/general_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Victoria II - 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review01/render/exterior/victoria2_a1.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Victoria II - 02',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review01/render/exterior/victoria2_a2.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Victoria II - 05',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review01/render/exterior/victoria2_a5.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review01/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review01/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review01/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review01/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review01/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review01/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review01/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review01/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review01/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review01/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review01/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review01/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/victoria-ii/review02/render/exterior/cam001.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/victoria-ii/review02/render/exterior/cam001.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review02/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/victoria-ii/review02/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render General 02',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review02/render/exterior/general_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior - 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review02/render/exterior/cam001.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior - 01 IA',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review02/render/exterior/cam001_AI.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior - 02',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review02/render/exterior/cam002.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior - 02 IA',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review02/render/exterior/cam002_AI.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior - 05',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review02/render/exterior/cam005.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior - 05 IA',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review02/render/exterior/cam005_AI.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review02/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review02/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review02/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review02/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review02/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review02/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review02/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review02/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review02/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review02/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review02/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review02/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/victoria-ii/review03/render/exterior/cam001.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/victoria-ii/review03/render/exterior/cam001.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review03/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/victoria-ii/review03/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render General 02',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review03/render/exterior/general_02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior - 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review03/render/exterior/cam001.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior - 01 IA',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review03/render/exterior/cam001_AI.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior - 02',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review03/render/exterior/cam002.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior - 02 IA',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review03/render/exterior/cam002_AI.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior - 05',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review03/render/exterior/cam005.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior - 05 IA',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review03/render/exterior/cam005_AI.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review03/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review03/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review03/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review03/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review03/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review03/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review03/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review03/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review03/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review03/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review03/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review03/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review04/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review04/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/victoria-ii/review04/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'PISO PILOTO',
              filter: 'interiores',
              active: false,
            },
            {
              title: 'ZONAS COMUNES',
              filter: 'zonas-comunes',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '19 de agosto de 2026',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/victoria-ii/download/exterior/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/victoria-ii/download/interior/render_interior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'zonas-comunes',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/victoria-ii/download/zonas-comunes/render_zonas-comunes_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/via-celere/victoria-ii/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/victoria-ii/live/exterior/cam001.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/via-celere/victoria-ii/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/victoria-ii/live/exterior/cam001.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Render General 02',
                src: 'https://media.bizionar.digital/via-celere/victoria-ii/live/exterior/general_02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior - 01',
                src: 'https://media.bizionar.digital/via-celere/victoria-ii/live/exterior/cam001.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior - 01 IA',
                src: 'https://media.bizionar.digital/via-celere/victoria-ii/live/exterior/cam001_AI.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior - 02',
                src: 'https://media.bizionar.digital/via-celere/victoria-ii/live/exterior/cam002.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior - 02 IA',
                src: 'https://media.bizionar.digital/via-celere/victoria-ii/live/exterior/cam002_AI.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior - 05',
                src: 'https://media.bizionar.digital/via-celere/victoria-ii/live/exterior/cam005.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior - 05 IA',
                src: 'https://media.bizionar.digital/via-celere/victoria-ii/live/exterior/cam005_AI.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/via-celere/victoria-ii/live/interior/still_Camera_001.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/via-celere/victoria-ii/live/interior/still_Camera_002.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/via-celere/victoria-ii/live/interior/still_Camera_003.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/via-celere/victoria-ii/live/interior/still_Camera_004.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/via-celere/victoria-ii/live/interior/still_Camera_005.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/via-celere/victoria-ii/live/interior/still_Camera_006.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/via-celere/victoria-ii/live/interior/still_Camera_007.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/via-celere/victoria-ii/live/interior/still_Camera_008.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/via-celere/victoria-ii/live/interior/still_Camera_009.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Sala Social - 01',
                src: 'https://media.bizionar.digital/via-celere/victoria-ii/live/zonas-comunes/still_Camera_001.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 02',
                src: 'https://media.bizionar.digital/via-celere/victoria-ii/live/zonas-comunes/still_Camera_002.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 03',
                src: 'https://media.bizionar.digital/via-celere/victoria-ii/live/zonas-comunes/still_Camera_003.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
            ],
          },
        },
        {
          id: 'nervion',
          name: 'Nervión',
          city: 'Sevilla',
          province: 'Sevilla',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://media.bizionar.digital/via-celere/nervion/show/index.html',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/via-celere/nervion',
          image: 'https://media.bizionar.digital/via-celere/nervion/review03/render/exterior/cam10.jpg',
          deliveries: [
            {
              categoryId: 'zonas-comunes',
              categoryName: 'ZONAS COMUNES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '8 de octubre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '5 de diciembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '22 de diciembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '23 de diciembre de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '16 de mayo de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '6 de octubre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '19 de mayo de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 4,
              totalReviews: 4,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '16 de mayo de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '27 de mayo de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '30 de mayo de 2025',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '5 de junio de 2025',
                  status: 'closed',
                },
                {
                  id: 'review05',
                  name: 'ENTREGA 5',
                  date: '6 de junio de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/nervion/review01/render/exterior/cam10.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/nervion/review01/render/exterior/cam10.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/nervion/review01/render/exterior/cam05.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review01/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review01/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review01/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review01/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review01/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior Extra',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review01/render/exterior/camera_new.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review01/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review01/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review01/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review01/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review01/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review01/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review01/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza - 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review01/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review01/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review01/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review01/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 04',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review01/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review01/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review01/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review01/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 02',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review01/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/nervion/review02/render/exterior/cam10.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/nervion/review02/render/exterior/cam10.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/nervion/review02/render/exterior/cam05.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review02/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review02/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review02/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review02/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review02/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior Extra',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review02/render/exterior/camera_new.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review02/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review02/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review02/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review02/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review02/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review02/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review02/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza - 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review02/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review02/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review02/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review02/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 04',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review02/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review02/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review02/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review02/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 02',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review02/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/nervion/review03/render/exterior/cam10.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/nervion/review03/render/exterior/cam10.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/nervion/review03/render/exterior/cam05.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review03/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review03/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review03/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review03/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review03/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior Extra',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review03/render/exterior/camera_new.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review03/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review03/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review03/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review03/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review03/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review03/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review03/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza - 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review03/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review03/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review03/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review03/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 04',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review03/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review03/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review03/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review03/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 02',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review03/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/nervion/review02/render/exterior/cam10.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review04/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review04/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review04/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review04/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review04/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review04/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review04/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza - 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review04/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review04/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review04/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review04/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 04',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review04/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review04/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review04/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review04/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 02',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review04/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review05',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review05/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/nervion/review02/render/exterior/cam10.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review05/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review05/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review05/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review05/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review05/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review05/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review05/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza - 01',
                  src: 'https://media.bizionar.digital/via-celere/nervion/review05/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'PISO PILOTO',
              filter: 'interiores',
              active: false,
            },
            {
              title: 'ZONAS COMUNES',
              filter: 'zonas-comunes',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '26 de mayo de 2026',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/nervion/download/exterior/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/nervion/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'zonas-comunes',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/nervion/download/zonas-comunes/render_zonas-comunes_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/via-celere/nervion/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/nervion/live/exterior/cam10.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/via-celere/nervion/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/nervion/live/exterior/cam10.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/via-celere/nervion/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/nervion/live/exterior/cam05.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 05',
                src: 'https://media.bizionar.digital/via-celere/nervion/live/exterior/cam05.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 06',
                src: 'https://media.bizionar.digital/via-celere/nervion/live/exterior/cam06.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 07',
                src: 'https://media.bizionar.digital/via-celere/nervion/live/exterior/cam07.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 08',
                src: 'https://media.bizionar.digital/via-celere/nervion/live/exterior/cam08.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 10',
                src: 'https://media.bizionar.digital/via-celere/nervion/live/exterior/cam10.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior Extra',
                src: 'https://media.bizionar.digital/via-celere/nervion/live/exterior/camera_new.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/via-celere/nervion/live/still_Camera_001.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/via-celere/nervion/live/still_Camera_002.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/via-celere/nervion/live/still_Camera_003.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/via-celere/nervion/live/still_Camera_004.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/via-celere/nervion/live/still_Camera_005.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/via-celere/nervion/live/still_Camera_006.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/via-celere/nervion/live/still_Camera_007.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza - 01',
                src: 'https://media.bizionar.digital/via-celere/nervion/live/still_Camera_008.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Sala Social - 01',
                src: 'https://media.bizionar.digital/via-celere/nervion/live/zonas-comunes/still_Camera_001.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 02',
                src: 'https://media.bizionar.digital/via-celere/nervion/live/zonas-comunes/still_Camera_002.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 03',
                src: 'https://media.bizionar.digital/via-celere/nervion/live/zonas-comunes/still_Camera_003.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 04',
                src: 'https://media.bizionar.digital/via-celere/nervion/live/zonas-comunes/still_Camera_004.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit - 01',
                src: 'https://media.bizionar.digital/via-celere/nervion/live/zonas-comunes/still_Camera_005.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit - 02',
                src: 'https://media.bizionar.digital/via-celere/nervion/live/zonas-comunes/still_Camera_006.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Coworking - 01',
                src: 'https://media.bizionar.digital/via-celere/nervion/live/zonas-comunes/still_Camera_007.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Coworking - 02',
                src: 'https://media.bizionar.digital/via-celere/nervion/live/zonas-comunes/still_Camera_008.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
            ],
          },
        },
        {
          id: 'tarso',
          name: 'Tarso',
          city: 'Sevilla',
          province: 'Sevilla',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://media.bizionar.digital/via-celere/tarso/show/index.html',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/via-celere/tarso',
          image: 'https://media.bizionar.digital/via-celere/tarso/live/exterior/cam06.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '30 de mayo de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '30 de junio de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '15 de julio de 2025',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '8 de septiembre de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 4,
              totalReviews: 4,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '2 de junio de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '30 de junio de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '17 de julio de 2025',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '25 de agosto de 2025',
                  status: 'closed',
                },
                {
                  id: 'review05',
                  name: 'ENTREGA 5',
                  date: '18 de septiembre de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'zonas-comunes',
              categoryName: 'ZONAS COMUNES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '17 de octubre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '5 de diciembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '18 de diciembre de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/tarso/review01/render/exterior/cam06.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/tarso/review01/render/exterior/cam06.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/tarso/review01/render/exterior/cam07.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review01/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review01/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review01/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 18',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review01/render/exterior/cam18.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 20',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review01/render/exterior/cam20.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review01/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review01/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review01/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review01/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review01/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review01/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review01/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review01/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review01/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social 02',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review01/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social 03',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review01/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social 04',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review01/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review01/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit 02',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review01/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/tarso/review02/render/exterior/cam06.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/tarso/review02/render/exterior/cam06.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/tarso/review02/render/exterior/cam07.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review02/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review02/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review02/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 18',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review02/render/exterior/cam18.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 20',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review02/render/exterior/cam20.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review02/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review02/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review02/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review02/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review02/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review02/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review02/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review02/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review02/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social 02',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review02/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social 03',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review02/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social 04',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review02/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review02/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit 02',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review02/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review06/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/tarso/review03/render/exterior/cam06.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review06/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/tarso/review03/render/exterior/cam06.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review04/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/tarso/review03/render/exterior/cam07.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review03/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review03/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review03/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 18',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review03/render/exterior/cam18.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 20',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review03/render/exterior/cam20.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review03/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review03/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review03/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review03/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review03/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review03/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review03/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review03/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review03/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social 02',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review03/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social 03',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review03/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social 04',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review03/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review03/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit 02',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review03/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review08/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/tarso/review04/render/exterior/cam06.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review07/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/tarso/review03/render/exterior/cam06.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review05/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/tarso/review04/render/exterior/cam07.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review04/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review04/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review04/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 18',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review04/render/exterior/cam18.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 20',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review04/render/exterior/cam20.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review04/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review04/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review04/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review04/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review04/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review04/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review04/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review04/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review05',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review09/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/tarso/review04/render/exterior/cam06.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review04/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review04/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review04/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review04/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review04/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review04/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review04/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/tarso/review04/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'PISO PILOTO',
              filter: 'interiores',
              active: false,
            },
            {
              title: 'ZONAS COMUNES',
              filter: 'zonas-comunes',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '12 de junio de 2026',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/tarso/download/exterior/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/tarso/download/interior/render_interior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'zonas-comunes',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/tarso/download/zonas-comunes/render_zonas-comunes_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/via-celere/tarso/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/tarso/live/exterior/cam07.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/via-celere/tarso/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/tarso/live/exterior/cam07.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/via-celere/tarso/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/tarso/live/exterior/cam07.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 06',
                src: 'https://media.bizionar.digital/via-celere/tarso/live/exterior/cam06.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 07',
                src: 'https://media.bizionar.digital/via-celere/tarso/live/exterior/cam07.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 09',
                src: 'https://media.bizionar.digital/via-celere/tarso/live/exterior/cam09.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 18',
                src: 'https://media.bizionar.digital/via-celere/tarso/live/exterior/cam18.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 20',
                src: 'https://media.bizionar.digital/via-celere/tarso/live/exterior/cam20.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/via-celere/tarso/live/interior/still_Camera_001.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/via-celere/tarso/live/interior/still_Camera_002.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/via-celere/tarso/live/interior/still_Camera_003.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/via-celere/tarso/live/interior/still_Camera_004.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/via-celere/tarso/live/interior/still_Camera_005.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/via-celere/tarso/live/interior/still_Camera_006.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 3 - 01',
                src: 'https://media.bizionar.digital/via-celere/tarso/live/interior/still_Camera_007.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/via-celere/tarso/live/interior/still_Camera_008.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Sala Social 01',
                src: 'https://media.bizionar.digital/via-celere/tarso/live/zonas-comunes/still_Camera_001.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social 02',
                src: 'https://media.bizionar.digital/via-celere/tarso/live/zonas-comunes/still_Camera_002.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social 03',
                src: 'https://media.bizionar.digital/via-celere/tarso/live/zonas-comunes/still_Camera_003.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social 04',
                src: 'https://media.bizionar.digital/via-celere/tarso/live/zonas-comunes/still_Camera_004.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit 01',
                src: 'https://media.bizionar.digital/via-celere/tarso/live/zonas-comunes/still_Camera_005.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit 02',
                src: 'https://media.bizionar.digital/via-celere/tarso/live/zonas-comunes/still_Camera_006.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
            ],
          },
        },
        {
          id: 'baviera-golf-ii',
          name: 'Baviera Golf Fase II',
          city: 'Vélez-Málaga',
          province: 'Málaga',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/show/index.html',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/via-celere/baviera-golf-ii',
          image: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review03/render/exterior/cam04.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '3 de junio de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '14 de octubre de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '3 de noviembre de 2026',
                  status: 'pending',
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '3 de junio de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '30 de junio de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '30 de julio de 2025',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '25 de agosto de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review01/render/exterior/cam04.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review01/render/exterior/cam04.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review01/render/exterior/cam11.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review01/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review01/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review01/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review01/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Aérea 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review01/render/exterior/punto4.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review01/render/interior/still_SALON.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review01/render/interior/still_TERRAZA.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review01/render/interior/still_COCINA.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review01/render/interior/still_SUITE.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review01/render/interior/still_SERV_PPL.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review01/render/interior/still_HAB2.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review01/render/interior/still_HAB3.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review01/render/interior/still_SERV_COMUN.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review05/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review02/render/exterior/cam04.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review01/render/exterior/cam04.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review02/render/exterior/cam11.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Video Completo',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review02/video/video_completo.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review02/render/exterior/cam04.jpg',
                  type: 'video',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review02/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review02/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review02/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review02/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Aérea 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review02/render/exterior/punto4.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review02/render/interior/still_SALON.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review02/render/interior/still_TERRAZA.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review02/render/interior/still_COCINA.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review02/render/interior/still_SUITE.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review02/render/interior/still_SERV_PPL.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review02/render/interior/still_HAB2.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review02/render/interior/still_HAB3.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review02/render/interior/still_SERV_COMUN.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review06/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review03/render/exterior/cam04.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review01/render/exterior/cam04.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review03/render/exterior/cam11.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review03/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review03/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review03/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review03/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Aérea 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review03/render/exterior/punto4.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review03/render/interior/still_SALON.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review03/render/interior/still_TERRAZA.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review03/render/interior/still_COCINA.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review03/render/interior/still_SUITE.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review03/render/interior/still_SERV_PPL.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review03/render/interior/still_HAB2.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review03/render/interior/still_HAB3.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review03/render/interior/still_SERV_COMUN.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review01/render/exterior/cam04.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review04/render/interior/still_SALON.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review04/render/interior/still_TERRAZA.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review04/render/interior/still_COCINA.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review04/render/interior/still_SUITE.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review04/render/interior/still_SERV_PPL.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review04/render/interior/still_HAB2.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 3 - 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review04/render/interior/still_HAB3.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/review04/render/interior/still_SERV_COMUN.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'PISO PILOTO',
              filter: 'interiores',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '17 de octubre de 2025',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/download/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/download/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/live/cam04.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/live/cam04.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/live/cam11.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/live/cam04.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Completo',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/live/video_completo.mp4',
                thumb: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/live/cam04.jpg',
                type: 'video',
                category: 'interiores',
              },
              {
                name: 'Render Exterior 04',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/live/cam04.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 06',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/live/cam06.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 10',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/live/cam10.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 11',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/live/cam11.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Aérea 01',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/live/punto4.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/live/still_SALON.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/live/still_TERRAZA.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/live/still_COCINA.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/live/still_SUITE.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/live/still_SERV_PPL.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/live/still_HAB2.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 3 - 01',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/live/still_HAB3.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-ii/live/still_SERV_COMUN.jpg',
                type: 'render',
                category: 'interiores',
              },
            ],
          },
        },
        {
          id: 'san-vicente',
          name: 'San Vicente',
          city: 'Valencia',
          province: 'Valencia',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://media.bizionar.digital/via-celere/san-vicente/show/index.html',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/via-celere/san-vicente',
          image: 'https://media.bizionar.digital/via-celere/san-vicente/live/exterior/cam02.jpg',
          deliveries: [
            {
              categoryId: 'zonas-comunes',
              categoryName: 'ZONAS COMUNES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '6 de julio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '24 de julio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '27 de agosto de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '14 de agosto de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '17 de octubre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '21 de octubre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '24 de octubre de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '2 de diciembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '26 de enero de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '10 de febrero de 2026',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '13 de febrero de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente/review01/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente/review01/render/exterior/cam01.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review01/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente/review01/render/interior/still_Camera_002.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review01/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review01/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review01/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review01/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review01/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review01/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review01/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review01/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review01/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review01/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review01/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review01/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review01/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review01/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review01/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review01/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review01/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review01/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza IA - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review01/render/zonas-comunes/still_Camera_004_ai.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review01/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review01/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 03',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review01/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review01/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review01/render/zonas-comunes/still_Camera_009.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente/review02/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente/review02/render/exterior/cam01.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review02/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente/review02/render/interior/still_Camera_002.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review02/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review02/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review02/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review02/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review02/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review02/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review02/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review02/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review02/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review02/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review02/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review02/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review02/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review02/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review02/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review02/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review02/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review02/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza IA - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review02/render/zonas-comunes/still_Camera_004_ai.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review02/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review02/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 03',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review02/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review02/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review02/render/zonas-comunes/still_Camera_009.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente/review03/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente/review03/render/exterior/cam01.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review03/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente/review03/render/interior/still_Camera_002.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review03/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review03/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review03/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review03/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review03/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review03/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review03/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review03/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review03/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review03/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review03/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review03/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review03/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review03/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review03/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review03/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review03/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review03/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza IA - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review03/render/zonas-comunes/still_Camera_004_ai.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review03/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review03/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 03',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review03/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review03/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review03/render/zonas-comunes/still_Camera_009.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente/review04/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review04/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente/review04/render/exterior/cam01.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review04/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente/review04/render/interior/still_Camera_002.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review04/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review04/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review04/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review04/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review04/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review04/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review04/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review04/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review04/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review04/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review04/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review04/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review04/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente/review04/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
            {
              title: 'ZONAS COMUNES',
              filter: 'zonas-comunes',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '28 de agosto de 2026',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/san-vicente/download/exterior/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/san-vicente/download/interior/render_interior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'zonas-comunes',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/san-vicente/download/zonas-comunes/render_zonas-comunes_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/via-celere/san-vicente/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/san-vicente/live/exterior/cam02.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/via-celere/san-vicente/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/san-vicente/live/exterior/cam01.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/via-celere/san-vicente/live/exterior/cam02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 04',
                src: 'https://media.bizionar.digital/via-celere/san-vicente/live/exterior/cam04.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 09',
                src: 'https://media.bizionar.digital/via-celere/san-vicente/live/exterior/cam09.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente/live/exterior/cam01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 06',
                src: 'https://media.bizionar.digital/via-celere/san-vicente/live/exterior/cam06.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/via-celere/san-vicente/live/interior/still_Camera_002.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente/live/interior/still_Camera_001.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente/live/interior/still_Camera_003.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente/live/interior/still_Camera_004.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente/live/interior/still_Camera_005.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente/live/interior/still_Camera_006.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente/live/interior/still_Camera_007.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente/live/interior/still_Camera_008.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente/live/interior/still_Camera_009.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Sala Social - 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente/live/zonas-comunes/still_Camera_001.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 02',
                src: 'https://media.bizionar.digital/via-celere/san-vicente/live/zonas-comunes/still_Camera_002.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 03',
                src: 'https://media.bizionar.digital/via-celere/san-vicente/live/zonas-comunes/still_Camera_003.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social Terraza - 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente/live/zonas-comunes/still_Camera_004.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social Terraza IA - 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente/live/zonas-comunes/still_Camera_004_ai.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Coworking - 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente/live/zonas-comunes/still_Camera_005.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Coworking - 02',
                src: 'https://media.bizionar.digital/via-celere/san-vicente/live/zonas-comunes/still_Camera_006.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Coworking - 03',
                src: 'https://media.bizionar.digital/via-celere/san-vicente/live/zonas-comunes/still_Camera_007.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit - 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente/live/zonas-comunes/still_Camera_008.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit - 02',
                src: 'https://media.bizionar.digital/via-celere/san-vicente/live/zonas-comunes/still_Camera_009.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
            ],
          },
        },
        {
          id: 'san-vicente-ii',
          name: 'San Vicente II',
          city: 'Valencia',
          province: 'Valencia',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://media.bizionar.digital/via-celere/san-vicente-ii/show/index.html',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/via-celere/san-vicente-ii',
          image: 'https://media.bizionar.digital/via-celere/san-vicente-ii/live/exterior/cam03.jpg',
          deliveries: [
            {
              categoryId: 'zonas-comunes',
              categoryName: 'ZONAS COMUNES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '7 de julio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '24 de julio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '27 de agosto de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '14 de agosto de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '15 de octubre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '22 de octubre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '24 de octubre de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 4,
              totalReviews: 4,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '16 de diciembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '28 de enero de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '11 de febrero de 2026',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '16 de febrero de 2026',
                  status: 'closed',
                },
                {
                  id: 'review05',
                  name: 'ENTREGA 5',
                  date: '2 de marzo de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review01/render/exterior/cam03.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review01/render/exterior/cam01.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review01/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review01/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review01/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review01/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review01/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review01/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review01/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review01/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review01/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review01/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review01/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review01/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review01/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review01/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review01/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review01/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review01/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 04',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review01/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review01/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review01/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 03',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review01/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review01/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review01/render/zonas-comunes/still_Camera_009.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review02/render/exterior/cam03.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review02/render/exterior/cam01.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review02/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review02/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review02/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review02/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review02/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review02/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review02/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review02/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review02/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review02/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review02/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review02/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review02/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review02/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review02/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review02/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review02/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 04',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review02/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review02/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review02/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 03',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review02/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review02/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review02/render/zonas-comunes/still_Camera_009.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review03/render/exterior/cam03.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review03/render/exterior/cam01.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review03/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review03/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review03/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review03/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review03/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review03/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review03/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review03/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review03/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review03/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review03/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review03/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review03/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review03/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review03/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review03/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review03/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 04',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review03/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review03/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review03/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 03',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review03/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review03/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review03/render/zonas-comunes/still_Camera_009.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review04/render/exterior/cam03.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review04/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review04/render/exterior/cam01.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review04/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review04/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review04/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review04/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review04/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review04/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review04/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review04/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review04/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review04/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review04/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review04/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review04/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review04/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review05',
              content: [
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review04/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review05/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review05/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review05/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review05/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review05/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review05/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review05/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review05/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/review05/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
            {
              title: 'ZONAS COMUNES',
              filter: 'zonas-comunes',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '10 de septiembre de 2026',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/san-vicente-ii/download/exterior/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/san-vicente-ii/download/interior/render_interior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'zonas-comunes',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/san-vicente-ii/download/zonas-comunes/render_zonas-comunes_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/san-vicente-ii/live/exterior/cam03.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/san-vicente-ii/live/exterior/cam01.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/live/exterior/cam03.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 05',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/live/exterior/cam05.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 09',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/live/exterior/cam09.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/live/exterior/cam01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/live/interior/still_Camera_001.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/live/interior/still_Camera_002.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/live/interior/still_Camera_003.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/live/interior/still_Camera_004.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/live/interior/still_Camera_005.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/live/interior/still_Camera_006.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/live/interior/still_Camera_007.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/live/interior/still_Camera_008.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Sala Social - 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/live/zonas-comunes/still_Camera_001.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 02',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/live/zonas-comunes/still_Camera_002.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 03',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/live/zonas-comunes/still_Camera_003.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 04',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/live/zonas-comunes/still_Camera_004.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Coworking - 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/live/zonas-comunes/still_Camera_005.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Coworking - 02',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/live/zonas-comunes/still_Camera_006.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Coworking - 03',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/live/zonas-comunes/still_Camera_007.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit - 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/live/zonas-comunes/still_Camera_008.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit - 02',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-ii/live/zonas-comunes/still_Camera_009.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
            ],
          },
        },
        {
          id: 'san-vicente-iii',
          name: 'San Vicente III',
          city: 'Valencia',
          province: 'Valencia',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://media.bizionar.digital/via-celere/san-vicente-iii/show/index.html',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/via-celere/san-vicente-iii',
          image: 'https://media.bizionar.digital/via-celere/san-vicente-iii/live/exterior/cam01.jpg',
          deliveries: [
            {
              categoryId: 'zonas-comunes',
              categoryName: 'ZONAS COMUNES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '9 de julio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '24 de julio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '27 de agosto de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '16 de septiembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '10 de octubre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '13 de octubre de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '20 de mayo de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '26 de mayo de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '8 de junio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '15 de junio de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review01/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review01/render/exterior/cam04.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review01/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review01/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review01/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review01/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review01/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review01/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review01/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review01/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review01/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review01/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review01/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review01/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review01/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review01/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                 {
                  name: 'Render Sala Coworking - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review01/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review01/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 03',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review01/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review01/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review01/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 03',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review01/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review02/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review02/render/exterior/cam04.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review02/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review02/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review02/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review02/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review02/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review02/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review02/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review02/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review02/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review02/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review02/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review02/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review02/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review02/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Coworking - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review02/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review02/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 03',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review02/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review02/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review02/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 03',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review02/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review03/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review03/render/exterior/cam04.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review03/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review03/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review03/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review03/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review03/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review03/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review03/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review03/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review03/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review03/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review03/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review03/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review03/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review03/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Coworking - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review03/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review03/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 03',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review03/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review03/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review03/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 03',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review03/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review04/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review04/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review04/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review04/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review04/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review04/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review04/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review04/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review04/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review04/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/review04/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
            {
              title: 'ZONAS COMUNES',
              filter: 'zonas-comunes',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '28 de agosto de 2026',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/san-vicente-iii/download/exterior/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/san-vicente-iii/download/interior/render_interior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'zonas-comunes',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/san-vicente-iii/download/zonas-comunes/render_zonas-comunes_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/san-vicente-iii/live/exterior/cam01.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/san-vicente-iii/live/exterior/cam01.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/san-vicente-iii/live/exterior/cam04.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/live/exterior/cam01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/live/exterior/cam02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 04',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/live/exterior/cam04.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/live/interior/still_Camera_001.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/live/interior/still_Camera_002.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/live/interior/still_Camera_003.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/live/interior/still_Camera_004.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/live/interior/still_Camera_005.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/live/interior/still_Camera_006.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/live/interior/still_Camera_007.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/live/interior/still_Camera_008.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/live/interior/still_Camera_009.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Sala Coworking - 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/live/zonas-comunes/still_Camera_001.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Coworking - 02',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/live/zonas-comunes/still_Camera_002.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Coworking - 03',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/live/zonas-comunes/still_Camera_003.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit - 01',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/live/zonas-comunes/still_Camera_004.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit - 02',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/live/zonas-comunes/still_Camera_005.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit - 03',
                src: 'https://media.bizionar.digital/via-celere/san-vicente-iii/live/zonas-comunes/still_Camera_006.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
            ],
          },
        },
        {
          id: 'neo',
          name: 'Neo',
          city: 'Valladolid',
          province: 'Valladolid',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://media.bizionar.digital/via-celere/neo/show/index.html',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/via-celere/neo',
          image: 'https://media.bizionar.digital/via-celere/neo/live/exterior/cam07.jpg',
          deliveries: [
            {
              categoryId: 'zonas-comunes',
              categoryName: 'ZONAS COMUNES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '21 de julio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '31 de julio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '27 de agosto de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '10 de octubre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '6 de noviembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '24 de noviembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '25 de noviembre de 2025',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 4,
              totalReviews: 4,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '10 de octubre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '29 de abril de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '20 de mayo de 2026',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '26 de mayo de 2026',
                  status: 'closed',
                },
                {
                  id: 'review05',
                  name: 'ENTREGA 5',
                  date: '28 de mayo de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/neo/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/neo/review01/render/exterior/cam07.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/neo/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/neo/review01/render/exterior/cam25.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/neo/review01/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/neo/review01/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/via-celere/neo/review01/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 25',
                  src: 'https://media.bizionar.digital/via-celere/neo/review01/render/exterior/cam25.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 23',
                  src: 'https://media.bizionar.digital/via-celere/neo/review01/render/exterior/cam23.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 22',
                  src: 'https://media.bizionar.digital/via-celere/neo/review01/render/exterior/cam22.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 20',
                  src: 'https://media.bizionar.digital/via-celere/neo/review01/render/exterior/cam20.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review01/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/neo/review01/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review01/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review01/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review01/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review01/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review01/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review01/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review01/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review01/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/neo/review01/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/neo/review01/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 04',
                  src: 'https://media.bizionar.digital/via-celere/neo/review01/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review01/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 02',
                  src: 'https://media.bizionar.digital/via-celere/neo/review01/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 03',
                  src: 'https://media.bizionar.digital/via-celere/neo/review01/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review01/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/neo/review01/render/zonas-comunes/still_Camera_009.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/neo/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/neo/review02/render/exterior/cam07.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/neo/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/neo/review02/render/exterior/cam25.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/neo/review02/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/neo/review02/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/via-celere/neo/review02/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 25',
                  src: 'https://media.bizionar.digital/via-celere/neo/review02/render/exterior/cam25.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 23',
                  src: 'https://media.bizionar.digital/via-celere/neo/review02/render/exterior/cam23.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 22',
                  src: 'https://media.bizionar.digital/via-celere/neo/review02/render/exterior/cam22.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 20',
                  src: 'https://media.bizionar.digital/via-celere/neo/review02/render/exterior/cam20.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review02/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/neo/review02/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review02/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review02/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review02/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review02/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review02/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review02/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review02/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review02/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/neo/review02/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/neo/review02/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 04',
                  src: 'https://media.bizionar.digital/via-celere/neo/review02/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review02/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 02',
                  src: 'https://media.bizionar.digital/via-celere/neo/review02/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 03',
                  src: 'https://media.bizionar.digital/via-celere/neo/review02/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review02/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/neo/review02/render/zonas-comunes/still_Camera_009.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/neo/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/neo/review03/render/exterior/cam07.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/neo/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/neo/review03/render/exterior/cam25.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/neo/review03/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/neo/review03/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/via-celere/neo/review03/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 25',
                  src: 'https://media.bizionar.digital/via-celere/neo/review03/render/exterior/cam25.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 23',
                  src: 'https://media.bizionar.digital/via-celere/neo/review03/render/exterior/cam23.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 22',
                  src: 'https://media.bizionar.digital/via-celere/neo/review03/render/exterior/cam22.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 20',
                  src: 'https://media.bizionar.digital/via-celere/neo/review03/render/exterior/cam20.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review03/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/neo/review03/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review03/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review03/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review03/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review03/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review03/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review03/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review03/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review03/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/neo/review03/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/neo/review03/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 04',
                  src: 'https://media.bizionar.digital/via-celere/neo/review03/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review03/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 02',
                  src: 'https://media.bizionar.digital/via-celere/neo/review03/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 03',
                  src: 'https://media.bizionar.digital/via-celere/neo/review03/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review03/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/neo/review03/render/zonas-comunes/still_Camera_009.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Render Exterior 25',
                  src: 'https://media.bizionar.digital/via-celere/neo/review04/render/exterior/cam25.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/neo/review04/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/neo/review03/render/exterior/cam25.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/neo/review04/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/neo/review04/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review04/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/neo/review04/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review04/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review04/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review04/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review04/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review04/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review04/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review04/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review05',
              content: [
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/neo/review05/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/neo/review05/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review05/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/neo/review05/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review05/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review05/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review05/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review05/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review05/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review05/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/neo/review05/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
            {
              title: 'ZONAS COMUNES',
              filter: 'zonas-comunes',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '2 de septiembre de 2026',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/neo/download/exterior/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/neo/download/interior/render_interior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'zonas-comunes',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/neo/download/zonas-comunes/render_zonas-comunes_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/via-celere/neo/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/neo/live/exterior/cam07.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/via-celere/neo/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/neo/live/exterior/cam25.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 07',
                src: 'https://media.bizionar.digital/via-celere/neo/live/exterior/cam07.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 25',
                src: 'https://media.bizionar.digital/via-celere/neo/live/exterior/cam25.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 23',
                src: 'https://media.bizionar.digital/via-celere/neo/live/exterior/cam23.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 22',
                src: 'https://media.bizionar.digital/via-celere/neo/live/exterior/cam22.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 20',
                src: 'https://media.bizionar.digital/via-celere/neo/live/exterior/cam20.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/via-celere/neo/live/interior/still_Camera_001.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/via-celere/neo/live/interior/still_Camera_002.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/via-celere/neo/live/interior/still_Camera_003.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/via-celere/neo/live/interior/still_Camera_004.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/via-celere/neo/live/interior/still_Camera_005.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/via-celere/neo/live/interior/still_Camera_006.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/via-celere/neo/live/interior/still_Camera_007.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/via-celere/neo/live/interior/still_Camera_008.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/via-celere/neo/live/interior/still_Camera_009.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Sala Social - 01',
                src: 'https://media.bizionar.digital/via-celere/neo/live/zonas-comunes/still_Camera_001.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 02',
                src: 'https://media.bizionar.digital/via-celere/neo/live/zonas-comunes/still_Camera_002.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 03',
                src: 'https://media.bizionar.digital/via-celere/neo/live/zonas-comunes/still_Camera_003.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 04',
                src: 'https://media.bizionar.digital/via-celere/neo/live/zonas-comunes/still_Camera_004.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Coworking - 01',
                src: 'https://media.bizionar.digital/via-celere/neo/live/zonas-comunes/still_Camera_005.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Coworking - 02',
                src: 'https://media.bizionar.digital/via-celere/neo/live/zonas-comunes/still_Camera_006.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Coworking - 03',
                src: 'https://media.bizionar.digital/via-celere/neo/live/zonas-comunes/still_Camera_007.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit - 01',
                src: 'https://media.bizionar.digital/via-celere/neo/live/zonas-comunes/still_Camera_008.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit - 02',
                src: 'https://media.bizionar.digital/via-celere/neo/live/zonas-comunes/still_Camera_009.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
            ],
          },
        },
        {
          id: 'baviera-golf-iii',
          name: 'Baviera Golf Fase III',
          city: 'Vélez-Málaga',
          province: 'Málaga',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/show/index.html',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/via-celere/baviera-golf-iii',
          image: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/exterior/cam21.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '20 de enero de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '24 de febrero de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '10 de agosto de 2026',
                  status: 'pending',
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 4,
              totalReviews: 4,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '13 de mayo de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '26 de mayo de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '16 de junio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '18 de junio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review05',
                  name: 'ENTREGA 5',
                  date: '2 de septiembre de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'zonas-comunes',
              categoryName: 'ZONAS COMUNES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '22 de junio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '1 de julio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '15 de julio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '17 de julio de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review01/render/exterior/cam21.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review01/render/exterior/cam15.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review01/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review01/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 21',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review01/render/exterior/cam21.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review01/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review01/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review01/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review01/render/exterior/cam15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 20',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review01/render/exterior/cam20.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review01/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review01/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review01/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review01/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review01/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review01/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review01/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review01/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review01/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review01/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review01/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 04',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review01/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review01/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 02',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review01/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review01/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review01/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 03',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review01/render/zonas-comunes/still_Camera_009.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/render/exterior/cam21.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/render/exterior/cam15.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 21',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/render/exterior/cam21.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/render/exterior/cam15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 20',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/render/exterior/cam20.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 04',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 01 IA',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/render/zonas-comunes/still_Camera_005_ai.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 02',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 02 IA',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/render/zonas-comunes/still_Camera_006_ai.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01 IA',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/render/zonas-comunes/still_Camera_007_ai.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02 IA',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/render/zonas-comunes/still_Camera_008_ai.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 03',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/render/zonas-comunes/still_Camera_009.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 03 IA',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review02/render/zonas-comunes/still_Camera_009_ai.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/exterior/cam21.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/exterior/cam15.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 21',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/exterior/cam21.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/exterior/cam15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 20',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/exterior/cam20.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 04',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 04 IA',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/zonas-comunes/still_Camera_004_ai.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 01 IA',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/zonas-comunes/still_Camera_005_ai.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 02',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 02 IA',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/zonas-comunes/still_Camera_006_ai.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 03',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/zonas-comunes/still_Camera_009.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit Exterior - 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/zonas-comunes/still_Camera_010.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit Exterior - 01 IA',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/zonas-comunes/still_Camera_010_ai.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit Exterior - 02',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/zonas-comunes/still_Camera_011.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit Exterior - 02 IA',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/zonas-comunes/still_Camera_011_ai.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit Exterior - 03',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/zonas-comunes/still_Camera_012.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit Exterior - 03 IA',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review03/render/zonas-comunes/still_Camera_012_ai.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review04/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review04/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review04/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review04/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review04/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review04/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review04/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review04/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review04/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review04/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review04/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review04/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review04/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 04',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review04/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 04 IA',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review04/render/zonas-comunes/still_Camera_004_ai.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review04/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 01 IA',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review04/render/zonas-comunes/still_Camera_005_ai.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 02',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review04/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 02 IA',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review04/render/zonas-comunes/still_Camera_006_ai.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review04/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review04/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 03',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review04/render/zonas-comunes/still_Camera_009.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit Exterior - 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review04/render/zonas-comunes/still_Camera_010.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit Exterior - 01 IA',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review04/render/zonas-comunes/still_Camera_010_ai.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit Exterior - 02',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review04/render/zonas-comunes/still_Camera_011.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit Exterior - 02 IA',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review04/render/zonas-comunes/still_Camera_011_ai.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit Exterior - 03',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review04/render/zonas-comunes/still_Camera_012.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit Exterior - 03 IA',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review04/render/zonas-comunes/still_Camera_012_ai.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review05',
              content: [
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review05/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review05/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review05/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review05/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review05/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review05/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review05/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review05/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review05/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/review05/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
           liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
             {
               title: 'INTERIORES',
               filter: 'interiores',
               active: false,
             },
             {
               title: 'ZONAS COMUNES',
               filter: 'zonas-comunes',
               active: false,
             },
          ],
          live: {
            id: 'live',
            lastUpdate: '2 de septiembre de 2026',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/download/exterior/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/download/interior/render_interior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'zonas-comunes',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/download/zonas-comunes/render_zonas-comunes_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/exterior/cam21.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/exterior/cam21.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/exterior/cam15.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 21',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/exterior/cam21.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/exterior/cam03.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 09',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/exterior/cam09.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 12',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/exterior/cam12.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 15',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/exterior/cam15.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 20',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/exterior/cam20.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/interior/still_Camera_001.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/interior/still_Camera_002.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/interior/still_Camera_003.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/interior/still_Camera_004.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/interior/still_Camera_005.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/interior/still_Camera_006.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/interior/still_Camera_007.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/interior/still_Camera_008.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Sala Social - 01',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/zonas-comunes/still_Camera_001.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 02',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/zonas-comunes/still_Camera_002.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 03',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/zonas-comunes/still_Camera_003.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 04',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/zonas-comunes/still_Camera_004.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 04 IA',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/zonas-comunes/still_Camera_004_ai.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social Terraza - 01',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/zonas-comunes/still_Camera_005.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social Terraza - 01 IA',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/zonas-comunes/still_Camera_005_ai.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social Terraza - 02',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/zonas-comunes/still_Camera_006.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social Terraza - 02 IA',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/zonas-comunes/still_Camera_006_ai.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit - 01',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/zonas-comunes/still_Camera_007.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit - 02',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/zonas-comunes/still_Camera_008.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit - 03',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/zonas-comunes/still_Camera_009.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit Exterior - 01',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/zonas-comunes/still_Camera_010.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit Exterior - 01 IA',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/zonas-comunes/still_Camera_010_ai.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit Exterior - 02',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/zonas-comunes/still_Camera_011.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit Exterior - 02 IA',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/zonas-comunes/still_Camera_011_ai.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit Exterior - 03',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/zonas-comunes/still_Camera_012.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit Exterior - 03 IA',
                src: 'https://media.bizionar.digital/via-celere/baviera-golf-iii/live/zonas-comunes/still_Camera_012_ai.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
            ],
          },
        },
        {
          id: 'vission-hills-r1',
          name: 'Vission Hills I',
          city: 'Mijas',
          province: 'Málaga',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://media.bizionar.digital/via-celere/vission-hills-r1/show/index.html',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/via-celere/vission-hills-r1',
          image: 'https://media.bizionar.digital/via-celere/vission-hills-r1/live/exterior/cam01.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '3 de noviembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '25 de noviembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '19 de diciembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '17 de septiembre de 2026',
                  status: 'closed',
                  isFinal:  true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '27 de octubre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '25 de noviembre de 2025',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '1 de abril de 2026',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '22 de abril de 2026',
                  status: 'closed',
                },
                {
                  id: 'review05',
                  name: 'ENTREGA 5',
                  date: '28 de abril de 2026',
                  status: 'pending',
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review01/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review01/render/exterior/cam03.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review01/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review01/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review01/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review01/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review01/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review01/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review01/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review01/render/exterior/cam13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review01/render/exterior/cam14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review01/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review01/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review01/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review01/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review01/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review01/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review01/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review01/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review02/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review02/render/exterior/cam03.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review02/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review02/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review02/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review02/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review02/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review02/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review02/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review02/render/exterior/cam13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review02/render/exterior/cam14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review02/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review02/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review02/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review02/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review02/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review02/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review02/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review02/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review03/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review03/render/exterior/cam03.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review03/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review03/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review03/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review03/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review03/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review03/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review03/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review03/render/exterior/cam13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review03/render/exterior/cam14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review03/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review03/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review03/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review03/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review03/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review03/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review03/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review03/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review04/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review04/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review04/render/exterior/cam03.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review04/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review04/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review04/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review04/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review04/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review04/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review04/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 13',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review04/render/exterior/cam13.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 14',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review04/render/exterior/cam14.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review04/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review04/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review04/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review04/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review04/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review04/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review04/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review04/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
            {
              id: 'review05',
              content: [
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review05/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review05/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review05/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review05/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review05/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review05/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review05/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review05/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review05/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/review05/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '18 de septiembre de 2026',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/vission-hills-r1/download/exterior/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/vission-hills-r1/download/interior/render_interior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/vission-hills-r1/live/exterior/cam01.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/vission-hills-r1/live/exterior/cam03.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/live/exterior/cam01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/live/exterior/cam03.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 04',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/live/exterior/cam04.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 05',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/live/exterior/cam05.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 11',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/live/exterior/cam11.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 13',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/live/exterior/cam13.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 14',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r1/live/exterior/cam14.jpg',
                type: 'render',
                category: 'exteriores',
              },
            ],
          },
        },
        {
          id: 'jara',
          name: 'Jara',
          city: 'Dos Hermanas',
          province: 'Sevilla',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://media.bizionar.digital/via-celere/jara/show/index.html',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/via-celere/jara',
          image: 'https://media.bizionar.digital/via-celere/jara/live/exterior/cam_006.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '12 de enero de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '2 de febrero de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '27 de marzo de 2026',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '13 de abril de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '17 de abril de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '15 de mayo de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '24 de julio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '28 de julio de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'zonas-comunes',
              categoryName: 'ZONAS COMUNES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '27 de agosto de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '2 de septiembre de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '15 de septiembre de 2026',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '16 de septiembre de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/jara/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/jara/review01/render/exterior/cam_002.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/jara/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/jara/review01/render/exterior/cam_006.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/jara/review01/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/jara/review01/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/jara/review01/render/exterior/cam_002.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review01/render/exterior/cam_001.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/via-celere/jara/review01/render/exterior/cam_003.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/via-celere/jara/review01/render/exterior/cam_004.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/via-celere/jara/review01/render/exterior/cam_005.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/jara/review01/render/exterior/cam_006.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/via-celere/jara/review01/render/exterior/cam_007.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/via-celere/jara/review01/render/exterior/cam_008.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review01/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/jara/review01/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review01/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review01/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review01/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review01/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review01/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review01/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review01/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review01/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/jara/review01/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Infantil - 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review01/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review01/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review01/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review01/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 01 IA',
                  src: 'https://media.bizionar.digital/via-celere/jara/review01/render/zonas-comunes/still_Camera_006_ai.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/jara/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/jara/review02/render/exterior/cam_002.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/jara/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/jara/review02/render/exterior/cam_006.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/jara/review02/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/jara/review02/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/jara/review02/render/exterior/cam_002.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review02/render/exterior/cam_001.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/via-celere/jara/review02/render/exterior/cam_003.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/via-celere/jara/review02/render/exterior/cam_004.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/via-celere/jara/review02/render/exterior/cam_005.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/jara/review02/render/exterior/cam_006.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/via-celere/jara/review02/render/exterior/cam_007.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/via-celere/jara/review02/render/exterior/cam_008.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review02/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/jara/review02/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review02/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review02/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review02/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review02/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review02/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review02/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review02/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review02/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/jara/review02/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Infantil - 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review02/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review02/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review02/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review02/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 01 IA',
                  src: 'https://media.bizionar.digital/via-celere/jara/review02/render/zonas-comunes/still_Camera_006_ai.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/jara/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/jara/review03/render/exterior/cam_002.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/jara/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/jara/review03/render/exterior/cam_006.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/jara/review03/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/jara/review03/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/jara/review03/render/exterior/cam_002.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review03/render/exterior/cam_001.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/via-celere/jara/review03/render/exterior/cam_003.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/via-celere/jara/review03/render/exterior/cam_004.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/via-celere/jara/review03/render/exterior/cam_005.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/jara/review03/render/exterior/cam_006.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/via-celere/jara/review03/render/exterior/cam_007.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/via-celere/jara/review03/render/exterior/cam_008.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review03/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/jara/review03/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review03/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review03/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review03/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review03/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review03/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review03/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review03/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review03/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/jara/review03/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/jara/review03/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Infantil - 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review03/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Infantil - 02',
                  src: 'https://media.bizionar.digital/via-celere/jara/review03/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review03/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/jara/review03/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review03/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 02',
                  src: 'https://media.bizionar.digital/via-celere/jara/review03/render/zonas-comunes/still_Camera_009.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review03/render/zonas-comunes/still_Camera_010.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 01 IA',
                  src: 'https://media.bizionar.digital/via-celere/jara/review03/render/zonas-comunes/still_Camera_010_ia.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ]
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/jara/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/jara/review04/render/exterior/cam_002.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/jara/review04/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/jara/review04/render/exterior/cam_006.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/jara/review04/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/jara/review04/render/interior/still_Camera_001.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/jara/review04/render/exterior/cam_002.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review04/render/exterior/cam_001.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/via-celere/jara/review04/render/exterior/cam_003.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/via-celere/jara/review04/render/exterior/cam_004.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/via-celere/jara/review04/render/exterior/cam_005.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/jara/review04/render/exterior/cam_006.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/via-celere/jara/review04/render/exterior/cam_007.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/via-celere/jara/review04/render/exterior/cam_008.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review04/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/via-celere/jara/review04/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review04/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review04/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review04/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review04/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review04/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review04/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Común 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review04/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review04/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/jara/review04/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Infantil - 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review04/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Infantil - 02',
                  src: 'https://media.bizionar.digital/via-celere/jara/review04/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review04/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/jara/review04/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review04/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 02',
                  src: 'https://media.bizionar.digital/via-celere/jara/review04/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 01',
                  src: 'https://media.bizionar.digital/via-celere/jara/review04/render/zonas-comunes/still_Camera_009.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 01 IA',
                  src: 'https://media.bizionar.digital/via-celere/jara/review04/render/zonas-comunes/still_Camera_009_ia.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'INTERIORES',
              filter: 'interiores',
              active: false,
            },
            {
              title: 'ZONAS COMUNES',
              filter: 'zonas-comunes',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '18 de septiembre de 2026',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/jara/download/exterior/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/jara/download/interior/render_interior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'zonas-comunes',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/jara/download/zonas-comunes/render_zonas-comunes_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/via-celere/jara/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/jara/live/exterior/cam_002.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/via-celere/jara/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/jara/live/exterior/cam_002.jpg',
                type: 'panoramic',
                category: 'interiores',
              },
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/via-celere/jara/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/jara/live/exterior/cam_006.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/via-celere/jara/live/exterior/cam_002.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/via-celere/jara/live/exterior/cam_001.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/via-celere/jara/live/exterior/cam_003.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 04',
                src: 'https://media.bizionar.digital/via-celere/jara/live/exterior/cam_004.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 05',
                src: 'https://media.bizionar.digital/via-celere/jara/live/exterior/cam_005.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 06',
                src: 'https://media.bizionar.digital/via-celere/jara/live/exterior/cam_006.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 07',
                src: 'https://media.bizionar.digital/via-celere/jara/live/exterior/cam_007.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 08',
                src: 'https://media.bizionar.digital/via-celere/jara/live/exterior/cam_008.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Salón 01',
                src: 'https://media.bizionar.digital/via-celere/jara/live/interior/still_Camera_001.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Salón 02',
                src: 'https://media.bizionar.digital/via-celere/jara/live/interior/still_Camera_002.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Terraza 01',
                src: 'https://media.bizionar.digital/via-celere/jara/live/interior/still_Camera_003.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Cocina 01',
                src: 'https://media.bizionar.digital/via-celere/jara/live/interior/still_Camera_004.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación Suite 01',
                src: 'https://media.bizionar.digital/via-celere/jara/live/interior/still_Camera_005.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Suite 01',
                src: 'https://media.bizionar.digital/via-celere/jara/live/interior/still_Camera_006.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 1 - 01',
                src: 'https://media.bizionar.digital/via-celere/jara/live/interior/still_Camera_007.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Habitación 2 - 01',
                src: 'https://media.bizionar.digital/via-celere/jara/live/interior/still_Camera_008.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Baño Común 01',
                src: 'https://media.bizionar.digital/via-celere/jara/live/interior/still_Camera_009.jpg',
                type: 'render',
                category: 'interiores',
              },
              {
                name: 'Render Sala Social - 01',
                src: 'https://media.bizionar.digital/via-celere/jara/live/zonas-comunes/still_Camera_001.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 02',
                src: 'https://media.bizionar.digital/via-celere/jara/live/zonas-comunes/still_Camera_002.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Infantil - 01',
                src: 'https://media.bizionar.digital/via-celere/jara/live/zonas-comunes/still_Camera_003.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Infantil - 02',
                src: 'https://media.bizionar.digital/via-celere/jara/live/zonas-comunes/still_Camera_004.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit - 01',
                src: 'https://media.bizionar.digital/via-celere/jara/live/zonas-comunes/still_Camera_005.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit - 02',
                src: 'https://media.bizionar.digital/via-celere/jara/live/zonas-comunes/still_Camera_006.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Coworking - 01',
                src: 'https://media.bizionar.digital/via-celere/jara/live/zonas-comunes/still_Camera_007.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Coworking - 02',
                src: 'https://media.bizionar.digital/via-celere/jara/live/zonas-comunes/still_Camera_008.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social Terraza - 01',
                src: 'https://media.bizionar.digital/via-celere/jara/live/zonas-comunes/still_Camera_009.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social Terraza - 01 IA',
                src: 'https://media.bizionar.digital/via-celere/jara/live/zonas-comunes/still_Camera_009_ia.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
            ],
          },
        },
        {
          id: 'vission-hills-r2c',
          name: 'Vission Hills II',
          city: 'Mijas',
          province: 'Málaga',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/show/index.html',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/via-celere/vission-hills-r2c',
          image: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/exterior/cam_09.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '11 de marzo de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '12 de junio de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '24 de septiembre de 2026',
                  status: 'pending',
                },
              ],
            },
            {
              categoryId: 'interiores',
              categoryName: 'INTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '28 de septiembre de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '14 de octubre de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '28 de octubre de 2026',
                  status: 'pending',
                },
              ],
            },
            {
              categoryId: 'zonas-comunes',
              categoryName: 'ZONAS COMUNES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '4 de mayo de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '8 de junio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '25 de junio de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/exterior/cam_05.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/exterior/cam_09.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/interior/still_Camera_007.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/tour-zzcc/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/zonas-comunes/still_Camera_016.jpg',
                  type: 'panoramic',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/exterior/cam_09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/exterior/cam_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/exterior/cam_10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/exterior/cam_15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 17',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/exterior/cam_17.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 23',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/exterior/cam_23.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salon/Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salon/Cocina 02',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salon/Cocina 03',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salon/Cocina 04',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Dormitorio 4 - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Jardin 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Jardin 02',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Dormitorio 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Servicio principal 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Dormitorio Principal Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Dormitorio 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Dormitorio 3 - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Servicio comun 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 02',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 03',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 02',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 03',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/zonas-comunes/still_Camera_009.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/zonas-comunes/still_Camera_010.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/zonas-comunes/still_Camera_011.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 03',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/zonas-comunes/still_Camera_012.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Spa - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/zonas-comunes/still_Camera_013.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Spa - 02',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/zonas-comunes/still_Camera_014.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Spa - 03',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/zonas-comunes/still_Camera_015.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Spa Terraza Exterior - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/zonas-comunes/still_Camera_016.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Spa Terraza Exterior - 02',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/zonas-comunes/still_Camera_017.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Spa Terraza Exterior - 03',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review01/render/zonas-comunes/still_Camera_018.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/exterior/cam_05.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/tour-zzcc/index.html?rand=123456789',
                  thumb: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/uploads/zzcc_exterior.jpg',
                  type: 'panoramic',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/exterior/cam_09.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/interior/still_Camera_007.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/exterior/cam_09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/exterior/cam_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/exterior/cam_10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/exterior/cam_15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 17',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/exterior/cam_17.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 23',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/exterior/cam_23.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salon/Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salon/Cocina 02',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salon/Cocina 03',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salon/Cocina 04',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Dormitorio 4 - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Jardin 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Jardin 02',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Dormitorio 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Servicio principal 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Dormitorio Principal Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Dormitorio 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Dormitorio 3 - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Servicio comun 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 02',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 03',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 02',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 03',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/zonas-comunes/still_Camera_009.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/zonas-comunes/still_Camera_010.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/zonas-comunes/still_Camera_011.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 03',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/zonas-comunes/still_Camera_012.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Spa - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/zonas-comunes/still_Camera_013.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Spa - 01 IA',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/zonas-comunes/still_Camera_013_AI.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Spa - 02',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/zonas-comunes/still_Camera_014.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Spa - 02 IA',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/zonas-comunes/still_Camera_014_AI.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Spa - 03',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/zonas-comunes/still_Camera_015.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Spa - 03 IA',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/zonas-comunes/still_Camera_015_AI.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Spa Terraza Exterior - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/zonas-comunes/still_Camera_016.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Spa Terraza Exterior - 01 IA',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/zonas-comunes/still_Camera_016_AI.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Spa Terraza Exterior - 02',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/zonas-comunes/still_Camera_017.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Spa Terraza Exterior - 02 IA',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/zonas-comunes/still_Camera_017_AI.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Spa Terraza Exterior - 03',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/zonas-comunes/still_Camera_018.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Spa Terraza Exterior - 03 IA',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review02/render/zonas-comunes/still_Camera_018_AI.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/exterior/cam_05.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/exterior/cam_09.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Tour Multipunto Interior',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/interior/still_Camera_007.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/exterior/cam_09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/exterior/cam_05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/exterior/cam_10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/exterior/cam_15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 17',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/exterior/cam_17.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 23',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/exterior/cam_23.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Salon/Cocina 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/interior/still_Camera_001.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salon/Cocina 02',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/interior/still_Camera_002.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salon/Cocina 03',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/interior/still_Camera_003.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salon/Cocina 04',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/interior/still_Camera_004.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Dormitorio 4 - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/interior/still_Camera_005.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Jardin 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/interior/still_Camera_006.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Jardin 02',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/interior/still_Camera_007.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Dormitorio 1 - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/interior/still_Camera_008.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Servicio principal 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/interior/still_Camera_009.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Dormitorio Principal Terraza 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/interior/still_Camera_010.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Dormitorio 2 - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/interior/still_Camera_011.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Dormitorio 3 - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/interior/still_Camera_012.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Servicio comun 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/interior/still_Camera_013.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/tour-zzcc/index.html?rand=123456789',
                  thumb: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/uploads/zzcc_exterior.jpg',
                  type: 'panoramic',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 02',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 03',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 02',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social Terraza - 03',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/zonas-comunes/still_Camera_009.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/zonas-comunes/still_Camera_010.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/zonas-comunes/still_Camera_011.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 03',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/zonas-comunes/still_Camera_012.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Spa - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/zonas-comunes/still_Camera_013.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Spa - 01 IA',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/zonas-comunes/still_Camera_013_AI.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Spa - 02',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/zonas-comunes/still_Camera_014.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Spa - 02 IA',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/zonas-comunes/still_Camera_014_AI.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Spa - 03',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/zonas-comunes/still_Camera_015.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Spa - 03 IA',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/zonas-comunes/still_Camera_015_AI.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Spa Terraza Exterior - 01',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/zonas-comunes/still_Camera_016.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Spa Terraza Exterior - 01 IA',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/zonas-comunes/still_Camera_016_AI.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Spa Terraza Exterior - 02',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/zonas-comunes/still_Camera_017.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Spa Terraza Exterior - 02 IA',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/zonas-comunes/still_Camera_017_AI.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Spa Terraza Exterior - 03',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/zonas-comunes/still_Camera_018.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Spa Terraza Exterior - 03 IA',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/review03/render/zonas-comunes/still_Camera_018_AI.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'ZONAS COMUNES',
              filter: 'zonas-comunes',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '24 de julio de 2026',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/download/exterior/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'interiores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/download/interior/render_interior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'zonas-comunes',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/download/zonas-comunes/render_zonas_comunes_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/exterior/cam_05.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/exterior/cam_09.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 09',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/exterior/cam_09.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 05',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/exterior/cam_05.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 10',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/exterior/cam_10.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 15',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/exterior/cam_15.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 17',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/exterior/cam_17.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 23',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/exterior/cam_23.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/tour-zzcc/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/uploads/zzcc_exterior.jpg',
                type: 'panoramic',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 01',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/zonas-comunes/still_Camera_001.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 02',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/zonas-comunes/still_Camera_002.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 03',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/zonas-comunes/still_Camera_003.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Coworking - 01',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/zonas-comunes/still_Camera_004.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Coworking - 02',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/zonas-comunes/still_Camera_005.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Coworking - 03',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/zonas-comunes/still_Camera_006.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social Terraza - 01',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/zonas-comunes/still_Camera_007.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social Terraza - 02',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/zonas-comunes/still_Camera_008.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social Terraza - 03',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/zonas-comunes/still_Camera_009.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit - 01',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/zonas-comunes/still_Camera_010.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit - 02',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/zonas-comunes/still_Camera_011.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit - 03',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/zonas-comunes/still_Camera_012.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Spa - 01',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/zonas-comunes/still_Camera_013.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Spa - 01 IA',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/zonas-comunes/still_Camera_013_AI.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Spa - 02',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/zonas-comunes/still_Camera_014.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Spa - 02 IA',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/zonas-comunes/still_Camera_014_AI.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Spa - 03',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/zonas-comunes/still_Camera_015.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Spa - 03 IA',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/zonas-comunes/still_Camera_015_AI.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Spa Terraza Exterior - 01',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/zonas-comunes/still_Camera_016.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Spa Terraza Exterior - 01 IA',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/zonas-comunes/still_Camera_016_AI.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Spa Terraza Exterior - 02',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/zonas-comunes/still_Camera_017.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Spa Terraza Exterior - 02 IA',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/zonas-comunes/still_Camera_017_AI.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Spa Terraza Exterior - 03',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/zonas-comunes/still_Camera_018.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Spa Terraza Exterior - 03 IA',
                src: 'https://media.bizionar.digital/via-celere/vission-hills-r2c/live/zonas-comunes/still_Camera_018_AI.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
            ],
          },
        },
        {
          id: 'tiber',
          name: 'Tiber',
          city: 'Madrid',
          province: 'Madrid',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://media.bizionar.digital/via-celere/tiber/show/index.html',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/via-celere/tiber',
          image: 'https://media.bizionar.digital/via-celere/tiber/live/exterior/cam01.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '20 de abril de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '2 de julio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '3 de septiembre de 2026',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '23 de septiembre de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'zonas-comunes',
              categoryName: 'ZONAS COMUNES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '8 de septiembre de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '23 de septiembre de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '30 de septiembre de 2026',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '5 de octubre de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/tiber/review01/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/tiber/review01/render/exterior/cam02.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/render/exterior-ia/cam01_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/render/exterior-ia/cam02_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/render/exterior-ia/cam03_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06 F',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/render/exterior-ia/cam06_F_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/render/exterior-ia/cam06_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/render/exterior-ia/cam09_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/render/exterior-ia/cam10_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 25',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/render/exterior-ia/cam25_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 26',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/render/exterior-ia/cam26_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 27',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/render/exterior-ia/cam27_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/video/exterior-ia/cam02_ia_video.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/tiber/review01/render/exterior-ia/cam02_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/video/exterior-ia/cam06_ia_video.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/tiber/review01/render/exterior/cam06.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 09',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/video/exterior-ia/cam09_ia_video.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/tiber/review01/render/exterior-ia/cam09_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 10',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/video/exterior-ia/cam10_ia_video.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/tiber/review01/render/exterior-ia/cam10_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 25',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/video/exterior-ia/cam25_ia_video.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/tiber/review01/render/exterior-ia/cam25_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 26',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/video/exterior-ia/cam26_video.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/tiber/review01/render/exterior-ia/cam26_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 27',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/video/exterior-ia/cam27_video.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/tiber/review01/render/exterior-ia/cam27_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 04',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking - 01',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking - 02',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking - 03',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking - 04',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Mascotas - 01',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/render/zonas-comunes/still_Camera_009.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Mascotas - 02',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/render/zonas-comunes/still_Camera_010.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Mascotas - 03',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/render/zonas-comunes/still_Camera_011.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Lavandería - 01',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/render/zonas-comunes/still_Camera_012.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Lavandería - 02',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review01/render/zonas-comunes/still_Camera_013.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/tiber/review02/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/tiber/review02/render/exterior/cam02.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review02/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review02/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review02/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review02/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review02/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review02/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review02/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review02/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 04',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review02/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking - 01',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review02/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking - 02',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review02/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking - 03',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review02/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking - 04',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review02/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Mascotas - 01',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review02/render/zonas-comunes/still_Camera_009.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Mascotas - 02',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review02/render/zonas-comunes/still_Camera_010.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Mascotas - 03',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review02/render/zonas-comunes/still_Camera_011.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Lavandería - 01',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review02/render/zonas-comunes/still_Camera_012.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Lavandería - 02',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review02/render/zonas-comunes/still_Camera_013.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/tiber/review03/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/tiber/review03/render/exterior/cam02.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/render/exterior-ia/cam01_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/render/exterior-ia/cam02_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/render/exterior-ia/cam03_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/render/exterior-ia/cam06_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06 F',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/render/exterior-ia/cam06_F_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/render/exterior-ia/cam10_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 25',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/render/exterior-ia/cam25_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 26',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/render/exterior-ia/cam26_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 27',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/render/exterior-ia/cam27_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/video/exterior-ia/video02_ia.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/tiber/review03/render/exterior-ia/cam02_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/video/exterior-ia/video06_ia.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/tiber/review03/render/exterior/cam06.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 06 F',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/video/exterior-ia/video06F_ia.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/tiber/review03/render/exterior-ia/cam06_F_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 10',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/video/exterior-ia/video10_ia.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/tiber/review03/render/exterior-ia/cam10_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 25',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/video/exterior-ia/video25_ia.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/tiber/review03/render/exterior-ia/cam25_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 26',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/video/exterior-ia/video26_ia.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/tiber/review03/render/exterior-ia/cam26_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 27',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/video/exterior-ia/video27_ia.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/tiber/review03/render/exterior-ia/cam27_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 04',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking - 01',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking - 02',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking - 03',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking - 04',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Mascotas - 01',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/render/zonas-comunes/still_Camera_009.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Mascotas - 02',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/render/zonas-comunes/still_Camera_010.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Mascotas - 03',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/render/zonas-comunes/still_Camera_011.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Lavandería - 01',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/render/zonas-comunes/still_Camera_012.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Lavandería - 02',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review03/render/zonas-comunes/still_Camera_013.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/tiber/review04/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/tiber/review04/render/exterior/cam02.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/render/exterior-ia/cam01_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/render/exterior-ia/cam02_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/render/exterior-ia/cam03_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/render/exterior-ia/cam06_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06 F',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/render/exterior-ia/cam06_F_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/render/exterior-ia/cam10_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 25',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/render/exterior-ia/cam25_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 26',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/render/exterior-ia/cam26_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 27',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/render/exterior-ia/cam27_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/video/exterior-ia/video02_ia.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/tiber/review04/render/exterior-ia/cam02_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 06 F',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/video/exterior-ia/video06F_ia.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/tiber/review04/render/exterior-ia/cam06_F_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 10',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/video/exterior-ia/video10_ia.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/tiber/review04/render/exterior-ia/cam10_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 25',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/video/exterior-ia/video25_ia.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/tiber/review04/render/exterior-ia/cam25_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 26',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/video/exterior-ia/video26_ia.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/tiber/review04/render/exterior-ia/cam26_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 27',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/video/exterior-ia/video27_ia.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/tiber/review04/render/exterior-ia/cam27_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 04',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking - 01',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking - 02',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking - 03',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking - 04',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Mascotas - 01',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/render/zonas-comunes/still_Camera_009.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Mascotas - 02',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/render/zonas-comunes/still_Camera_010.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Mascotas - 03',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/render/zonas-comunes/still_Camera_011.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Lavandería - 01',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/render/zonas-comunes/still_Camera_012.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Lavandería - 02',
                  src: 'https://media.bizionar.digital/via-celere/tiber/review04/render/zonas-comunes/still_Camera_013.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'ZONAS COMUNES',
              filter: 'zonas-comunes',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '5 de octubre de 2026',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/tiber/download/exterior/render_exterior_md.zip',
                videoBundleUrl: 'https://media.bizionar.digital/via-celere/tiber/download/video/exterior/video_exterior.zip',
              },
              {
                category: 'zonas-comunes',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/tiber/download/zonas-comunes/render_zonas-comunes_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/tiber/live/exterior/cam01.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/tiber/live/exterior/cam02.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/exterior/cam01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/exterior/cam02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/exterior/cam03.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 06',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/exterior/cam06.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 09',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/exterior/cam09.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 01 - IA',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/exterior/cam01_ia.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02 - IA',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/exterior/cam02_ia.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 03 - IA',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/exterior/cam03_ia.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 06 - IA',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/exterior/cam06_ia.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 06 F - IA',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/exterior/cam06_F_ia.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 10 - IA',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/exterior/cam10_ia.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 25 - IA',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/exterior/cam25_ia.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 26 - IA',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/exterior/cam26_ia.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 27 - IA',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/exterior/cam27_ia.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Video Exterior 02',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/video/exterior/video02_ia.mp4',
                thumb: 'https://media.bizionar.digital/via-celere/tiber/live/exterior/cam02_ia.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Exterior 06 F',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/video/exterior/video06F_ia.mp4',
                thumb: 'https://media.bizionar.digital/via-celere/tiber/live/exterior/cam06_F_ia.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Exterior 10',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/video/exterior/video10_ia.mp4',
                thumb: 'https://media.bizionar.digital/via-celere/tiber/live/exterior/cam10_ia.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Exterior 25',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/video/exterior/video25_ia.mp4',
                thumb: 'https://media.bizionar.digital/via-celere/tiber/live/exterior/cam25_ia.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Exterior 26',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/video/exterior/video26_ia.mp4',
                thumb: 'https://media.bizionar.digital/via-celere/tiber/live/exterior/cam26_ia.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Exterior 27',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/video/exterior/video27_ia.mp4',
                thumb: 'https://media.bizionar.digital/via-celere/tiber/live/exterior/cam27_ia.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Render Sala Social - 01',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/zonas-comunes/still_Camera_001.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 02',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/zonas-comunes/still_Camera_002.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 03',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/zonas-comunes/still_Camera_003.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 04',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/zonas-comunes/still_Camera_004.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Coworking - 01',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/zonas-comunes/still_Camera_005.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Coworking - 02',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/zonas-comunes/still_Camera_006.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Coworking - 03',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/zonas-comunes/still_Camera_007.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Coworking - 04',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/zonas-comunes/still_Camera_008.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Mascotas - 01',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/zonas-comunes/still_Camera_009.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Mascotas - 02',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/zonas-comunes/still_Camera_010.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Mascotas - 03',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/zonas-comunes/still_Camera_011.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Lavandería - 01',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/zonas-comunes/still_Camera_012.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Lavandería - 02',
                src: 'https://media.bizionar.digital/via-celere/tiber/live/zonas-comunes/still_Camera_013.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
            ],
          },
        },
        {
          id: 'fortuna',
          name: 'Fortuna',
          city: 'Madrid',
          province: 'Madrid',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://media.bizionar.digital/via-celere/fortuna/show/index.html',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/via-celere/fortuna',
          image: 'https://media.bizionar.digital/via-celere/fortuna/live/exterior/cam02.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '20 de abril de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '2 de julio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '3 de septiembre de 2026',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '23 de septiembre de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'zonas-comunes',
              categoryName: 'ZONAS COMUNES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '8 de septiembre de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '23 de septiembre de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '30 de septiembre de 2026',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '5 de octubre de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/exterior/cam02.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 25',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/exterior/cam25.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 26',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/exterior/cam26.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 27',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/exterior/cam27.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/exterior-ia/cam02_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/exterior-ia/cam04_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/exterior-ia/cam05_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06 F',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/exterior-ia/cam06_F_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/exterior-ia/cam06_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/exterior-ia/cam09_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/exterior-ia/cam10_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 25',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/exterior-ia/cam25_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 26',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/exterior-ia/cam26_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 27',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/exterior-ia/cam27_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/video/exterior-ia/cam02_video.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/exterior-ia/cam02_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/video/exterior-ia/cam06_ia_video.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/exterior/cam06.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 09',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/video/exterior-ia/cam09_ia_video.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/exterior-ia/cam09_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 10',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/video/exterior-ia/cam10_ia_video.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/exterior-ia/cam10_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 25',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/video/exterior-ia/cam25_ia_video.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/exterior-ia/cam25_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 26',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/video/exterior-ia/cam26_video.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/exterior-ia/cam26_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 27',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/video/exterior-ia/cam27_video.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/exterior-ia/cam27_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 03',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 04',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Zona Calistenia - 01',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Zona Calistenia - 02',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Zona Exterior - 01',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Zona Exterior - 01 IA',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/zonas-comunes/still_Camera_007_ia.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Zona Exterior - 02',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Zona Exterior - 02 IA',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review01/render/zonas-comunes/still_Camera_008_ia.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/fortuna/review02/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/fortuna/review02/render/exterior/cam02.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review02/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review02/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review02/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review02/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review02/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 25',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review02/render/exterior/cam25.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 26',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review02/render/exterior/cam26.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 27',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review02/render/exterior/cam27.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review02/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review02/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 03',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review02/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 04',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review02/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Zona Calistenia - 01',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review02/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Zona Calistenia - 02',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review02/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Zona Exterior - 01',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review02/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Zona Exterior - 01 IA',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review02/render/zonas-comunes/still_Camera_007_ia.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Zona Exterior - 02',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review02/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Zona Exterior - 02 IA',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review02/render/zonas-comunes/still_Camera_008_ia.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/exterior/cam02.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 25',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/exterior/cam25.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 26',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/exterior/cam26.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 27',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/exterior/cam27.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02 F',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/exterior-ia/cam02F_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04 F',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/exterior-ia/cam04F_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05 F',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/exterior-ia/cam05F_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/exterior-ia/cam06_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06 F',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/exterior-ia/cam06F_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/exterior-ia/cam10_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 25',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/exterior-ia/cam25_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 26',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/exterior-ia/cam26_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 27',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/exterior-ia/cam27_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 02 F',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/video/exterior-ia/video02F_ia.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/exterior-ia/cam02F_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/video/exterior-ia/video06_ia.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/exterior-ia/cam06_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 06 F',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/video/exterior-ia/video06F_ia.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/exterior-ia/cam06F_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 10',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/video/exterior-ia/video10_ia.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/exterior-ia/cam10_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 25',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/video/exterior-ia/video25_ia.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/exterior-ia/cam25_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 26',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/video/exterior-ia/video26_ia.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/exterior-ia/cam26_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 27',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/video/exterior-ia/video27_ia.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/exterior-ia/cam27_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 03',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 04',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Zona Calistenia - 01',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Zona Calistenia - 02',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Zona Exterior - 01',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Zona Exterior - 02',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review03/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/exterior/cam02.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 25',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/exterior/cam25.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 26',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/exterior/cam26.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 27',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/exterior/cam27.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02 F',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/exterior-ia/cam02F_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04 F',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/exterior-ia/cam04F_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05 F',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/exterior-ia/cam05F_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/exterior-ia/cam06_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06 F',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/exterior-ia/cam06F_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/exterior-ia/cam10_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 25',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/exterior-ia/cam25_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 26',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/exterior-ia/cam26_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 27',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/exterior-ia/cam27_ia.jpg',
                  type: 'render-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 02 F',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/video/exterior-ia/video02F_ia.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/exterior-ia/cam02F_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 06 F',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/video/exterior-ia/video06F_ia.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/exterior-ia/cam06F_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 10',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/video/exterior-ia/video10_ia.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/exterior-ia/cam10_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 25',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/video/exterior-ia/video25_ia.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/exterior-ia/cam25_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 26',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/video/exterior-ia/video26_ia.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/exterior-ia/cam26_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Video Exterior 27',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/video/exterior-ia/video27_ia.mp4',
                  thumb: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/exterior-ia/cam27_ia.jpg',
                  type: 'video-ia',
                  category: 'exteriores',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 03',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 04',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Zona Calistenia - 01',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Zona Calistenia - 02',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Zona Exterior - 01',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Zona Exterior - 02',
                  src: 'https://media.bizionar.digital/via-celere/fortuna/review04/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'ZONAS COMUNES',
              filter: 'zonas-comunes',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '5 de octubre de 2026',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/fortuna/download/exterior/render_exterior_md.zip',
                videoBundleUrl: 'https://media.bizionar.digital/via-celere/fortuna/download/video/exterior/video_exterior.zip',
              },
              {
                category: 'zonas-comunes',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/fortuna/download/zonas-comunes/render_zonas-comunes_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/fortuna/live/exterior/cam02.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/fortuna/live/exterior/cam02.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/exterior/cam02.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 04',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/exterior/cam04.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 05',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/exterior/cam05.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 06',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/exterior/cam06.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 10',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/exterior/cam10.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 25',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/exterior/cam25.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 26',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/exterior/cam26.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 27',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/exterior/cam27.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 02 F - IA',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/exterior/cam02F_ia.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 04 F - IA',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/exterior/cam04F_ia.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 05 F - IA',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/exterior/cam05F_ia.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 06 - IA',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/exterior/cam06_ia.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 06 F - IA',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/exterior/cam06_F_ia.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 10 - IA',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/exterior/cam10_ia.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 25 - IA',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/exterior/cam25_ia.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 26 - IA',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/exterior/cam26_ia.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 27 - IA',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/exterior/cam27_ia.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Video Exterior 02 F',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/video/exterior/video02F_ia.mp4',
                thumb: 'https://media.bizionar.digital/via-celere/fortuna/live/exterior/cam02F_ia.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Exterior 06 F',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/video/exterior/video06F_ia.mp4',
                thumb: 'https://media.bizionar.digital/via-celere/fortuna/live/exterior/cam06_F_ia.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Exterior 10',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/video/exterior/video10_ia.mp4',
                thumb: 'https://media.bizionar.digital/via-celere/fortuna/live/exterior/cam10_ia.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Exterior 25',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/video/exterior/video25_ia.mp4',
                thumb: 'https://media.bizionar.digital/via-celere/fortuna/live/exterior/cam25_ia.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Exterior 26',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/video/exterior/video26_ia.mp4',
                thumb: 'https://media.bizionar.digital/via-celere/fortuna/live/exterior/cam26_ia.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Video Exterior 27',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/video/exterior/video27_ia.mp4',
                thumb: 'https://media.bizionar.digital/via-celere/fortuna/live/exterior/cam27_ia.jpg',
                type: 'video',
                category: 'exteriores',
              },
              {
                name: 'Render Espacio Fit - 01',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/zonas-comunes/still_Camera_001.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit - 02',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/zonas-comunes/still_Camera_002.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit - 03',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/zonas-comunes/still_Camera_003.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit - 04',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/zonas-comunes/still_Camera_004.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Zona Calistenia - 01',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/zonas-comunes/still_Camera_005.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Zona Calistenia - 02',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/zonas-comunes/still_Camera_006.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Zona Exterior - 01',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/zonas-comunes/still_Camera_007.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Zona Exterior - 02',
                src: 'https://media.bizionar.digital/via-celere/fortuna/live/zonas-comunes/still_Camera_008.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
            ],
          },
        },
        {
          id: 'mislata-iii',
          name: 'Mislata III',
          city: 'Mislata',
          province: 'Valencia',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://media.bizionar.digital/via-celere/mislata-iii/show/index.html',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/via-celere/mislata-iii',
          image: 'https://media.bizionar.digital/via-celere/mislata-iii/review03/render/exterior/cam04.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '6 de mayo de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '13 de agosto de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '22 de septiembre de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'zonas-comunes',
              categoryName: 'ZONAS COMUNES',
              closedReviews: 1,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '7 de octubre de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '29 de octubre de 2026',
                  status: 'pending',
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/mislata-iii/review01/render/exterior/cam04.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/mislata-iii/review01/render/exterior/cam04.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review01/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review01/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review01/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review01/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review01/render/exterior/cam15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review01/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review01/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review01/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 04',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review01/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review01/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review01/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Patio Inglés - 01',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review01/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Exterior - 01',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review01/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Exterior - 02',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review01/render/zonas-comunes/still_Camera_009.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/mislata-iii/review02/render/exterior/cam04.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/mislata-iii/review02/render/exterior/cam04.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review02/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review02/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review02/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review02/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review02/render/exterior/cam15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review02/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review02/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review02/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 04',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review02/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review02/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review02/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Patio Inglés - 01',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review02/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Exterior - 01',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review02/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Exterior - 02',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review02/render/zonas-comunes/still_Camera_009.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/mislata-iii/review03/render/exterior/cam04.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/mislata-iii/review03/render/exterior/cam04.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review03/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review03/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review03/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review03/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iii/review03/render/exterior/cam15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '22 de septiembre de 2026',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/mislata-iii/download/exterior/render_exterior_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/via-celere/mislata-iii/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/mislata-iii/live/exterior/cam04.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/via-celere/mislata-iii/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/mislata-iii/live/exterior/cam04.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 04',
                src: 'https://media.bizionar.digital/via-celere/mislata-iii/live/exterior/cam04.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 07',
                src: 'https://media.bizionar.digital/via-celere/mislata-iii/live/exterior/cam07.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 09',
                src: 'https://media.bizionar.digital/via-celere/mislata-iii/live/exterior/cam09.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 12',
                src: 'https://media.bizionar.digital/via-celere/mislata-iii/live/exterior/cam12.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 15',
                src: 'https://media.bizionar.digital/via-celere/mislata-iii/live/exterior/cam15.jpg',
                type: 'render',
                category: 'exteriores',
              },
            ],
          },
        },
        {
          id: 'dalt-mar',
          name: 'Dalt Mar',
          city: 'Premià de Dalt',
          province: 'Barcelona',
          liveEnabled: true,
          showEnabled: true,
          digitalShowUrl: 'https://media.bizionar.digital/via-celere/dalt-mar/show/index.html',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/via-celere/dalt-mar',
          image: 'https://media.bizionar.digital/via-celere/dalt-mar/live/exterior/cam01.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '28 de mayo de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '10 de julio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '15 de septiembre de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
            {
              categoryId: 'zonas-comunes',
              categoryName: 'ZONAS COMUNES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '29 de julio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '10 de septiembre de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '15 de septiembre de 2026',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '23 de septiembre de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/dalt-mar/review01/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/dalt-mar/review01/render/exterior/cam01.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review01/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review01/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review01/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 32',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review01/render/exterior/cam32.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior Aérea 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review01/render/exterior/camR1.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review01/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review01/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review01/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 04',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review01/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review01/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review01/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 03',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review01/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 04',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review01/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review01/render/zonas-comunes/still_Camera_009.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review01/render/zonas-comunes/still_Camera_010.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Multiusos - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review01/render/zonas-comunes/still_Camera_011.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Multiusos - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review01/render/zonas-comunes/still_Camera_012.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/dalt-mar/review02/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/dalt-mar/review02/render/exterior/cam01.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review02/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review02/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review02/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 32',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review02/render/exterior/cam32.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior Aérea 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review02/render/exterior/camR1.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review02/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review02/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review02/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 04',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review02/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review02/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review02/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 03',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review02/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 04',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review02/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review02/render/zonas-comunes/still_Camera_009.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review02/render/zonas-comunes/still_Camera_010.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Multiusos - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review02/render/zonas-comunes/still_Camera_011.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Multiusos - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review02/render/zonas-comunes/still_Camera_012.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/dalt-mar/review03/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review03/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/dalt-mar/review03/render/exterior/cam01.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review03/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 10',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review03/render/exterior/cam10.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review03/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 32',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review03/render/exterior/cam32.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior Aérea 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review03/render/exterior/camR1.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review03/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review03/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review03/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 04',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review03/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review03/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review03/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 03',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review03/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 04',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review03/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review03/render/zonas-comunes/still_Camera_009.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review03/render/zonas-comunes/still_Camera_010.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Multiusos - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review03/render/zonas-comunes/still_Camera_011.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Multiusos - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review03/render/zonas-comunes/still_Camera_012.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review04/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review04/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review04/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 04',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review04/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review04/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review04/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 03',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review04/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Coworking - 04',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review04/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review04/render/zonas-comunes/still_Camera_009.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review04/render/zonas-comunes/still_Camera_010.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Multiusos - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review04/render/zonas-comunes/still_Camera_011.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Multiusos - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar/review04/render/zonas-comunes/still_Camera_012.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'EXTERIORES',
              filter: 'exteriores',
              active: true,
            },
            {
              title: 'ZONAS COMUNES',
              filter: 'zonas-comunes',
              active: false,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '28 de septiembre de 2026',
            categoryBundles: [
              {
                category: 'exteriores',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/dalt-mar/download/exterior/render_exterior_md.zip',
                videoBundleUrl: '',
              },
              {
                category: 'zonas-comunes',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/dalt-mar/download/zonas-comunes/render_zonas-comunes_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/dalt-mar/live/exterior/cam01.jpg',
                type: 'panoramic',
                category: 'exteriores',
              },
              {
                name: 'Orbita 3D',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar/live/orbit/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/dalt-mar/live/exterior/cam01.jpg',
                type: 'orbit',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 01',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar/live/exterior/cam01.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 10',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar/live/exterior/cam10.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 12',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar/live/exterior/cam12.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior 32',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar/live/exterior/cam32.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Render Exterior Aérea 01',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar/live/exterior/camR1.jpg',
                type: 'render',
                category: 'exteriores',
              },
              {
                name: 'Tour Virtual 360°',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar/live/tour/index.html',
                thumb: 'https://media.bizionar.digital/via-celere/dalt-mar/live/exterior/cam01.jpg',
                type: 'panoramic',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 01',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar/live/zonas-comunes/still_Camera_001.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 02',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar/live/zonas-comunes/still_Camera_002.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 03',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar/live/zonas-comunes/still_Camera_003.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 04',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar/live/zonas-comunes/still_Camera_004.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Coworking - 01',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar/live/zonas-comunes/still_Camera_005.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Coworking - 02',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar/live/zonas-comunes/still_Camera_006.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Coworking - 03',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar/live/zonas-comunes/still_Camera_007.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Coworking - 04',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar/live/zonas-comunes/still_Camera_008.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit - 01',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar/live/zonas-comunes/still_Camera_009.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit - 02',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar/live/zonas-comunes/still_Camera_010.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Multiusos - 01',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar/live/zonas-comunes/still_Camera_011.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Multiusos - 02',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar/live/zonas-comunes/still_Camera_012.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
            ],
          },
        },
        {
          id: 'dalt-mar-ii',
          name: 'Dalt Mar - Fase 2',
          city: 'Premià de Dalt',
          province: 'Barcelona',
          liveEnabled: true,
          showEnabled: false,
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/via-celere/dalt-mar-ii',
          image: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review02/render/exterior/cam02.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 2,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '24 de julio de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '30 de septiembre de 2026',
                  status: 'pending',
                },
              ],
            },
            {
              categoryId: 'zonas-comunes',
              categoryName: 'ZONAS-COMUNES',
              closedReviews: 3,
              totalReviews: 3,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '2 de septiembre de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '14 de octubre de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '19 de octubre de 2026',
                  status: 'closed',
                },
                {
                  id: 'review04',
                  name: 'ENTREGA 4',
                  date: '21 de octubre de 2026',
                  status: 'closed',
                  isFinal:  true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review01/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review01/render/exterior/cam02.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review01/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review01/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review01/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 23',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review01/render/exterior/cam24.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior Aérea 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review01/render/exterior/cam21a.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior Aérea 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review01/render/exterior/cam21b.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Sala Social A - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review01/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social A - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review01/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social A - 03',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review01/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social A - 04',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review01/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking A - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review01/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking A - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review01/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking A - 03',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review01/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit A - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review01/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit A - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review01/render/zonas-comunes/still_Camera_009.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social B - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review01/render/zonas-comunes/still_Camera_010.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social B - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review01/render/zonas-comunes/still_Camera_011.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social B - 03',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review01/render/zonas-comunes/still_Camera_012.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social B - 04',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review01/render/zonas-comunes/still_Camera_013.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking B - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review01/render/zonas-comunes/still_Camera_014.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking B - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review01/render/zonas-comunes/still_Camera_015.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking B - 03',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review01/render/zonas-comunes/still_Camera_016.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit B - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review01/render/zonas-comunes/still_Camera_017.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit B - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review01/render/zonas-comunes/still_Camera_018.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review03/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review02/render/exterior/cam02.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review02/render/exterior/cam02.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review02/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review02/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review02/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 23',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review02/render/exterior/cam24.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior Aérea 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review02/render/exterior/cam21a.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior Aérea 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review02/render/exterior/cam21b.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Sala Social A - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review02/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social A - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review02/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social A - 03',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review02/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social A - 04',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review02/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking A - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review02/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking A - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review02/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking A - 03',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review02/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit A - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review02/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit A - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review02/render/zonas-comunes/still_Camera_009.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social B - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review02/render/zonas-comunes/still_Camera_010.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social B - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review02/render/zonas-comunes/still_Camera_011.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social B - 03',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review02/render/zonas-comunes/still_Camera_012.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social B - 04',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review02/render/zonas-comunes/still_Camera_013.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking B - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review02/render/zonas-comunes/still_Camera_014.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking B - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review02/render/zonas-comunes/still_Camera_015.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking B - 03',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review02/render/zonas-comunes/still_Camera_016.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit B - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review02/render/zonas-comunes/still_Camera_017.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit B - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review02/render/zonas-comunes/still_Camera_018.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Render Sala Social A - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review03/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social A - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review03/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social A - 03',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review03/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social A - 04',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review03/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking A - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review03/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking A - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review03/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking A - 03',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review03/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit A - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review03/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit A - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review03/render/zonas-comunes/still_Camera_009.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social B - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review03/render/zonas-comunes/still_Camera_010.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social B - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review03/render/zonas-comunes/still_Camera_011.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social B - 03',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review03/render/zonas-comunes/still_Camera_012.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social B - 04',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review03/render/zonas-comunes/still_Camera_013.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking B - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review03/render/zonas-comunes/still_Camera_014.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking B - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review03/render/zonas-comunes/still_Camera_015.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking B - 03',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review03/render/zonas-comunes/still_Camera_016.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit B - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review03/render/zonas-comunes/still_Camera_017.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit B - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review03/render/zonas-comunes/still_Camera_018.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review04',
              content: [
                {
                  name: 'Render Sala Social A - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review04/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social A - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review04/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social A - 03',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review04/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social A - 04',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review04/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking A - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review04/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking A - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review04/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking A - 03',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review04/render/zonas-comunes/still_Camera_007.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit A - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review04/render/zonas-comunes/still_Camera_008.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit A - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review04/render/zonas-comunes/still_Camera_009.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social B - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review04/render/zonas-comunes/still_Camera_010.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social B - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review04/render/zonas-comunes/still_Camera_011.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social B - 03',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review04/render/zonas-comunes/still_Camera_012.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social B - 04',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review04/render/zonas-comunes/still_Camera_013.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking B - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review04/render/zonas-comunes/still_Camera_014.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking B - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review04/render/zonas-comunes/still_Camera_015.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Coworking B - 03',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review04/render/zonas-comunes/still_Camera_016.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit B - 01',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review04/render/zonas-comunes/still_Camera_017.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit B - 02',
                  src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/review04/render/zonas-comunes/still_Camera_018.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'ZONAS COMUNES',
              filter: 'zonas-comunes',
              active: true,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '22 de octubre de 2026',
            categoryBundles: [
              {
                category: 'zonas-comunes',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/download/zonas-comunes/render_zonas-comunes_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Render Sala Social A - 01',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_001.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social A - 01 - IA',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_001_ia.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social A - 02',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_002.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social A - 02 - IA',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_002_ia.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social A - 03',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_003.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social A - 03 - IA',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_003_ia.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social A - 04',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_004.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social A - 04 - IA',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_004_ia.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Coworking A - 01',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_005.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Coworking A - 01 - IA',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_005_ia.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Coworking A - 02',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_006.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Coworking A - 02 - IA',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_006_ia.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Coworking A - 03',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_007.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Coworking A - 03 - IA',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_007_ia.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit A - 01',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_008.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit A - 01 - IA',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_008_ia.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit A - 02',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_009.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit A - 02 - IA',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_009_ia.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social B - 01',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_010.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social B - 01 - IA',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_010_ia.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social B - 02',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_011.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social B - 02 - IA',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_011_ia.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social B - 03',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_012.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social B - 03 - IA',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_012_ia.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social B - 04',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_013.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social B - 04 - IA',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_013_ia.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Coworking B - 01',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_014.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Coworking B - 01 - IA',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_014_ia.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Coworking B - 02',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_015.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Coworking B - 02 - IA',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_015_ia.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Coworking B - 03',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_016.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Coworking B - 03 - IA',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_016_ia.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit B - 01',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_017.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit B - 01 - IA',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_017_ia.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit B - 02',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_018.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit B - 02 - IA',
                src: 'https://media.bizionar.digital/via-celere/dalt-mar-ii/live/zonas-comunes/still_Camera_018_ia.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
            ],
          },
        },
        {
          id: 'vission-hills-iii',
          name: 'Vission Hills III',
          city: 'Mijas',
          province: 'Málaga',
          liveEnabled: false,
          showEnabled: false,
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/via-celere/vission-hills-iii',
          image: 'https://media.bizionar.digital/via-celere/vission-hills-iii/review01/render/exterior/cam11.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 0,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '22 de junio de 2026',
                  status: 'pending',
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-iii/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/vission-hills-iii/review01/render/exterior/cam09.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-iii/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/vission-hills-iii/review01/render/exterior/cam11.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-iii/review01/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 05',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-iii/review01/render/exterior/cam05.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-iii/review01/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 11',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-iii/review01/render/exterior/cam11.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 18',
                  src: 'https://media.bizionar.digital/via-celere/vission-hills-iii/review01/render/exterior/cam18.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
          ],
        },
        {
          id: 'baviera-golf-iv',
          name: 'Baviera Golf Fase IV',
          city: 'Vélez-Málaga',
          province: 'Málaga',
          liveEnabled: false,
          showEnabled: false,
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/via-celere/baviera-golf-iv',
          image: 'https://media.bizionar.digital/via-celere/baviera-golf-iv/review01/render/exterior/cam06.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 0,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '20 de julio de 2026',
                  status: 'pending',
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iv/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/baviera-golf-iv/review01/render/exterior/cam06.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iv/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/baviera-golf-iv/review01/render/exterior/cam03.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 03',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iv/review01/render/exterior/cam03.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iv/review01/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 06',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iv/review01/render/exterior/cam06.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iv/review01/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 15',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iv/review01/render/exterior/cam15.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 18',
                  src: 'https://media.bizionar.digital/via-celere/baviera-golf-iv/review01/render/exterior/cam18.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
          ],
        },
        {
          id: 'mislata-iv',
          name: 'Mislata IV',
          city: 'Mislata',
          province: 'Valencia',
          liveEnabled: false,
          showEnabled: false,
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/via-celere/mislata-iv',
          image: 'https://media.bizionar.digital/via-celere/mislata-iv/review02/render/exterior/cam01.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 1,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '1 de octubre de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '28 de octubre de 2026',
                  status: 'pending',
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iv/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/mislata-iv/review01/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iv/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/mislata-iv/review01/render/exterior/cam01.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iv/review01/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iv/review01/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iv/review01/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iv/review01/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 16',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iv/review01/render/exterior/cam16.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iv/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/mislata-iv/review02/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iv/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/mislata-iv/review02/render/exterior/cam01.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iv/review02/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iv/review02/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 09',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iv/review02/render/exterior/cam09.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 12',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iv/review02/render/exterior/cam12.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 16',
                  src: 'https://media.bizionar.digital/via-celere/mislata-iv/review02/render/exterior/cam16.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
              ],
            },
          ],
        },
        {
          id: 'quirinal',
          name: 'Quirinal',
          city: 'Madrid',
          province: 'Madrid',
          liveEnabled: true,
          showEnabled: false,
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/via-celere/quirinal',
          image: 'https://media.bizionar.digital/via-celere/quirinal/review02/render/exterior/cam01.jpg',
          deliveries: [
            {
              categoryId: 'exteriores',
              categoryName: 'EXTERIORES',
              closedReviews: 1,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '14 de octubre de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '2 de noviembre de 2026',
                  status: 'pending',
                },
              ],
            },
            {
              categoryId: 'zonas-comunes',
              categoryName: 'ZONAS COMUNES',
              closedReviews: 1,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '27 de octubre de 2026',
                  status: 'closed',
                },
                {
                  id: 'review02',
                  name: 'ENTREGA 2',
                  date: '30 de octubre de 2026',
                  status: 'closed',
                },
                {
                  id: 'review03',
                  name: 'ENTREGA 3',
                  date: '3 de noviembre de 2026',
                  status: 'closed',
                  isFinal: true,
                  isLive: true,
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review01/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/quirinal/review01/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review01/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/quirinal/review01/render/exterior/cam01.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review01/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review01/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review01/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review01/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review01/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review01/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review01/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review01/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review01/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Zona Exterior - 01',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review01/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Huerto Urbano - 01',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review01/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review02',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review02/tour/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/quirinal/review02/render/exterior/cam01.jpg',
                  type: 'panoramic',
                  category: 'exteriores',
                },
                {
                  name: 'Orbita 3D',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review02/orbit/index.html',
                  thumb: 'https://media.bizionar.digital/via-celere/quirinal/review02/render/exterior/cam01.jpg',
                  type: 'orbit',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 01',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review02/render/exterior/cam01.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 02',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review02/render/exterior/cam02.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 04',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review02/render/exterior/cam04.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 07',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review02/render/exterior/cam07.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Exterior 08',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review02/render/exterior/cam08.jpg',
                  type: 'render',
                  category: 'exteriores',
                },
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review02/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review02/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review02/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review02/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Zona Exterior - 01',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review02/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Huerto Urbano - 01',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review02/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
            {
              id: 'review03',
              content: [
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review03/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 01 IA',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review03/render/zonas-comunes/still_Camera_001_ia.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review03/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02 IA',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review03/render/zonas-comunes/still_Camera_002_ia.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review03/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03 IA',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review03/render/zonas-comunes/still_Camera_003_ia.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review03/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01 IA',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review03/render/zonas-comunes/still_Camera_004_ia.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Zona Exterior - 01',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review03/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Zona Exterior - 01 IA',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review03/render/zonas-comunes/still_Camera_005_ia.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Huerto Urbano - 01',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review03/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Huerto Urbano - 01 IA',
                  src: 'https://media.bizionar.digital/via-celere/quirinal/review03/render/zonas-comunes/still_Camera_006_ia.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
          ],
          liveFilters: [
            {
              title: 'ZONAS COMUNES',
              filter: 'zonas-comunes',
              active: true,
            },
          ],
          live: {
            id: 'live',
            lastUpdate: '3 de noviembre de 2026',
            categoryBundles: [
              {
                category: 'zonas-comunes',
                renderBundleUrl: 'https://media.bizionar.digital/via-celere/quirinal/download/zonas-comunes/render_zonas-comunes_md.zip',
                videoBundleUrl: '',
              },
            ],
            content: [
              {
                name: 'Render Sala Social - 01',
                src: 'https://media.bizionar.digital/via-celere/quirinal/live/zonas-comunes/still_Camera_001.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 01 IA',
                src: 'https://media.bizionar.digital/via-celere/quirinal/live/zonas-comunes/still_Camera_001_ia.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 02',
                src: 'https://media.bizionar.digital/via-celere/quirinal/live/zonas-comunes/still_Camera_002.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 02 IA',
                src: 'https://media.bizionar.digital/via-celere/quirinal/live/zonas-comunes/still_Camera_002_ia.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 03',
                src: 'https://media.bizionar.digital/via-celere/quirinal/live/zonas-comunes/still_Camera_003.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Sala Social - 03 IA',
                src: 'https://media.bizionar.digital/via-celere/quirinal/live/zonas-comunes/still_Camera_003_ia.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit - 01',
                src: 'https://media.bizionar.digital/via-celere/quirinal/live/zonas-comunes/still_Camera_004.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Espacio Fit - 01 IA',
                src: 'https://media.bizionar.digital/via-celere/quirinal/live/zonas-comunes/still_Camera_004_ia.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Zona Exterior - 01',
                src: 'https://media.bizionar.digital/via-celere/quirinal/live/zonas-comunes/still_Camera_005.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Zona Exterior - 01 IA',
                src: 'https://media.bizionar.digital/via-celere/quirinal/live/zonas-comunes/still_Camera_005_ia.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Huerto Urbano - 01',
                src: 'https://media.bizionar.digital/via-celere/quirinal/live/zonas-comunes/still_Camera_006.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
              {
                name: 'Render Huerto Urbano - 01 IA',
                src: 'https://media.bizionar.digital/via-celere/quirinal/live/zonas-comunes/still_Camera_006_ia.jpg',
                type: 'render',
                category: 'zonas-comunes',
              },
            ],
          },
        },
        {
          id: 'miralta',
          name: 'Miralta',
          city: 'Valladolid',
          province: 'Valladolid',
          liveEnabled: false,
          showEnabled: false,
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/via-celere/miralta',
          image: 'https://media.bizionar.digital/via-celere/miralta/review01/render/zonas-comunes/still_Camera_004.jpg',
          deliveries: [
            {
              categoryId: 'zonas-comunes',
              categoryName: 'ZONAS COMUNES',
              closedReviews: 0,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '29 de octubre de 2026',
                  status: 'pending',
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Render Sala Social - 01',
                  src: 'https://media.bizionar.digital/via-celere/miralta/review01/render/zonas-comunes/still_Camera_001.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 02',
                  src: 'https://media.bizionar.digital/via-celere/miralta/review01/render/zonas-comunes/still_Camera_002.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 03',
                  src: 'https://media.bizionar.digital/via-celere/miralta/review01/render/zonas-comunes/still_Camera_003.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Sala Social - 04',
                  src: 'https://media.bizionar.digital/via-celere/miralta/review01/render/zonas-comunes/still_Camera_004.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 01',
                  src: 'https://media.bizionar.digital/via-celere/miralta/review01/render/zonas-comunes/still_Camera_005.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
                {
                  name: 'Render Espacio Fit - 02',
                  src: 'https://media.bizionar.digital/via-celere/miralta/review01/render/zonas-comunes/still_Camera_006.jpg',
                  type: 'render',
                  category: 'zonas-comunes',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: 'reina',
      name: 'reina',
      url: '/client/reina',
      image: '/home/reina-logo.jpg',
      provinces: [
        'Mallorca'
      ],
      promotions: [
        {
          id: 'ses-marjades',
          name: 'Ses Marjades',
          city: 'Palma de Mallorca',
          province: 'Mallorca',
          liveEnabled: false,
          showEnabled: false,
          digitalShowUrl: '',
          reviewStatus: {
            current: 0,
            total: 3,
            status: 'pending',
          },
          url: '/client/reina/ses-marjades',
          image: 'https://media.bizionar.digital/reina/ses-marjades/review01/render/interior/render_SALON01.jpg',
          deliveries: [
            {
              categoryId: 'interiores',
              categoryName: 'PISO PILOTO',
              closedReviews: 0,
              totalReviews: 2,
              reviews: [
                {
                  id: 'review01',
                  name: 'ENTREGA 1',
                  date: '26 de octubre de 2026',
                  status: 'pending',
                },
              ],
            },
          ],
          reviews: [
            {
              id: 'review01',
              content: [
                {
                  name: 'Tour Virtual 360°',
                  src: 'https://media.bizionar.digital/reina/ses-marjades/review01/tour-multipunto/index.html',
                  thumb: 'https://media.bizionar.digital/reina/ses-marjades/review01/render/interior/render_SALON01.jpg',
                  type: 'panoramic',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 01',
                  src: 'https://media.bizionar.digital/reina/ses-marjades/review01/render/interior/render_SALON01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Salón 02',
                  src: 'https://media.bizionar.digital/reina/ses-marjades/review01/render/interior/render_SALON02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Terraza 01',
                  src: 'https://media.bizionar.digital/reina/ses-marjades/review01/render/interior/render_TERRAZA.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 01',
                  src: 'https://media.bizionar.digital/reina/ses-marjades/review01/render/interior/render_COCINA01.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Cocina 02',
                  src: 'https://media.bizionar.digital/reina/ses-marjades/review01/render/interior/render_COCINA02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación Suite 01',
                  src: 'https://media.bizionar.digital/reina/ses-marjades/review01/render/interior/render_SUITE.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 01',
                  src: 'https://media.bizionar.digital/reina/ses-marjades/review01/render/interior/render_BANO_PPAL.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Suite 02',
                  src: 'https://media.bizionar.digital/reina/ses-marjades/review01/render/interior/render_BANO_PPAL02.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 01 - 01',
                  src: 'https://media.bizionar.digital/reina/ses-marjades/review01/render/interior/render_HAB_JUVENIL.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Habitación 02 - 01',
                  src: 'https://media.bizionar.digital/reina/ses-marjades/review01/render/interior/render_HAB_INVITADOS.jpg',
                  type: 'render',
                  category: 'interiores',
                },
                {
                  name: 'Render Baño Secundario 01',
                  src: 'https://media.bizionar.digital/reina/ses-marjades/review01/render/interior/render_BANO_SECUNDARIO.jpg',
                  type: 'render',
                  category: 'interiores',
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  currentClient: null,
  currentPromotion: null,

  // Actions
  setCurrentClient: action((state, clientId) => {
    {
      state.clients.map((client, index) => {
        if (client.id === clientId) {
          state.currentClient = client;
          return;
        }
      });
    }
  }),

  setCurrentPromotion: action((state, promotionId) => {
    {
      state.currentClient.promotions.map((promotion, index2) => {
        if (promotion.id === promotionId) {
          state.currentPromotion = promotion;
        }
      });
    }
  }),
};
